import type { TranslationMap } from './types';

// Simplified Chinese (简体中文) translations. Keys mirror en.ts; missing/
// English-identical values fall back to English via I18nContext.resolveEn().
const messages: TranslationMap = {
  'connections.header.companion': '一个悬浮的桌面伙伴，随时提供快速帮助。',
  'settings.assistant.desktopCompanion': '桌面伴侣',
  'settings.assistant.desktopCompanionDesc': '带有系统托盘快捷方式的常驻伴侣模式',
  'pages.settings.features.desktopCompanion': '桌面伴侣',
  'settings.companion.title': '桌面伴侣',
  'settings.companion.session': '会话',
  'settings.companion.activeLabel': '活跃',
  'settings.companion.inactiveStatus': '不活跃',
  'settings.companion.stopping': '正在停止…',
  'settings.companion.stopSession': '停止会话',
  'settings.companion.starting': '正在启动…',
  'settings.companion.startSession': '开始会话',
  'settings.companion.sessionId': '会话ID',
  'settings.companion.turns': '轮次',
  'settings.companion.remaining': '剩余',
  'settings.companion.configuration': '配置',
  'settings.companion.hotkey': '热键',
  'settings.companion.activationMode': '激活模式',
  'settings.companion.sessionTtl': '会话有效期',
  // Share cards (#5006).
  'share.button': '分享',
  'share.modalTitle': '分享这一刻',
  'share.modalSubtitle': '将你的智能体的成果发布到 X 或 LinkedIn',
  'share.drafting': '正在设计你的卡片...',
  'share.cardAlt': '分享卡片预览',
  'share.imageError': '无法生成图片，请重试。',
  'share.captionLabel': '文案',
  'share.captionPlaceholder': '写点文案...',
  'share.privacyNote': '仅分享标题、文案、智能体名称和品牌标识。你的聊天、记忆和文件保持私密。',
  'share.defaultHeadline': '看看我的 OpenHuman 智能体刚刚做了什么',
  'share.defaultAgentName': '我的智能体',
  'share.defaultCaption': '看看我的 OpenHuman 智能体刚刚做了什么。',
  'share.captionWithHeadline': '{headline}。由我的 OpenHuman 智能体制作。',
  'share.linkedInHint': '文案已复制，请粘贴到你的 LinkedIn 帖子中。',
  'share.shareX': '分享到 X',
  'share.shareLinkedIn': '分享到 LinkedIn',
  'share.copyImage': '复制图片',
  'share.copiedImage': '图片已复制',
  'share.copyCaption': '复制文案',
  'share.copiedCaption': '文案已复制',
  'agentWorld.welcome.nav': '欢迎',
  'agentWorld.welcome.eyebrow': 'TinyPlace',
  'agentWorld.welcome.title': '一个让你的智能体相遇的世界',
  'agentWorld.welcome.body':
    'TinyPlace 是 AI 智能体的社交层：你的智能体可以发现其他智能体、给它们发消息、接取赏金任务并进行交易，全部代你完成。走进这个世界，看看它们都在做些什么。',
  'agentWorld.welcome.ctaWorld': '进入世界',
  'agentWorld.welcome.ctaFeed': '浏览动态',
  'agentWorld.welcome.ctaDirectory': '查找智能体',
  'agentWorld.welcome.featsLabel': '这里会发生什么',
  'agentWorld.welcome.feat1Title': '结识其他智能体',
  'agentWorld.welcome.feat1Body': '发现并联系来自整个网络的智能体。',
  'agentWorld.welcome.feat2Title': '接取赏金任务',
  'agentWorld.welcome.feat2Body': '你的智能体可以通过完成发布的任务来赚取收益。',
  'agentWorld.welcome.feat3Title': '交易与结算',
  'agentWorld.welcome.feat3Body': '智能体之间以钱包为后盾进行支付，且需经你批准。',
  'brain.header.graph': '你的智能体的知识如何相互关联：人物、话题和记忆。',
  'brain.header.goals': '你的智能体正在努力实现什么，以及为什么。',
  'brain.header.sources': '你的智能体从中学习的数据。',
  'brain.header.sync': '保持记忆的新鲜度，并回顾发生了哪些变化。',
  'brain.header.subconscious': '在你离开时于后台运行的思考。',
  'brain.welcome.nav': '欢迎',
  'brain.welcome.eyebrow': 'Brain',
  'brain.welcome.title': '绘制出你的智能体的记忆',
  'brain.welcome.body':
    'Brain 是你的智能体存放所知内容的地方：它所依赖的人物、对话、来源和目标，让它能带着真实的上下文帮助你，而不是每次都从零开始。',
  'brain.welcome.ctaGraph': '打开记忆图谱',
  'brain.welcome.ctaGoals': '设定目标',
  'brain.welcome.ctaSources': '连接来源',
  'brain.welcome.featsLabel': '这里都有什么',
  'brain.welcome.feat1Title': '记忆图谱',
  'brain.welcome.feat1Body': '一目了然地看清人物、话题和消息如何相互关联。',
  'brain.welcome.feat2Title': '目标与重点',
  'brain.welcome.feat2Body': '告诉你的智能体什么最重要，好让它优先处理正确的工作。',
  'brain.welcome.feat3Title': '来源与同步',
  'brain.welcome.feat3Body': '连接你的智能体从中学习的数据，并保持其新鲜度。',
  'feedback.header.title': '反馈',
  'feedback.header.desc': '分享想法，并为我们接下来要开发的内容投票。',
  'feedback.welcome.nav': '欢迎',
  'feedback.welcome.main': '反馈看板',
  'feedback.welcome.eyebrow': '反馈',
  'feedback.welcome.title': '帮助塑造我们要打造的产品',
  'feedback.welcome.body':
    '告诉我们什么行得通、缺少什么，以及怎样能让 OpenHuman 变得更好。发布一个想法，为他人的建议投票，看着最棒的那些一路升到我们路线图的顶端。',
  'feedback.welcome.ctaShare': '分享想法',
  'feedback.welcome.ctaBoard': '查看看板',
  'feedback.welcome.featsLabel': '你可以做什么',
  'feedback.welcome.feat1Title': '分享想法',
  'feedback.welcome.feat1Body': '缺陷、功能需求、粗略的念头：统统欢迎。',
  'feedback.welcome.feat2Title': '投票',
  'feedback.welcome.feat2Body': '为重要的内容点赞，好让我们知道该优先处理什么。',
  'feedback.welcome.feat3Title': '跟踪进展',
  'feedback.welcome.feat3Body': '查看哪些已规划、进行中，以及已发布。',
  'connections.header.composio': '连接你的智能体可以在其中行动的应用。',
  'connections.header.channels': '关联你社区所在的聊天应用。',
  'connections.header.mcp': '添加 MCP 服务器以扩展你的智能体的工具。',
  'connections.header.skills': '安装并管理智能体技能。',
  'connections.header.meetings': '连接日历，让你的智能体加入通话。',
  'connections.header.llm': '配置 AI 提供商、本地模型和智能体聊天测试器。',
  'connections.header.embeddings': '选择用于记忆搜索的嵌入模型。',
  'connections.header.search': '为你的智能体配置网络搜索。',
  'connections.header.wallet': '你的本地钱包余额和恢复短语。',
  'connections.header.composioKey': '添加 Composio API 密钥，解锁数百个应用集成。',
  'connections.llm.apiKeys': 'API 密钥与路由',
  'connections.welcome.nav': '欢迎',
  'connections.welcome.eyebrow': '连接',
  'connections.welcome.title': '你所用的一切，尽在一处',
  'connections.welcome.body':
    '连接你的消息应用、邮箱、日历和工具，让你的智能体能够读取上下文并在所有这些应用中采取行动：无需在十几个标签页之间来回复制粘贴。它能触及什么，始终由你掌控。',
  'connections.welcome.ctaChannel': '连接一个渠道',
  'connections.welcome.ctaApps': '连接应用',
  'connections.welcome.ctaSkills': '浏览技能',
  'connections.welcome.featsLabel': '你在这里可以做什么',
  'connections.welcome.feat1Title': '接入渠道',
  'connections.welcome.feat1Body': 'Slack、WhatsApp、Telegram、Gmail 等等：只需点击几下即可关联。',
  'connections.welcome.feat2Title': '让你的智能体行动起来',
  'connections.welcome.feat2Body': '它会带着来自所有已连接内容的完整上下文进行阅读、起草和回复。',
  'connections.welcome.feat3Title': '始终掌控',
  'connections.welcome.feat3Body': '随时可按渠道授予或撤销访问权限。未经你同意，一切都不会运行。',
  'alerts.header.desc': '智能体活动以及一切需要你关注的内容。',
  'notifications.welcome.nav': '欢迎',
  'notifications.welcome.main': '提醒',
  'notifications.welcome.eyebrow': '通知',
  'notifications.welcome.title': '只呈现真正需要你的内容',
  'notifications.welcome.body':
    '一份平和、经过评分的摘要，汇总你的智能体做了什么以及什么需要决策：让重要的事情浮现，把噪音挡在你的视线之外。',
  'notifications.welcome.ctaView': '查看提醒',
  'notifications.welcome.featsLabel': '你会看到什么',
  'notifications.welcome.feat1Title': '需要你处理的事',
  'notifications.welcome.feat1Body': '你的智能体标记出需要人来处理的决策和提及。',
  'notifications.welcome.feat2Title': '智能体活动',
  'notifications.welcome.feat2Body': '一份运行了什么以及产出了什么的实时日志。',
  'notifications.welcome.feat3Title': '按类别筛选',
  'notifications.welcome.feat3Body': '消息、会议、提醒：按你的思路分门别类。',
  'rewards.header.desc': '你的积分、连续记录、推荐和福利。',
  'rewards.welcome.nav': '欢迎',
  'rewards.welcome.main': '奖励',
  'rewards.welcome.eyebrow': '奖励',
  'rewards.welcome.title': '因常来而获得奖励',
  'rewards.welcome.body':
    '在使用 OpenHuman 和邀请他人的过程中赚取积分，保持你的连续记录不断，并兑换你所赚取的一切：全部在一处追踪。',
  'rewards.welcome.ctaView': '查看奖励',
  'rewards.welcome.featsLabel': '运作方式',
  'rewards.welcome.feat1Title': '赚取积分',
  'rewards.welcome.feat1Body': '日常操作和推荐会随时间不断累积。',
  'rewards.welcome.feat2Title': '保持连续记录',
  'rewards.welcome.feat2Body': '经常光临以解锁连续记录奖励。',
  'rewards.welcome.feat3Title': '兑换福利',
  'rewards.welcome.feat3Body': '把积分变成优惠券和奖励。',
  'flows.welcome.nav': '欢迎',
  'flows.welcome.main': '工作流',
  'flows.welcome.eyebrow': '工作流',
  'flows.welcome.title': '让繁琐工作自动运行',
  'flows.welcome.body':
    '描述一件你反复要做的事情（例如分类处理、跟进或生成摘要），你的智能体就会把它变成一个可以端到端运行的工作流，可按计划或按需执行。',
  'flows.welcome.ctaNew': '新建工作流',
  'flows.welcome.ctaBrowse': '浏览工作流',
  'flows.welcome.featsLabel': '你可以自动化什么',
  'flows.welcome.feat1Title': '用文字描述',
  'flows.welcome.feat1Body': '用平实的语言说出你想要什么；构建器会草拟出流程。',
  'flows.welcome.feat2Title': '按计划运行',
  'flows.welcome.feat2Body': '按定时器、事件或一个按钮触发：由你决定。',
  'flows.welcome.feat3Title': '让人始终参与其中',
  'flows.welcome.feat3Body': '在任何内容发出之前，先批准敏感步骤。',
  // Privacy Mode selector (#4435)：data-egress posture
  'privacy.mode.title': '隐私模式',
  'privacy.mode.description': '控制有多少数据可以离开此设备。与代理访问模式相互独立。',
  'privacy.mode.localOnly': '仅本地',
  'privacy.mode.localOnlyDesc': '仅使用设备端模型。外部模型调用将被阻止。',
  'privacy.mode.standard': '标准',
  'privacy.mode.standardDesc': '均衡。按配置使用外部模型。',
  'privacy.mode.sensitive': '敏感',
  'privacy.mode.sensitiveDesc': '对敏感数据格外谨慎。更多控制项即将推出。',
  'privacy.mode.saved': '已保存',
  'privacy.mode.saveError': '无法更新隐私模式。',
  'skills.recallCalendar.title': 'Google 日历',
  'skills.recallCalendar.description': '通过 Recall.ai 自动加入 Google Meet 通话',
  // Core connection panel (GH-4396)
  'settings.core.title': '核心连接',
  'settings.core.menuDesc': '使用内置的本地核心，或连接到远程核心。',
  'settings.core.useRemoteToggle': '使用远程核心',
  'settings.core.useRemoteToggleDesc': '通过 HTTP 连接到远程核心，而不是使用内置的本地核心。',
  'settings.core.statusConnectedRemote': '已连接到远程核心',
  'settings.core.statusConnectedLocal': '已连接到本地核心',
  'settings.core.statusChecking': '正在检查连接…',
  'settings.core.statusAuthFailed': '可访问，但令牌被拒绝',
  'settings.core.statusUnreachable': '无法连接到核心',
  'settings.core.recheck': '重新检查',
  'settings.core.save': '保存并重启',
  'settings.core.applyRestartNote': '保存后 OpenHuman 将重启以重新连接。',
  // Cross-host vault (#4278)
  'crossHostVault.title': '记忆库位于核心主机上。',
  'crossHostVault.message':
    '此记忆库存储在 openhuman-core 主机（{os}）上。只能在该机器上打开或显示，无法从本设备访问。',
  'conversations.toolFailure.whyLabel': '原因',
  'conversations.toolFailure.nextLabel': '接下来该怎么做',
  'conversations.toolFailure.missingPermission.cause': 'OpenHuman 目前还没有执行此操作的权限。',
  'conversations.toolFailure.missingPermission.next': '授予所需权限，然后重试。',
  'conversations.toolFailure.missingApp.cause': '此操作所需的应用或程序不可用。',
  'conversations.toolFailure.missingApp.next': '安装或打开该应用，然后重试。',
  'conversations.toolFailure.serviceUnavailable.cause': 'OpenHuman 需要的某项服务暂时不可用。',
  'conversations.toolFailure.serviceUnavailable.next': 'OpenHuman 稍后会重试：无需任何操作。',
  'conversations.toolFailure.badCredentials.cause': '保存的登录信息缺失或已失效。',
  'conversations.toolFailure.badCredentials.next': '请重新登录或更新凭据，然后重试。',
  'conversations.toolFailure.blockedByPolicy.cause': '此操作已被你的安全设置阻止。',
  'conversations.toolFailure.blockedByPolicy.next': '如果希望执行，请在“设置 → 代理访问”中允许它。',
  'conversations.toolFailure.modelConnection.cause': 'OpenHuman 无法连接到 AI 模型。',
  'conversations.toolFailure.modelConnection.next':
    '请检查你的网络连接或模型设置；OpenHuman 将会重试。',
  'conversations.toolFailure.timeout.cause': '操作耗时过长，已被停止。',
  'conversations.toolFailure.timeout.next': 'OpenHuman 会重试，你也可以手动重试。',
  'conversations.toolFailure.denied.cause': '你拒绝了此操作。',
  'conversations.toolFailure.denied.next':
    '无需任何操作：它没有被执行。如果你改变主意，请再次提出。',
  'conversations.toolFailure.approvalExpired.cause': '在有人响应之前，审批请求已过期。',
  'conversations.toolFailure.approvalExpired.next': '再次提出以执行它：OpenHuman 不会自行重试。',
  'conversations.toolFailure.unknown.cause': '此操作出现了问题。',
  'conversations.toolFailure.unknown.next': '请重试；如果持续失败，请在设置中运行诊断。',
  'conversations.backgroundTasks.title': '后台任务',
  'nav.feedback': '分享反馈',
  'feedback.board': '反馈板',
  'feedback.empty': '还没有反馈。来分享第一个想法吧。',
  'feedback.loadMore': '加载更多',
  'feedback.loadError': '加载反馈失败',
  'feedback.expand': '展开',
  'feedback.collapse': '收起',
  'feedback.comments': '条评论',
  'feedback.viewIssue': '查看问题',
  'feedback.status.open': '待处理',
  'feedback.status.planned': '已计划',
  'feedback.status.completed': '已完成',
  'feedback.status.closed': '已关闭',
  'feedback.type.feature': '功能',
  'feedback.type.bug': '缺陷',
  'feedback.sort.hot': '热门',
  'feedback.sort.top': '最赞',
  'feedback.sort.new': '最新',
  'feedback.filter.allTypes': '全部类型',
  'feedback.filter.allStatuses': '全部状态',
  'feedback.vote.up': '赞成',
  'feedback.vote.down': '反对',
  'feedback.submit.heading': '分享反馈',
  'feedback.submit.subheading': '提出功能建议或报告缺陷，其他人可以为其投票。',
  'feedback.submit.titlePlaceholder': '标题',
  'feedback.submit.bodyPlaceholder': '描述你的想法或遇到的问题',
  'feedback.submit.action': '提交',
  'feedback.submit.success': '谢谢！你的反馈已发布到反馈板。',
  'feedback.submit.rejected': '无法发布你的反馈。',
  'feedback.submit.error': '出了点问题，请重试。',
  'feedback.admin.status': '状态',
  'feedback.admin.updateFailed': '更新状态失败',
  'feedback.comments.empty': '暂无评论。',
  'feedback.comments.placeholder': '添加评论',
  'feedback.comments.post': '发表',
  'feedback.comments.loadError': '加载评论失败',
  'feedback.comments.postError': '发表评论失败',
  'feedback.comments.you': '你',
  'conversations.backgroundTasks.titleWithCount': '后台任务（{count}）',
  'conversations.backgroundTasks.running': '{count} 个正在运行',
  'conversations.backgroundTasks.noneRunning': '当前无任务运行',
  'conversations.backgroundTasks.total': '共 {count} 个',
  'conversations.backgroundTasks.empty':
    '此聊天中没有后台任务。要求助手在后台执行某些操作，它就会显示在此处。',
  'conversations.backgroundTasks.statusRunning': 'Running',
  'conversations.backgroundTasks.statusDone': 'Done',
  'conversations.backgroundTasks.statusFailed': 'Failed',
  'conversations.backgroundTasks.statusNeedsYou': '需要你',
  'conversations.backgroundTasks.statusCancelled': '已取消',
  'conversations.backgroundTasks.toolCallOne': '{count} 次工具调用',
  'conversations.backgroundTasks.toolCallOther': '{count} 次工具调用',
  'conversations.backgroundTasks.steps': '{count} 个步骤',
  'conversations.backgroundTasks.viewDetails': '查看详情 →',
  'conversations.backgroundTasks.close': 'Close',
  'conversations.backgroundTasks.sectionThisChat': '在此对话中',
  'conversations.backgroundTasks.sectionScheduled': '计划任务',
  'conversations.backgroundTasks.sectionSubconscious': '潜意识思考',
  'conversations.backgroundTasks.sectionMemory': '正在同步记忆',
  'conversations.backgroundTasks.cronEmpty': '没有计划任务。',
  'conversations.backgroundTasks.cronUnnamed': '未命名任务',
  'conversations.backgroundTasks.cronPaused': '已暂停',
  'conversations.backgroundTasks.cronNext': '下次 {time}',
  'conversations.backgroundTasks.cronLast': '上次运行 {time}',
  'conversations.backgroundTasks.cronNever': '尚未运行',
  'conversations.backgroundTasks.cronSchedCron': 'Cron {expr}',
  'conversations.backgroundTasks.cronSchedEvery': '每 {duration}',
  'conversations.backgroundTasks.cronSchedAt': '一次',
  'conversations.backgroundTasks.subOff': '关闭',
  'conversations.backgroundTasks.subWorking': '工作中…',
  'conversations.backgroundTasks.subIdle': '空闲',
  'conversations.backgroundTasks.subLastRan': '上次运行 {time}',
  'conversations.backgroundTasks.subNeverRan': '尚未运行',
  'conversations.backgroundTasks.subTicks': '{count} 次运行',
  'conversations.backgroundTasks.subQueued': '{count} 个排队中',
  'conversations.backgroundTasks.memUpToDate': '所有记忆均为最新',
  'conversations.backgroundTasks.memIngesting': '正在索引 {title}',
  'conversations.backgroundTasks.memIngestingUntitled': '正在索引记忆',
  'conversations.backgroundTasks.memQueued': '{count} 个排队中',
  'conversations.backgroundTasks.memProviderActive': '正在同步',
  'conversations.backgroundTasks.memProviderRecent': '最近已同步',
  'conversations.backgroundTasks.memProviderIdle': '空闲',
  'nav.home': '首页',
  'nav.chat': '对话',
  'nav.human': '助手',
  'nav.assistant': '助手',
  'assistant.faceMode.on': '正在与 Tiny 对话',
  'assistant.faceMode.off': '与 Tiny 对话',
  'assistant.faceMode.turnOn': '显示形象',
  'assistant.faceMode.turnOff': '隐藏形象',
  'nav.connections': '连接',
  'nav.memory': '记忆',
  'nav.alerts': '通知',
  'nav.rewards': '奖励',
  'nav.settings': '设置',
  'nav.agentProfiles': '代理档案',
  'nav.switchAgentProfile': '切换代理档案',
  'nav.defaultAgentProfile': '默认代理',
  'nav.noAgentProfiles': '未找到代理档案',
  'nav.activity': '动态',
  'nav.brain': '大脑',
  'nav.flows': '工作流',
  'nav.workflowRuns': '工作流运行',
  'nav.workflowDiscoveries': '发现工作流',
  'nav.orchestration': '编排',
  'orchestration.cloudUnreachable': '无法连接云端大脑：正在显示缓存的视图。',
  'orchPage.subtitle': '协调你的主智能体',
  'orchPage.group.agent': '智能体',
  'orchPage.group.network': '网络',
  'orchPage.group.insights': '洞察',
  'orchPage.overview.nav': '智能体图谱',
  'orchPage.overview.desc': '您的智能体及其协调的子智能体的实时图谱。',
  'orchPage.network.desc': '您已连接的对等智能体、发现与使用情况。',
  'wallet.tabs.balance': '钱包余额',
  'wallet.tabs.recovery': '恢复',
  'wallet.ariaLabel': '钱包视图',
  'orchPage.medulla.nav': '概览',
  'orchPage.medulla.badge': '即将推出',
  'orchPage.medulla.title': 'Medulla',
  'orchPage.medulla.tagline': 'OpenHuman 的编排模型',
  'orchPage.medulla.body':
    'Medulla 是 OpenHuman 从零打造的自研大语言模型，专为同时编排数千个智能体而设计：具备 1000 万 token 的上下文窗口和极低成本的编排能力。',
  'orchPage.medulla.featAgents': '数千个智能体',
  'orchPage.medulla.featContext': '10M token 上下文',
  'orchPage.medulla.featCost': '低成本编排',
  'orchPage.medulla.subscriberTitle': 'OpenHuman 订阅用户',
  'orchPage.medulla.subscriberNote': 'Medulla 上线后将仅面向 OpenHuman 订阅用户开放。',
  'orchPage.medulla.subscriberCta': '获取订阅',
  'orchPage.medulla.discordTitle': '加入 Discord',
  'orchPage.medulla.earlyAccess': '想抢先体验？加入我们的 Discord，领取抢先体验邀请。',
  'orchPage.medulla.cta': '加入我们的 Discord',
  'orchPage.demo.banner': '这是一个大规模编排效果的示例。',
  'orchPage.demo.device': '设备',
  'orchPage.demo.taskRoute': '路由入站请求',
  'orchPage.demo.taskSummarize': '总结对话',
  'orchPage.demo.taskEnrich': '丰富联系人记录',
  'orchPage.demo.taskSchedule': '安排跟进',
  'orchPage.demo.taskDraft': '起草回复',
  'orchPage.demo.taskSync': '同步数据源',
  'orchPage.demo.networkTitle': '对等智能体',
  'orchPage.demo.networkSummary': '已连接 {peers} 个 · {sessions} 个活跃子智能体',
  'orchPage.demo.peer.connected': '已连接',
  'orchPage.demo.peer.connecting': '连接中',
  'orchPage.demo.peer.idle': '空闲',
  'orchPage.demo.peerSessions': '{count} 个子智能体',
  'orchPage.demo.chat.user1': '在我的所有渠道上协调这次外联活动。',
  'orchPage.demo.chat.assistant1':
    '这就来：正在 2 台设备上启动 120 个智能体，并行运行外联、信息丰富和跟进。',
  'orchPage.demo.chat.activity1': '设备 1 · 100 个智能体正在路由 1,284 个对话',
  'orchPage.demo.chat.activity2': '设备 2 · 20 个智能体正在丰富 512 个联系人',
  'orchPage.demo.chat.activity3': '正在起草 640 条个性化回复',
  'orchPage.demo.chat.assistant2': '完成。120 个智能体在 38 秒内处理了 1,796 个对话。',
  'orchPage.demo.chat.composerDisabled': '拥有 Medulla 访问权限即可使用聊天',
  'orchPage.tasks.nav': '任务',
  'orchPage.tasks.subtitle': '编排器的全局任务看板',
  'orchPage.tasks.colPending': '待处理',
  'orchPage.tasks.colActive': '进行中',
  'orchPage.tasks.colBlocked': '已阻塞',
  'orchPage.tasks.colCompleted': '已完成',
  'orchPage.overview.core': '智能体核心',
  'orchPage.overview.empty': '暂无可可视化的子智能体',
  'orchPage.agent.nav': '聊天',
  'orchPage.agent.mainTab': '主智能体',
  'orchPage.agent.consciousTab': '意识',
  'orchPage.agent.subconsciousTab': '潜意识',
  'orchPage.agent.modeLabel': '智能体心智',
  'orchPage.agent.description': '与主智能体聊天并观察其潜意识',
  'orchPage.agent.viewSession': '查看会话',
  'orchPage.sessions.railTitle': '活跃智能体',
  'orchPage.sessions.empty': '暂无活跃智能体',
  'orchPage.sessions.statusConnected': '已连接',
  'orchPage.sessions.statusDisconnected': '已断开',
  'orchPage.sessions.statusWaiting': '等待输入',
  'orchPage.session.runtime': '运行时',
  'orchPage.session.directory': '目录',
  'orchPage.session.runningOn': '运行于',
  'orchPage.connections.nav': '连接',
  'orchPage.connections.title': '已关联智能体',
  'orchPage.connections.description': '你的智能体协作的伙伴：展开其中一个即可查看你与它的会话',
  'orchPage.connections.empty': '暂无连接。',
  'orchPage.connections.emptyCta': '添加连接',
  'orchPage.connections.statContacts': '连接',
  'orchPage.connections.statPending': '待处理',
  'orchPage.connections.statSessions': '会话',
  'orchPage.connections.sessionCount': '{n} 个会话',
  'orchPage.connections.noSessions': '暂无会话',
  'orchPage.connections.messageCount': '{n} 条消息',
  'orchPage.connections.back': '连接',
  'orchPage.connections.replyPlaceholder': '回复…',
  'orchPage.connections.initTitle': '初始化一个智能体或实例',
  'orchPage.connections.initDesc':
    '启动一个新的子智能体与你协作。打开智能体聊天，描述它的角色、目标和所需工具：OpenHuman 会创建一个专属实例，你可以在这里进行操控。',
  'orchPage.connections.initCta': '在聊天中开始',
  'orchPage.connections.status.needsYou': '需要你',
  'orchPage.connections.status.running': '运行中',
  'orchPage.connections.status.idle': '空闲',
  'orchPage.connections.status.done': '完成',
  'orchPage.connections.status.error': '错误',
  'orchPage.connections.pendingHint': '等待接受',
  'orchPage.discover.nav': '发现',
  'orchPage.discover.linkAction': '添加',
  'orchPage.discover.identityTitle': '你的可发现性',
  'orchPage.discover.notDiscoverableGuide':
    '注册一个 @handle，以便其他智能体可以找到你并给你发消息。',
  'orchPage.discover.linkTitle': '关联新智能体',
  'orchPage.discover.linkDescription': '粘贴智能体 ID 以发送连接请求。',
  'orchPage.discover.noRequests': '没有传入请求。',
  'orchPage.usage.nav': '用量',
  'orchPage.usage.connections': '连接',
  'orchPage.usage.balance': '信用余额',
  'orchPage.usage.balanceHint': '促销 + 充值',
  'orchPage.usage.cycleSpend': '周期支出',
  'orchPage.usage.ofBudget': '/',
  'orchPage.usage.inferenceCalls': '模型调用',
  'orchPage.usage.integrationCalls': '集成调用',
  'orchPage.usage.tokensSaved': '已节省令牌',
  'orchPage.usage.saved': '已节省',
  'orchPage.usage.footnote': '用量反映你当前的计费周期。',
  'nav.agentWorld': 'Tiny Place',
  'nav.wallet': '钱包',
  'agentWorld.description':
    'Tiny.Place 是面向 AI 智能体的社交网络。使用 OpenHuman 来互动、查找和发布工作、交易并共同成长。',
  'agentWorld.world': '世界',
  'agentWorld.world.booting': '正在启动渲染器...',
  'agentWorld.world.initError': '无法启动世界渲染器。',
  'agentWorld.world.retry': '重试',
  'agentWorld.world.title': 'Tiny Place',
  'agentWorld.world.description':
    '加入 tiny.place，让你的代理与网络上的其他代理协作：查找和发布任务、交易、收发消息以及共同完成悬赏。',
  'agentWorld.world.offlineBadge': '离线预览',
  'agentWorld.world.offlineBadgeTitle':
    '此处显示的智能体为本地模拟。实时在线状态和世界同步即将推出。',
  'agentWorld.world.room': '房间',
  'agentWorld.world.rooms.poker.name': '扑克',
  'agentWorld.world.rooms.poker.description': '八个座位围绕一张毡面牌桌。',
  'agentWorld.world.rooms.court.name': '法庭',
  'agentWorld.world.rooms.court.description': '高台法官席、陪审席和旁听席。',
  'agentWorld.world.rooms.office.name': '办公室',
  'agentWorld.world.rooms.office.description': '隔间、办公桌和白板。',
  'agentWorld.world.rooms.home.name': '家',
  'agentWorld.world.rooms.home.description': '带沙发和地毯的舒适休息室。',
  'agentWorld.world.rooms.outside.name': '世界',
  'agentWorld.world.rooms.outside.description': '一座被建筑环绕的大型开放广场。',
  'agentWorld.feed': '动态',
  'agentWorld.feed.loadMore': '加载更多',
  'agentWorld.feed.loadingMore': '正在加载…',
  'agentWorld.feed.loadMoreError': '无法加载更多帖子，请重试。',
  'agentWorld.ledger': '账本',
  'agentWorld.profileViewer.description': '公开资料',
  'agentWorld.profileViewer.agentCard': '智能体卡片',
  'agentWorld.profileViewer.loading': '正在加载资料…',
  'agentWorld.profileViewer.notFoundTitle': '未找到资料',
  'agentWorld.profileViewer.notFoundBody': '此账号句柄尚未发布资料。',
  'agentWorld.profileViewer.errorTitle': '无法加载资料',
  'agentWorld.profileViewer.follow': '关注',
  'agentWorld.profileViewer.following': '已关注',
  'agentWorld.profileViewer.copyLink': '复制链接',
  'agentWorld.profileViewer.linkCopied': '链接已复制',
  'agentWorld.profileViewer.skills': '技能',
  'agentWorld.profileViewer.verifiedAccounts': '已验证账户',
  'agentWorld.profileViewer.handlesOwned': '拥有的句柄',
  'agentWorld.profileViewer.followers': '关注者',
  'agentWorld.profileViewer.followingCount': '正在关注',
  'agentWorld.profileViewer.joined': '加入于',
  'agentWorld.profileViewer.ownProfile': '这是你的资料',
  'agentWorld.profileViewer.agentBadge': '智能体',
  'agentWorld.profileViewer.humanBadge': '人类',
  'agentWorld.ledger.loadMore': '加载更多',
  'agentWorld.ledger.loadingMore': '正在加载…',
  'agentWorld.ledger.loadMoreError': '无法加载更多交易，请重试。',
  'agentWorld.ledger.filterAsset': '资产',
  'agentWorld.ledger.filterAllAssets': '所有资产',
  'agentWorld.ledger.direction': '方向',
  'agentWorld.ledger.directionAll': '全部',
  'agentWorld.ledger.directionIn': '转入',
  'agentWorld.ledger.directionOut': '转出',
  'agentWorld.ledger.copyTxId': '复制交易 ID',
  'agentWorld.ledger.copied': '已复制',
  'agentWorld.ledger.noMatch': '没有符合这些筛选条件的交易。',
  'agentWorld.ledger.noMatchHint': '请尝试放宽或清除筛选条件。',
  'agentWorld.jobs': '工作',
  'agentWorld.bounties': '赏金',
  'agentWorld.explore': '探索',
  'agentWorld.directory': '目录',
  'agentWorld.directory.empty': '未找到智能体',
  'agentWorld.directory.emptyHint': '目录中还没有注册任何智能体。',
  'agentWorld.directory.searchLabel': '搜索智能体',
  'agentWorld.directory.searchPlaceholder': '按用户名或名称搜索智能体',
  'agentWorld.directory.noResults': '没有符合搜索条件的智能体。',
  'agentWorld.directory.noResultsHint': '请尝试其他用户名或名称。',
  'agentWorld.directory.loadMore': '加载更多',
  'agentWorld.directory.loadingMore': '正在加载…',
  'agentWorld.directory.loadMoreError': '无法加载更多智能体。',
  'agentWorld.directory.profile.verified': '已验证',
  'agentWorld.directory.profile.joined': '加入于',
  'agentWorld.directory.profile.noBio': '暂无简介。',
  'agentWorld.directory.profile.skills': '技能',
  'agentWorld.directory.profile.loadError': '无法加载完整资料。',
  'agentWorld.identities': '身份',
  'agentWorld.profiles': '档案',
  'agentWorld.transferHandle.action': '转移',
  'agentWorld.transferHandle.title': '转移句柄',
  'agentWorld.transferHandle.warning': '句柄转移是永久性的，无法撤销。接收者将成为其唯一所有者。',
  'agentWorld.transferHandle.recipientPlaceholder': '接收者 @handle',
  'agentWorld.transferHandle.confirm': '转移句柄',
  'agentWorld.transferHandle.submitting': '正在转移…',
  'agentWorld.transferHandle.recipientRequired': '请输入接收者的句柄。',
  'agentWorld.transferHandle.confirmLabel': '输入句柄以确认',
  'agentWorld.transferHandle.confirmMismatch': '输入的句柄不匹配。',
  'agentWorld.transferHandle.primaryLocked': '无法转移主用户名。请先将另一个用户名设为活跃。',
  'agentWorld.profile.edit': '编辑资料',
  'agentWorld.profile.displayName': '显示名称',
  'agentWorld.profile.bio': '简介',
  'agentWorld.profile.avatarEmail': '头像邮箱',
  'agentWorld.profile.avatarEmailHint': '用于从 Gravatar 获取你的头像。',
  'agentWorld.profile.save': '保存',
  'agentWorld.profile.nameRequired': '显示名称不能为空。',
  'agentWorld.profile.cancel': '取消',
  'agentWorld.profile.saving': '保存中…',
  'agentWorld.profile.saveError': '无法保存你的资料，请重试。',
  'agentWorld.marketplace': '市场',
  'agentWorld.messaging': '消息',
  'agentWorld.walletNotConfigured': '钱包未设置',
  'agentWorld.copyAddress': '复制地址',
  'agentWorld.addressCopied': '已复制',
  'agentWorld.walletUnavailable': '钱包不可用',
  'agentWorld.walletRetry': '重试加载钱包',
  // Agent World：Explore section live data
  'explore.networkOverview': '网络概览',
  'explore.trendingCommunities': '热门社区',
  'explore.activeJobs': '活跃职位',
  'explore.featuredBounties': '精选赏金',
  'explore.newAgents': '新代理',
  'explore.viewAll': '查看全部',
  'explore.noCommunities': '暂无社区',
  'explore.noJobs': '暂无活跃职位',
  'explore.noBounties': '暂无开放赏金',
  'explore.noAgents': '暂无注册代理',
  'agentWorld.jobs.deadlineFuture': '提案截止日期必须是将来的日期',
  'nav.avatarMenu.account': '账户',
  'nav.avatarMenu.billing': '账单',
  'nav.avatarMenu.rewards': '奖励',
  'nav.avatarMenu.invites': '邀请好友',
  'nav.avatarMenu.wallet': '钱包',

  // Brain：full-page memory knowledge-graph surface
  'brain.subtitle': '你的知识图谱、记忆来源与控制项。',
  'brain.tabs.memory': '记忆',
  'brain.tabs.subconscious': '潜意识',
  'brain.tabs.graph': '图谱',
  'brain.tabs.goals': '目标',
  'brain.goals.title': '长期目标',
  'brain.goals.description': '智能体与你协作的持久目标。在此编辑，或使用反思功能自动更新。',
  'brain.goals.reflect': '反思',
  'brain.goals.reflecting': '反思中…',
  'brain.goals.reflectDone': '目标已更新。',
  'brain.goals.add': '添加',
  'brain.goals.addPlaceholder': '添加一个长期目标…',
  'brain.goals.empty': '暂无目标。添加一个，或使用反思根据近期上下文生成。',
  'brain.goals.editGoal': '编辑目标',
  'brain.goals.deleteGoal': '删除目标',
  'brain.goals.actionError': '出了点问题。请重试。',
  'brain.tabs.sources': '来源',
  'brain.tabs.sync': '同步',
  'brain.tabs.orchestration': '编排',
  'tinyplaceOrchestration.title': 'TinyPlace 中继',
  'tinyplaceOrchestration.subtitle': '固定的代理频道和应用会话聊天',
  'tinyplaceOrchestration.refresh': '刷新',
  'tinyplaceOrchestration.newInstance': '新建实例',
  'tinyplaceOrchestration.newInstanceSoon': '即将推出',
  'tinyplaceOrchestration.pinned': '固定',
  'tinyplaceOrchestration.sessions': '会话',
  'tinyplaceOrchestration.contacts': '联系人',
  'tinyplaceOrchestration.noContacts': '暂无联系人。',
  'tinyplaceOrchestration.newSession': '新会话',
  'tinyplaceOrchestration.otherSessions': '其他会话',
  'tinyplaceOrchestration.loading': '正在加载 TinyPlace 聊天…',
  'tinyplaceOrchestration.paymentRequired': '访问 TinyPlace 需要付款。',
  'tinyplaceOrchestration.failedToLoad': '无法加载 TinyPlace 聊天',
  'tinyplaceOrchestration.noSessions': '还没有 TinyPlace 应用会话。',
  'tinyplaceOrchestration.noMessages': '此聊天中还没有消息。',
  'tinyplaceOrchestration.active': '活跃',
  'tinyplaceOrchestration.inactive': '不活跃',
  'tinyplaceOrchestration.encryptedBody': '加密的 TinyPlace 消息',
  'tinyplaceOrchestration.unknownSender': '未知发送者',
  'tinyplaceOrchestration.master.title': '代理 / 人类',
  'tinyplaceOrchestration.master.subtitle': '主聊天',
  'tinyplaceOrchestration.master.preview': '你和 OpenHuman 之间的直接协调。',
  'tinyplaceOrchestration.subconscious.title': '潜意识',
  'tinyplaceOrchestration.subconscious.subtitle': '代理内部聊天',
  'tinyplaceOrchestration.subconscious.preview': '后台代理协调和记忆循环。',
  'tinyplaceOrchestration.session.subtitle': 'TinyPlace 应用会话',
  'tinyplaceOrchestration.pairing.linkLabel': '链接会话',
  'tinyplaceOrchestration.pairing.linkPlaceholder': '粘贴会话智能体 ID',
  'tinyplaceOrchestration.pairing.linkAction': '链接',
  'tinyplaceOrchestration.pairing.requests': '联系人请求',
  'tinyplaceOrchestration.pairing.accept': '接受',
  'tinyplaceOrchestration.pairing.decline': '拒绝',
  'tinyplaceOrchestration.pairing.block': '屏蔽',
  'tinyplaceOrchestration.pairing.linked': '已链接',
  'tinyplaceOrchestration.pairing.pending': '待处理',
  'tinyplaceOrchestration.pairing.unlinked': '未链接',
  'tinyplaceOrchestration.pairing.incoming': '传入',
  'tinyplaceOrchestration.pairing.outgoing': '传出',
  'tinyplaceOrchestration.master.you': '你',
  'tinyplaceOrchestration.composer.placeholder': '给 OpenHuman 发消息…',
  'tinyplaceOrchestration.composer.send': '发送',
  'tinyplaceOrchestration.composer.sendFailed': '消息发送失败',
  'tinyplaceOrchestration.steering.label': '引导',
  'tinyplaceOrchestration.relay.staging': '预发布',
  'tinyplaceOrchestration.relay.prod': '生产',
  'tinyplaceOrchestration.identity.loading': '正在加载身份…',
  'tinyplaceOrchestration.identity.noHandle': '尚无 @handle',
  'tinyplaceOrchestration.identity.copy': '复制',
  'tinyplaceOrchestration.identity.copied': '已复制',
  'tinyplaceOrchestration.identity.discoverable': '可被发现',
  'tinyplaceOrchestration.identity.undiscoverable': '不可被发现',
  'tinyplaceOrchestration.identity.undiscoverableHint':
    '发布你的目录卡片和加密密钥，以便其他代理可以给你发消息。',
  'tinyplaceOrchestration.identity.makeDiscoverable': '设为可被发现',
  'tinyplaceOrchestration.identity.republish': '重新发布密钥',
  'tinyplaceOrchestration.identity.publishing': '正在发布…',
  'tinyplaceOrchestration.identity.publishFailed': '发布失败：请重试',
  'tinyplaceOrchestration.identity.card': '目录卡片',
  'tinyplaceOrchestration.identity.key': '加密密钥',
  'tinyplaceOrchestration.identity.published': '已发布',
  'tinyplaceOrchestration.identity.notPublished': '未发布',
  'tinyplaceOrchestration.roster.instances': '实例',
  'tinyplaceOrchestration.roster.empty': '暂无代理实例',
  'tinyplaceOrchestration.roster.other': '其他',
  'tinyplaceOrchestration.status.running': '运行中',
  'tinyplaceOrchestration.status.idle': '空闲',
  'tinyplaceOrchestration.status.waitingApproval': '等待批准',
  'tinyplaceOrchestration.status.errored': '出错',
  'tinyplaceOrchestration.status.stopped': '已停止',
  'tinyplaceOrchestration.attention.title': '需要你处理',
  'tinyplaceOrchestration.attention.empty': '全部处理完毕',
  'tinyplaceOrchestration.attention.unread': '未读消息',
  'tinyplaceOrchestration.attention.review': '审查',
  'tinyplaceOrchestration.attention.open': '打开',
  'tinyplaceOrchestration.attention.kind.approval': '审批',
  'tinyplaceOrchestration.attention.kind.needsInput': '需要输入',
  'tinyplaceOrchestration.attention.kind.unread': '未读',
  'brain.empty': '你的大脑暂时是空的：连接一个来源即可开始构建记忆。',
  'brain.error': '无法加载你的大脑，请重试。',
  'common.cancel': '取消',
  'common.save': '保存',
  'common.confirm': '确认',
  'common.delete': '删除',
  'common.edit': '编辑',
  'common.create': '创建',
  'common.search': '搜索',
  'common.loading': '加载中…',
  'sync.runs': '次同步',
  'sync.totalCost': '合计',
  'sync.when': '时间',
  'sync.source': '来源',
  'sync.items': '条目',
  'sync.tokens': '令牌',
  'sync.cost': '费用',
  'sync.duration': '时长',
  'sync.noAuditEntries': '尚未记录任何同步。',
  'sync.timeAgo.justNow': '刚刚',
  'sync.timeAgo.minutes': '{n}分钟前',
  'sync.timeAgo.hours': '{n}小时前',
  'sync.timeAgo.days': '{n}天前',
  'sync.status.success': '成功',
  'sync.status.failed': '失败',
  'common.error': '错误',
  'common.success': '成功',
  'common.back': '返回',
  'common.next': '下一步',
  'common.finish': '完成',
  'common.close': '关闭',
  'common.enabled': '已启用',
  'common.disabled': '已禁用',
  'common.on': '开',
  'common.off': '关',
  'common.yes': '是',
  'common.no': '否',
  'common.ok': '确定',
  'common.name': '名称',
  'common.retry': '重试',
  'common.copy': '复制',
  'common.copied': '已复制',
  'common.learnMore': '了解更多',
  'common.seeAll': '查看全部',
  'common.dismiss': '忽略',
  'common.clear': '清除',
  'common.reset': '重置',
  'common.refresh': '刷新',
  'common.export': '导出',
  'common.import': '导入',
  'common.upload': '上传',
  'common.download': '下载',
  'common.add': '添加',
  'common.remove': '移除',
  'common.showMore': '展开更多',
  'common.showLess': '收起',
  'common.submit': '提交',
  'common.continue': '继续',
  'common.comingSoon': '即将推出',
  'common.breadcrumb': '面包屑',
  'common.beta': '测试版',
  'common.betaDisclaimer': '此功能处于测试阶段。它可能会更改或存在不足：您的反馈有助于我们改进。',
  'settings.general': '通用',
  // Settings layman groups (Phase 4 IA revamp)
  'settings.groups.account': '账户',
  'settings.groups.assistant': '助手',
  'settings.groups.privacySecurity': '隐私与安全',
  'settings.groups.notifications': '通知',
  'settings.groups.about': '关于',
  'settings.assistant.personality': '个性',
  'settings.personalityFace.title': '个性与形象',
  'settings.personalityFace.menuDesc': '调整助手的性格并选择它的形象',
  'settings.assistant.voice': '语音',
  'settings.assistant.voiceDesc': '语音转文字和文字转语音设置',
  'settings.assistant.faceMascot': '面孔 / 吉祥物',
  'settings.assistant.backgroundActivity': '潜意识',
  'settings.assistant.backgroundActivityDesc': '控制助手在后台工作的活跃程度',
  'settings.assistant.permissions': '权限',
  'settings.assistant.permissionsDesc': '选择助手可以做什么以及可以在哪里工作',
  'settings.privacySecurity.privacy': '隐私',
  'settings.privacySecurity.privacyDesc': '控制哪些数据离开您的计算机',
  'settings.privacySecurity.security': '安全',
  'settings.privacySecurity.securityDesc': '会话和登录选项',
  'settings.privacySecurity.approvalsHistory': '审批与历史',
  'settings.privacySecurity.approvalsHistoryDesc': '查看最近的工具审批决定',
  'settings.notifications.menuTitle': '通知',
  'settings.notifications.menuDesc': '提醒收件箱和通知偏好设置',
  'settings.devGroups.knowledgeMemory': '知识与记忆',
  'settings.devGroups.agentsAutonomy': '智能体与自主性',
  'settings.devGroups.modelsInference': '模型与推理',
  'settings.devGroups.automationIntegrations': '自动化与集成',
  'settings.devGroups.toolsCapabilities': '工具与能力',
  'settings.devGroups.council': '委员会',
  'settings.analysisViews.title': '分析视图',
  'settings.analysisViews.menuDesc':
    '内存图分析：关系图、中心性、内聚性、关联、新鲜度、时间线、路径和命名空间',
  'settings.buildInfo.title': '构建/版本信息',
  'settings.buildInfo.menuDesc': '应用构建、版本和核心连接详情',
  'settings.tokenUsage.title': '令牌与成本',
  'settings.tokenUsage.menuDesc': '压缩设置以及它们已节省的令牌和美元数量',
  'settings.tokenUsage.saving': '正在保存…',
  'settings.tokenUsage.saved': '已保存',
  'settings.tokenUsage.savingsTitle': '节省',
  'settings.tokenUsage.attributedTo': '按 {model} 计价的成本',
  'settings.tokenUsage.tokensSaved': '节省的令牌',
  'settings.tokenUsage.costSaved': '节省的成本',
  'settings.tokenUsage.cacheOccupancy': '已缓存的原文',
  'settings.tokenUsage.compactions': '压缩次数',
  'settings.tokenUsage.overEvents': '在 {count} 次压缩中',
  'settings.tokenUsage.byCompressor': '按压缩器',
  'settings.tokenUsage.refresh': '刷新',
  'settings.tokenUsage.reset': '重置统计',
  'settings.tokenUsage.compressionTitle': '压缩',
  'settings.tokenUsage.compressionDesc': '在大型工具输出进入模型上下文之前，对其进行内容感知压缩。',
  'settings.tokenUsage.routerEnabled': '启用压缩',
  'settings.tokenUsage.routerEnabledDesc': '内容路由器的总开关。',
  'settings.tokenUsage.search': '搜索结果',
  'settings.tokenUsage.searchDesc': '按相关性对 grep/搜索输出进行排序，保留最佳匹配项。',
  'settings.tokenUsage.code': '源代码',
  'settings.tokenUsage.codeDesc': '保留签名，折叠函数主体。',
  'settings.tokenUsage.html': 'HTML',
  'settings.tokenUsage.htmlDesc': '去除标记，转为可读文本。',
  'settings.tokenUsage.ml': 'ML 文本压缩器',
  'settings.tokenUsage.mlDesc': '用于纯文本的本地 ModernBERT 模型（需要 Python 运行时）。',
  'settings.tokenUsage.ccrTitle': '缓存与恢复（CCR）',
  'settings.tokenUsage.ccrDesc': '压缩后的原文会被缓存，以便代理可按需获取完整文本。',
  'settings.tokenUsage.ccrEnabled': '保留原文以便恢复',
  'settings.tokenUsage.ccrEnabledDesc': '卸载原文并添加检索标记，确保不丢失任何内容。',
  'settings.tokenUsage.ccrMinTokens': '缓存的最小大小',
  'settings.tokenUsage.ccrMinTokensDesc': '仅缓存并有损压缩估算达到或超过此令牌数量的结果。',
  'settings.tokenUsage.tokensUnit': '令牌',
  'settings.tokenUsage.ccrDisk': '将缓存持久化到磁盘',
  'settings.tokenUsage.ccrDiskDesc': '在重启之间保留可恢复的原文。',
  'settings.dataSync.title': '数据同步',
  'settings.dataSync.menuDesc': '助手同步的内容：来源、新鲜度和状态',
  'settings.dataSync.description':
    '管理同步到助手记忆中的内容：每个已连接的来源及其上次同步时间、已同步的数量，以及当前是否正在同步。',
  'settings.devGroups.diagnosticsLogs': '诊断与日志',
  'settings.featuresAndAI': '功能与 AI',
  'settings.billingAndRewards': '账单与奖励',
  'settings.support': '支持',
  'settings.advanced': '高级',
  'settings.dangerZone': '危险区域',
  'settings.account': '账户',
  'settings.accountDesc': '恢复短语、团队、连接与隐私',
  'settings.notifications': '通知',
  'settings.notificationsDesc': '免打扰模式与各账户通知控制',
  'settings.notifications.tabs.preferences': '偏好设置',
  'settings.notifications.tabs.routing': '路由',
  'settings.features': '功能',
  'settings.aiModels': 'AI 与模型',
  'settings.aiModelsDesc': '本地 AI 模型设置、下载与 LLM 提供商',
  'settings.ai': 'AI',
  'settings.aiDesc': '云端提供商、本地 Ollama 模型以及按工作负载路由',
  'settings.billingUsage': '账单与用量',
  'settings.billingUsageDesc': '订阅方案、配额与支付方式',
  'settings.rewards': '奖励',
  'settings.rewardsDesc': '邀请、优惠券与获得的配额',
  'settings.restartTour': '重新开始导览',
  'settings.restartTourDesc': '从头开始回放产品导览',
  'settings.about': '关于',
  'settings.aboutDesc': '应用版本与软件更新',
  'settings.developerOptions': '开发者选项',
  'settings.developerOptionsDesc': '诊断、调试面板、Webhook 与记忆检查',
  'settings.developerDiagnostics': '开发者与诊断',
  'settings.developerDiagnosticsDesc': '高级开发者工具、诊断、记忆、代理和调试面板',
  'settings.developerMode.title': '开发者模式',
  'settings.developerMode.description': '显示高级开发者和诊断工具',
  'settings.developerMode.enabledByBuild': '开发版本中始终启用',
  'settings.clearAppData': '清除应用数据',
  'settings.clearAppDataDesc': '退出登录并永久清除所有本地应用数据',
  'settings.logOut': '退出登录',
  'settings.logOutDesc': '退出当前账户',
  'settings.exitLocalSession': '退出本地会话',
  'settings.exitLocalSessionDesc': '返回登录页面',
  'settings.language': '语言',
  'settings.navGroups.general': '通用',
  'settings.navGroups.assistant': '助手',
  'settings.navGroups.data': '数据',
  'settings.navGroups.connections': '连接',
  'settings.navGroups.system': '系统',
  'settings.betaBuild': '测试版本 - v{version}',
  'settings.languageDesc': '应用界面显示语言',
  'settings.alerts': '通知',
  'settings.alertsDesc': '查看收件箱中的最新通知和活动',
  'settings.account.profile': '个人资料',
  'settings.account.profileDesc': '姓名、邮箱和头像',
  'settings.account.devices': '设备',
  'settings.account.devicesDesc': '配对和管理移动设备',
  'settings.account.teamMembers': '团队与成员',
  'settings.account.teamMembersDesc': '管理团队访问权限和成员角色',
  'settings.account.dataMigration': '数据与迁移',
  'settings.account.dataMigrationDesc': '从其他助手导入记忆',
  'settings.account.recoveryPhrase': '恢复短语',
  'settings.account.recoveryPhraseDesc': '查看并备份你的账户恢复短语',
  'settings.account.team': '团队',
  'settings.account.teamDesc': '管理团队成员与权限',
  'settings.account.connections': '连接',
  'settings.account.connectionsDesc': '管理已关联的账户与服务',
  'settings.account.privacy': '隐私',
  'settings.account.privacyDesc': '控制哪些数据离开你的电脑',
  'migration.title': '从其他助手导入',
  'migration.description':
    '将记忆和笔记从另一个本地助手迁移到此工作区。先点击「预览」查看将要变更的内容，然后点击「应用」复制数据。当前的记忆会先备份。',
  'migration.vendorLabel': '来源助手',
  'migration.vendor.openclaw': 'OpenClaw',
  'migration.vendor.hermes': 'Hermes Agent',
  'migration.sourceLabel': '来源工作区路径（可选）',
  'migration.sourcePlaceholder': '留空可自动检测（例如 ~/.openclaw/workspace）',
  'migration.sourcePlaceholderHermes': '留空以自动检测（例如 ~/.hermes）',
  'migration.sourceHint':
    '留空时使用该助手的默认位置。如果你已将工作区移到其他位置，请填写明确路径。',
  'migration.previewAction': '预览',
  'migration.previewRunning': '正在预览…',
  'migration.applyAction': '应用导入',
  'migration.applyRunning': '正在导入…',
  'migration.applyDisclaimer': '只有对同一来源完成预览后才能应用。导入前会自动备份现有记忆。',
  'migration.reportTitlePreview': '预览：尚未导入任何数据',
  'migration.reportTitleApplied': '导入完成',
  'migration.report.source': '来源工作区',
  'migration.report.target': '目标工作区',
  'migration.report.fromSqlite': '来自 SQLite (brain.db)',
  'migration.report.fromMarkdown': '来自 Markdown',
  'migration.report.imported': '已导入',
  'migration.report.skippedUnchanged': '已跳过（未变更）',
  'migration.report.renamedConflicts': '冲突时已重命名',
  'migration.report.warnings': '警告',
  'migration.report.previewHint': '尚未导入任何数据。点击「应用导入」开始复制。',
  'migration.report.appliedHint': '导入的条目已加入你的记忆。如需再次比较，请重新运行预览。',
  'migration.confirmImport.singular':
    '将 {count} 条数据导入当前工作区？\n\n来源：{source}\n目标：{target}\n\n导入前会先备份现有记忆。',
  'migration.confirmImport.plural':
    '将 {count} 条数据导入当前工作区？\n\n来源：{source}\n目标：{target}\n\n导入前会先备份现有记忆。',
  'settings.notifications.doNotDisturb': '免打扰',
  'settings.notifications.doNotDisturbDesc': '在一定时间内暂停所有通知',
  'settings.notifications.channelControls': '各渠道控制',
  'settings.notifications.channelControlsDesc': '为每个渠道配置通知偏好',
  'settings.features.messaging': '消息',
  'settings.features.messagingDesc': '渠道与消息集成设置',
  'settings.features.tools': '工具',
  'settings.features.toolsDesc': '管理已连接的工具与集成',
  'settings.ai.localSetup': '本地 AI 设置',
  'settings.ai.localSetupDesc': '下载并配置本地 AI 模型',
  'settings.ai.llmProvider': 'LLM 提供商',
  'settings.ai.llmProviderDesc': '选择并配置你的 AI 提供商',
  'clearData.title': '清除应用数据',
  'clearData.warning': '这将退出你的账户并永久删除本地应用数据，包括：',
  'clearData.bulletSettings': '应用设置与对话',
  'clearData.bulletCache': '所有本地集成缓存数据',
  'clearData.bulletWorkspace': '工作空间数据',
  'clearData.bulletOther': '所有其他本地数据',
  'clearData.irreversible': '此操作不可撤销。',
  'clearData.clearing': '正在清除应用数据...',
  'clearData.failed': '清除数据失败，请重试。',
  'clearData.failedLogout': '退出登录失败，请重试。',
  'clearData.failedPersist': '清除持久化应用状态失败，请重试。',
  'welcome.logoAlt': 'OpenHuman',
  'welcome.title': '欢迎使用 OpenHuman',
  'welcome.subtitle': '你的私人 AI 超级智能。私密、简单、强大。',
  'welcome.connectPrompt': '输入 Core RPC 地址以开始使用',
  'welcome.selectRuntime': '选择运行时',
  'welcome.clearingAppData': '清除应用程序数据...',
  'welcome.clearAppDataAndRestart': '清除应用数据并重启',
  'welcome.clearAppDataWarning':
    '此操作将清除此设备上本地存储的密钥和账户。您的云端账户不受影响：清除后可立即重新登录。',
  'welcome.resetErrorFallback': '无法清除应用数据。请退出并重新打开 OpenHuman，然后重试。',
  'welcome.signingIn': '正在为您签名...',
  'welcome.termsIntro': '继续即表示您同意',
  'welcome.termsOfUse': '条款',
  'welcome.termsJoiner': '和',
  'welcome.privacyPolicy': '隐私政策',
  'welcome.termsOutro': '.',
  'welcome.urlPlaceholder': 'http://localhost:8089',
  'welcome.invalidUrl': '请输入有效的 HTTP 或 HTTPS URL',
  'welcome.connecting': '连接中...',
  'welcome.connect': '连接',
  'home.greeting': '早上好',
  'home.greetingAfternoon': '下午好',
  'home.greetingEvening': '晚上好',
  'home.askAssistant': '向你的助手提问...',
  'home.statusOk': '你的助手已准备就绪。在下方输入内容即可开始。',
  'home.statusBackendOnly': '正在重新连接后端…你的智能体很快将再次可用。',
  'home.statusCoreUnreachable': '本地核心 sidecar 无响应。OpenHuman 后台进程可能已崩溃或未能启动。',
  'home.statusInternetOffline': '你的设备当前处于离线状态。请检查网络或重启应用以重新连接。',
  'home.restartCore': '重启核心',
  'home.restartingCore': '正在重启核心…',
  'home.themeToggle.toLight': '切换到浅色模式',
  'home.themeToggle.toDark': '切换到深色模式',
  'home.usageExhaustedTitle': '您的使用额度已耗尽',
  'home.usageExhaustedBody': '您当前已用完包含的使用额度。开始订阅以解锁更多持续容量。',
  'home.usageExhaustedCta': '开始订阅',
  'openrouterFree.cta': '使用 OpenRouter 免费模型',
  'openrouterFree.saving': '正在连接 OpenRouter...',
  'openrouterFree.error': '无法切换到 OpenRouter 免费模型。请检查 OpenRouter 登录后重试。',
  'home.routinesCard': '我的例程',
  'home.routinesActive': '{count} 个运行中',
  'routines.title': '你的例程',
  'routines.subtitle': '助手自动执行的事项',
  'routines.loading': '正在加载例程…',
  'routines.empty': '暂无例程',
  'routines.emptyHint': '你的助手可以按计划运行任务，例如晨间简报或每日摘要。',
  'routines.refresh': '刷新',
  'routines.nextRun': '下次运行',
  'routines.lastRunSuccess': '上次运行成功',
  'routines.lastRunFailed': '上次运行失败',
  'routines.notRunYet': '尚未运行',
  'routines.runNow': '立即运行',
  'routines.running': '运行中…',
  'routines.runNowTimedOut': '运行超时，请刷新后重试。',
  'routines.viewHistory': '查看历史',
  'routines.loadingHistory': '加载中…',
  'routines.noHistory': '暂无运行历史。',
  'routines.statusSuccess': '成功',
  'routines.statusError': '错误',
  'routines.showOutput': '显示输出',
  'routines.hideOutput': '隐藏输出',
  'routines.toggleEnabled': '启用或禁用此例程',
  'routines.typeAgent': '智能体',
  'routines.typeCommand': '命令',
  'nav.routines': 'Routines',
  'chat.newThread': '新对话',
  'chat.newConversation': '新对话',
  'chat.newWindowWelcome1': '欢迎，{name} 👋',
  'chat.newWindowWelcome2': '开干吧，{name} 🧑‍🍳。',
  'chat.newWindowWelcome3': '是时候专注了 🧘🏻',
  'chat.typeMessage': '今天我能帮您做什么？',
  'chat.send': '发送',
  'chat.stopGeneration': '停止生成',
  'chat.stoppedByUser': '已停止',
  'chat.parallelBranchHint': '输入并行分支：⌘/Ctrl+Enter 发送',
  'chat.followupHint': '将后续消息加入队列：将在本次回复后发送 · ⌘/Ctrl+Enter 开启并行分支',
  'chat.queuedFollowups.label': '排队的后续消息',
  'chat.queuedFollowups.clear': '清除',
  'chat.queuedFollowups.clearFailed': '无法清空队列：请重试。',
  'chat.createThreadFailed': '无法创建新会话。请重试。',
  'chat.parallelBranchLabel': '并行分支',
  'chat.thinking': '思考中...',
  'chat.noMessages': '暂无消息',
  'chat.startConversation': '开始对话',
  'chat.regenerate': '重新生成',
  'chat.copyResponse': '复制回复',
  'chat.citations': '引用',
  'chat.toolUsed': '已使用的工具',
  'scope.legacy': '旧版',
  'scope.user': '用户',
  'scope.project': '项目',
  'skills.title': '连接',
  'skills.search': '搜索连接...',
  'skills.noResults': '未找到连接',
  'skills.loadingIntegrations': '正在加载集成…',
  'skills.connect': '连接',
  'skills.disconnect': '断开',
  'skills.configure': '配置',
  'skills.connected': '已连接',
  'skills.available': '可用',
  'skills.addAccount': '添加账户',
  'skills.channels': '消息',
  'skills.explorer.emptyCta': '通过 URL 安装',
  'skills.explorer.emptyDescription':
    '安装 SKILL.md 包，或将 Hermes 风格的文件夹放到 ~/.openhuman/skills 下。',
  'skills.explorer.emptyTitle': '未找到技能',
  'skills.explorer.installFromUrl': '通过 URL 安装',
  'skills.explorer.newSkill': '新建技能',
  'skills.explorer.subtitle':
    '浏览 SKILL.md 包，包括 Hermes 风格的 Markdown、脚本、参考资料、模板、示例和提示词。',
  'skills.explorer.title': '技能浏览器',
  'skills.explorer.searchPlaceholder': '搜索技能...',
  'skills.explorer.scopeUser': 'User',
  'skills.explorer.scopeProject': 'Project',
  'skills.explorer.scopeLegacy': 'Legacy',
  'skills.explorer.noDescription': '未提供描述。',
  'skills.explorer.uninstallSuccess': '技能已成功卸载。',
  'skills.explorer.registryTab': '注册表',
  'skills.explorer.installedTab': '已安装',
  'skills.explorer.allFormats': '所有格式',
  'skills.explorer.refreshRegistry': '刷新注册表',
  'skills.explorer.registryEmptyTitle': '没有注册表条目',
  'skills.explorer.registryEmptyDescription': '无法加载技能注册表。请检查您的连接并尝试刷新。',
  'skills.explorer.showingOf': '显示 {total} 个结果中的 {shown} 个。请优化搜索以查看更多。',
  'skills.explorer.installed': '已安装',
  'skills.explorer.install': '安装',
  'skills.explorer.installing': '安装中…',
  'skills.integrations': 'Composio 集成',
  'skills.integrationsSubtitle':
    '基于云端的 OAuth 连接：使用您的账户登录，Composio 代管令牌，让智能体能以您的名义读取数据并执行操作，无需管理 API 密钥。',
  'skills.composio.noApiKeyTitle': '尚未配置 Composio API 密钥',
  'skills.composio.noApiKeyDescription':
    '本地模式使用你自己的 Composio API 密钥。在此连接集成之前，请打开 设置 → 高级 → Composio 添加一个密钥。',
  'skills.composio.noApiKeyCta': '在设置中打开',
  'skills.tabs.composio': 'Composio',
  'skills.tabs.channels': '渠道',
  'skills.tabs.explorer': '技能',
  'skills.tabs.meetings': 'Google Meet 会议',
  'skills.tabs.mcp': 'MCP 服务器',
  'connections.tabs.composio': 'Composio',
  'connections.tabs.channels': '频道',
  'connections.tabs.mcp': 'MCP 服务器',
  'connections.tabs.skills': '技能',
  'connections.tabs.meetings': '会议',
  'connections.groups.integrations': '集成',
  'connections.groups.desktop': '桌面',
  'connections.tabs.oauth': 'OAuth',
  'connections.tabs.composioKey': 'Composio',
  'connections.groups.apiKeys': 'API 密钥',
  'connections.groups.intelligence': '智能',
  'memory.title': '记忆',
  'memory.search': '搜索记忆...',
  'memory.noResults': '未找到记忆',
  'memory.empty': '暂无记忆。记忆将在你交互时自动创建。',
  'memory.tab.memory': '记忆',
  'memory.tab.memoryTree': '记忆树',
  'memory.tab.tasks': '任务',
  'memory.tab.tasksDescription':
    '创建并跟踪任务：包括您自己的待办事项以及智能体在对话中创建的看板。',
  'memory.tab.subconscious': '潜意识',
  'memory.tab.agentWork': '智能体工作',
  'memory.tab.agentWorkDescription':
    '所有后台智能体运行的指挥中心：按需要你处理的、正在运行的和已完成的进行分组。',
  'memory.tab.worktrees': '工作树',
  'memory.tab.worktreesDescription':
    '来自并行智能体工作进程的隔离 git 工作树：检查更改、打开它们或清理它们。',
  'memory.tab.teams': '团队',
  'memory.tab.teamsDescription':
    '协同的智能体团队：谁负责每项任务、有什么被阻塞，以及队友之间在交流什么。',
  'memory.tab.agents': '资料库',
  'memory.tab.agentsDescription':
    '浏览并运行可用的智能体：每个智能体都有自己的工具、能力和专注领域。',
  'memory.tab.workflows': 'Workflows',
  'memory.tab.workflowsDescription':
    '可复用的可运行流程：目标加上实现步骤。创建一个、从 URL 安装或打开工作流来运行。',
  'memory.tab.dreams': '梦境',
  'memory.tab.calls': '调用记录',
  'memory.tab.diagram': 'Diagram',
  'memory.tab.centrality': 'Centrality',
  'memory.tab.namespaces': '命名空间',
  'memory.tab.timeline': 'Timeline',
  'memory.tab.settings': '设置',
  'memory.analyzeNow': '立即分析',
  'memoryTimeline.title': '记忆时间线',
  'memoryTimeline.intro':
    '助手了解您的时间线：按最后一次强化的月份分组的事实。展示增长、活动高峰和平静期。',
  'memoryTimeline.loading': '正在构建时间线…',
  'memoryTimeline.errorPrefix': '无法加载图谱：',
  'memoryTimeline.retry': 'Retry',
  'memoryTimeline.namespaceLabel': 'Namespace',
  'memoryTimeline.namespaceAll': '所有命名空间',
  'memoryTimeline.empty': '尚无知识图谱。',
  'memoryTimeline.emptyHint': '当助手记录关于您的事实时，时间线将在此显示。',
  'memoryTimeline.metricTotal': 'Facts',
  'memoryTimeline.metricMonths': '活跃月份',
  'memoryTimeline.metricRecent': '最近 30 天',
  'memoryTimeline.heading': '每月学到的事实',
  'memoryTimeline.busiestCaption': '最活跃：{period}（{count}）',
  'memoryTimeline.undatedNote': '{count} 个事实没有记录日期。',
  'memoryTimeline.truncated': '显示最近 {shown}/{total} 个月。',
  'namespaceOverview.title': '命名空间概览',
  'namespaceOverview.intro':
    '您的知识如何在各个上下文中分布：每个命名空间中记录的事实和不同实体的数量。',
  'namespaceOverview.loading': '正在汇总命名空间…',
  'namespaceOverview.errorPrefix': '无法加载图谱：',
  'namespaceOverview.retry': '重试',
  'namespaceOverview.empty': '暂无知识图谱。',
  'namespaceOverview.emptyHint': '随着助手在各个上下文中记录事实，每个命名空间都会显示在这里。',
  'namespaceOverview.metricNamespaces': '命名空间',
  'namespaceOverview.metricFacts': '事实',
  'namespaceOverview.metricEntities': '实体',
  'namespaceOverview.heading': '按命名空间',
  'namespaceOverview.unnamespaced': '(无命名空间)',
  'namespaceOverview.factsLabel': '{count} 条事实',
  'namespaceOverview.entitiesLabel': '{count} 个实体',
  'namespaceOverview.entitiesShort': '{count} 实体',
  'namespaceOverview.truncated': '显示 {total} 个命名空间中的前 {shown} 个。',
  'graphCentrality.title': '知识图谱中心性',
  'graphCentrality.intro':
    '对你的记忆图谱运行 PageRank，可找出关键枢纽以及连接原本分离聚类的连接实体，这是单纯频次统计无法揭示的。',
  'graphCentrality.loading': '正在计算中心性…',
  'graphCentrality.errorPrefix': '无法加载图谱：',
  'graphCentrality.retry': '重试',
  'graphCentrality.empty': '暂无知识图谱。',
  'graphCentrality.emptyHint': '随着助手记录与你相关的事实，连接最多的实体会显示在这里。',
  'graphCentrality.namespaceLabel': '命名空间',
  'graphCentrality.namespaceAll': '所有命名空间',
  'graphCentrality.metricEntities': '实体',
  'graphCentrality.metricConnections': '连接',
  'graphCentrality.metricClusters': '聚类',
  'graphCentrality.clustersCaption': '{components} 个聚类 · 最大聚类包含 {largest}',
  'graphCentrality.approximateBadge': '近似',
  'graphCentrality.approximateTitle': '在完全收敛前达到迭代上限并停止',
  'graphCentrality.rankedHeading': '按影响力排名的热门实体',
  'graphCentrality.colRank': '#',
  'graphCentrality.colEntity': '实体',
  'graphCentrality.colInfluence': '影响力',
  'graphCentrality.colLinks': '链接',
  'graphCentrality.bridgeBadge': '连接点',
  'graphCentrality.bridgeTitle': '连接点，影响力高于其链接数量所暗示的程度',
  'graphCentrality.degreeTitle': '{in} 入 · {out} 出',
  'memory.tab.associations': 'Associations',
  'entityAssociations.title': '实体关联',
  'entityAssociations.intro':
    '共享许多相同连接的实体会被关联：即使没有单一事实直接连接它们。Jaccard 相似度可揭示这些隐含的关联。',
  'entityAssociations.loading': '正在计算关联…',
  'entityAssociations.errorPrefix': '无法加载图谱：',
  'entityAssociations.retry': 'Retry',
  'entityAssociations.empty': '暂无关联。',
  'entityAssociations.emptyHint': '当实体开始共享连接时，最强的关联将在此显示。',
  'entityAssociations.namespaceLabel': 'Namespace',
  'entityAssociations.namespaceAll': '所有命名空间',
  'entityAssociations.metricEntities': 'Entities',
  'entityAssociations.metricPairs': 'Associations',
  'entityAssociations.rankedHeading': '最强关联',
  'entityAssociations.linkedBadge': 'linked',
  'entityAssociations.inferredBadge': 'inferred',
  'entityAssociations.linkedTitle': '这些实体直接相连。',
  'entityAssociations.inferredTitle': '无直接关联：仅通过共享连接推断。',
  'entityAssociations.sharedLabel': '{shared} 个共享',
  'entityAssociations.pairTitle': '{jaccard}% 相似 · 共享 {shared}/{union} 个连接',
  'entityAssociations.truncated': '显示 {shown}/{total}：最强优先。',
  'memory.tab.freshness': 'Freshness',
  'memoryFreshness.title': '知识新鲜度',
  'memoryFreshness.intro':
    '助手近期未重新确认的事实会沿遗忘曲线衰减。这将显示哪些事实正在过时、值得重新核查，以避免将旧事实视为仍然确定。',
  'memoryFreshness.loading': '正在计算新鲜度…',
  'memoryFreshness.errorPrefix': '无法加载图谱：',
  'memoryFreshness.retry': 'Retry',
  'memoryFreshness.empty': '尚无知识图谱。',
  'memoryFreshness.emptyHint': '当助手记录关于您的事实时，其新鲜度将在此跟踪。',
  'memoryFreshness.namespaceLabel': 'Namespace',
  'memoryFreshness.namespaceAll': '所有命名空间',
  'memoryFreshness.metricFresh': 'Fresh',
  'memoryFreshness.metricFading': 'Fading',
  'memoryFreshness.metricStale': 'Stale',
  'memoryFreshness.recallCaption': '在 {total} 个事实中平均召回率 {recall}%',
  'memoryFreshness.queueHeading': '重新确认队列',
  'memoryFreshness.queueTruncated': '显示 {shown}/{total}：请优先处理这些。',
  'memoryFreshness.allFresh': '所有事实仍然新鲜：无需重新确认。',
  'memoryFreshness.statusFading': 'fading',
  'memoryFreshness.statusStale': 'stale',
  'memoryFreshness.ageLabel': '{days} 天前',
  'memoryFreshness.recallTitle': '{recall}% 召回率 · 半衰期 {halfLife} 天',
  'memory.tab.path': '路径',
  'connectionPath.title': '连接路径',
  'connectionPath.intro':
    '追溯连接任意两个实体的最短关系链：看看图谱如何将它们关联起来，即使要跨越多个跳数。',
  'connectionPath.loading': '正在加载图谱…',
  'connectionPath.errorPrefix': '无法加载图谱：',
  'connectionPath.retry': '重试',
  'connectionPath.namespaceLabel': '命名空间',
  'connectionPath.namespaceAll': '所有命名空间',
  'connectionPath.sourceLabel': '起点',
  'connectionPath.targetLabel': '终点',
  'connectionPath.sourcePlaceholder': '起始实体',
  'connectionPath.targetPlaceholder': '结束实体',
  'connectionPath.prompt': '选择两个实体以追溯它们之间的连接方式。',
  'connectionPath.empty': '暂无知识图谱。',
  'connectionPath.emptyHint': '助手记录相关事实后，你就可以在这里追溯连接关系。',
  'connectionPath.resultHeading': '最短路径',
  'connectionPath.pathSummary': '相距 {length} 跳',
  'connectionPath.sameMessage': '请选择两个不同的实体。',
  'connectionPath.missingSource': '“{entity}”不在图谱中。',
  'connectionPath.missingTarget': '“{entity}”不在图谱中。',
  'connectionPath.noPath': '未找到“{source}”与“{target}”之间的连接。',
  'memoryTree.status.title': '记忆树',
  'memoryTree.status.autoSyncLabel': '自动同步',
  'memoryTree.status.autoSyncDescription': '暂停后将停止新的摄取。现有 wiki 仍可查询。',
  'memoryTree.status.statusTile': '状态',
  'memoryTree.status.lastSyncTile': '上次同步',
  'memoryTree.status.totalChunksTile': '分块总数',
  'memoryTree.status.wikiSizeTile': 'Wiki 大小',
  'memoryTree.status.statusRunning': '运行中',
  'memoryTree.status.statusPaused': '已暂停',
  'memoryTree.status.statusSyncing': '同步中',
  'memoryTree.status.statusError': '错误',
  'memoryTree.status.statusIdle': '空闲',
  'memoryTree.status.never': '从未',
  'memoryTree.status.fetchError': '无法获取记忆树状态',
  'memoryTree.status.retry': '重试',
  'memoryTree.status.retryFailed': '重试失败的任务',
  'memoryTree.status.retryFailedBusy': '正在重试...',
  'memoryTree.status.retryFailedDone': '失败的任务已重新排队',
  'memoryTree.status.retryFailedCount': '已有 {count} 个任务重新排队等待运行。',
  'memoryTree.status.retryFailedError': '无法将失败的任务重新排队',
  'memoryTree.status.toggleFailed': '无法切换自动同步',
  'memoryTree.status.justNow': '刚刚',
  'memoryTree.status.secondsAgo': '{count} 秒前',
  'memoryTree.status.minuteAgo': '1 分钟前',
  'memoryTree.status.minutesAgo': '{count} 分钟前',
  'memoryTree.status.hourAgo': '1 小时前',
  'memoryTree.status.hoursAgo': '{count} 小时前',
  'memoryTree.status.dayAgo': '1 天前',
  'memoryTree.status.daysAgo': '{count} 天前',
  'memoryTree.status.integrationsTitle': '各集成状态',
  'memoryTree.status.integrationsEmpty': '未连接任何集成',
  'memoryTree.status.integrationActive': '活跃',
  'memoryTree.status.integrationStale': '过期',
  'memoryTree.status.integrationChunks': '分块: {count}',
  'alerts.title': '通知',
  'alerts.empty': '暂无通知',
  'alerts.markAllRead': '全部标记为已读',
  'alerts.unread': '未读',
  'rewards.title': '奖励',
  'rewards.referrals': '邀请',
  'rewards.coupons': '优惠券',
  'rewards.localUnavailable':
    '本地登录不会获得奖励、优惠券或推荐积分。若要累计奖励，请先登出，然后使用 OpenHuman 账号登录。',
  'rewards.localUnavailableCta': '打开账户设置',
  'rewards.credits': '配额',
  'rewards.referralCode': '你的邀请码',
  'rewards.copyCode': '复制邀请码',
  'rewards.share': '分享',
  'onboarding.welcome': '欢迎使用 OpenHuman',
  'onboarding.welcomeDesc': '只需几步即可完成设置。',
  'onboarding.context': '上下文收集',
  'onboarding.contextDesc': '连接你日常使用的工具与服务。',
  'onboarding.localAI': '本地 AI',
  'onboarding.localAIDesc': '设置一个运行在你本机的 AI 模型。',
  'onboarding.chatProvider': '对话方式',
  'onboarding.chatProviderDesc': '选择你希望如何与助手交互。',
  'onboarding.referral': '邀请码',
  'onboarding.referralDesc': '如果你有邀请码，可以在此使用。',
  'onboarding.finish': '完成设置',
  'onboarding.finishDesc': '一切就绪！开始使用 OpenHuman。',
  'onboarding.skip': '跳过',
  'onboarding.getStarted': '开始使用',
  'onboarding.runtimeChoice.title': '你希望如何运行 OpenHuman？',
  'onboarding.runtimeChoice.subtitle': '选择最适合你的设置。之后可在设置中更改。',
  'onboarding.runtimeChoice.cloud.title': '简单模式',
  'onboarding.runtimeChoice.cloud.tagline': '让 OpenHuman 为你管理一切。',
  'onboarding.runtimeChoice.cloud.f1': '内置安全保护',
  'onboarding.runtimeChoice.cloud.f2': '令牌压缩，让用量更耐用',
  'onboarding.runtimeChoice.cloud.f3': '一个订阅，包含所有模型',
  'onboarding.runtimeChoice.cloud.f4': '无需管理 API 密钥',
  'onboarding.runtimeChoice.cloud.f5': '设置简单',
  'onboarding.runtimeChoice.custom.title': '自定义运行',
  'onboarding.runtimeChoice.custom.tagline': '使用你自己的密钥。完全掌控使用的服务。',
  'onboarding.runtimeChoice.custom.f1': '几乎所有功能都需要 API 密钥',
  'onboarding.runtimeChoice.custom.f2': '可复用你已经付费的服务',
  'onboarding.runtimeChoice.custom.f3': '如果全部本地运行，也可以免费',
  'onboarding.runtimeChoice.custom.f4': '更多设置，更多可调选项',
  'onboarding.runtimeChoice.custom.f5': '最适合高级用户和开发者',
  'onboarding.runtimeChoice.cloud.creditHighlight': '注册即可获得免费额度',
  'onboarding.runtimeChoice.continueCloud': '继续使用简单模式',
  'onboarding.runtimeChoice.continueCustom': '继续使用自定义模式',
  'onboarding.runtimeChoice.recommended': '推荐',
  'onboarding.runtimeChoice.exitError': '无法完成引导流程，请重试。',
  'onboarding.apiKeys.title': '添加你的 API 密钥',
  'onboarding.apiKeys.subtitle':
    '你可以现在粘贴，也可以跳过并稍后在连接 › API 密钥中添加。密钥会加密存储在此设备上。',
  'onboarding.apiKeys.openaiLabel': 'OpenAI API 密钥',
  'onboarding.apiKeys.openaiPlaceholder': 'sk-...',
  'onboarding.apiKeys.openaiOauthHint':
    '使用 ChatGPT Plus/Pro（订阅）或 OpenAI API 密钥：并非两者都需要。',
  'onboarding.apiKeys.openaiOauthOpening': '正在打开登录...',
  'onboarding.apiKeys.openaiOauthConnect': '使用 ChatGPT 登录',
  'onboarding.apiKeys.openaiOauthConnected': '已通过 ChatGPT 连接',
  'onboarding.apiKeys.openaiOauthCallbackHint':
    '登录后，粘贴浏览器中的完整重定向 URL（以 {url} 开头）。',
  'onboarding.apiKeys.oauthDesktopOnly': 'ChatGPT 登录仅在桌面应用中可用。',
  'onboarding.apiKeys.oauthStartFailed': '无法启动 ChatGPT 登录。请重试或使用 API 密钥。',
  'onboarding.apiKeys.oauthPasteRedirect': '登录后，粘贴浏览器中的重定向 URL。',
  'onboarding.apiKeys.oauthCompleteFailed': 'ChatGPT 登录未完成。请检查重定向 URL 并重试。',
  'onboarding.apiKeys.finishSignIn': '完成 ChatGPT 登录',
  'onboarding.apiKeys.orApiKey': '或 API 键',
  'onboarding.apiKeys.anthropicLabel': 'Anthropic API 密钥',
  'onboarding.apiKeys.anthropicPlaceholder': 'sk-ant-...',
  'onboarding.apiKeys.saveError': '无法保存该密钥。请仔细检查后重试。',
  'onboarding.apiKeys.skipForNow': '暂时跳过',
  'onboarding.apiKeys.continue': '保存并继续',
  'onboarding.apiKeys.saving': '保存中…',
  'onboarding.custom.stepperInference': '推理',
  'onboarding.custom.stepperVoice': '语音',
  'onboarding.custom.stepperOAuth': 'OAuth',
  'onboarding.custom.stepperSearch': '搜索',
  'onboarding.custom.stepperEmbeddings': 'Embeddings',
  'onboarding.custom.stepperMemory': '记忆',
  'onboarding.custom.stepCounter': '第 {n} 步，共 {total} 步',
  'onboarding.custom.defaultTitle': '默认',
  'onboarding.custom.defaultSubtitle': '让 OpenHuman 为你管理。',
  'onboarding.custom.configureTitle': '配置',
  'onboarding.custom.configureSubtitle': '我来选择使用什么。',
  'onboarding.custom.progressAriaLabel': '入门进度',
  'onboarding.custom.continue': '继续',
  'onboarding.custom.back': '返回',
  'onboarding.custom.finish': '完成设置',
  'onboarding.custom.configureLater':
    '你可以在入门流程结束后继续配置。完成后，我们会带你前往对应的设置页面。',
  'onboarding.custom.openSettings': '在设置中打开',
  'onboarding.custom.inference.title': '推理（文本）',
  'onboarding.custom.inference.subtitle': '哪个语言模型应该回答你的问题并运行你的智能体？',
  'onboarding.custom.inference.defaultDesc':
    'OpenHuman 会为每种工作负载路由到合适的默认模型。无需密钥，无需设置。',
  'onboarding.custom.inference.configureDesc':
    '使用你自己的 OpenAI 或 Anthropic 密钥。我们会将它用于所有文本类工作负载。',
  'onboarding.custom.voice.title': '语音',
  'onboarding.custom.voice.subtitle': '用于语音模式的语音转文本和文本转语音。',
  'onboarding.custom.voice.defaultDesc': 'OpenHuman 内置托管的 STT/TTS，开箱即用。无需额外配置。',
  'onboarding.custom.voice.configureDesc':
    '使用你自己的 ElevenLabs、OpenAI Whisper 等服务。在设置 › 语音中配置。',
  'onboarding.custom.oauth.title': '连接（OAuth）',
  'onboarding.custom.oauth.subtitle': 'Gmail、Slack、Notion 以及其他需要 OAuth 的连接服务。',
  'onboarding.custom.oauth.defaultDesc':
    'OpenHuman 使用托管的 Composio 工作区。之后每个服务都可一键连接。',
  'onboarding.custom.oauth.configureDesc':
    '使用你自己的 Composio 账户或 API 密钥。在设置 › 连接中配置。',
  'onboarding.custom.search.title': '网页搜索',
  'onboarding.custom.search.subtitle': 'OpenHuman 如何代表你搜索网页。',
  'onboarding.custom.search.defaultDesc': 'OpenHuman 使用托管搜索后端。无需密钥。',
  'onboarding.custom.search.configureDesc':
    '使用你自己的搜索提供商密钥（Tavily、Brave 等）。在设置 › 工具中配置。',
  'onboarding.custom.embeddings.title': 'Embeddings',
  'onboarding.custom.embeddings.subtitle': 'OpenHuman 生成向量嵌入以实现语义记忆搜索的方式。',
  'onboarding.custom.embeddings.defaultDesc': 'OpenHuman 使用托管嵌入服务，无需 API 密钥。',
  'onboarding.custom.embeddings.configureDesc':
    '使用您自己的嵌入服务提供商（OpenAI、Voyage、Ollama 等）。',
  'onboarding.custom.memory.title': '记忆',
  'onboarding.custom.memory.subtitle': 'OpenHuman 如何记住你的上下文、偏好和历史对话。',
  'onboarding.custom.memory.defaultDesc': 'OpenHuman 会自动管理记忆存储和检索。无需设置。',
  'onboarding.custom.memory.configureDesc': '你可以自行查看、导出或清除记忆。在设置 › 记忆中配置。',
  'accounts.addAccount': '添加账户',
  'accounts.addApps': '添加应用',
  'accounts.manageAccounts': '管理账户',
  'accounts.noAccounts': '未连接任何账户',
  'accounts.connectAccount': '连接一个账户以开始使用',
  'accounts.agent': '助手',
  'accounts.respondQueue': '回复队列',
  'accounts.disconnect': '断开连接',
  'accounts.disconnectConfirm': '确定要断开此账户的连接吗？',
  'accounts.disconnectClearMemory': '同时删除来自此来源的记忆',
  'accounts.disconnectClearMemoryHint': '永久删除与此连接关联的本地记忆片段。',
  'accounts.searchAccounts': '搜索账户...',
  'channels.title': '渠道',
  'channels.configure': '配置渠道',
  'channels.setup': '设置渠道',
  'channels.noChannels': '未配置任何渠道',
  'channels.localManagedUnavailable': '本地用户无法使用托管频道。',
  'channels.addChannel': '添加渠道',
  'channels.status.connected': '已连接',
  'channels.status.disconnected': '已断开',
  'channels.status.error': '错误',
  'channels.status.configuring': '配置中',
  'channels.defaultMessaging': '默认消息渠道',
  'channels.setAsDefault': '设为默认',
  'channels.defaultBadge': '默认',
  'webhooks.title': 'Webhook',
  'webhooks.create': '创建 Webhook',
  'webhooks.noWebhooks': '未配置任何 Webhook',
  'webhooks.url': 'URL',
  'webhooks.secret': '密钥',
  'webhooks.events': '事件',
  'webhooks.archiveDirectory': '归档目录',
  'webhooks.todayFile': '今日文件',
  'invites.title': '邀请',
  'invites.create': '创建邀请',
  'invites.noInvites': '暂无待处理的邀请',
  'invites.code': '邀请码',
  'invites.copyLink': '复制链接',
  'invites.generate': '生成邀请',
  'invites.generating': '生成...',
  'invites.refreshing': '正在刷新邀请...',
  'invites.loading': '正在加载邀请...',
  'invites.copyCodeAria': '复制邀请码',
  'invites.revokeAria': '撤销邀请',
  'invites.usedUp': '用完',
  'invites.uses': '用途： {current}{max}',
  'invites.expiresOn': '过期 {date}',
  'invites.empty': '还没有邀请',
  'invites.emptyHint': '生成邀请码与他人分享',
  'invites.revokeTitle': '撤销邀请码',
  'invites.revokePromptPrefix': '您确定要撤销邀请码吗',
  'invites.revokeWarning': '此邀请码将失效，无法再用于加入团队。',
  'invites.revoking': '撤销...',
  'invites.revokeAction': '撤销邀请',
  'invites.failedGenerate': '生成邀请失败',
  'invites.failedRevoke': '撤销邀请失败',
  'team.refreshingMembers': '正在刷新会员...',
  'team.loadingMembers': '正在加载会员...',
  'team.memberCount': '{count} 成员',
  'team.memberCountPlural': '{count} 成员',
  'team.you': '（你）',
  'team.removeAria': '删除 {name}',
  'team.noMembers': '没有找到会员',
  'team.removeTitle': '删除团队成员',
  'team.removePromptPrefix': '您确定要删除吗',
  'team.removePromptSuffix': '来自团队？',
  'team.removeWarning': '他们将失去对团队及所有团队资源的访问权限。',
  'team.removing': '正在删除...',
  'team.removeAction': '删除会员',
  'team.changeRoleTitle': '更改成员角色',
  'team.changeRolePrompt': '将 {name} 的角色从 {oldRole} 更改为 {newRole}？',
  'team.changeRoleAdminGrant': '此操作将授予其完整管理员权限，包括管理团队成员的能力。',
  'team.changeRoleAdminRemove': '此操作将撤销其管理员权限，其将无法再管理团队。',
  'team.changing': '改变...',
  'team.changeRoleAction': '改变角色',
  'team.failedChangeRole': '角色变更失败',
  'team.failedRemoveMember': '删除会员失败',
  'devOptions.title': '开发者选项',
  'devOptions.titleDiagnostics': '开发者与诊断',
  'devOptions.diagnostics': '诊断',
  'devOptions.diagnosticsDesc': '系统健康、日志与性能指标',
  'devOptions.toolPolicyDiagnosticsDesc': '工具清单、策略态势、MCP 允许列表和近期拦截',
  'devOptions.toolPolicyDiagnostics.loading': '加载中…',
  'devOptions.toolPolicyDiagnostics.unavailable': '诊断不可用',
  'devOptions.toolPolicyDiagnostics.posture.title': '策略态势',
  'devOptions.toolPolicyDiagnostics.posture.autonomy': '自主性：',
  'devOptions.toolPolicyDiagnostics.posture.workspaceOnly': '仅工作区：',
  'devOptions.toolPolicyDiagnostics.posture.maxActionsPerHour': '最大操作数/小时：',
  'devOptions.toolPolicyDiagnostics.posture.approvalMediumRisk': '审批（中等风险）：',
  'devOptions.toolPolicyDiagnostics.posture.blockHighRisk': '阻止高风险：',
  'devOptions.toolPolicyDiagnostics.inventory.title': '清单',
  'devOptions.toolPolicyDiagnostics.inventory.totalTools': '工具总数',
  'devOptions.toolPolicyDiagnostics.inventory.enabledTools': '已启用工具',
  'devOptions.toolPolicyDiagnostics.inventory.mcpStdioTools': 'MCP stdio 工具',
  'devOptions.toolPolicyDiagnostics.inventory.jsonRpcTools': 'JSON-RPC 工具',
  'devOptions.toolPolicyDiagnostics.mcpAllowlists.title': 'MCP 允许列表',
  'devOptions.toolPolicyDiagnostics.mcpAllowlists.summary':
    '已启用：{enabled} · 服务器：{enabledCount}/{totalCount}',
  'devOptions.toolPolicyDiagnostics.mcpAllowlists.unnamed': '<未命名>',
  'devOptions.toolPolicyDiagnostics.mcpAllowlists.allowDeny': '允许={allowCount} 拒绝={denyCount}',
  'devOptions.toolPolicyDiagnostics.mcpWriteAudit.title': 'MCP 写入审计',
  'devOptions.toolPolicyDiagnostics.mcpWriteAudit.summary':
    '已启用：{enabled} · 最近（24 小时）：{recentRows}',
  'devOptions.toolPolicyDiagnostics.recentBlocked.title': '最近被拦截的调用',
  'devOptions.toolPolicyDiagnostics.recentBlocked.empty': '没有记录到被拦截的调用。',
  'devOptions.toolPolicyDiagnostics.redactedSurfaces.title': '已脱敏表面',
  'devOptions.toolPolicyDiagnostics.redactedSurfaces.summary':
    '可写：{writeCount} · 策略表面：{policyCount}',
  'devOptions.debugPanels': '调试面板',
  'devOptions.debugPanelsDesc': '功能开关、状态检查与调试工具',
  'devOptions.webhooks': 'Webhook',
  'devOptions.webhooksDesc': '配置并测试 Webhook 集成',
  'devOptions.memoryInspection': '记忆检查',
  'devOptions.memoryInspectionDesc': '浏览、查询与管理记忆条目',
  'voice.pushToTalk': '按住说话',
  'voice.recording': '录音中...',
  'voice.processing': '处理中...',
  'voice.languageHint': '语言',
  'misc.rehydrating': '正在加载你的数据...',
  'misc.checkingServices': '正在检查服务...',
  'misc.serviceUnavailable': '服务不可用',
  'misc.somethingWentWrong': '出现了一些问题',
  'misc.tryAgainLater': '请稍后重试。',
  'misc.restartApp': '重启应用',
  'misc.updateAvailable': '发现新版本',
  'misc.updateNow': '立即更新',
  'misc.updateLater': '稍后再说',
  'misc.downloading': '下载中...',
  'misc.installing': '安装中...',
  'misc.beta': '测试版',
  'misc.betaFeedback': '发送反馈',
  'mnemonic.title': '恢复短语',
  'mnemonic.warning': '按顺序记下这些单词，并将其保存在安全的地方。',
  'mnemonic.copyWarning': '永远不要分享你的恢复短语。任何拥有这些单词的人都可以访问你的账户。',
  'mnemonic.copied': '恢复短语已复制到剪贴板',
  'mnemonic.reveal': '显示短语',
  'mnemonic.revealPhrase': '显示恢复助记词',
  'mnemonic.hidden': '恢复短语已隐藏',
  'privacy.title': '隐私与安全',
  'privacy.description': '发送到外部服务的数据透明度报告。',
  'privacy.empty': '未检测到外部数据传输。',
  'privacy.whatLeavesComputer': '离开你电脑的数据',
  'privacy.loading': '正在加载隐私详情...',
  'privacy.loadError': '无法加载实时隐私列表。下方的分析控件仍然可用。',
  'privacy.noCapabilities': '当前没有功能披露数据移动。',
  'privacy.sentTo': '发送至',
  'privacy.leavesDevice': '离开设备',
  'privacy.staysLocal': '留在本地',
  'privacy.anonymizedAnalytics': '产品分析',
  'privacy.shareAnonymizedData': '分享产品分析和诊断数据',
  'privacy.shareAnonymizedDataDesc':
    '通过分享受隐私限制的崩溃报告和使用事件来帮助改进 OpenHuman，其中包括稳定的账号 ID 和应用版本元数据。我们绝不会收集消息、钱包密钥、API 密钥或会话令牌。',
  'privacy.meetingFollowUps': '会议跟进',
  'privacy.autoHandoffMeet': '自动将 Google Meet 转录交给编排器',
  'privacy.autoHandoffMeetDesc':
    '当 Google Meet 通话结束时，OpenHuman 的编排器可以阅读转录内容，并可能执行起草消息、安排跟进、或将摘要发布到已连接的 Slack 工作区等操作。默认关闭。',
  'privacy.analyticsDisclaimer':
    '启用后，产品分析和诊断可能包括受隐私限制的崩溃报告和使用事件、稳定的账号 ID，以及应用版本元数据。我们绝不会收集消息、钱包密钥、API 密钥或会话令牌。你可以随时更改此设置。',
  'settings.about.version': '版本',
  'settings.about.updateAvailable': '可用',
  'settings.about.softwareUpdates': '软件更新',
  'settings.about.lastChecked': '上次检查',
  'settings.about.checking': '检查中...',
  'settings.about.checkForUpdates': '检查更新',
  'settings.about.releases': '发布版本',
  'settings.about.releasesDesc': '在 GitHub 上浏览发布说明和早期版本。',
  'settings.about.openReleases': '打开 GitHub 发布',
  'settings.about.starCta.title': '喜欢 OpenHuman 吗？',
  'settings.about.starCta.body': '在 GitHub 上给我们点个星，这能帮助更多人发现我们。',
  'settings.about.starCta.star': '在 GitHub 上加星',
  'settings.about.starCta.dismiss': '暂不',
  'settings.about.connection': '连接方式',
  'settings.about.connectionMode': '模式',
  'settings.about.connectionModeLocal': '本地',
  'settings.about.connectionModeCloud': '云',
  'settings.about.connectionModeUnset': '未选择',
  'settings.about.serverUrl': '服务器 URL',
  'settings.about.serverUrlUnavailable': '不可用',
  'settings.about.connectionHelperLocal':
    '应用启动时由 Tauri shell 在进程内启动。端口会在启动时选择，因此此 URL 每次启动都可能变化。',
  'settings.about.connectionHelperCloud': '已连接到远程核心。可在 BootCheck 或云模式选择器中更改。',
  'settings.heartbeat.title': '心跳和循环',
  'settings.usage.title': '用量与限制',
  'settings.usage.menuDesc': '费用、token 使用量、预算和后台活动',
  'settings.costDashboard.title': '成本看板',
  'settings.costDashboard.sevenDayCost': '7 天每日成本',
  'settings.costDashboard.sevenDayTokens': '7 天 token 用量',
  'settings.costDashboard.totalSpend': '7 天总计',
  'settings.costDashboard.monthlyPace': '月度节奏',
  'settings.costDashboard.budgetLimit': '预算上限',
  'settings.costDashboard.utilization': '利用率',
  'settings.costDashboard.modelBreakdown': '按模型拆分',
  'settings.costDashboard.model': '模型',
  'settings.costDashboard.provider': '提供商',
  'settings.costDashboard.cost': '成本',
  'settings.costDashboard.tokens': 'Token',
  'settings.costDashboard.requests': '请求',
  'settings.costDashboard.percentOfTotal': '占总量百分比',
  'settings.costDashboard.inputTokens': '输入',
  'settings.costDashboard.outputTokens': '输出',
  'settings.costDashboard.budgetNormal': '进度正常',
  'settings.costDashboard.budgetWarning': '警告',
  'settings.costDashboard.budgetExceeded': '超出预算',
  'settings.costDashboard.noBudget': '未设置上限',
  'settings.costDashboard.noData': '过去 7 天尚无成本记录。',
  'settings.costDashboard.noModels': '过去 7 天没有模型活动。',
  'settings.costDashboard.loading': '正在加载成本看板…',
  'settings.costDashboard.disabledHint':
    '成本看板已在配置中禁用。请在 config.toml 中设置 [cost.dashboard] enabled = true 以重新启用。',
  'settings.costDashboard.subtitle':
    '集群实时支出和 token 消耗。条形图每隔几秒自动刷新，无需重新加载页面。',
  'settings.costDashboard.summaryAriaLabel': '成本汇总指标',
  'settings.costDashboard.lastSevenDays': '过去 7 天',
  'settings.costDashboard.utilizationOf': '/',
  'settings.costDashboard.thisMonth': '本月',
  'settings.costDashboard.monthlyPaceHint': '按当前每日运行速率预计的月支出（平均值 × 30）。',
  'settings.costDashboard.budgetLimitHint':
    '从 config.toml 的 cost.monthly_limit_usd 读取月度预算。',
  'settings.costDashboard.dailyTarget': '每日目标',
  'settings.costDashboard.today': '今天',
  'settings.costDashboard.todayBadge': '今天',
  'settings.costDashboard.unknownProvider': '无',
  'settings.costDashboard.justNow': '刚刚',
  'settings.costDashboard.secondsAgo': '{value} 秒前',
  'settings.costDashboard.minutesAgo': '{value} 分钟前',
  'settings.costDashboard.hoursAgo': '{value} 小时前',
  'settings.costDashboard.daysAgo': '{value} 天前',
  'settings.costDashboard.updated': '已更新',
  'settings.costDashboard.refresh': '刷新',
  'settings.costDashboard.utcNote': '按 UTC 日期分组',
  'settings.costDashboard.stackedNote': '输入 + 输出堆叠',
  'settings.costDashboard.modelBreakdownHint': '汇总过去 7 天。',
  'settings.costDashboard.categoryDistribution': '按类别的花费',
  'settings.costDashboard.categoryDistributionHint':
    '根据最近的聊天、嵌入、语音、图像和重排调用记录推断。',
  'settings.costDashboard.noCategories': '尚未记录类别花费。',
  'settings.costDashboard.categoryMeta': '{requests} 次请求 • {tokens} 个 token',
  'settings.costDashboard.usageLog': '使用日志',
  'settings.costDashboard.usageLogHint': '最近 {days} 天的最新记录，最多显示 {limit} 行。',
  'settings.costDashboard.logTotal': '{requests} 次请求 • {cost}',
  'settings.costDashboard.noUsageLog': '此期间没有找到使用记录。',
  'settings.costDashboard.when': '时间',
  'settings.costDashboard.category': '类别',
  'settings.costDashboard.session': '会话',
  'settings.costDashboard.noDataHint':
    '发送一条智能体消息后，下一次提供商调用的 token 用量会在约 10 秒内填充图表。',
  'settings.search.title': '搜索引擎',
  'settings.search.menuDesc': '默认使用 OpenHuman 托管搜索，或用 API 密钥接入你自己的提供商。',
  'settings.search.description':
    '选择智能体使用的搜索引擎。托管模式使用 OpenHuman 后端（无需设置）。Parallel、Brave、Querit 和 Exa 会用你的 API 密钥从本机直接调用。',
  'settings.search.engineAria': '搜索引擎',
  'settings.search.engineDisabledLabel': 'Disabled',
  'settings.search.engineDisabledDesc': '从智能体上下文和可用工具列表中移除搜索工具。',
  'settings.search.engineManagedLabel': 'OpenHuman 托管',
  'settings.search.engineManagedDesc':
    '默认选项。通过 OpenHuman 后端路由，当前由 Exa 提供支持，无需 API 密钥。',
  'settings.search.localManagedUnavailable':
    '本地用户无法使用 OpenHuman 托管搜索。请添加你自己的 Parallel、Brave、Querit 或 Exa API 密钥以启用网页搜索。',
  'settings.search.engineParallelLabel': 'Parallel',
  'settings.search.engineParallelDesc':
    '直接调用 Parallel API：搜索、提取、聊天、研究、增强和数据集工具。',
  'settings.search.engineBraveLabel': 'Brave 搜索',
  'settings.search.engineBraveDesc': '直接Brave 搜索API：网络、新闻、图像和视频工具。',
  'settings.search.engineQueritLabel': 'Querit',
  'settings.search.engineQueritDesc':
    '直接调用 Querit API：支持站点、时间范围、国家/地区和语言筛选的网页搜索。',
  'settings.search.engineExaLabel': 'Exa',
  'settings.search.engineExaDesc':
    '由 Exa 提供的神经搜索。需要你自己的 Exa API 密钥。新增搜索、查找相似页面和获取页面内容工具。',
  'settings.search.statusConfigured': '已配置',
  'settings.search.statusNeedsKey': '需要 API 密钥',
  'settings.search.fallbackToManaged': '未配置密钥，保存密钥前搜索会回退到托管模式。',
  'settings.search.getApiKey': '获取 API 密钥',
  'settings.search.save': '保存',
  'settings.search.clear': '清除',
  'settings.search.show': '显示',
  'settings.search.hide': '隐藏',
  'settings.search.statusSaving': '正在保存...',
  'settings.search.statusSaved': '已保存。',
  'settings.search.statusError': '失败',
  'settings.search.parallelKeyLabel': 'Parallel API 键',
  'settings.search.braveKeyLabel': 'Brave 搜索 API 键',
  'settings.search.queritKeyLabel': 'Querit API 键',
  'settings.search.exaKeyLabel': 'Exa API 密钥',
  'settings.search.placeholderStored': '••••••••（已存储）',
  'settings.search.placeholderParallel': 'PK_...',
  'settings.search.placeholderBrave': 'BSA...',
  'settings.search.placeholderQuerit': 'Querit API 密钥',
  'settings.search.placeholderExa': '粘贴你的 Exa API 密钥…',
  'settings.search.allowedSitesLabel': '允许的网站',
  'settings.search.allowedSitesHint':
    '助手在研究时可以打开并阅读的网站（每行一个主机，例如 reuters.com）。主机也包含其子域名。留空将阻止所有网页访问。',
  'settings.search.allowedSitesAllOn': '助手可以打开任何公开网站。本地和私有地址仍会被阻止。',
  'settings.search.allowedSitesPlaceholder': 'reuters.com\napnews.com\ngithub.com',
  'settings.search.allowedSitesSave': '保存网站',
  'settings.search.accessModeAria': '网页访问模式',
  'settings.search.accessAllowAll': '全部允许',
  'settings.search.accessCustom': '自定义',
  'settings.search.accessBlockAll': '全部阻止',
  'settings.search.accessBlockAllHint': '所有网页访问都已阻止，助手无法打开或阅读任何网站。',
  // ─── Settings global search bar ────────────────────────────
  'settings.settingsSearch.placeholder': '搜索设置…',
  'settings.settingsSearch.ariaLabel': '搜索设置',
  'settings.settingsSearch.clear': '清除搜索',
  'settings.settingsSearch.resultsLabel': '搜索结果',
  'settings.settingsSearch.noResults': '未找到与“{query}”匹配的设置',
  'settings.embeddings.title': '向量嵌入',
  'settings.embeddings.description':
    '选择将记忆转换为语义搜索向量的嵌入提供商。更改提供商、模型或维度会使已存储的向量无效，需要完全重置记忆。',
  'settings.embeddings.providerAria': '嵌入提供商',
  'settings.embeddings.statusConfigured': '已配置',
  'settings.embeddings.statusNeedsKey': '需要 API 密钥',
  'settings.embeddings.requiresSignIn': '需要登录 OpenHuman',
  'settings.embeddings.managedLoginRequired':
    '托管嵌入需要登录 OpenHuman。请登录后使用 OpenHuman 后端。',
  'settings.embeddings.managedBannerIntro':
    '托管嵌入会通过 OpenHuman 后端，并且需要 OpenHuman 账号会话。',
  'settings.embeddings.managedBannerLocalSession':
    '退出本地会话并登录即可使用此提供商，或切换到本地/自带密钥的嵌入提供商。',
  'settings.embeddings.managedBannerRemoteSession':
    '重新登录以刷新 OpenHuman 会话，或切换到本地/自带密钥的嵌入提供商。',
  'settings.embeddings.signInAgain': '重新登录',
  'settings.embeddings.apiKeyLabel': '{provider} API 密钥',
  'settings.embeddings.apiKeyLabelGeneric': 'API 密钥',
  'settings.embeddings.placeholderStored': '••••••••（已存储）',
  'settings.embeddings.placeholderKey': '粘贴您的 API 密钥…',
  'settings.embeddings.keyStoredEncrypted': '您的 API 密钥已加密存储在此设备上。',
  'settings.embeddings.show': '显示',
  'settings.embeddings.hide': '隐藏',
  'settings.embeddings.save': '保存',
  'settings.embeddings.clear': '清除',
  'settings.embeddings.model': '模型',
  'settings.embeddings.dimensions': '维度',
  'settings.embeddings.customEndpoint': '自定义端点',
  'settings.embeddings.customModelPlaceholder': '模型名称',
  'settings.embeddings.customDimsPlaceholder': '维度',
  'settings.embeddings.applyCustom': '应用',
  'settings.embeddings.testConnection': '测试连接',
  'settings.embeddings.testing': '测试中…',
  'settings.embeddings.testSuccess': '已连接：{dims} 维度',
  'settings.embeddings.connectionTestFailed': '测试失败',
  'settings.embeddings.verifyFallback':
    '无法验证嵌入端点。请确认其正在运行并提供嵌入模型，然后重新保存。',
  'settings.embeddings.testFailed': '失败：{error}',
  'settings.embeddings.saving': '保存中…',
  'settings.embeddings.saved': '已保存。',
  'settings.embeddings.errorPrefix': '失败',
  'settings.embeddings.wipeTitle': '重置记忆向量？',
  'settings.embeddings.wipeBody':
    '更改嵌入提供商、模型或维度将删除所有已存储的记忆向量。记忆必须重新构建后检索才能再次工作。此操作无法撤消。',
  'settings.embeddings.cancel': '取消',
  'settings.embeddings.confirmWipe': '清除并应用',
  'settings.embeddings.setupTitle': '设置 {provider}',
  'settings.embeddings.saveAndSwitch': '保存并切换',
  'settings.embeddings.optional': '可选',
  'settings.embeddings.vectorSearchDisabled':
    '向量搜索已禁用。记忆召回将只使用关键词匹配和时间新近度，不进行语义排序。',
  'settings.embeddings.clearKey': '清除 API 密钥',
  'pages.settings.ai.embeddings': '向量嵌入',
  'pages.settings.ai.embeddingsDesc': '用于记忆检索的向量编码模型',
  'mcp.alphaBadge': '阿尔法',
  'mcp.alphaBannerText':
    'MCP 服务器支持仍处于早期 alpha 阶段。注册表、安装流程和工具接线在不同版本间可能异常或发生变化。',
  'mcp.toolList.noTools': '没有可用的工具。',
  'mcp.setup.secretDialog.title': 'MCP 设置：输入密码',
  'mcp.setup.secretDialog.bodyPrefix': 'MCP 设置代理需要',
  'mcp.setup.secretDialog.bodySuffix': '。你的值会直接发送到核心进程，绝不会进入 AI 对话。',
  'mcp.setup.secretDialog.inputLabel': '值',
  'mcp.setup.secretDialog.inputPlaceholder': '粘贴在这里',
  'mcp.setup.secretDialog.show': '显示',
  'mcp.setup.secretDialog.hide': '隐藏',
  'mcp.setup.secretDialog.submit': '提交',
  'mcp.setup.secretDialog.cancel': '取消',
  'mcp.setup.secretDialog.submitting': '正在提交...',
  'mcp.setup.secretDialog.errorPrefix': '提交失败：',
  'mcp.setup.secretDialog.privacyNote':
    '会加密存储在本地 MCP 密钥表中。绝不记录到日志，也不会发送给模型。',
  'devices.betaBadge': '贝塔',
  'devices.betaText': '此功能目前处于测试阶段。将 iOS 手机与此 OpenHuman 配对，以用作远程客户端。',
  'devices.comingSoonDescription': '设备配对即将推出。此页面将用于配对 iPhone 并管理已连接设备。',
  'devices.title': '设备',
  'devices.pairIphone': '配对 iPhone',
  'devices.noPaired': '没有配对的设备',
  'devices.emptyState': '扫描 iPhone 上的 QR code 将其连接到此 OpenHuman 会话。',
  'devices.devicePairedTitle': '设备已配对',
  'devices.devicePairedMessage': 'iPhone 连接成功。',
  'devices.deviceRevokedTitle': '设备已撤销',
  'devices.deviceRevokedMessage': '{label} 已删除。',
  'devices.revokeFailedTitle': '撤销失败',
  'devices.online': '在线',
  'devices.offline': '离线',
  'devices.lastSeenNever': '从来没有',
  'devices.lastSeenNow': '刚才',
  'devices.lastSeenMinutes': '{count}分钟前',
  'devices.lastSeenHours': '{count} 小时前',
  'devices.lastSeenDays': '{count} 天前',
  'devices.revoke': '撤销',
  'devices.revokeAria': '撤销 {label}',
  'devices.confirmRevokeTitle': '撤销设备？',
  'devices.confirmRevokeBody': '{label} 将无法再连接。此操作无法撤消。',
  'devices.loadFailed': '无法加载设备：{message}',
  'devices.pairModal.title': '配对 iPhone',
  'devices.pairModal.loading': '正在生成配对代码...',
  'devices.pairModal.instructions': '打开 iPhone 上的 OpenHuman 应用程序并扫描此代码。',
  'devices.pairModal.expiresIn': '代码将在 ~{count} 分钟后过期',
  'devices.pairModal.expiresInPlural': '代码将在 ~{count} 分钟后过期',
  'devices.pairModal.showDetails': '显示详情',
  'devices.pairModal.hideDetails': '隐藏详细信息',
  'devices.pairModal.channelId': '通道号',
  'devices.pairModal.pairingUrl': '配对URL',
  'devices.pairModal.expiredTitle': 'QR code 已过期',
  'devices.pairModal.expiredBody': '生成新代码以继续配对。',
  'devices.pairModal.generateNewCode': '生成新代码',
  'devices.pairModal.successTitle': '与 iPhone 配对',
  'devices.pairModal.autoClose': '自动关闭...',
  'devices.pairModal.errorPrefix': '无法创建配对：{message}',
  'devices.pairModal.errorTitle': '出了点问题',
  'devices.pairModal.copyUrl': '复制',
  'mcp.catalog.searchAria': '搜索锻造目录',
  'mcp.catalog.searchPlaceholder': '搜索锻造目录...',
  'mcp.catalog.loadFailed': '加载目录失败',
  'mcp.registry.error.notFound':
    '在注册表中找不到该服务器。请检查服务器名称后重试，也可以浏览可用的 MCP 服务器，或通过 URL 手动添加服务器。',
  'mcp.registry.error.network':
    '无法连接到 MCP 注册表。请检查网络连接后重试，或通过 URL 手动添加服务器。',
  'mcp.registry.error.unavailable':
    'MCP 注册表暂时不可用。请稍后重试，也可以浏览可用的 MCP 服务器，或通过 URL 手动添加服务器。',
  'mcp.catalog.noResults': '未找到服务器。',
  'mcp.catalog.noResultsFor': '找不到“{query}”的服务器。',
  'mcp.catalog.loadMore': '加载更多',
  'mcp.configAssistant.title': '配置助手',
  'mcp.configAssistant.empty': '询问配置、所需的环境变量或设置步骤。',
  'mcp.configAssistant.autoPromptCta': '获取分步设置帮助',
  'mcp.configAssistant.suggestedValues': '建议值：',
  'mcp.configAssistant.valueHidden': '（隐藏值）',
  'mcp.configAssistant.applySuggested': '应用建议值',
  'mcp.configAssistant.reinstallHint': '使用这些值重新安装以应用它们。',
  'mcp.configAssistant.thinking': '想着……',
  'mcp.configAssistant.inputPlaceholder': '提出问题（Enter 发送，Shift+Enter 换行）',
  'mcp.configAssistant.send': '发送',
  'mcp.configAssistant.failedResponse': '未能得到回复',
  'mcp.toolList.availableSingular': '{count} 工具可用',
  'mcp.toolList.availablePlural': '{count} 可用工具',
  'mcp.toolList.tryTool': '试用',
  'mcp.toolList.tryToolAria': '打开 {name} 的执行试验场',
  'mcp.playground.title': '运行 {name}',
  'mcp.playground.close': '关闭试验场',
  'mcp.playground.inputSchema': '输入 schema',
  'mcp.playground.argsLabel': '参数（JSON）',
  'mcp.playground.argsHelp': '输入符合输入 schema 的 JSON。空输入会按 {} 处理。',
  'mcp.playground.runShortcut': '⌘/Ctrl + Enter 运行',
  'mcp.playground.format': '格式化',
  'mcp.playground.invalidJson': '无效 JSON',
  'mcp.playground.run': '运行工具',
  'mcp.playground.running': '运行中…',
  'mcp.playground.result': '结果',
  'mcp.playground.resultError': '工具返回错误',
  'mcp.playground.copyResult': '复制结果',
  'mcp.playground.copied': '已复制',
  'mcp.playground.history': '历史',
  'mcp.playground.historyEmpty': '此会话中尚无调用。',
  'mcp.playground.historyLoad': '加载',
  'mcp.playground.unexpectedError': '调用工具时出现意外错误。',
  'mcp.catalog.deployed': '已部署',
  'mcp.catalog.installCount': '{count} 安装',
  'app.update.dismissNotification': '关闭更新通知',
  'bootCheck.rpcAuthSuffix': '在每个 RPC 上。',
  'app.localAiDownload.expandAria': '展开下载进度',
  'app.localAiDownload.collapseAria': '折叠下载进度',
  'app.localAiDownload.dismissAria': '关闭下载通知',
  'mobile.nav.ariaLabel': '手机导航',
  'progress.stepsAria': '进度步骤',
  'progress.stepAria': '{total} 的步骤 {current}',
  'workspace.vaultsTitle': '知识库',
  'workspace.vaultsDesc': '指向本地文件夹；文件被分块并镜像到内存中。',
  'calls.title': '通话',
  'calls.comingSoonBody': '人工智能辅助通话即将推出。敬请关注。',
  'art.rotatingTetrahedronAria': '旋转倒四面体航天器',
  'mcp.installed.title': '已安装',
  'mcp.installed.browseCatalog': '浏览目录',
  'mcp.installed.empty': '尚未安装 MCP 服务器。',
  'mcp.installed.toolSingular': '{count} 工具',
  'mcp.installed.toolPlural': '{count} 工具',
  'mcp.health.title': '健康状态',
  'mcp.health.summaryAria': 'MCP 连接健康状态摘要',
  'mcp.health.connectedCount': '{count} 个已连接',
  'mcp.health.connectingCount': '{count} 个连接中',
  'mcp.health.errorCount': '{count} 个错误',
  'mcp.health.disconnectedCount': '{count} 个空闲',
  'mcp.health.retryAll': '全部重试（{count}）',
  'mcp.health.retryAllAria': '重试全部 {count} 个出错的 MCP 服务器',
  'mcp.health.disconnectAll': '全部断开（{count}）',
  'mcp.health.disconnectAllAria': '断开全部 {count} 个已连接的 MCP 服务器',
  'mcp.health.disconnectConfirm.title': '断开所有 MCP 服务器？',
  'mcp.health.disconnectConfirm.body':
    '这会断开当前已连接的 {count} 个 MCP 服务器。已安装配置和密钥会保留，你之后可以重新连接任意服务器。',
  'mcp.health.disconnectConfirm.cancel': '取消',
  'mcp.health.disconnectConfirm.confirm': '全部断开',
  'mcp.health.opErrorGeneric': '批量操作失败。请查看日志。',
  'mcp.health.bulkPartialFailure': '{total} 个服务器中有 {failed} 个发生故障。请查看日志。',
  'mcp.installed.search.landmarkAria': '搜索已安装的 MCP 服务器',
  'mcp.installed.search.inputAria': '按名称筛选已安装的 MCP 服务器',
  'mcp.installed.search.placeholder': '筛选服务器…',
  'mcp.installed.search.clearAria': '清除筛选',
  'mcp.installed.search.countMatches': '{shown} / {total} 个服务器',
  'mcp.installed.search.noMatches': '没有服务器匹配“{query}”。',
  'mcp.inventory.openButton': '清单',
  'mcp.inventory.openAria': '打开可分享的 MCP 清单面板',
  'mcp.inventory.title': '可分享的 MCP 清单',
  'mcp.inventory.subtitle':
    '将已安装的 MCP 服务器导出为可移植且不含密钥的 manifest，或从队友处导入。密钥环境值绝不会被包含或导入。',
  'mcp.inventory.close': '关闭清单面板',
  'mcp.inventory.tablistAria': '清单分区',
  'mcp.inventory.tab.export': '导出',
  'mcp.inventory.tab.import': '导入',
  'mcp.inventory.export.empty': '尚未安装 MCP 服务器，没有可导出的内容。请先从目录安装一个。',
  'mcp.inventory.export.privacyTitle': '此 manifest 包含的内容',
  'mcp.inventory.export.privacyBody':
    '仅包含服务器名称、限定名称、环境变量 KEY 名称和非密钥配置。密钥值、机器标识符和每次安装的时间戳会被有意移除。',
  'mcp.inventory.export.serverCount': '此 manifest 中有 {count} 个服务器',
  'mcp.inventory.export.copy': '复制',
  'mcp.inventory.export.copied': '已复制',
  'mcp.inventory.export.copyAria': '将 manifest JSON 复制到剪贴板',
  'mcp.inventory.export.download': '下载',
  'mcp.inventory.export.downloadAria': '将 manifest 下载为 JSON 文件',
  'mcp.inventory.import.trustTitle': '将导入的 manifest 视为不可信代码',
  'mcp.inventory.import.trustBody':
    'MCP 服务器是你授权给智能体的工具。只导入来自可信来源的 manifest。每次安装都需要你明确点击，不会自动安装任何内容。',
  'mcp.inventory.import.pasteLabel': '粘贴 manifest JSON',
  'mcp.inventory.import.pastePlaceholder': '在此粘贴 manifest，或在下方上传 .json 文件。',
  'mcp.inventory.import.preview': '预览',
  'mcp.inventory.import.clear': '清除',
  'mcp.inventory.import.uploadFile': '或上传 .json 文件',
  'mcp.inventory.import.uploadFileAria': '上传 manifest .json 文件',
  'mcp.inventory.import.fileTooLarge': '文件过大（超过 1 MB）。已拒绝加载。',
  'mcp.inventory.import.fileReadFailed': '无法读取文件。',
  'mcp.inventory.import.parseErrorPrefix': '无法解析 manifest：',
  'mcp.inventory.import.previewHeading': '预览',
  'mcp.inventory.import.previewCounts': '{total} 个服务器，{newly} 个新增，{already} 个已安装',
  'mcp.inventory.import.previewEmpty': 'Manifest 中不包含服务器。',
  'mcp.inventory.import.exportedFrom': '导出自 {exporter}',
  'mcp.inventory.import.exportedAt': '时间：{when}',
  'mcp.inventory.import.statusNew': '新增',
  'mcp.inventory.import.statusAlreadyInstalled': '已安装',
  'mcp.inventory.import.envKeysLabel': '环境键',
  'mcp.inventory.import.install': '安装',
  'mcp.inventory.import.installAria': '从此 manifest 安装 {name}',
  'mcp.inventory.import.skipped': '已跳过',
  'mcp.inventory.parseError.empty': 'Manifest 为空。',
  'mcp.inventory.parseError.invalidJson': '无效 JSON。',
  'mcp.inventory.parseError.rootNotObject': 'Manifest 根级必须是 JSON 对象。',
  'mcp.inventory.parseError.unsupportedSchema':
    '不支持的 manifest schema，此文件不是由兼容的导出器生成的。',
  'mcp.inventory.parseError.missingExportedAt': '缺少或无效的 `exported_at` 字段。',
  'mcp.inventory.parseError.missingExportedBy': '缺少或无效的 `exported_by` 字段。',
  'mcp.inventory.parseError.invalidServers': '缺少或无效的 `servers` 数组。',
  'mcp.inventory.parseError.serverNotObject': '某个服务器条目不是对象。',
  'mcp.inventory.parseError.serverMissingQualifiedName': '某个服务器条目缺少 qualified_name。',
  'mcp.inventory.parseError.serverMissingDisplayName': '某个服务器条目缺少 display_name。',
  'mcp.inventory.parseError.serverEnvKeysNotArray':
    '某个服务器条目的 env_keys 字段不是字符串数组。',
  'mcp.inventory.parseError.serverContainsEnv':
    '某个服务器条目包含 `env` 值映射。已拒绝导入，manifest 只能携带 env_keys（名称），绝不能包含密钥值。',
  'mcp.inventory.parseError.duplicateQualifiedName':
    'Manifest 中发现重复的 qualified_name。每个服务器最多只能出现一次。',
  'mcp.tab.loading': '正在加载 MCP 服务器...',
  'mcp.tab.emptyDetail': '选择服务器或浏览目录。',
  'mcp.tab.filter.all': '全部',
  'mcp.tab.filter.installed': '已安装 ({count})',
  'mcp.tab.filter.registry': '注册表',
  'mcp.tab.column.name': '名称',
  'mcp.tab.column.description': '描述',
  'mcp.tab.column.type': '类型',
  'mcp.tab.column.author': '作者',
  'mcp.tab.column.action': '操作',
  'mcp.tab.transport.hosted': '托管',
  'mcp.tab.transport.local': 'Stdio',
  'mcp.tab.transportFilter.label': '类型',
  'mcp.tab.transportFilter.aria': '按传输方式筛选服务器',
  'mcp.tab.link.website': '网站',
  'mcp.tab.link.repo': '仓库',
  'mcp.tab.transport.hostedHint': '在远程服务器上运行：安装时设置登录或令牌',
  'mcp.tab.transport.localHint': '在您的设备上运行：安装时可能需要令牌',
  'mcp.tab.officialBadge': '官方',
  'mcp.tab.officialHint': '来自供应商的官方服务器',
  'mcp.tab.badge.installed': '已安装',
  'mcp.tab.badge.registry': '注册表',
  'mcp.tab.action.manage': '管理',
  'mcp.tab.aria.viewDetails': '查看 {name} 的详情',
  'mcp.tab.aria.installServer': '安装 {name}',
  'mcp.install.loadingDetail': '正在加载服务器详细信息...',
  'mcp.install.back': '返回',
  'mcp.install.title': '安装 {name}',
  'mcp.install.requiredEnv': '所需的环境变量',
  'mcp.install.enterValue': '输入 {key}',
  'mcp.install.show': '显示',
  'mcp.install.hide': '隐藏',
  'mcp.install.configLabel': '配置（可选 JSON）',
  'mcp.install.configPlaceholder': '{"key": "value"}',
  'mcp.install.missingRequired': '“{key}”为必填项',
  'mcp.install.invalidJson': '配置 JSON 不是有效的 JSON',
  'mcp.install.failedDetail': '无法加载服务器详细信息',
  'mcp.install.failedInstall': '安装失败',
  'mcp.install.button': '安装',
  'mcp.install.installing': '正在安装...',
  'mcp.install.by': '作者',
  'mcp.install.useCount': '{count} 次安装',
  'mcp.install.connections': '可用连接',
  'mcp.install.published': '已发布',
  'mcp.install.configureAndInstall': '配置并安装',
  'mcp.install.configureTitle': '配置 {name}',
  'mcp.install.advancedConfig': '高级配置',
  'mcp.detail.suggestedEnvReady': '建议的环境值已准备好',
  'mcp.detail.suggestedEnvBody': '使用建议值重新安装此服务器以应用它们：{keys}',
  'mcp.detail.connect': '连接',
  'mcp.detail.connecting': '正在连接...',
  'mcp.detail.authenticate': '登录',
  'mcp.detail.authRequired': '此服务器需要您先登录或添加访问令牌才能连接。点击“登录”进行身份验证。',
  'mcp.detail.disconnect': '断开连接',
  'mcp.detail.hideAssistant': '隐藏助手',
  'mcp.detail.helpConfigure': '帮我配置一下',
  'mcp.detail.confirmUninstall': '确认卸载？',
  'mcp.detail.confirmUninstallAction': '是的，卸载',
  'mcp.detail.uninstall': '卸载',
  'mcp.detail.envVars': '环境变量',
  'mcp.detail.reconfigure': '重新配置',
  'mcp.detail.reconfigureHint': '为每个变量输入新值，然后重新连接。这将替换已存储的值。',
  'mcp.detail.saveReconnect': '保存并重新连接',
  'mcp.detail.reconfigureSaving': '正在保存…',
  'mcp.detail.reconfigureSuccess': '环境已更新并重新连接。',
  'mcp.detail.reconfigureReconnectFailed': '已保存，但使用新值重新连接失败。',
  'mcp.detail.enable': '启用',
  'mcp.detail.disable': '禁用',
  'mcp.status.disabled': '已禁用',
  'mcp.status.unauthorized': '需要登录',
  'mcp.detail.tools': '工具',
  'mcp.connectAuth.title': '连接 {name}',
  'mcp.connectAuth.hint':
    '添加此服务器所需的任何身份验证，然后连接。令牌会加密存储。对于无需身份验证的服务器，请留空。',
  'mcp.connectAuth.requiredLabel': '必填',
  'mcp.connectAuth.customHeadersLabel': '自定义请求头',
  'mcp.connectAuth.customHeadersEmpty':
    '没有自定义请求头。如果此服务器需要注册表未声明的身份验证请求头，请添加一个。',
  'mcp.connectAuth.addHeader': '+ 添加请求头',
  'mcp.connectAuth.headerName': '请求头名称',
  'mcp.connectAuth.headerValue': '值',
  'mcp.connectAuth.removeHeader': '移除请求头',
  'mcp.connectAuth.howToGetToken': '帮助与配置',
  'mcp.connectAuth.tokenProvider': '获取令牌的位置：',
  'mcp.connectAuth.findToken': '在哪里获取令牌？',
  'mcp.connectAuth.hideHelp': '隐藏帮助',
  'mcp.connectAuth.schemeLabel': '如何发送该值',
  'mcp.connectAuth.schemeBearer': 'Bearer',
  'mcp.connectAuth.schemeRaw': '无',
  'mcp.connectAuth.reconnectFailed': '凭据已保存，但连接失败。',
  'mcp.connectAuth.oauthHint': '此服务器使用 OAuth。请通过浏览器登录以授权 OpenHuman。',
  'mcp.connectAuth.signIn': '使用浏览器登录',
  'mcp.connectAuth.oauthWaiting': '正在等待登录…',
  'mcp.connectAuth.oauthOrToken': '已经有访问令牌？请改为在下方将其粘贴为 Authorization 请求头。',
  'mcp.connectAuth.oauthTimeout': '等待浏览器登录超时。请重试。',
  'mcp.connectAuth.authError.oauthRequired':
    '此服务器使用 OAuth。请使用“使用浏览器登录”：粘贴的令牌将不被接受。',
  'mcp.connectAuth.authError.tokenRejected': '服务器拒绝了此令牌。请检查它是否正确且尚未过期。',
  'mcp.connectAuth.authError.credentialRequired': '此服务器需要身份验证。请添加令牌或登录。',
  'onboarding.skipForNow': '暂时跳过',
  'onboarding.localAI.continueWithCloud': '继续使用云',
  'onboarding.localAI.useLocalAnyway': '无论如何使用本地人工智能（不推荐用于您的设备）',
  'onboarding.localAI.useLocalInstead': '使用本地 AI 代替（现在连接 Ollama）',
  'onboarding.localAI.setupIssue': '本地 AI 设置遇到问题',
  'autonomy.title': '代理自主权',
  'autonomy.maxActionsLabel': '每小时最大动作数',
  'autonomy.maxActionsHelp':
    '智能体每滚动小时内可执行的最大工具操作次数。新值将在下次对话时生效。定时任务和频道监听器将保持当前限制，直到重启 OpenHuman。',
  'autonomy.statusSaving': '正在保存...',
  'autonomy.statusSaved': '已保存。',
  'autonomy.statusFailed': '失败',
  'autonomy.unlimitedNote': '无限制：禁用速率限制。',
  'autonomy.invalidIntegerMsg': '必须为正整数（如需无限制，请使用「无限制」预设）。',
  'autonomy.presetUnlimited': '无限制（默认）',
  'triggers.toggleFailed': '{trigger} 的 {action} 失败：{message}',
  'settings.ai.overview': 'AI 系统概览',
  'settings.ai.configStatus': '配置状态',
  'settings.ai.fallbackMode': '回退模式',
  'settings.ai.loadedFromRuntime': '从运行时加载',
  'settings.ai.loadingDuration': '加载时长',
  'settings.ai.localRuntime': '本地模型运行时',
  'settings.ai.openManager': '打开管理器',
  'settings.ai.retryDownload': '重试下载',
  'settings.ai.state': '状态',
  'settings.ai.targetModel': '目标模型',
  'settings.ai.download': '下载',
  'settings.ai.localModelUnavailable': '本地模型状态不可用。',
  'settings.ai.soulConfig': 'SOUL 角色配置',
  'settings.ai.refreshing': '刷新中...',
  'settings.ai.refreshSoul': '刷新 SOUL',
  'settings.ai.loadingSoul': '正在加载 SOUL 配置...',
  'settings.ai.identity': '身份',
  'settings.ai.personality': '个性',
  'settings.ai.safetyRules': '安全规则',
  'settings.ai.source': '来源',
  'settings.ai.loaded': '已加载',
  'settings.ai.toolsConfig': 'TOOLS 配置',
  'settings.ai.refreshTools': '刷新 TOOLS',
  'settings.ai.toolsAvailable': '可用工具',
  'settings.ai.tools': '个工具',
  'settings.ai.activeSkills': '活跃技能',
  'settings.ai.skills': '个技能',
  'settings.ai.skillsOverview': '技能概览',
  'settings.ai.refreshingAll': '刷新全部中...',
  'settings.ai.refreshAll': '刷新所有 AI 配置',
  'settings.notifications.suppressAll': '抑制所有通知',
  'settings.notifications.suppressAllDesc':
    '阻止来自嵌入式应用的所有操作系统通知弹窗，不受焦点状态影响。',
  'settings.notifications.toggleDnd': '切换免打扰',
  'settings.notifications.categories': '类别',
  'settings.notifications.categoryFooter':
    '禁用一个类别后，该类新的通知将不再出现在通知中心。已有的通知在被清除前保持可见。',
  'settings.billing.movedToWeb': '账单已移至网页',
  'settings.billing.openDashboard': '打开账单面板',
  'settings.billing.movedToWebDesc': '订阅变更、支付方式、配额和发票现在在 TinyHumans 网页上管理。',
  'settings.billing.backToSettings': '返回设置',
  'settings.billing.openingBrowser': '正在打开浏览器...',
  'settings.billing.browserNotOpen': '如果浏览器未打开，请使用上方按钮。',
  'settings.billing.browserOpenFailed': '无法自动打开浏览器。请使用上方按钮。',
  'settings.tools.chooseCapabilities': '选择 OpenHuman 可代表你使用的能力。',
  'settings.tools.saveChanges': '保存更改',
  'settings.tools.preferencesSaved': '偏好设置已保存',
  'settings.tools.saveFailed': '保存偏好失败，请重试。',
  'connections.comingSoon': '即将推出',
  'connections.setUp': '设置',
  'connections.configured': '已配置',
  'connections.unavailable': '不可用',
  'connections.checking': '检查中...',
  'connections.walletConfigured': '本地 EVM、BTC、Solana 和 Tron 身份已从你的恢复短语中配置。',
  'connections.walletReady': '通过一个恢复短语设置本地 EVM、BTC、Solana 和 Tron 身份。',
  'connections.walletError': '无法检查钱包状态。点击从恢复短语面板重试。',
  'connections.walletChecking': '正在检查钱包状态...',
  'connections.walletIdentities': '钱包身份',
  'connections.walletDerived': '从你的恢复短语本地派生，仅作为安全元数据存储。',
  'connections.privacySecurity': '隐私与安全',
  'connections.privacySecurityDesc':
    '所有数据和凭据均存储在本地，采用零数据保留政策。你的信息经过加密，绝不会与第三方共享。',
  'channels.status.connecting': '连接中',
  'channels.status.notConfigured': '未配置',
  'channels.noActiveRoute': '无活跃路由',
  'channels.activeRoute': '活跃路由',
  'channels.loadingDefinitions': '正在加载渠道定义...',
  'channels.channelConnections': '渠道连接',
  'channels.configureAuthModes': '为每个消息渠道配置认证模式。',
  'channels.configNotAvailable': '配置',
  'channels.channel': '渠道',
  'devOptions.coreModeNotSet': '核心模式：未设置',
  'devOptions.coreModeNotSetDesc': '启动检查选择器尚未确认。使用选择器上的切换模式选择本地或云端。',
  'devOptions.local': '本地',
  'devOptions.embeddedCoreSidecar': '嵌入式核心侧车',
  'devOptions.sidecarSpawned': '由 Tauri shell 在应用启动时进程内启动。',
  'devOptions.cloud': '云端',
  'devOptions.remoteCoreRpc': '远程核心 RPC',
  'devOptions.token': '令牌',
  'devOptions.tokenNotSet': '未设置：RPC 将返回 401',
  'devOptions.triggerSentryTest': '触发 Sentry 测试 (staging)',
  'devOptions.triggerSentryTestDesc':
    '发送一个带有标签的错误以验证 Sentry 管道。Issue #1072：验证后移除。',
  'devOptions.sendTestEvent': '发送测试事件',
  'devOptions.sending': '发送中…',
  'devOptions.eventSent': '事件已发送',
  'devOptions.sentryDisabled': '（无 id：哨兵在此版本中被禁用）',
  'devOptions.failed': '失败',
  'devOptions.appLogs': '应用日志',
  'devOptions.appLogsDesc': '打开包含滚动日志文件的文件夹。报告问题时请附上最近的文件。',
  'devOptions.openLogsFolder': '打开日志文件夹',
  'mnemonic.phraseSaved': '恢复短语已保存',
  'mnemonic.walletReady': '多链钱包身份已就绪。正在返回设置...',
  'mnemonic.writeDownWords': '按顺序记下这',
  'mnemonic.wordsInOrder':
    '个单词，并将其保存在安全的地方。这个短语保护你的本地加密密钥以及你的 EVM、BTC、Solana 和 Tron 钱包身份。',
  'mnemonic.cannotRecover': '这个短语一旦丢失将无法恢复，应该完全保留在你的本地设备上。',
  'mnemonic.copyToClipboard': '复制到剪贴板',
  'mnemonic.alreadyHavePhrase': '我已经有恢复短语',
  'mnemonic.consentSaved': '我已保存此短语并同意将其用于本地钱包设置',
  'mnemonic.enterPhraseToRestore':
    '在下面输入你的恢复短语以恢复本地钱包身份，或将完整的短语粘贴到任意字段中（新备份为 12 个单词；旧版本的 24 个单词短语仍然有效）。',
  'mnemonic.words': '单词数',
  'mnemonic.validPhrase': '有效的恢复短语',
  'mnemonic.generateNewPhrase': '改为生成新的恢复短语',
  'mnemonic.securingData': '正在保护你的数据...',
  'mnemonic.saveRecoveryPhrase': '保存恢复短语',
  'mnemonic.userNotLoaded': '用户未加载。请重新登录或刷新页面。',
  'mnemonic.invalidPhrase': '恢复短语无效。请检查你的单词后重试。',
  'mnemonic.somethingWentWrong': '出了点问题。请重试。',
  'mnemonic.walletAlreadyConfigured': '您的钱包已设置好。',
  'mnemonic.walletSource': '来源',
  'mnemonic.walletWordCount': '助记词长度',
  'mnemonic.walletLastUpdated': '最后更新',
  'mnemonic.replaceWallet': '替换钱包',
  'mnemonic.replaceWalletWarning': '这将永久替换您当前的钱包。在继续之前，请确保您已备份恢复短语。',
  'mnemonic.replaceWalletConfirm': '我明白，替换我的钱包',
  'mnemonic.loadingWalletStatus': '正在检查钱包状态...',
  'mnemonic.viewAccounts': '钱包账户',
  'mnemonic.revealRecoveryPhrase': '显示恢复短语',
  'mnemonic.hidePhrase': '隐藏短语',
  'team.failedToCreate': '创建团队失败',
  'team.invalidInviteCode': '无效或已过期的邀请码',
  'team.failedToSwitch': '切换团队失败',
  'team.failedToLeave': '离开团队失败',
  'team.role.owner': '拥有者',
  'team.role.admin': '管理员',
  'team.role.billingManager': '账单管理员',
  'team.role.member': '成员',
  'team.active': '活跃',
  'team.personalTeam': '个人团队',
  'team.manageTeam': '管理团队',
  'team.switching': '切换中...',
  'team.switch': '切换',
  'team.leaving': '离开中...',
  'team.leave': '离开',
  'team.yourTeams': '你的团队',
  'team.createNewTeam': '创建新团队',
  'team.teamName': '团队名称',
  'team.creating': '创建中...',
  'team.joinExistingTeam': '加入已有团队',
  'team.personalAutoCreatedNote':
    '您的个人团队会自动创建。如需协作，请使用下方的邀请码加入现有团队。',
  'team.inviteCode': '邀请码',
  'team.joining': '加入中...',
  'team.join': '加入',
  'team.leaveTeam': '离开团队',
  'team.confirmLeave': '确定要离开',
  'team.leaveWarning': '你将失去对该团队及所有团队资源的访问权限。需要重新获得邀请才能重新加入。',
  'team.management': '团队管理',
  'team.notFound': '未找到团队',
  'team.accessDenied': '访问被拒绝',
  'team.members': '成员',
  'team.membersDesc': '管理团队成员和角色',
  'team.invites': '邀请',
  'team.invitesDesc': '生成和管理邀请码',
  'team.settings': '团队设置',
  'team.settingsDesc': '编辑团队名称和设置',
  'team.editSettings': '编辑团队设置',
  'team.enterName': '输入团队名称',
  'team.saving': '正在保存...',
  'team.saveChanges': '保存更改',
  'team.delete': '删除团队',
  'team.deleteDesc': '永久删除该团队',
  'team.deleting': '正在删除...',
  'team.failedToUpdate': '更新团队失败',
  'team.failedToDelete': '删除团队失败',
  'team.manageTitle': '管理 {name}',
  'team.planCreated': '{plan} 计划 • 创建 {date}',
  'team.confirmDelete': '您确定要删除 {name} 吗？',
  'team.deleteWarning': '此操作无法撤消。所有团队数据将被永久删除。',
  'voice.title': '语音听写',
  'voice.settings': '语音设置',
  'voice.settingsDesc': '按住快捷键进行语音听写，将文本插入到当前活动字段中。',
  'voice.hotkey': '快捷键',
  'voice.activationMode': '激活模式',
  'voice.tapToToggle': '点击切换',
  'voice.writingStyle': '书写风格',
  'voice.verbatimTranscription': '逐字转录',
  'voice.naturalCleanup': '自然清理',
  'voice.autoStart': '与核心一起自动启动语音服务',
  'voice.customDictionary': '自定义词典',
  'voice.customDictionaryDesc': '添加姓名、技术术语和领域词汇以提高识别准确率。',
  'voice.addWord': '添加词语...',
  'voice.sttDisabled': '语音听写功能在本地 STT 模型下载并准备好之前被禁用。',
  'voice.openLocalAiModel': '打开本地 AI 模型',
  'voice.serverRestarted': '语音服务已使用新设置重启。',
  'voice.settingsSaved': '语音设置已保存。',
  'voice.serverStarted': '语音服务已启动。',
  'voice.serverStopped': '语音服务已停止。',
  'voice.saveVoiceSettings': '保存语音设置',
  'voice.startVoiceServer': '启动语音服务',
  'voice.stopVoiceServer': '停止语音服务',
  'voice.debugTitle': '语音调试',
  'voice.failedToLoadSettings': '无法加载语音设置',
  'voice.failedToSaveSettings': '无法保存语音设置',
  'voice.failedToStartServer': '语音服务器启动失败',
  'voice.failedToStopServer': '停止语音服务器失败',
  'voice.sttDisabledPrefix': '语音听写已禁用，直到本地 STT 模型下载完成。请使用',
  'voice.sttDisabledSuffix': '上面的部分安装 Whisper。',
  'voice.debug.failedToLoadVoiceDebugData': '加载语音调试数据失败',
  'voice.debug.settingsSaved': '已保存调试设置。',
  'voice.debug.failedToSaveSettings': '无法保存语音设置',
  'voice.debug.runtimeStatus': '运行时状态',
  'voice.debug.runtimeStatusDesc': '语音服务器和语音转文字引擎的实时诊断信息。',
  'voice.debug.server': '服务器',
  'voice.debug.unavailable': '不可用',
  'voice.debug.ready': '准备好',
  'voice.debug.notReady': '还没准备好',
  'voice.debug.hotkey': '热键',
  'voice.debug.notAvailable': '不适用',
  'voice.debug.mode': '模式',
  'voice.debug.transcriptions': '转录',
  'voice.debug.serverError': '服务器错误',
  'voice.debug.advancedSettings': '高级设置',
  'voice.debug.advancedSettingsDesc': '用于录音和静音检测的底层调节参数。',
  'voice.debug.minimumRecordingSeconds': '最短录音秒数',
  'voice.debug.silenceThreshold': '静音阈值 (RMS)',
  'voice.debug.silenceThresholdDesc': '能量低于此值的录音将被视为静音并跳过。值越低，灵敏度越高。',
  'voice.debug.alwaysOn': '常驻聆听',
  'voice.debug.alwaysOnDesc':
    '保持麦克风开启，无需快捷键即可自动将你说的话发送给智能体。屏幕锁定时暂停。',
  'voice.providers.saved': '语音提供商已保存。',
  'voice.providers.failedToSave': '无法保存语音提供商',
  'voice.providers.ellipsis': '…',
  'voice.providers.installing': '安装中',
  'voice.providers.installingBusy': '正在安装...',
  'voice.providers.reinstallLocally': '本地重新安装',
  'voice.providers.repair': '修复',
  'voice.providers.retryLocally': '本地重试',
  'voice.providers.installLocally': '本地安装',
  'voice.providers.whisperReady': '耳语准备好了。',
  'voice.providers.whisperInstallStarted': '耳语安装开始',
  'voice.providers.queued': '排队',
  'voice.providers.failedToInstallWhisper': '安装耳语失败',
  'voice.providers.piperReady': '派珀准备好了。',
  'voice.providers.piperInstallStarted': 'Piper 安装开始',
  'voice.providers.failedToInstallPiper': '安装 Piper 失败',
  'voice.mode.title': '语音模式',
  'voice.mode.desc': '选择助手在 Human 标签页中的说话方式。',
  'voice.mode.realtime': '实时语音（测试版）',
  'voice.mode.realtimeDesc': '进行实时连续对话，而不是轮流发言。',
  'voice.mode.start': '开始语音聊天',
  'voice.mode.stop': '结束语音聊天',
  'voice.mode.connecting': '连接中…',
  'voice.mode.listening': '正在聆听',
  'voice.mode.speaking': '正在讲话',
  'voice.providers.title': '语音提供商',
  'voice.providers.desc':
    '选择转录和合成的运行位置。使用「本地安装」按钮将二进制文件和模型下载到您的工作区。本地服务提供商可在安装完成前保存：无需手动配置 WHISPER_BIN 或 PIPER_BIN。',
  'voice.providers.sttProvider': '语音转文本提供商',
  'voice.providers.sttProviderAria': 'STT 提供商',
  'voice.providers.cloudWhisperProxy': '云（耳语代理）',
  'voice.providers.localWhisper': '本地耳语',
  'voice.providers.installRequired': ' （需要安装）',
  'voice.providers.whisperInstalledTitle': '耳语已安装。单击重新安装。',
  'voice.providers.whisperDownloadTitle': '将 whisper.cpp 和 GGML 模型下载到您的工作区。',
  'voice.providers.installed': '已安装',
  'voice.providers.installFailed': '安装失败',
  'voice.providers.notInstalled': '未安装',
  'voice.providers.whisperModel': '耳语模型',
  'voice.providers.whisperModelAria': '耳语模型',
  'voice.providers.whisperModelTiny': '很小（39 MB，最快）',
  'voice.providers.whisperModelBase': '基础 (74 MB)',
  'voice.providers.whisperModelSmall': '小 (244 MB)',
  'voice.providers.whisperModelMedium': '中型（769 MB，推荐）',
  'voice.providers.whisperModelLargeTurbo': '大型 v3 Turbo（1.5 GB，最佳精度）',
  'voice.providers.ttsProvider': '文本转语音提供商',
  'voice.providers.ttsProviderAria': 'TTS 提供商',
  'voice.providers.cloudElevenLabsProxy': '云（ElevenLabs 代理）',
  'voice.providers.localPiper': '当地风笛手',
  'voice.providers.piperInstalledTitle': 'Piper 已安装。单击重新安装。',
  'voice.providers.piperDownloadTitle':
    '将 Piper 及内置的 en_US-lessac-medium 声音下载到您的工作区。',
  'voice.providers.piperVoice': '派珀之声',
  'voice.providers.piperVoiceAria': '吹笛者的声音',
  'voice.providers.customVoiceOption': '其他（在下面输入）...',
  'voice.providers.customVoiceAria': 'Piper 语音 ID（自定义）',
  'voice.providers.customVoicePlaceholder': 'en_US-lessac-medium',
  'voice.providers.piperVoicesDesc':
    '声音来自 huggingface.co/rhasspy/piper-voices。切换声音后，可能需要点击「安装/重新安装」以下载新的 .onnx 文件。',
  'voice.providers.mascotVoice': '吉祥物声音',
  'voice.providers.mascotVoiceDescPrefix':
    '吉祥物语音回复所使用的 ElevenLabs 声音，在以下位置配置：',
  'voice.providers.mascotSettings': '吉祥物设置',
  'voice.providers.mascotVoiceDescSuffix': '.',
  'voice.providers.hotkeyPlaceholder': 'Fn',
  'voice.providers.piperPreset.lessacMedium': '美国·Lessac（中性，推荐）',
  'voice.providers.piperPreset.lessacHigh': '美国·Lessac（更高品质，更大）',
  'voice.providers.piperPreset.ryanMedium': '美国·瑞安（男）',
  'voice.providers.piperPreset.amyMedium': '美国·艾米（女）',
  'voice.providers.piperPreset.librittsHigh': '美国·LibriTTS（多扬声器）',
  'voice.providers.piperPreset.alanMedium': 'GB·艾伦（男）',
  'voice.providers.piperPreset.jennyDiocoMedium': 'GB·珍妮·迪奥科（女）',
  'voice.providers.piperPreset.northernEnglishMaleMedium': 'GB·北方英语（男）',
  'voice.providers.chip.cloud': 'OpenHuman（托管）',
  'voice.providers.chip.cloudAria': 'OpenHuman 托管服务商始终启用',
  'voice.providers.chip.whisper': 'Whisper（本地）',
  'voice.providers.chip.enableWhisper': '启用本地 Whisper STT',
  'voice.providers.chip.disableWhisper': '禁用本地 Whisper STT',
  'voice.providers.chip.piper': 'Piper（本地）',
  'voice.providers.chip.enablePiper': '启用本地 Piper TTS',
  'voice.providers.chip.disablePiper': '禁用本地 Piper TTS',
  'voice.providers.chip.enableProvider': 'Enable',
  'voice.providers.chip.disableProvider': 'Disable',
  'voice.providers.chip.apiKeyLabel': 'API 密钥',
  'voice.providers.chip.apiKeyPlaceholder': 'sk-…',
  'voice.providers.chip.comingSoon': '即将推出',
  'voice.modal.title': 'Configure',
  'voice.modal.desc': '输入您的 API 密钥以启用此服务提供商。保存前可先测试连接。',
  'voice.modal.testKey': '测试密钥',
  'voice.modal.testing': '测试中…',
  'voice.modal.saveAndEnable': '保存并启用',
  'voice.modal.enable': 'Enable',
  'voice.modal.whisperDesc':
    '选择模型大小并将 Whisper 二进制文件和 GGML 模型安装到您的工作区。模型越大，精度越高，但速度越慢。',
  'voice.modal.piperDesc':
    '选择一个语音并将 Piper 二进制文件和 ONNX 模型安装到您的工作区。Piper 可完全离线运行，延迟极低。',
  'voice.routing.title': '语音路由',
  'voice.routing.desc': '选择由哪些已启用的服务提供商处理语音转文字和文字转语音。',
  'voice.routing.save': 'Save',
  'voice.routing.testStt': '测试 STT',
  'voice.routing.testTts': '测试 TTS',
  'voice.routing.elevenlabsVoice': 'ElevenLabs 声音',
  'voice.routing.elevenlabsVoiceAria': 'ElevenLabs 声音选择',
  'voice.routing.elevenlabsVoiceIdAria': 'ElevenLabs 声音 ID（自定义）',
  'voice.routing.elevenlabsVoiceDesc':
    '选择精选声音，或粘贴来自 ElevenLabs 控制台的自定义声音 ID。',
  'voice.externalProviders.title': '外部语音服务提供商',
  'voice.externalProviders.desc': '直接接入第三方 STT/TTS API，如 Deepgram、ElevenLabs 或 OpenAI。',
  'voice.externalProviders.keySet': '密钥已设置',
  'voice.externalProviders.noKey': '无 API 密钥',
  'voice.externalProviders.test': 'Test',
  'voice.externalProviders.testing': '测试中…',
  'voice.externalProviders.remove': 'Remove',
  'voice.externalProviders.provider': 'Provider',
  'voice.externalProviders.selectProvider': '选择服务提供商…',
  'voice.externalProviders.apiKey': 'API 密钥',
  'voice.externalProviders.apiKeyPlaceholder': 'sk-…',
  'voice.externalProviders.add': 'Add',
  'pttSettings.title': '按住说话',
  'pttSettings.description':
    '在其他应用中时，按住按键即可与 OpenHuman 对话。松开按键发送录音；若已开启「朗读回复」，OpenHuman 会用语音读出回复。',
  'pttSettings.shortcutLabel': '快捷键',
  'pttSettings.shortcutPlaceholder': '按下一个键（例如 F13）',
  'pttSettings.shortcutUnsetHint': '按住说话已关闭：请选择一个快捷键来启用。',
  'pttSettings.speakRepliesLabel': '朗读智能体的回复',
  'pttSettings.showOverlayLabel': '按住时显示悬浮层',
  'pttSettings.errorConflictsWithDictation': '该快捷键已被听写功能占用。请选择其他按键。',
  'pttSettings.errorModifierOnly':
    '请选择一个常规按键（例如 F13）：仅由修饰键组成的快捷键无法用于按住说话。',
  'pttSettings.errorEmpty': '请选择要绑定的按键。',
  'pttSettings.errorAccessibility':
    '此快捷键需要 macOS 的辅助功能权限。请打开系统设置 → 隐私与安全 → 辅助功能，并启用 OpenHuman。',
  'pttSettings.errorShortcutInUse': '该快捷键已被其他应用占用。请选择其他快捷键。',
  'pttSettings.errorUnsupportedWayland':
    'Wayland 会话尚不支持 OpenHuman 的全局快捷键：请切换到 X11 会话，或使用应用内的听写开关。',
  'pttSettings.exclusiveFullscreenHint':
    '在独占式全屏游戏中悬浮层不会显示：你只会听到提示音。切换到无边框全屏即可看到悬浮层。',
  'pttOverlay.listening': '正在聆听…',
  'pttOverlay.idle': '空闲',
  'chat.agentChat': '智能体对话',
  'chat.overrides': '覆盖设置',
  'chat.model': '模型',
  'chat.temperature': '温度',
  'chat.conversation': '对话',
  'chat.startAgentConversation': '开始与智能体对话。',
  'chat.you': '你',
  'chat.agent': '智能体',
  'chat.askAgent': '向智能体提问...',
  'chat.sendMessage': '发送消息',
  'composio.triageTitle': '集成触发器',
  'composio.triageDesc':
    '启用时，每个传入的 Composio 触发器都会经过 AI 分类步骤，对事件进行分类并可能启动自动化操作：每个触发器使用一个本地 LLM 轮次。如果你更喜欢手动审查，可以全局或按集成禁用。如果环境变量',
  'composio.disableAllTriage': '禁用所有触发器的 AI 分类',
  'composio.triggersStillRecorded': '触发器仍记录到历史记录中：不运行 LLM 轮次。',
  'composio.disableSpecificIntegrations': '禁用特定集成的 AI 分类',
  'composio.settingsSaved': '设置已保存',
  'composio.saveFailed': '保存失败。请重试。',
  'cron.title': '定时任务',
  'cron.scheduledJobs': '计划任务',
  'cron.manageCronJobs': '管理核心调度器的定时任务。',
  'cron.refreshCronJobs': '刷新定时任务',
  'localModel.modelStatus': '模型状态',
  'localModel.downloadModels': '下载模型',
  'localModel.usage': '使用',
  'localModel.usageDesc': '选择哪些子系统在本地模型上运行。未勾选的将使用云端。',
  'localModel.enableRuntime': '启用本地 AI 运行时',
  'localModel.enableRuntimeDesc':
    '总开关。默认关闭：Ollama 保持空闲。启用后，树摘要器、屏幕智能和自动补全始终使用本地模型。',
  'localModel.advancedSettings': '高级设置',
  'localModel.debugTitle': '本地模型调试',
  'memory.debugTitle': '记忆调试',
  'memory.documents': '文件',
  'memory.filterByNamespace': '按名称空间过滤...',
  'memory.refresh': '刷新',
  'memory.noDocumentsFound': '没有找到文件。',
  'memory.delete': '删除',
  'memory.rawResponse': '原始响应',
  'memory.namespaces': '命名空间',
  'memory.noNamespacesFound': '未找到名称空间。',
  'memory.queryRecall': '查询与召回',
  'memory.namespace': '命名空间',
  'memory.queryText': '查询文字...',
  'memory.defaultMaxChunks': '10',
  'memory.maxChunks': '最大块数',
  'memory.query': '查询',
  'memory.recall': '召回',
  'memory.queryLabel': '查询',
  'memory.recallLabel': '召回',
  'memory.queryResult': '查询结果',
  'memory.recallResult': '调用结果',
  'memory.clearNamespace': '清除命名空间',
  'memory.clearNamespaceDescription': '永久删除命名空间内的所有文档。',
  'memory.selectNamespace': '选择命名空间...',
  'memory.exampleNamespace': '例如技能:gmail:user@example.com',
  'memory.clear': '清除',
  'memory.deleteConfirm': '删除命名空间“{namespace}”中的文档“{documentId}”吗？',
  'memory.clearNamespaceConfirm': '此操作将永久删除命名空间「{namespace}」中的所有文档。是否继续？',
  'memory.clearNamespaceSuccess': '命名空间“{namespace}”已清除。',
  'memory.clearNamespaceEmpty': '“{namespace}”中没有需要清除的内容。',
  'webhooks.debugTitle': 'Webhook 调试',
  'webhooks.failedToLoadDebugData': '无法加载 webhook 调试数据',
  'webhooks.clearLogsConfirm': '清除所有捕获的 Webhook 调试日志吗？',
  'webhooks.failedToClearLogs': '无法清除 webhook 日志',
  'webhooks.loading': '正在加载...',
  'webhooks.refresh': '刷新',
  'webhooks.clearing': '清算...',
  'webhooks.clearLogs': '清除日志',
  'webhooks.registered': '已注册',
  'webhooks.captured': '被捕获',
  'webhooks.live': '直播',
  'webhooks.disconnected': '断开连接',
  'webhooks.lastEvent': '最后活动',
  'webhooks.at': '在',
  'webhooks.registeredWebhooks': '注册网络钩子',
  'webhooks.noActiveRegistrations': '没有活跃的注册。',
  'webhooks.resolvingBackendUrl': '正在解析后端 URL...',
  'webhooks.capturedRequests': '捕获的请求',
  'webhooks.noRequestsCaptured': '尚未捕获任何 Webhook 请求。',
  'webhooks.unrouted': '未布线的',
  'webhooks.pending': '待定',
  'webhooks.requestHeaders': '请求标头',
  'webhooks.queryParams': '查询参数',
  'webhooks.requestBody': '请求正文',
  'webhooks.responseHeaders': '响应头',
  'webhooks.responseBody': '响应体',
  'webhooks.rawPayload': '原始有效负载',
  'webhooks.empty': '[空]',
  'providerSetup.error.defaultDetails': '提供商设置失败。',
  'providerSetup.error.providerFallback': '提供者',
  'providerSetup.error.credentialsRejected': '{provider} 拒绝了此凭据。请检查 API 密钥后重试。',
  'providerSetup.error.endpointNotRecognized': '{provider} 无法识别该端点。请检查基础 URL 后重试。',
  'providerSetup.error.providerUnavailable': '{provider} 当前不可用。请稍后重试或查看服务商状态。',
  'providerSetup.error.unreachable': '无法连接到 {provider}。请检查端点 URL 和网络连接后重试。',
  'providerSetup.error.couldNotReachWithMessage': '无法到达 {provider}：{message}',
  'providerSetup.error.technicalDetails': '技术细节',
  'notifications.routingTitle': '通知路由',
  'notifications.routing.pipelineStats': '管道统计',
  'notifications.routing.total': '合计',
  'notifications.routing.unread': '未读',
  'notifications.routing.unscored': '未计分',
  'notifications.routing.intelligenceTitle': '通知情报',
  'notifications.routing.intelligenceDesc':
    '来自已连接账户的每条通知都由本地 AI 模型进行评分。重要通知将自动路由至您的编排器智能体，确保关键信息不会遗漏。',
  'notifications.routing.howItWorks': '它是如何运作的',
  'notifications.routing.level.drop': '掉落',
  'notifications.routing.level.dropDesc': '噪音/垃圾邮件 - 已存储但未浮出水面',
  'notifications.routing.level.acknowledge': '确认',
  'notifications.routing.level.acknowledgeDesc': '低优先级：显示在通知中心',
  'notifications.routing.level.react': '反应',
  'notifications.routing.level.reactDesc': '中优先级：触发集中的座席响应',
  'notifications.routing.level.escalate': '升级',
  'notifications.routing.level.escalateDesc': '高优先级：转发给协调器代理',
  'notifications.routing.perProvider': '每个提供商的路由',
  'notifications.routing.threshold': '阈值',
  'notifications.routing.routeToOrchestrator': '路由到协调器',
  'notifications.routing.loadSettingsError': '无法加载设置。重新打开此面板以重试。',
  'common.reload': '重新加载',
  'common.skip': '跳过',
  'common.disable': '禁用',
  'common.enable': '启用',
  'chat.safetyTimeout': '助手 2 分钟内未响应。请重试或检查你的连接。',
  'chat.filter.general': '常规',
  'chat.filter.subconscious': '潜意识',
  'chat.filter.meetings': '会议',
  'chat.filter.tasks': '任务',
  'chat.selectThread': '选择一个对话',
  'chat.threads': '对话列表',
  'chat.noThreads': '暂无对话',
  'chat.noLabelThreads': '此标签下暂无对话',
  'chat.deleteThread': '删除对话',
  'chat.deleteThreadConfirm': '确定要删除"{title}"吗？',
  'chat.untitledThread': '未命名对话',
  'chat.editThreadTitle': '编辑会话标题',
  'chat.hideSidebar': '隐藏侧边栏',
  'chat.showSidebar': '显示侧边栏',
  'chat.searchThreads': '搜索对话',
  'layout.resizeSidebar': '调整侧边栏大小',
  'layout.showSidebar': '显示侧边栏',
  'chat.newThreadShortcut': '新建对话',
  'chat.new': '新建',
  'chat.failedToLoadMessages': '加载消息失败',
  'chat.thinkingIteration': '思考中...({n})',
  'chat.thinkingDots': '思考中...',
  'chat.approachingLimit': '接近使用限制',
  'chat.approachingLimitMsg': '你已使用了可用配额的{pct}%。',
  'chat.upgrade': '升级',
  'chat.weeklyLimitHit': '已达到每周限制。',
  'chat.resets': '重置时间',
  'chat.topUpToContinue': '充值以继续使用。',
  'chat.budgetComplete': '预算已用完。',
  'chat.topUp': '充值',
  'chat.cycle': '周期',
  'chat.cycleSpent': '本周期已用',
  'chat.cycleRemaining': '剩余',
  'chat.left': '剩余',
  'chat.setup': '设置',
  'chat.switchToText': '切换到文本',
  'chat.superContext.label': '超级上下文',
  'chat.superContext.hint':
    '超级上下文让 OpenHuman 能够从其可访问的所有数据中收集并准备上下文，从而给出高度相关的回答。超级上下文目前处于早期测试阶段。',
  'chat.transcribing': '转录中...',
  'chat.stopAndSend': '停止并发送',
  'chat.startTalking': '开始说话',
  'chat.playingVoiceReply': '正在播放语音回复',
  'chat.voiceHint': '使用麦克风说话',
  'chat.micUnavailable': '麦克风不可用',
  // Chat mascot: the figure standing on the composer, and its voice stage.
  'chat.mascot.expand': '和你的助手说话',
  'chat.mascot.collapse': '返回聊天',
  'chat.mascot.speakReplies': '朗读回复',
  'chat.mascot.speakRepliesHint': '吉祥物打开时会朗读回复。关闭后对话将保持静音。',
  'chat.turn': '轮',
  'chat.mascot.dismiss': '隐藏 Tiny',
  'chat.mascot.dismissTitle': '隐藏 Tiny？',
  'chat.mascot.dismissBody':
    '如果你更想独占消息框，也没关系。随时可以在设置 › 外观 › 聊天中把 Tiny 请回来。',
  'chat.mascot.dismissConfirm': '隐藏 Tiny',
  'chat.mascot.dismissCancel': '留下 Tiny',
  'chat.turns': '轮',
  'chat.openWorkerThread': '打开工作线程',
  'chat.attachment.attach': '添加图片',
  'chat.attachment.remove': '移除 {name}',
  'chat.attachment.tooMany': '每条消息最多 {max} 张图片',
  'chat.attachment.tooManyFiles': '每条消息最多 {max} 个文件',
  'chat.attachment.tooManyVideos': '每条消息最多 {max} 个视频',
  'chat.attachment.videoNotSupported':
    '此模型无法读取视频。您可以使用 OpenHuman 推理层级来附加视频。',
  'chat.attachment.dropToAttach': '拖放文件以添加',
  'chat.attachment.tooLarge': '图片超过 {max} 大小限制',
  'chat.attachment.unsupportedType':
    '不支持的文件类型。请使用图片（PNG、JPEG、WebP、GIF、BMP）或 PDF、TXT、Markdown 文件。',
  'chat.attachment.imageNotSupported':
    '此模型无法读取图像。您可以使用 OpenHuman 推理层级来附加您的图像。',
  'chat.attachment.readFailed': '无法读取文件',
  'memory.searchAria': '搜索记忆',
  'memory.searchPlaceholder': '搜索记忆条目...',
  'memory.sourceFilter.all': '所有来源',
  'memory.sourceFilter.email': '邮件',
  'memory.sourceFilter.calendar': '日历',
  'memory.sourceFilter.telegram': 'Telegram',
  'memory.sourceFilter.aiInsight': 'AI 洞察',
  'memory.sourceFilter.system': '系统',
  'memory.sourceFilter.trading': '交易',
  'memory.sourceFilter.security': '安全',
  'memory.ingestionActivity': '摄取活动',
  'memory.events': '个事件',
  'memory.event': '个事件',
  'memory.overTheLast': '过去',
  'memory.months': '个月',
  'memory.peak': '峰值',
  'memory.perDay': '/天',
  'memory.less': '较少',
  'memory.more': '较多',
  'memory.on': '于',
  'memory.loading': '正在加载记忆',
  'memory.fetching': '正在获取你的记忆条目...',
  'memory.analyzing': '正在分析记忆',
  'memory.analyzingHint': '正在处理你的记忆以提取洞察...',
  'memory.noMatches': '未找到匹配',
  'memory.noMatchesHint': '尝试更改搜索词或筛选条件。',
  'memory.allCaughtUp': '全部完成',
  'memory.allCaughtUpHint': '没有新的记忆条目需要处理。',
  'memory.noAnalysis': '暂无分析',
  'memory.noAnalysisHint': '运行分析以发现记忆中的模式。',
  'memory.emptyHint': '开始交互以创建你的第一条记忆。',
  'mic.unavailable': '麦克风不可用',
  'mic.permissionDenied': '麦克风权限被拒绝',
  'mic.failedToStartRecorder': '启动录音失败',
  'mic.deviceUnavailable': '所选麦克风不可用：请尝试其他设备。',
  'mic.deviceInUse': '麦克风正被其他应用程序占用。',
  'mic.error': '麦克风错误',
  'mic.transcribing': '转录中...',
  'mic.retryingTranscription': '正在重试…（第 {attempt} 次，共 {max} 次）',
  'mic.tapToSend': '点击发送',
  'mic.waitingForAgent': '等待助手...',
  'mic.tapAndSpeak': '点击说话',
  'mic.stopRecording': '停止录音',
  'mic.startRecording': '开始录音',
  'mic.deviceSelector': '麦克风装置',
  'mic.tapToSendCountdown': '点击发送 ({seconds}秒)',
  'token.usageLimitReached': '已达到使用限制',
  'token.approachingLimit': '接近限制',
  'token.planClickForDetails': '套餐 - 点击查看详情',
  'token.sessionTokens': '输入: {in} | 输出: {out} | 轮次: {turns}',
  'token.limit': '已达限制',
  'token.inLabel': '输入',
  'token.outLabel': '输出',
  'token.inputTokens': '本次会话输入令牌',
  'token.outputTokens': '本次会话输出令牌',
  'token.turnsCount': '本次会话推理轮次',
  'token.turn': '轮',
  'token.turns': '轮',
  'token.ctxLabel': '上下文',
  'token.contextWindow': '上下文窗口使用量（上一轮）',
  'token.cachedLabel': '已缓存',
  'token.costLabel': '费用',
  'token.costTitle': '本次会话的预估费用（美元）',
  'token.sessionUsageTitle': '会话用量',
  'token.subAgentsHeading': '子代理用量',
  'token.byAgentHeading': '按代理',
  'token.orchestrator': '编排器',
  'token.noSubAgents': '暂无子代理用量',
  'token.popInput': '输入令牌',
  'token.popOutput': '输出令牌',
  'token.popCacheHit': '缓存命中',
  'token.popContext': '上下文窗口',
  'token.tipInput': '本次会话发送给模型的令牌：你的提示词加上对话历史。',
  'token.tipOutput': '本次会话由模型生成的令牌。',
  'token.tipCacheHit': '由缓存的提示词前缀提供的输入令牌，按较低费率计费。',
  'token.clickForDetails': '点击查看会话用量详情',
  'catalog.noCapabilityBinding': '无能力绑定',
  'catalog.downloadFailed': '下载失败',
  'catalog.active': '活跃',
  'catalog.installed': '已安装',
  'catalog.notDownloaded': '未下载',
  'catalog.inUse': '使用中',
  'catalog.use': '使用',
  'catalog.deleteModel': '删除模型',
  'catalog.download': '下载',
  'navigator.recent': '最近',
  'navigator.today': '今天',
  'navigator.thisWeek': '本周',
  'navigator.sources': '来源',
  'navigator.email': '邮件',
  'navigator.slack': 'Slack',
  'navigator.chat': '对话',
  'navigator.documents': '文档',
  'navigator.people': '联系人',
  'navigator.topics': '主题',
  'dreams.description': '梦境是 AI 生成的反思，综合了你记忆中的模式。',
  'dreams.comingSoon': '即将推出',
  'assignment.memoryLlm': '记忆 LLM',
  'assignment.memoryLlmAria': '选择记忆 LLM',
  'assignment.embedder': '嵌入模型',
  'assignment.loaded': '已加载',
  'assignment.notDownloaded': '未下载',
  'assignment.usedForExtractSummarise': '用于提取和摘要',
  'insights.knownFacts': '已知事实',
  'insights.preferences': '偏好',
  'insights.relationships': '关系',
  'insights.skills': '技能',
  'insights.opinions': '观点',
  'insights.other': '其他',
  'insights.title': '洞察',
  'insights.empty': '暂无洞察。随着你的记忆增长，洞察会自动生成。',
  'insights.description': '基于记忆图谱中的 {count} 个关系。',
  'insights.items': '条',
  'insights.more': '更多',
  'calls.joiningCall': '正在加入通话',
  'calls.meetWindowOpening': 'Meet 窗口正在打开...',
  'calls.failedToStart': '启动通话失败',
  'calls.couldNotStart': '无法启动通话',
  'calls.failedToClose': '关闭通话失败',
  'calls.couldNotClose': '无法关闭通话',
  'calls.joinMeet': '加入 Meet',
  'calls.joinMeetDescription': '输入 Google Meet 链接以加入。',
  'calls.meetLink': 'Meet 链接',
  'calls.displayName': '显示名称',
  'calls.openingMeet': '正在打开 Meet...',
  'calls.joinCall': '加入通话',
  'calls.activeCalls': '活跃通话',
  'calls.leave': '离开',
  'workspace.wipeConfirm': '确定要清除所有记忆吗？此操作不可撤销。',
  'workspace.resetTreeConfirm': '确定要重建记忆树吗？',
  'workspace.wipeTitle': '清除记忆',
  'workspace.resetting': '重置中...',
  'workspace.resetMemory': '重置记忆',
  'workspace.resetTreeTitle': '重建记忆树',
  'workspace.rebuilding': '重建中...',
  'workspace.resetMemoryTree': '重置记忆树',
  'workspace.building': '构建中...',
  'workspace.buildSummaryTrees': '构建摘要树',
  'workspace.viewVault': '查看存储库',
  'workspace.openingVaultTitle': '在 Obsidian 中打开存储库',
  'workspace.openingVaultMessage':
    '如果 Obsidian 没有打开，请从 obsidian.md 安装或使用"显示文件夹"。存储库路径：',
  'workspace.openVaultFailedTitle': '无法在 Obsidian 中打开存储库',
  'workspace.openVaultFailedMessage': '使用"显示文件夹"直接打开存储库目录。存储库路径：',
  'workspace.revealVaultFailed': '无法显示存储库文件夹',
  'workspace.revealFolder': '显示文件夹',
  'workspace.checkingVault': '检查中…',
  'workspace.vaultNotRegisteredHelp':
    'Obsidian 只能打开您已添加为存储库的文件夹。在 Obsidian 中选择「以存储库方式打开文件夹」并选取下方文件夹：只需操作一次。然后再次点击「查看存储库」。',
  'workspace.obsidianNotFoundHelp':
    '未能在此设备上找到 Obsidian。请安装它，或者如果安装在非标准位置，请在「高级」中设置其配置文件夹。',
  'workspace.openAnyway': '仍在 Obsidian 中打开',
  'workspace.installObsidian': '安装 Obsidian',
  'workspace.obsidianAdvanced': 'Obsidian 安装在其他位置？',
  'workspace.obsidianConfigDirLabel': 'Obsidian 配置文件夹',
  'workspace.obsidianConfigDirHint':
    '包含 obsidian.json 的文件夹路径（例如 ~/.config/obsidian）。留空以自动检测。',
  'workspace.obsidianConfigDirPlaceholder': '~/.config/obsidian',
  'workspace.graphLoadFailed': '无法加载记忆图谱',
  'workspace.loadingGraph': '正在加载记忆图谱...',
  'workspace.graphViewMode': '记忆图谱视图模式',
  'workspace.trees': '树状视图',
  'workspace.contacts': '联系人',
  'graph.noContactMentions': '无联系人提及',
  'graph.noMemory': '无记忆',
  'graph.source': '来源',
  'graph.topic': '主题',
  'graph.global': '全局',
  'graph.document': '文档',
  'graph.contact': '联系人',
  'graph.nodes': '个节点',
  'graph.parentChild': '父子',
  'graph.documentContact': '文档-联系人',
  'graph.link': '条链接',
  'graph.links': '条链接',
  'graph.children': '个子节点',
  'graph.clickToOpenObsidian': '点击在 Obsidian 中打开',
  'graph.person': '人物',
  'graph.resetView': '重置视图',
  'modal.dontShowAgain': '不再显示',
  'reflections.loading': '正在加载反思...',
  'reflections.empty': '暂无反思',
  'reflections.title': '反思',
  'reflections.proposedAction': '建议操作',
  'reflections.act': '执行',
  'reflections.dismiss': '忽略',
  'reflections.viewConversation': '查看',
  'subconscious.mode.label': '潜意识模式',
  'subconscious.mode.off.title': '关闭',
  'subconscious.mode.off.desc': '潜意识已禁用。',
  'subconscious.mode.simple.title': '简单',
  'subconscious.mode.simple.desc': '只读观察。仅可访问记忆和文件。',
  'subconscious.mode.aggressive.title': '积极',
  'subconscious.mode.aggressive.desc': '完整工具访问。可写入、创建代理和委派任务。',
  'subconscious.mode.aggressiveWarning':
    '积极模式赋予潜意识完整的工具访问权限，包括写入和创建子代理。',
  'subconscious.interval.label': '频率',
  'subconscious.interval.minutes': '{n}分钟',
  'subconscious.interval.hours': '{n}小时',
  'subconscious.interval.oneHour': '1小时',
  'subconscious.interval.oneDay': '24小时',
  'whatsapp.chatsSynced': '个对话已同步',
  'whatsapp.chatSynced': '个对话已同步',
  'sync.active': '活跃',
  'sync.recent': '最近',
  'sync.idle': '空闲',
  'sync.memorySources': '记忆来源',
  'sync.noConnectedSources': '未连接任何来源',
  'sync.chunks': '个片段',
  'sync.lastChunk': '最后片段：',
  'sync.pending': '待处理',
  'sync.processed': '已处理',
  'sync.syncing': '同步中...',
  'sync.sync': '同步',
  'sync.failedToLoad': '加载失败',
  'sync.noContent': '无可用内容',
  'memorySyncInterval.title': '同步计划',
  'memorySyncInterval.lastSynced': '上次同步',
  'memorySyncInterval.never': '从不',
  'memorySyncInterval.everyHours': '每 {h} 小时',
  'memorySyncInterval.everyMinutes': '每 {m} 分钟',
  'memorySyncInterval.manual': '仅手动',
  'memorySyncInterval.saveFailed': '更新同步计划失败',
  'memorySources.title': '记忆来源',
  'memorySources.empty': '暂无记忆来源。添加一个来源即可开始注入记忆。',
  'memorySources.customSources': '自定义来源',
  'memorySources.addSource': '添加来源',
  'memorySources.noCustomSources':
    '暂无自定义来源。添加文件夹、GitHub 仓库、RSS 订阅或网页即可开始。',
  'memorySources.loadingConnections': '正在加载连接…',
  'memorySources.noConnections': '未找到活跃的 Composio 连接。请先连接一个集成。',
  'memorySources.pickConnection': '选择连接',
  'memorySources.selectConnection': '选择连接',
  'memorySources.comingSoon': '即将推出',
  'memorySources.composioListFailed': '加载 Composio 连接失败。',
  'memorySources.browse': '浏览…',
  'memorySources.folderPathPlaceholder': '/Users/you/notes',
  'memorySources.globPatternPlaceholder': '**/*.md',
  'memorySources.repoUrlPlaceholder': 'https://github.com/org/repo',
  'memorySources.branchPlaceholder': 'main',
  'memorySources.feedUrlPlaceholder': 'https://example.com/feed.xml',
  'memorySources.pageUrlPlaceholder': 'https://example.com/article',
  'memorySources.cssSelectorPlaceholder': 'article',
  'memorySources.searchQueryPlaceholder': 'from:user AI safety',
  'memorySources.kind.composio': '集成',
  'memorySources.kind.conversation': '对话',
  'memorySources.kind.folder': '本地文件夹',
  'memorySources.kind.github_repo': 'GitHub 仓库',
  'memorySources.kind.twitter_query': 'Twitter 搜索',
  'memorySources.kind.rss_feed': 'RSS 订阅',
  'memorySources.kind.web_page': '网页',
  'memorySources.sync.successTitle': '正在同步',
  'memorySources.sync.successMessage': '进度很快会显示。',
  'memorySources.sync.failedTitle': '同步失败：',
  'memorySources.sync.completeTitle': '已同步',
  'memorySources.sync.itemsSynced': '项已同步',
  'memorySources.sync.upToDate': '已是最新',
  'memorySources.sync.failedLabel': '失败',
  'time.justNow': '刚刚',
  'time.secondsAgoSuffix': '秒前',
  'time.minutesAgoSuffix': '分钟前',
  'time.hoursAgoSuffix': '小时前',
  'time.daysAgoSuffix': '天前',
  'memorySources.pickKind': '要添加哪种来源？',
  'memorySources.backToKinds': '返回来源类型',
  'memorySources.label': '标签',
  'memorySources.labelPlaceholder': '我的研究笔记',
  'memorySources.add': '添加',
  'memorySources.adding': '正在添加…',
  'memorySources.added': '来源已添加',
  'memorySources.removed': '来源已移除',
  'memorySources.remove': '移除',
  'memorySources.enable': '启用',
  'memorySources.disable': '停用',
  'memorySources.toggleFailed': '切换失败',
  'memorySources.removeFailed': '移除失败',
  'memorySources.folderPath': '文件夹路径',
  'memorySources.globPattern': 'Glob 模式',
  'memorySources.repoUrl': '仓库 URL',
  'memorySources.branch': '分支',
  'memorySources.feedUrl': '订阅 URL',
  'memorySources.pageUrl': '页面 URL',
  'memorySources.cssSelector': 'CSS 选择器（可选）',
  'memorySources.searchQuery': '搜索查询',
  'memorySources.build.title': '构建',
  'memorySources.build.building': '正在构建…',
  'memorySources.build.successTitle': '树构建完成',
  'memorySources.build.failedTitle': '构建失败',
  'memorySources.build.sealsMessage': '密封完成',
  'memorySources.allIn.button': '全部启用',
  'memorySources.allIn.title': '全部启用？',
  'memorySources.allIn.message':
    '这将启用所有记忆来源并移除所有同步限制。可构建最丰富的记忆图谱，但可能会消耗更多积分。',
  'memorySources.allIn.confirm': '是',
  'memorySources.allIn.cancel': '否',
  'memorySources.allIn.success': '所有来源已无限制启用。同步已开始。',
  'memorySources.allIn.failed': '无法应用全部启用。请重试。',
  'memorySources.settings.button': '设置',
  'memorySources.settings.title': '同步设置',
  'memorySources.settings.maxPrs': '最大拉取请求数',
  'memorySources.settings.maxIssues': '最大问题数',
  'memorySources.settings.maxCommits': '最大提交数',
  'memorySources.settings.maxItems': '最大条目数',
  'memorySources.settings.sinceDays': '回溯天数',
  'memorySources.settings.syncDepthDays': '同步深度（天）',
  'memorySources.settings.maxTokens': '每次同步最大令牌数',
  'memorySources.settings.maxCost': '每次同步最大费用（USD）',
  'memorySources.settings.unlimited': '无限制',
  'memorySources.settings.unlimitedTooltip':
    '您已选择为 {toolkit} 同步最大数量。您可以在此处更改上限。',
  'memorySources.settings.maxed': '已满',
  'memorySources.settings.save': '保存',
  'memorySources.settings.saving': '保存中…',
  'memorySources.settings.saved': '设置已保存',
  'memorySources.settings.saveFailed': '无法保存设置',
  'backend.aiBackend': 'AI 后端',
  'backend.cloud': '云端',
  'backend.recommended': '推荐',
  'backend.cloudDescription': '快速、强大的模型托管在我们的服务器上。可立即使用。',
  'backend.privacyNote': '个人数据、消息或密钥绝不会发送到我们的服务器。',
  'backend.local': '本地',
  'backend.advanced': '高级',
  'backend.localDescription': '使用 Ollama 在本地运行模型。完全隐私，需要设置。',
  'backend.ramRecommended': '建议 16GB+ 内存',
  'subconscious.tasks': '个任务',
  'subconscious.ticks': '次滴答',
  'subconscious.last': '上次',
  'subconscious.failed': '失败',
  'subconscious.tickInterval': '滴答间隔',
  'subconscious.runNow': '立即运行',
  'subconscious.instance.on': '开启',
  'subconscious.instance.off': '关闭',
  'subconscious.instance.memory.title': '你的世界',
  'subconscious.instance.memory.subtitle': '已连接的记忆来源',
  'subconscious.instance.tinyplace.title': '编排引导',
  'subconscious.instance.tinyplace.subtitle': 'tiny.place 会话审查',
  'subconscious.instance.tinyplace.disabledHint': '启用编排以引导封装的会话。',
  'subconscious.instance.tinyplace.viewDirectives': '查看指令 →',
  'subconscious.runReviewNow': '立即运行审查',
  'tinyplaceOrchestration.subconsciousBadge': '潜意识 · 引导',
  'tinyplaceOrchestration.steeringHeader.current': '当前指令',
  'tinyplaceOrchestration.steeringHeader.none': '无活动指令',
  'tinyplaceOrchestration.steeringHeader.expires': '{n} 个周期后过期',
  'tinyplaceOrchestration.steeringHeader.lastReview': '上次审查',
  'tinyplaceOrchestration.steeringHeader.runReview': '立即运行审查',
  'tinyplaceOrchestration.steeringHeader.running': '运行中…',
  'subconscious.providerUnavailableTitle': '潜意识已暂停',
  'subconscious.providerSettings': 'AI 设置',
  'subconscious.scratchpadInfo':
    '潜意识在每次循环时检查你已连接来源中发生的变化，然后在待办事项列表中记录后续事项、更新你的目标，或在有需要关注的事情时通知你。请前往设置 → 代理访问来配置模式和频率。',
  'subconscious.approvalNeeded': '需要审批',
  'subconscious.requiresApproval': '需要审批',
  'subconscious.fixInConnections': '在连接中修复',
  'subconscious.goAhead': '继续执行',
  'subconscious.activeTasks': '活跃任务',
  'subconscious.noActiveTasks': '暂无活跃任务',
  'subconscious.default': '默认',
  'subconscious.addTaskPlaceholder': '添加新任务...',
  'subconscious.activityLog': '活动日志',
  'subconscious.noActivity': '暂无活动',
  'subconscious.decision.nothingNew': '无新内容',
  'subconscious.decision.completed': '已完成',
  'subconscious.decision.evaluating': '评估中',
  'subconscious.decision.waitingApproval': '等待审批',
  'subconscious.decision.failed': '失败',
  'subconscious.decision.cancelled': '已取消',
  'subconscious.decision.skipped': '已跳过',
  // Subconscious triggers (event-driven orchestrator) debug panel
  'subconsciousTriggers.title': '潜意识触发器',
  'subconsciousTriggers.subtitle': '事件驱动的后台编排器',
  'subconsciousTriggers.pipeline': '流水线',
  'subconsciousTriggers.mode': '模式',
  'subconsciousTriggers.orchestrator': '编排器',
  'subconsciousTriggers.running': '运行中',
  'subconsciousTriggers.stopped': '已停止',
  'subconsciousTriggers.promotionsPerHour': '提升 / 小时',
  'subconsciousTriggers.queueDepth': '队列深度',
  'subconsciousTriggers.orchestratorThread': '编排器线程',
  'subconsciousTriggers.userThread': '用户线程',
  'subconsciousTriggers.disabledHint': '启用事件驱动模式以激活流水线。',
  'subconsciousTriggers.enable': '启用',
  'subconsciousTriggers.disable': '停用',
  'actionable.complete': '完成',
  'actionable.dismiss': '忽略',
  'actionable.snooze': '稍后提醒',
  'actionable.new': '新',
  'stats.storage': '存储',
  'stats.files': '个文件',
  'stats.documents': '文档',
  'stats.today': '今天',
  'stats.namespaces': '命名空间',
  'stats.relations': '关系',
  'stats.firstMemory': '首条记忆',
  'stats.latest': '最新',
  'stats.sessions': '会话数',
  'stats.tokens': '个令牌',
  'bootCheck.invalidUrl': '请输入核心 URL。',
  'bootCheck.urlMustStartWith': 'URL 必须以 http:// 或 https:// 开头',
  'bootCheck.validUrlRequired': '请输入有效的 URL（例如 https://core.example.com/rpc）',
  'bootCheck.tokenRequired': '请输入核心认证令牌。',
  'bootCheck.httpPublicWarning':
    '这是公网主机上的纯 HTTP 地址：流量不会被加密。除非你信任该网络，否则请使用 HTTPS。',
  'bootCheck.chooseCoreMode': '选择核心模式',
  'bootCheck.connectToCore': '连接到你的核心',
  'bootCheck.desktopDescription': 'OpenHuman 需要一个运行中的核心才能工作。请选择连接方式。',
  'bootCheck.webDescription':
    '网页版 OpenHuman 连接到由你控制的远程核心。请输入其 URL 和认证令牌，或安装桌面版在本地运行核心。',
  'bootCheck.preferDesktop': '更希望在自己的设备上运行一切？',
  'bootCheck.downloadDesktop': '下载桌面应用',
  'bootCheck.localRecommended': '本地（推荐）',
  'bootCheck.localDescription': '嵌入式核心在本设备上运行：最快，无需配置。',
  'bootCheck.cloudMode': '云端',
  'bootCheck.cloudDescription': '连接到自定义 URL 处的远程核心。',
  'bootCheck.coreRpcUrl': '核心 RPC URL',
  'bootCheck.rpcUrlPlaceholder': 'https://core.example.com/rpc',
  'bootCheck.authToken': '认证令牌',
  'bootCheck.bearerTokenPlaceholder': '远程核心上配置的 Bearer 令牌',
  'bootCheck.storedLocally': '仅存储在本设备上。远程核心必需：桌面版每次 RPC 都会以 ',
  'bootCheck.testing': '测试中…',
  'bootCheck.testConnection': '测试连接',
  'bootCheck.connectedOk': '已连接 ✓',
  'bootCheck.authFailed': '认证失败：请检查令牌（收到 401/403）。',
  'bootCheck.unreachablePrefix': '无法连接：',
  'bootCheck.checkingCore': '正在检查核心…',
  'bootCheck.cannotReach': '无法连接到核心',
  'bootCheck.cannotReachDesc': '核心进程无法访问。请尝试切换到其他模式。',
  'bootCheck.switchMode': '切换模式',
  'bootCheck.quit': '退出',
  'bootCheck.legacyDetected': '检测到旧版后台核心',
  'bootCheck.legacyDescription':
    '此设备上正在运行一个单独安装的 OpenHuman 守护进程。必须先将其移除，嵌入式核心才能接管。',
  'bootCheck.removing': '正在移除…',
  'bootCheck.removeContinue': '移除并继续',
  'bootCheck.localNeedsRestart': '本地核心需要重启',
  'bootCheck.localNeedsRestartDesc': '本地核心版本与此应用构建版本不匹配。重启后将加载正确的版本。',
  'bootCheck.restarting': '正在重启…',
  'bootCheck.restartCore': '重启核心',
  'bootCheck.cloudNeedsUpdate': '云端核心需要更新',
  'bootCheck.cloudNeedsUpdateDesc':
    '云端核心版本与此应用构建版本不匹配。请运行核心更新程序来解决此差异。',
  'bootCheck.updating': '正在更新…',
  'bootCheck.updateCloudCore': '更新云端核心',
  'bootCheck.versionCheckFailed': '核心版本检查失败',
  'bootCheck.versionCheckFailedDesc':
    '核心正在运行但未暴露版本接口。它可能已过时。请重启或更新核心以继续。',
  'bootCheck.working': '正在执行…',
  'bootCheck.restartUpdateCore': '重启 / 更新核心',
  'bootCheck.unexpectedError': '意外的启动检查错误',
  'bootCheck.actionFailed': '操作失败：请重试。',
  'bootCheck.portConflictTitle': '无法启动应用引擎',
  'bootCheck.portConflictBody':
    '另一个进程正在占用 OpenHuman 所需的网络端口。我们将尝试自动修复此问题。',
  'bootCheck.portConflictFixButton': '自动修复',
  'bootCheck.portConflictFixing': '修复中…',
  'bootCheck.portConflictFixFailed': '自动修复未成功。请重启您的计算机后重试。',
  'bootCheck.portConflictOwner': '{name}（PID {pid}）正在占用 OpenHuman 所需的网络端口。',
  'bootCheck.portConflictGuidance': '请关闭该程序以释放端口，或在下方强制退出，然后重试。',
  'bootCheck.portConflictForceQuit': '强制退出 {name}',
  'bootCheck.portConflictForceQuitting': '正在关闭 {name}…',
  'bootCheck.portConflictForceQuitFailed': '无法关闭该程序。您可能需要手动关闭它，然后重试。',
  'notifications.justNow': '刚刚',
  'notifications.minAgo': '{n} 分钟前',
  'notifications.hrAgo': '{n} 小时前',
  'notifications.dayAgo': '{n} 天前',
  'notifications.category.messages': '消息',
  'notifications.category.agents': '智能体',
  'notifications.category.skills': '技能',
  'notifications.category.system': '系统',
  'notifications.category.meetings': '会议',
  'notifications.category.reminders': '提醒',
  'notifications.category.important': '重要',
  'notifications.filterAll': '全部',
  'notifications.filterEmpty': '此分类暂无通知',
  'about.update.status.checking': '检查中...',
  'about.update.status.available': 'v{version} 可用',
  'about.update.status.availableNoVersion': '更新可用',
  'about.update.status.downloading': '下载中...',
  'about.update.status.readyToInstall': 'v{version} 已准备好安装',
  'about.update.status.readyToInstallNoVersion': '已准备好安装',
  'about.update.status.installing': '安装中...',
  'about.update.status.restarting': '重启中...',
  'about.update.status.upToDate': '已是最新版本',
  'about.update.status.error': '更新检查失败',
  'about.update.status.default': '检查更新',
  'welcome.connectionFailed': '连接失败: {status} {statusText}',
  'welcome.connectionFailedMsg': '连接失败: {message}',
  'welcome.continueLocally': '本地继续',
  'welcome.continueLocallyExperimental': '本地继续（实验性）',
  'welcome.localSessionStarting': '正在启动本地会话...',
  'welcome.coreConfigUnreadable':
    '运行时无法读取自己的配置文件。config.toml 可能归属于其他用户账户，或因其他原因无法被运行时进程访问。请重启运行时；若仍未解决，请修复工作目录的归属权或重新创建其数据卷。',
  'welcome.localSessionErrorFallback': '无法启动本地会话。',
  'welcome.localSessionDesc': '使用离线本地配置文件，跳过 TinyHumans OAuth。',
  'chat.agentChatDesc': '与智能体进行直接对话。',
  'chat.modelPlaceholder': 'gpt-4o',
  'channels.activeRouteValue': '{channel} 通过 {authMode}',
  'privacy.dataKind.messages': '消息',
  'privacy.dataKind.agents': '智能体',
  'privacy.dataKind.skills': '技能',
  'privacy.dataKind.system': '系统',
  'privacy.dataKind.meetings': '会议',
  'privacy.dataKind.reminders': '提醒',
  'privacy.dataKind.important': '重要',
  'onboarding.enableLocalAI': '启用本地 AI',
  'onboarding.skills.status.available': '可用',
  'onboarding.skills.status.connected': '已连接',
  'onboarding.skills.status.connecting': '连接中',
  'onboarding.skills.status.error': '错误',
  'onboarding.skills.status.unavailable': '不可用',
  'composio.statusUnavailable': '状态不可用',
  'composio.authExpired': '授权已过期',
  'composio.reconnect': '重新连接',
  'composio.expiredAuthorization': '{name} 授权已过期',
  'composio.expiredDescription':
    '重新连接以重新启用 {name} 工具。 OpenHuman 将保持此集成不可用，直到您刷新 OAuth 访问权限。',
  'composio.envVarOverrides': '已设置，将覆盖此设置。',
  'composio.previewBadge': '预览',
  'composio.previewTooltip': '代理集成即将推出 - 您可以连接，但代理尚无法使用此工具包。',
  'memory.day.sun': '日',
  'memory.day.mon': '一',
  'memory.day.tue': '二',
  'memory.day.wed': '三',
  'memory.day.thu': '四',
  'memory.day.fri': '五',
  'memory.day.sat': '六',
  'memory.ingesting': '摄取中',
  'memory.ingestionQueued': '排队中',
  'memory.ingestingTitle': '正在摄取 {title}',
  'mic.noAudioCaptured': '未捕获到音频',
  'mic.noSpeechDetected': '未检测到语音',
  'mic.lowConfidenceResult': '无法清楚地理解音频：请重试',
  'mic.failedToStopRecording': '停止录音失败: {message}',
  'mic.transcriptionFailed': '转录失败: {message}',
  'mic.voiceNotCompiled': '此版本的应用未包含语音转文字功能。请更新 OpenHuman 后再使用。',
  'reflections.kind.retrospective': '回顾',
  'reflections.kind.derivedFact': '派生事实',
  'reflections.kind.moodInsight': '情绪洞察',
  'reflections.kind.relationshipInsight': '关系洞察',
  'graph.tooltip.summary': '摘要',
  'graph.tooltip.contact': '联系人',
  'localModel.usage.never': '从不',
  'localModel.usage.mediumLoad': '中等负载',
  'localModel.usage.lowLoad': '低负载',
  'localModel.usage.idleMode': '空闲模式',
  'localModel.rebootstrapComplete': '模型重新引导完成。',
  'localModel.modelsVerified': '本地模型已验证。',
  'accounts.addModal.allConnected': '全部已连接',
  'accounts.addModal.title': '添加账户',
  'accounts.respondQueue.empty': '队列为空',
  'accounts.respondQueue.hide': '隐藏回复队列',
  'accounts.respondQueue.loadFailed': '加载回复队列失败',
  'accounts.respondQueue.loading': '加载队列中…',
  'accounts.respondQueue.pending': '待处理',
  'accounts.respondQueue.show': '显示回复队列',
  'accounts.respondQueue.title': '回复队列',
  'accounts.webviewHost.almostReady': '即将就绪...',
  'accounts.webviewHost.loadTimeout': '网页视图加载超时',
  'accounts.webviewHost.loading': '正在加载 {providerName}...',
  'accounts.webviewHost.loadingAccount': '正在加载账户',
  'accounts.webviewHost.restoringSession': '正在恢复会话...',
  'accounts.webviewHost.retryLoading': '重试加载',
  'accounts.webviewHost.takingLonger': '{providerName} 加载时间比预期更长。',
  'accounts.webviewHost.timeoutHint': '超时提示',
  'app.connectionBadge.composio': 'Composio',
  'app.connectionBadge.messaging': '消息',
  'app.connectionIndicator.connected': '已连接到 OpenHuman AI',
  'app.connectionIndicator.connecting': '连接中',
  'app.connectionIndicator.coreOffline': '核心离线',
  'app.connectionIndicator.disconnected': '已断开',
  'app.connectionIndicator.offline': '离线',
  'app.connectionIndicator.reconnecting': '重新连接中…',
  'app.errorFallback.componentStack': '组件堆栈',
  'app.errorFallback.contactSupport': '联系支持',
  'app.errorFallback.copyEventId': '复制',
  'app.errorFallback.eventIdCopied': '已复制',
  'app.errorFallback.eventIdLabel': '错误 ID',
  'app.errorFallback.revealLogs': '显示日志',
  'app.errorFallback.downloadLatest': '下载最新版本',
  'app.errorFallback.heading': '出现错误',
  'app.errorFallback.hint': '提示',
  'app.errorFallback.reloadApp': '重新加载应用',
  'app.errorFallback.subheading': '详情',
  'app.errorFallback.tryRecover': '尝试恢复',
  'app.localAiDownload.installing': '安装中...',
  'app.localAiDownload.preparing': '准备中...',
  'app.openhumanLink.accounts.continueWith': '使用 {label} 登录继续',
  'app.openhumanLink.accounts.done': '完成',
  'app.openhumanLink.accounts.intro': '简介',
  'app.openhumanLink.accounts.webviewNote': '网页视图说明',
  'app.openhumanLink.billing.openDashboard': '打开控制台',
  'app.openhumanLink.billing.stayOnTrial': '继续试用',
  'app.openhumanLink.billing.trialCredit': '注册额度',
  'app.openhumanLink.billing.trialDesc': '额度优惠可能因促销活动和账号资格而异。',
  'app.openhumanLink.defaultBody': '弹窗中尚未就绪。完成后打开完整设置页面',
  'app.openhumanLink.discord.intro': '简介',
  'app.openhumanLink.discord.openInvite': '打开邀请',
  'app.openhumanLink.discord.perk1': '福利 1',
  'app.openhumanLink.discord.perk2': '福利 2',
  'app.openhumanLink.discord.perk3': '福利 3',
  'app.openhumanLink.discord.perk4': '福利 4',
  'app.openhumanLink.discordReport.intro':
    '抱歉：我们这边出错了。我们会尝试自动记录这些错误，但在 Discord 上分享详情能帮助我们更快地修复问题。',
  'app.openhumanLink.discordReport.openDiscord': '打开 Discord',
  'app.openhumanLink.done': '完成',
  'app.openhumanLink.notifications.desktopOnly':
    '原生通知仅在桌面应用中可用（运行 `pnpm dev:app`）。',
  'app.openhumanLink.notifications.permissionOff':
    '通知权限已关闭。请在“系统设置 → 通知”中启用 OpenHuman，然后重试。',
  'app.openhumanLink.notifications.triggerFailed':
    'OpenHuman 无法触发系统通知。请检查操作系统的通知设置，然后重试。',
  'app.openhumanLink.notifications.welcomeBody': '当有事情需要您关注时，您将在此处收到提醒。',
  'app.openhumanLink.notifications.welcomeTitle': 'OpenHuman 已准备就绪',
  'app.openhumanLink.status.closed': '已关闭',
  'app.openhumanLink.status.connected': '已连接',
  'app.openhumanLink.status.error': '错误',
  'app.openhumanLink.status.loading': '加载中…',
  'app.openhumanLink.status.needsSignIn': '需要登录',
  'app.openhumanLink.status.timedOut': '已超时',
  'app.openhumanLink.loadingChannelSetup': '正在加载渠道设置',
  'app.openhumanLink.maybeLater': '稍后再说',
  'app.openhumanLink.notifications.asking': '正在请求系统权限…',
  'app.openhumanLink.notifications.blocked': '已被阻止',
  'app.openhumanLink.notifications.blockedStep1': '打开系统设置',
  'app.openhumanLink.notifications.blockedStep2': '找到 OpenHuman',
  'app.openhumanLink.notifications.blockedStep3': '开启通知权限',
  'app.openhumanLink.notifications.intro': '简介',
  'app.openhumanLink.notifications.promptHint': '提示',
  'app.openhumanLink.notifications.retry': '重试测试通知',
  'app.openhumanLink.notifications.send': '发送测试通知',
  'app.openhumanLink.notifications.sendFailed': '无法发送：{error}',
  'app.openhumanLink.notifications.sent':
    '测试通知已发送。如果未收到，请前往「系统设置 → 通知 → OpenHuman」，开启「允许通知」并将横幅样式设置为「持续」。',
  'app.openhumanLink.skipForNow': '暂时跳过',
  'app.openhumanLink.telegramUnavailable': 'Telegram 不可用',
  'app.openhumanLink.title.accounts': '连接你的应用',
  'app.openhumanLink.title.billing': '账单与配额',
  'app.openhumanLink.title.discord': '加入社区',
  'app.openhumanLink.title.discordReport': '报告此错误',
  'app.openhumanLink.title.messaging': '连接聊天渠道',
  'app.openhumanLink.title.notifications': '允许通知',
  'app.persistRehydration.body': '正在恢复应用状态',
  'app.persistRehydration.heading': '加载中',
  'app.persistRehydration.resetCta': '重置中…',
  'app.persistRehydration.resetting': '重置中…',
  'app.routeLoading.initializing': '正在初始化 OpenHuman...',
  'app.update.currentlyOn': '{version}',
  'app.update.errorFallback': '更新时出现问题。',
  'app.update.header.default': '更新',
  'app.update.header.error': '更新失败',
  'app.update.header.installing': '正在安装更新',
  'app.update.header.readyToInstall': '更新已准备好安装',
  'app.update.header.restarting': '正在重启…',
  'app.update.later': '稍后',
  'app.update.newVersionReady': '新版本已准备好安装。',
  'app.update.progress.downloaded': '已下载',
  'app.update.progress.installing': '正在安装新版本…',
  'app.update.progress.restarting': '正在重新启动应用…',
  'app.update.progress.working': '{percent}%',
  'app.update.restartNote': '重启说明',
  'app.update.restartNow': '立即重启',
  'app.update.versionReady': '版本 {newVersion} 已准备好安装。',
  'channels.discord.accountLinked': '账户已关联',
  'channels.discord.connect': '连接',
  'channels.discord.linkTokenExpired': '关联令牌已过期，请重试。',
  'channels.discord.linkTokenInstruction': '{token}',
  'channels.discord.linkTokenLabel': '关联令牌',
  'channels.discord.linkTokenOnce': '一次性关联令牌',
  'channels.discord.picker.allPermissionsOk': '机器人在该频道拥有所有必要权限。',
  'channels.discord.picker.botNotInServers': '机器人未加入任何服务器',
  'channels.discord.picker.category': '分类',
  'channels.discord.picker.channel': '频道',
  'channels.discord.picker.checkingPermissions': '检查权限中',
  'channels.discord.picker.loadingChannels': '正在加载频道...',
  'channels.discord.picker.loadingServers': '正在加载服务器...',
  'channels.discord.picker.missingPermissions': '缺少权限',
  'channels.discord.picker.noChannels': '未找到文字频道',
  'channels.discord.picker.noServers': '未找到服务器',
  'channels.discord.picker.selectChannel': '选择频道',
  'channels.discord.picker.selectServer': '选择服务器',
  'channels.discord.picker.server': '服务器',
  'channels.discord.picker.serverChannelSelection': '服务器与频道选择',
  'channels.discord.savedRestartRequired': '频道已保存。重启应用以激活。',
  'channels.telegram.connect': '连接',
  'channels.telegram.managedDmConnecting': '正在连接私信',
  'channels.telegram.managedDmTimeout': '私信连接超时',
  'channels.telegram.reconnect': '重新连接',
  'channels.telegram.savedRestartRequired': '频道已保存。重启应用以激活。',
  'channels.web.alwaysAvailable': '始终可用',
  'chat.approval.approve': '批准',
  'chat.approval.alwaysAllow': '始终允许',
  'chat.approval.alwaysAllowHint': '不再询问此工具：将其加入始终允许列表',
  'chat.approval.deciding': '处理中…',
  'chat.approval.deny': '拒绝',
  'chat.approval.error': '无法记录你的决定：请重试。',
  'chat.approval.fallback': '智能体想要运行一项需要你批准的操作。',
  'chat.approval.title': '需要批准',
  'chat.approval.tool': '工具：',
  'chat.flowApproval.title': '工作流需要批准',
  'chat.flowApproval.fallback': '工作流运行想要执行一个需要你批准的操作。',
  'chat.flowApproval.tool': '工具：',
  'chat.flowApproval.flow': '流程：',
  'chat.flowApproval.approve': '批准一次',
  'chat.flowApproval.approveAlways': '始终批准',
  'chat.flowApproval.approveAlwaysHint': '跳过此流程未来运行中的此检查点',
  'chat.flowApproval.deny': '拒绝',
  'chat.flowApproval.deciding': '处理中…',
  'chat.flowApproval.error': '无法记录你的决定：请重试。',
  'chat.flowProposal.title': '工作流建议',
  'chat.flowProposal.subtitle': '保存前请先查看此自动化流程。',
  'chat.flowProposal.triggerLabel': '触发器',
  'chat.flowProposal.stepsLabel': '步骤',
  'chat.flowProposal.noSteps': '没有其他步骤。',
  'chat.flowProposal.requireApprovalHint': '每个外发操作都需要你的批准。',
  'chat.flowProposal.save': '保存并启用',
  'chat.flowProposal.saving': '保存中…',
  'chat.flowProposal.openInCanvas': '在画布中打开',
  'chat.flowProposal.dismiss': '忽略',
  'chat.flowProposal.error': '无法保存该工作流。请重试。',
  'chat.flowProposal.enableError': '工作流已保存，但无法启用。请重试，或在“工作流”页面手动启用。',
  'chat.flowProposal.savedConfirmation': '已保存',
  'chat.flowProposal.viewWorkflow': '查看工作流',
  'chat.flowProposal.stepKind.agent': '智能体',
  'chat.flowProposal.stepKind.toolCall': '操作',
  'chat.flowProposal.stepKind.httpRequest': '网络请求',
  'chat.flowProposal.stepKind.code': '运行代码',
  'chat.flowProposal.stepKind.condition': '条件',
  'chat.flowProposal.stepKind.switch': '分支选择',
  'chat.flowProposal.stepKind.merge': '合并',
  'chat.flowProposal.stepKind.splitOut': '拆分',
  'chat.flowProposal.stepKind.transform': '转换',
  'chat.flowProposal.stepKind.outputParser': '解析输出',
  'chat.flowProposal.stepKind.subWorkflow': '子工作流',
  'channels.authMode.managed_dm': '使用 OpenHuman 登录',
  'channels.authMode.oauth': 'OAuth 登录',
  'channels.authMode.bot_token': '使用你自己的 Bot Token',
  'channels.authMode.api_key': '使用你自己的 API Key',
  'channels.fieldRequired': '{field} 是必填项',
  'channels.mcp.title': 'MCP 服务器',
  'channels.mcp.description': '浏览和管理扩展 AI 能力的 Model Context Protocol 服务器。',
  'channels.discord.displayName': 'Discord',
  'channels.discord.description': '通过 Discord 发送和接收消息。',
  'channels.discord.authMode.bot_token.description': '提供你自己的 Discord bot token。',
  'channels.discord.authMode.oauth.description':
    '通过 OAuth 将 OpenHuman 机器人安装到你的 Discord 服务器。',
  'channels.discord.authMode.managed_dm.description':
    '将你的个人 Discord 账户关联到 OpenHuman 机器人。',
  'channels.discord.fields.bot_token.label': '机器人代币',
  'channels.discord.fields.bot_token.placeholder': '你的 Discord bot token',
  'channels.discord.fields.guild_id.label': '服务器 (Guild) ID',
  'channels.discord.fields.guild_id.placeholder': '可选：限制到特定服务器',
  'channels.telegram.displayName': 'Telegram',
  'channels.telegram.description': '通过 Telegram 发送和接收消息。',
  'channels.telegram.authMode.managed_dm.description': '直接向 OpenHuman Telegram 机器人发送消息。',
  'channels.telegram.authMode.bot_token.description':
    '从 @BotFather 获取你自己的 Telegram Bot token。',
  'channels.telegram.fields.bot_token.label': '机器人代币',
  'channels.telegram.fields.bot_token.placeholder': '123456:ABC-DEF1234ghIkl-zyx57W2v1u123ew11',
  'channels.telegram.fields.allowed_users.label': '允许的用户',
  'channels.telegram.fields.allowed_users.placeholder': '逗号分隔的 Telegram 用户名',
  'channels.telegram.remoteControlTitle': '远程控制 (Telegram)',
  'channels.telegram.remoteControlBody':
    '从允许的 Telegram 聊天中，发送 /status、/sessions、/new 或 /help。模型路由仍然使用 /model 和 /models。',
  'channels.connectHelp.title': '如何连接',
  'channels.connectHelp.discord':
    '在下方选择一种方式：通过 OpenHuman 关联你的账号、用 OAuth 安装机器人，或粘贴你在 Discord 开发者门户中的机器人令牌。',
  'channels.connectHelp.telegram':
    '在下方选择一种方式：给托管的 OpenHuman 机器人发消息以完成关联，或粘贴你在 @BotFather 获取的机器人令牌。',
  'channels.connectHelp.slackNote':
    '在找 Slack？Slack 是在 连接 → OAuth 中作为应用连接的，而不是这里的消息渠道。',
  'channels.web.displayName': '网络',
  'channels.web.description': '通过内置的 Web UI 聊天。',
  'channels.web.authMode.managed_dm.description': '使用嵌入式 Web 聊天：无需设置。',
  'channels.yuanbao.connect': 'Connect',
  'channels.yuanbao.connecting': '连接中…',
  'channels.yuanbao.fieldRequired': '{field} 不能为空',
  'channels.yuanbao.reconnect': 'Reconnect',
  'channels.yuanbao.savedRestartRequired': '频道已保存。重启应用以激活。',
  'channels.yuanbao.unexpectedStatus': '意外的连接状态：{status}',
  'chat.unsubscribeApproval.approve': '批准并退订',
  'chat.unsubscribeApproval.approved': '✓ 已成功退订。',
  'chat.unsubscribeApproval.denied': '✕ 请求已拒绝。',
  'chat.unsubscribeApproval.deny': '拒绝',
  'chat.unsubscribeApproval.processing': '处理中...',
  'chat.unsubscribeApproval.title': '退订请求',
  'commandPalette.ariaLabel': '命令面板',
  'commandPalette.description': '描述',
  'commandPalette.label': '命令',
  'commandPalette.noResults': '无结果',
  'commandPalette.placeholder': '输入命令或搜索…',
  'commandPalette.searchAria': '搜索命令',
  'commandPalette.shortcutHint': '按 ? 查看所有快捷键',
  'commandPalette.title': '命令面板',
  'kbd.ariaLabel': '键盘快捷键：{shortcut}',
  'shortcuts.title': '键盘快捷键',
  'shortcuts.subtitle': '使用这些键盘快捷键加快你的工作流程。',
  'shortcuts.menuDesc': '浏览应用中的所有键盘快捷键。',
  'shortcuts.empty': '当前没有可用的键盘快捷键。',
  'shortcuts.openHint': '随时可用以下按键打开此列表',
  'shortcuts.group.navigation': '导航',
  'shortcuts.group.profiles': '配置文件',
  'shortcuts.group.chat': '聊天',
  'shortcuts.group.view': '视图',
  'shortcuts.group.general': '常规',
  'shortcuts.group.help': '帮助',
  'shortcuts.action.home': '转到主页',
  'shortcuts.action.chat': '转到聊天',
  'shortcuts.action.knowledge': '转到知识与记忆',
  'shortcuts.action.connections': '转到连接',
  'shortcuts.action.activity': '转到活动',
  'shortcuts.action.settings': '打开设置',
  'shortcuts.action.newChat': '新建聊天',
  'shortcuts.action.toggleSidebar': '切换侧边栏',
  'shortcuts.action.commandPalette': '命令面板',
  'iosMascot.connectedTo': '连接到',
  'iosMascot.defaultPairedLabel': '桌面',
  'iosMascot.disconnect': '断开连接',
  'iosMascot.error.generic': '出了点问题。请再试一次。',
  'iosMascot.error.sendFailed': '发送失败。检查您的连接。',
  'iosMascot.pushToTalk': '一键通话',
  'iosMascot.sendMessage': '发送消息',
  'iosMascot.thinking': '想着……',
  'iosMascot.typeMessage': '输入消息...',
  'iosPair.connectedLoading': '已连接！正在加载...',
  'iosPair.connecting': '正在连接到桌面...',
  'iosPair.desktopLabel': '桌面',
  'iosPair.error.camera': '相机扫描失败。检查相机权限并重试。',
  'iosPair.error.connectionFailed': '连接失败。请确保桌面应用正在运行，然后重试。',
  'iosPair.error.invalidQr': '二维码无效。请确保您扫描的是 OpenHuman 配对码。',
  'iosPair.error.unreachableDesktop': '无法连接到桌面端。请确保两台设备均已联网，然后重试。',
  'iosPair.expired': 'QR code 已过期。要求桌面重新生成代码。',
  'iosPair.instructions':
    '在桌面端打开 OpenHuman，前往「设置 > 设备」，点击「配对手机」以显示二维码。',
  'iosPair.retryScan': '重试扫描',
  'iosPair.scanQrCode': '扫描QR code',
  'iosPair.scannerOpening': '扫描仪打开...',
  'iosPair.step.openDesktop': '在桌面上打开 OpenHuman',
  'iosPair.step.openSettings': '转至设置 > 设备',
  'iosPair.step.showQr': '点击“配对手机”以显示 QR',
  'iosPair.title': '与您的桌面配对',
  'composio.connect.additionalConfigRequired': '需要额外配置',
  'composio.connect.atlassianSubdomainHint': '极致',
  'composio.connect.atlassianSubdomainLabel': 'Atlassian 子域名',
  'composio.connect.connect': '连接',
  'composio.connect.connectedAccounts': '已连接账户',
  'composio.connect.defaultLabel': '默认',
  'composio.connect.disconnectAccount': '移除',
  'composio.connect.addAnotherAccount': '添加另一个账户',
  'composio.connect.dynamicsOrgNameHint':
    '例如，myorg.crm.dynamics.com 的组织名称为 "myorg"。仅输入简短的组织名称，而不是完整 URL。',
  'composio.connect.dynamicsOrgNameLabel': 'Dynamics 365 组织名称',
  'composio.connect.connectionFailed': '连接失败（状态：{status}）。',
  'composio.connect.disconnectFailed': '断开连接失败：{msg}',
  'composio.connect.disconnecting': '断开中…',
  'composio.connect.idleDescription': '连接你的',
  'composio.connect.idleDescriptionSuffix':
    '账户。我们会打开浏览器窗口，你在其中授权后，应用会自动检测到该连接。',
  'composio.connect.isConnected': '已连接。',
  'composio.connect.manage': '管理',
  'composio.connect.needsFieldsPrefix': '若要连接',
  'composio.connect.needsFieldsSuffix': '我们需要一些额外信息。请填写下面缺失的字段并重试。',
  'composio.connect.needsSubdomain': '要连接',
  'composio.connect.needsSubdomainSuffix':
    '请输入你的 Atlassian 子域名（例如 acme.atlassian.net 中的 acme），然后重试。',
  'composio.connect.oauthComplete': '等待完成 OAuth…',
  'composio.connect.oauthTimeout': 'OAuth 超时',
  'composio.connect.permissions': '权限',
  'composio.connect.permissionsDefault': '默认启用读写权限',
  'composio.connect.permissionsNote': '可暴露',
  'composio.connect.permissionsNoteSuffix':
    'OpenHuman 自身的智能体权限通过下方的读取、写入和管理员开关控制。',
  'composio.connect.reopenBrowser': '重新打开浏览器',
  'composio.connect.requestingUrl': '正在请求连接 URL…',
  'composio.connect.requiredFieldEmpty': '此字段为必填项。',
  'composio.connect.retryConnection': '重试连接',
  'composio.connect.scopeLoadError': '无法加载权限范围偏好：{msg}',
  'composio.connect.scopeSaveError': '无法保存 {key} 权限范围：{msg}',
  'composio.connect.scope.read': '阅读',
  'composio.connect.scope.readHint': '允许代理从此连接读取数据。',
  'composio.connect.scope.write': '写',
  'composio.connect.scope.writeHint': '允许代理通过此连接创建或修改数据。',
  'composio.connect.scope.admin': '管理员',
  'composio.connect.scope.adminHint': '允许代理管理设置、权限或破坏性操作。',
  'composio.connect.subdomainInvalid':
    '仅输入短子域名（例如 "acme"），而非完整 URL。只能包含字母、数字和连字符。',
  'composio.connect.subdomainRequired': '请输入你的 Atlassian 子域名以继续。',
  'composio.connect.wabaIdHint':
    '通过 Meta 访问令牌调用 GET /me/businesses，然后 GET /{business_id}/owned_whatsapp_business_accounts 获取。',
  'composio.connect.wabaIdLabel': 'WhatsApp 企业账户 ID',
  'composio.connect.atlassianSubdomainPlaceholder': 'your-subdomain',
  'composio.connect.dynamicsOrgNamePlaceholder': 'myorg',
  'composio.connect.wabaIdPlaceholder': 'e.g. 123456789012345',
  'composio.connect.wabaIdRequired': '请输入你的 WhatsApp 企业账户 ID（WABA ID）以继续。',
  'composio.connect.waitingFor': '等待中',
  'composio.connect.waitingHint': '请在浏览器中完成授权',
  'composio.triggers.heading': '触发器',
  'composio.triggers.listenFrom': '监听来自以下的事件',
  'composio.triggers.loadError': '无法加载触发器',
  'composio.triggers.sessionExpired': '你的 OpenHuman 会话已过期。请重新登录以加载触发器。',
  'composio.triggers.needsConfiguration': '需要配置',
  'composio.triggers.noneAvailable': '当前没有可用的触发器：',
  'conversations.taskKanban.moveLeft': '向左移动',
  'conversations.taskKanban.moveRight': '向右移动',
  'conversations.taskKanban.title': '任务',
  'conversations.threadTodo.title': '计划',
  'conversations.planReview.title': '审阅计划',
  'conversations.planReview.subtitle': '批准以执行，拒绝以放弃，或发送反馈以修改。',
  'conversations.planReview.approve': '批准并执行',
  'conversations.planReview.reject': '拒绝',
  'conversations.planReview.feedbackLabel': '请求修改',
  'conversations.planReview.feedbackPlaceholder': '描述需要修改的内容…',
  'conversations.planReview.sendFeedback': '发送反馈',
  'conversations.threadGoal.label': '目标',
  'conversations.threadGoal.setCta': '设定目标',
  'conversations.threadGoal.placeholder': '这个对话需要完成什么？',
  'conversations.threadGoal.save': '保存',
  'conversations.threadGoal.cancel': '取消',
  'conversations.threadGoal.edit': '编辑目标',
  'conversations.threadGoal.clear': '清除目标',
  'conversations.threadGoal.complete': '标记为完成',
  'conversations.threadGoal.pause': '暂停',
  'conversations.threadGoal.resume': '继续',
  'conversations.threadGoal.tokensSuffix': '令牌',
  'conversations.threadGoal.status.active': '进行中',
  'conversations.threadGoal.status.paused': '已暂停',
  'conversations.threadGoal.status.budget_limited': '预算已用尽',
  'conversations.threadGoal.status.complete': '已完成',
  'conversations.taskKanban.approval.default': '默认',
  'conversations.taskKanban.approval.notRequired': '无需审批',
  'conversations.taskKanban.approval.notRequiredBadge': '无需审批',
  'conversations.taskKanban.approval.required': '需要审批',
  'conversations.taskKanban.approval.requiredBadge': '需审批',
  'conversations.taskKanban.approval.requiredBeforeExecution': '执行前需要审批',
  'conversations.taskKanban.briefButton': '任务简报',
  'conversations.taskKanban.briefTitle': '任务简报',
  'conversations.taskKanban.closeBrief': '关闭任务简报',
  'conversations.taskKanban.field.acceptanceCriteria': '验收标准',
  'conversations.taskKanban.field.allowedTools': '允许的工具',
  'conversations.taskKanban.field.approval': '审批',
  'conversations.taskKanban.field.assignedAgent': '已分配智能体',
  'conversations.taskKanban.field.blocker': '阻碍项',
  'conversations.taskKanban.field.evidence': '证据',
  'conversations.taskKanban.field.notes': '备注',
  'conversations.taskKanban.field.objective': '目标',
  'conversations.taskKanban.field.plan': '计划',
  'conversations.taskKanban.field.status': '状态',
  'conversations.taskKanban.field.title': '标题',
  'conversations.taskKanban.saveChanges': '保存更改',
  'conversations.taskKanban.deleteCard': '删除',
  'conversations.taskKanban.workTask': '处理任务',
  'conversations.taskKanban.viewWork': '查看工作',
  'conversations.taskKanban.startingTask': '正在启动…',
  'conversations.taskKanban.updateFailed': '无法更新任务；更改未保存。',
  'conversations.taskKanban.sourcesButton': '来源',
  'conversations.taskKanban.source.openExternal': '打开外部任务',
  'conversations.taskKanban.source.openExternalShort': '打开',
  'conversations.taskKanban.source.unknownProvider': '未知来源',
  'conversations.taskKanban.source.urgencyValue': '紧急度 {percent}%',
  'conversations.taskKanban.sources.desktopOnly': '任务来源控件可在桌面应用中使用。',
  'conversations.taskKanban.sources.title': '任务来源',
  'conversations.taskKanban.sources.statusEnabled': '自动轮询已启用',
  'conversations.taskKanban.sources.manage': '管理来源',
  'conversations.taskKanban.source.title': '来源',
  'conversations.taskKanban.source.sourceId': '来源 ID',
  'conversations.taskKanban.source.externalId': '外部 ID',
  'conversations.taskKanban.source.repo': '仓库',
  'conversations.taskKanban.source.urgency': '紧急度',
  'conversations.toolTimeline.turn': '轮次',
  'conversations.toolTimeline.step': '步骤',
  'conversations.toolTimeline.workerThread': '工作线程',
  'conversations.subagent.viewProcessing': '查看完整处理过程',
  'conversations.subagent.parent': '父级',
  'conversations.subagent.thinking': '思考中',
  'conversations.subagent.thoughts': '想法',
  'conversations.subagent.response': '回复',
  'conversations.subagent.toolCalls': '工具调用',
  'conversations.subagent.working': '处理中…',
  'conversations.subagent.noOutputYet': '暂无输出',
  'conversations.subagent.input': '输入',
  'conversations.subagent.output': '输出',
  'conversations.subagent.noOutput': '无输出返回',
  'conversations.subagent.close': '关闭',
  'conversations.subagent.cancel': '取消任务',
  'conversations.subagent.cancelling': '正在取消…',
  'conversations.subagent.cancelFailed': '无法取消任务。请重试。',
  'conversations.subagent.statusRunning': '运行中',
  'conversations.subagent.statusCompleted': '已完成',
  'conversations.subagent.statusFailed': '失败',
  'conversations.subagent.statusAwaitingUser': '等待用户',
  'conversations.subagent.statusCancelled': '已取消',
  'conversations.agentTaskInsights.title': '智能体任务洞察',
  'conversations.agentTaskInsights.response': '回复',
  'conversations.agentTaskInsights.processSourceTitle': '智能体处理来源',
  'conversations.agentTaskInsights.stepsHeading': '步骤',
  'conversations.agentTaskInsights.sourcesHeading': '来源',
  'conversations.agentTaskInsights.noSteps': '未记录任何步骤',
  'conversations.agentTaskInsights.viewProcessSource': '查看完整的智能体处理来源',
  'conversations.agentTaskInsights.processing': '处理中',
  'conversations.agentTaskInsights.done': '完成',
  'conversations.agentTaskInsights.failed': '失败',
  'conversations.agentTaskInsights.running': '运行中',
  'conversations.agentTaskInsights.cancelled': '已取消',
  'conversations.agentTaskInsights.awaitingUser': '等待输入',
  'conversations.agentTaskInsights.viewDetails': '查看详情',
  'conversations.agentTaskInsights.subagentsHeading': '子代理',
  'daemon.serviceBlockingGate.body': '核心服务不可用，请等待或下载最新版本。',
  'daemon.serviceBlockingGate.downloadHint': '下载最新版本',
  'daemon.serviceBlockingGate.downloadLatest': '下载最新版本',
  'daemon.serviceBlockingGate.retryCore': '重试 Core',
  'daemon.serviceBlockingGate.retryFailed': '重试失败。请下载最新应用版本后重试。',
  'daemon.serviceBlockingGate.retrying': '重试中...',
  'daemon.serviceBlockingGate.title': 'OpenHuman 核心不可用',
  'home.banners.discordSubtitle': '加入我们，获取最新资讯',
  'home.banners.discordTitle': '加入我们的 Discord',
  'home.banners.earlyBirdDismiss': '忽略早鸟横幅',
  'home.banners.earlyBirdFirstSub': '首次订阅。',
  'home.banners.earlyBirdOn': '早鸟优惠进行中',
  'home.banners.earlyBirdTitle': '前 1,000 名用户享 6 折优惠。',
  'home.banners.earlyBirdUseCode': '使用早鸟码',
  'home.banners.getSubscription': '获取订阅',
  'home.banners.promoCreditsBody': '你有 {amount} 促销额度。你可以',
  'home.banners.promoCreditsUsage': '查看用量详情',
  'intelligence.memoryChunk.detail.chunk': '片段',
  'intelligence.memoryChunk.detail.copyChunkId': '复制片段 ID',
  'intelligence.memoryChunk.detail.embeddingInfo': 'bge-m3 1024 维',
  'intelligence.memoryChunk.detail.noEmbedding': '无嵌入',
  'intelligence.memoryChunk.letterhead.from': '来自',
  'intelligence.memoryChunk.letterhead.to': '至',
  'intelligence.memoryChunk.mentioned.chunkOne': '1 个片段',
  'intelligence.memoryChunk.mentioned.chunkOther': '{count} 个片段',
  'intelligence.memoryChunk.mentioned.heading': '提及',
  'intelligence.memoryChunk.scoreBars.ariaScore': '{name} 得分 {pct}%',
  'intelligence.memoryChunk.scoreBars.atThreshold': '阈值 {threshold}',
  'intelligence.memoryChunk.scoreBars.dropped': '已丢弃',
  'intelligence.memoryChunk.scoreBars.heading': '保留原因',
  'intelligence.memoryChunk.scoreBars.kept': '已保留',
  'intelligence.diagram.title': '架构图',
  'intelligence.diagram.description': '来自已配置图表端点的最新本地架构输出。',
  'intelligence.diagram.refresh': 'Refresh',
  'intelligence.diagram.refreshAria': '刷新图表',
  'intelligence.diagram.emptyTitle': '暂无可用图表',
  'intelligence.diagram.emptyDescription': '从编排器生成架构图，此面板将从已配置的本地端点刷新。',
  'intelligence.diagram.skillInstallCommand': 'npx skills add yizhiyanhua-ai/fireworks-tech-graph',
  'intelligence.diagram.promptExample': '以深色终端风格生成当前集群的架构图',
  'intelligence.diagram.imageAlt': '最新生成的 OpenHuman 架构图',
  'intelligence.diagram.refreshesEvery': '每 {seconds} 秒刷新',
  'intelligence.memoryText.entityTypePrefix': '实体类型',
  'intelligence.tasks.activeBoardOne': '1 个跨对话的活跃看板',
  'intelligence.tasks.activeBoardOther': '{count} 个跨对话的活跃看板',
  'intelligence.tasks.empty': '暂无智能体任务看板',
  'intelligence.tasks.emptyHint': '完成一项对话后，任务看板将出现在这里。',
  'intelligence.tasks.failedToLoad': '加载失败',
  'intelligence.tasks.live': '实时',
  'intelligence.tasks.loadingBoards': '正在加载任务看板…',
  'intelligence.tasks.threadPrefix': '对话 {thread}',
  'intelligence.tasks.subtitle': '整个工作区中的你的任务和智能体任务看板。',
  'intelligence.tasks.newTask': '新建任务',
  'intelligence.tasks.personalBoardTitle': '智能体任务',
  'intelligence.tasks.personalEmpty': '暂无个人任务',
  'intelligence.tasks.composer.title': '新建任务',
  'intelligence.tasks.composer.titleLabel': '标题',
  'intelligence.tasks.composer.titlePlaceholder': '需要完成什么？',
  'intelligence.tasks.composer.statusLabel': '状态',
  'intelligence.tasks.composer.attachLabel': '附加到对话',
  'intelligence.tasks.composer.attachNone': '个人（无对话）',
  'intelligence.tasks.composer.objectiveLabel': '目标',
  'intelligence.tasks.composer.objectivePlaceholder': '可选：期望的结果',
  'intelligence.tasks.composer.notesLabel': '备注',
  'intelligence.tasks.composer.notesPlaceholder': '可选备注',
  'intelligence.tasks.composer.create': '创建任务',
  'intelligence.tasks.composer.creating': '正在创建…',
  'intelligence.tasks.composer.createFailed': '无法创建任务',
  'intelligence.tasks.composer.assignAgentLabel': '让智能体自动处理此任务',
  'intelligence.tasks.composer.assignAgentHint':
    '任务看板会接手并替你执行。普通的个人待办请保持关闭。',
  'intelligence.tasks.sourceList.subtitle': '等待转为智能体工作的来源任务。',
  'intelligence.tasks.sourceList.empty': '没有等待处理的来源任务。',
  'intelligence.tasks.sourceList.queued': '已入队',
  'intelligence.tasks.sourceList.workOnTask': '处理任务',
  'intelligence.tasks.sourcePlan.title': '细化来源任务',
  'intelligence.tasks.sourcePlan.subtitle': '创建智能体任务前，请检查研究草稿。',
  'intelligence.tasks.sourcePlan.researchAgent': '研究智能体草稿',
  'intelligence.tasks.sourcePlan.approve': '批准计划',
  'intelligence.tasks.sourcePlan.creating': '正在创建任务…',
  'intelligence.tasks.sourcePlan.createFailed': '无法创建智能体任务',
  'intelligence.tasks.workTaskFailed': '无法开始处理任务',
  'intelligence.workTask.sourceTaskHeading': '来源任务：',
  'intelligence.workTask.repositoryLine': '- 仓库：{repo}',
  'intelligence.workTask.externalIdLine': '- 外部 ID：{externalId}',
  'intelligence.workTask.urlLine': '- 网址：{url}',
  'intelligence.workTask.closingInstruction':
    '先简要重述具体的实施计划，然后执行它。在此线程中保持进度可见，并在工作状态变化时更新任务看板。',
  'intelligence.agentWork.subtitle': '所有后台智能体运行，按生命周期状态分组。',
  'intelligence.agentWork.loading': '正在加载智能体工作…',
  'intelligence.agentWork.failedToLoad': '无法加载智能体工作',
  'intelligence.agentWork.empty': '暂无后台智能体运行。',
  'intelligence.agentWork.bucket.needsInput': '需要输入',
  'intelligence.agentWork.bucket.working': '进行中',
  'intelligence.agentWork.bucket.completed': '已完成',
  'intelligence.agentWork.bucket.failed': '失败',
  'intelligence.agentWork.bucket.stopped': '已停止',
  'intelligence.agentWork.column.agent': '智能体',
  'intelligence.agentWork.column.status': '状态',
  'intelligence.agentWork.column.elapsed': '已用时间',
  'intelligence.agentWork.column.cost': '成本',
  'intelligence.agentWork.column.tokens': '令牌',
  'intelligence.agentWork.status.pending': '待定',
  'intelligence.agentWork.status.running': '进行中',
  'intelligence.agentWork.status.awaitingUser': '需要输入',
  'intelligence.agentWork.status.paused': '已暂停',
  'intelligence.agentWork.status.completed': '已完成',
  'intelligence.agentWork.status.failed': '失败',
  'intelligence.agentWork.status.cancelled': '已取消',
  'intelligence.agentWork.status.interrupted': '已中断',
  'intelligence.agentWork.kind.subagent': '子智能体',
  'intelligence.agentWork.kind.workerThread': '工作线程',
  'intelligence.agentWork.kind.backgroundAgent': '后台智能体',
  'intelligence.agentWork.kind.teamMember': '团队成员',
  'intelligence.agentWork.kind.workflowChild': '工作流子项',
  'intelligence.agentWork.openThread': '打开会话',
  'intelligence.agentWork.openWorker': '打开工作线程',
  'worktree.label': '工作树',
  'worktree.dirty': '未提交的更改',
  'worktree.clean': '干净',
  'worktree.changedFile': '个更改的文件',
  'worktree.changedFiles': '个更改的文件',
  'worktree.removing': '正在移除…',
  'worktree.removeFailed': '移除工作树失败',
  'worktree.diffFailed': '加载差异失败',
  'worktree.diffLoading': '正在加载差异…',
  'worktree.diffEmpty': '与 HEAD 相比没有更改。',
  'worktree.dirtyConfirm': '此工作树有未提交的更改。移除它将丢弃这些工作。工作进程分支会保留。',
  'worktree.action.open': '打开文件夹',
  'worktree.action.diff': '差异',
  'worktree.action.hideDiff': '隐藏差异',
  'worktree.action.remove': '移除',
  'worktree.action.removeAnyway': '丢弃并移除',
  'worktree.action.preserve': '保留',
  'worktree.panel.subtitle': '由并行智能体工作进程创建的隔离 git 工作树。',
  'worktree.panel.loading': '正在加载工作树…',
  'worktree.panel.failedToLoad': '加载工作树失败',
  'worktree.panel.empty': '没有隔离的工作树。具有工作树隔离的并行工作进程将显示在此处。',
  'worktree.panel.overlapsTitle': '重叠的更改',
  'worktree.panel.overlapHint': '这些文件被多个工作树更改过：合并前请先协调。',
  'intelligence.agentWork.action.stop': '停止',
  'intelligence.agentWork.action.retry': '重试',
  'intelligence.agentWork.action.continue': '继续',
  'intelligence.agentWork.action.followUp': '追问',
  'intelligence.agentWork.action.send': '发送',
  'intelligence.agentWork.action.cancel': '取消',
  'intelligence.agentWork.action.continuePlaceholder': '回复以解除此智能体的阻塞…',
  'intelligence.agentWork.action.followUpPlaceholder': '发送追加指令…',
  'intelligence.agentWork.action.failed': '操作失败',
  'intelligence.teams.subtitle': '协同的智能体团队及其共享的任务。',
  'intelligence.teams.loading': '正在加载团队…',
  'intelligence.teams.failedToLoad': '加载团队失败',
  'intelligence.teams.empty': '暂无智能体团队',
  'intelligence.teams.emptyHint':
    '当某个智能体生成协同的子智能体以共享同一目标时，团队会显示在这里。',
  'intelligence.teams.refresh': '刷新',
  'intelligence.teams.backToList': '所有团队',
  'intelligence.teams.status.active': '活跃',
  'intelligence.teams.status.closed': '已关闭',
  'intelligence.teams.header.lead': '负责人',
  'intelligence.teams.header.taskCount': '{count} 个任务',
  'intelligence.teams.header.memberCount': '{count} 名成员',
  'intelligence.teams.member.active': '活跃',
  'intelligence.teams.member.pending': '待处理',
  'intelligence.teams.member.idle': '空闲',
  'intelligence.teams.member.stopped': '已停止',
  'intelligence.teams.column.todo': '待办',
  'intelligence.teams.column.ready': '就绪',
  'intelligence.teams.column.inProgress': '进行中',
  'intelligence.teams.column.blocked': '已阻塞',
  'intelligence.teams.column.done': '已完成',
  'intelligence.teams.emptyColumn': '空',
  'intelligence.teams.unclaimed': '未认领',
  'intelligence.teams.pickedUpBy': '由 {name} 接手',
  'intelligence.teams.depLockTitle': '{count} 项未满足的依赖',
  'intelligence.teams.gate.pending': '关卡待定',
  'intelligence.teams.gate.passed': '关卡通过',
  'intelligence.teams.gate.failed': '关卡失败',
  'intelligence.teams.gate.label': '关卡：{status}',
  'intelligence.teams.activity.title': '团队动态',
  'intelligence.teams.activity.empty': '暂无消息',
  'intelligence.teams.activity.toTeam': '团队',
  'intelligence.teams.member.start': '启动',
  'intelligence.teams.composer.placeholder': '给队友发消息…',
  'intelligence.teams.composer.send': '发送',
  'intelligence.teams.composer.recipient': '接收者',
  'intelligence.teams.composer.toTeam': '整个团队',
  'intelligence.teams.action.blocked': '正在等待依赖',
  'intelligence.teams.action.alreadyClaimed': '已被其他队友认领',
  'intelligence.teams.action.alreadyActive': '队友已在运行中',
  'intelligence.teams.action.noClaimableTask': '没有可供该队友处理的任务',
  'intelligence.teams.action.unknownTask': '未找到任务',
  'intelligence.refine.objectiveDefault': '将来源任务转化为可立即实施的智能体任务：{title}',
  'intelligence.refine.sourceLine': '来源：{url}',
  'intelligence.refine.sourceIntake': '来源：任务来源接收',
  'intelligence.refine.repositoryLine': '仓库：{repo}',
  'intelligence.refine.externalTaskLine': '外部任务：{externalId}',
  'intelligence.refine.planStep1': '阅读关联的来源任务，确认所请求的确切行为。',
  'intelligence.refine.planStep2': '检查相关代码路径，确定最小的实施边界。',
  'intelligence.refine.planStep3': '围绕用户可见的行为，通过有针对性的测试实现该更改。',
  'intelligence.refine.planStep4': '运行有针对性的验证，并记录任何残留风险或后续工作。',
  'intelligence.refine.acceptance1': '来源任务的需求已体现在最终实现中。',
  'intelligence.refine.acceptance2': '相关的单元测试或集成测试覆盖了已更改的行为。',
  'intelligence.refine.acceptance3': '验证结果和任何未解决的风险在完成时被记录。',
  'notifications.card.dismiss': '忽略通知',
  'notifications.card.importanceTitle': '重要性',
  'notifications.center.empty': '暂无通知',
  'notifications.center.emptyHint': '新通知将出现在这里',
  'notifications.center.filterAll': '全部',
  'notifications.center.markAllRead': '全部标记已读',
  'notifications.center.title': '通知',
  'notifications.meeting.joinListen': '加入（仅收听）',
  'notifications.meeting.joinActive': '加入并回复',
  'notifications.meeting.skip': '不是这个',
  'notifications.meeting.alwaysJoin': '始终加入',
  'notifications.meeting.actionError': '无法完成该操作，请重试。',
  'notifications.flow.approveTitle': '工作流需要批准',
  'notifications.flow.approve': '批准',
  'notifications.flow.approving': '批准中…',
  'notifications.flow.dismiss': '忽略',
  'notifications.flow.error': '无法恢复工作流，请重试。',
  'notifications.flow.gateCount': '正在等待 {count} 个批准节点',
  'notifications.flow.approveHint': '在此检查点之后恢复工作流',
  'notifications.flow.dismissHint': '隐藏此提示但不恢复工作流',
  'notifications.flow.viewRun': '查看运行',
  'notifications.flowGate.title': '工作流需要批准',
  'notifications.flowGate.tool': '工具：',
  'notifications.flowGate.approve': '批准一次',
  'notifications.flowGate.approveAlways': '始终批准',
  'notifications.flowGate.approveAlwaysHint': '跳过此流程未来运行中的此检查点',
  'notifications.flowGate.deny': '拒绝',
  'notifications.flowGate.deciding': '处理中…',
  'notifications.flowGate.error': '无法记录你的决定：请重试。',
  'flowRuns.inspector.title': '运行详情',
  'flowRuns.inspector.startedAt': '开始时间',
  'flowRuns.inspector.finishedAt': '结束时间',
  'flowRuns.inspector.running': '运行中…',
  'flowRuns.inspector.error': '错误',
  'flowRuns.inspector.pendingApprovals': '待批准',
  'flowRuns.inspector.pendingApprovalsCount': '{count} 个节点等待批准',
  'flowRuns.inspector.approval.tool': '工具：',
  'flowRuns.inspector.approval.approve': '批准一次',
  'flowRuns.inspector.approval.approveAlways': '始终批准',
  'flowRuns.inspector.approval.approveAlwaysHint': '跳过此流程未来运行中的此检查点',
  'flowRuns.inspector.approval.deny': '拒绝',
  'flowRuns.inspector.approval.deciding': '处理中…',
  'flowRuns.inspector.approval.loadError': '无法加载此运行的待批准项。',
  'flowRuns.inspector.steps': '步骤',
  'flowRuns.inspector.noSteps': '尚未记录任何步骤。',
  'flowRuns.inspector.output': '显示原始输出',
  'flowRuns.inspector.summary.failedPrefix': '无法完成：',
  'flowRuns.inspector.summary.unknownError': '出了点问题',
  'flowRuns.inspector.summary.itemsFetched': '已获取 {count} 项',
  'flowRuns.inspector.summary.completed': '步骤已完成',
  'flowRuns.inspector.summary.noOutput': '未生成任何输出',
  'flowRuns.inspector.port': '端口',
  'flowRuns.inspector.loading': '正在加载运行…',
  'flowRuns.inspector.loadError': '无法加载此运行',
  'flowRuns.inspector.fixWithAgent': '让智能体修复',
  'flowRuns.inspector.dataTable': '表格',
  'flowRuns.inspector.dataJson': 'JSON',
  'flowRuns.inspector.dataViewLabel': '输出视图',
  'flowRuns.inspector.itemCount': '{count} 项',
  'flowRuns.inspector.noItems': '无输出项',
  'flowRuns.inspector.emptyValue': '(空)',
  'flowRuns.inspector.binaryLabel': '二进制',
  'flowRuns.inspector.showSource': '来源',
  'flowRuns.inspector.hideSource': '隐藏来源',
  'flowRuns.inspector.sourceInputTitle': '来源输入项',
  'flowRuns.status.running': '运行中',
  'flowRuns.status.completed': '已完成',
  'flowRuns.status.completed_with_warnings': '完成但有警告',
  'flowRuns.status.pending_approval': '等待批准',
  'flowRuns.status.failed': '失败',
  'flowRuns.status.cancelled': '已取消',
  'flowRuns.status.interrupted': '已中断',

  'flows.page.title': '工作流',
  'flows.page.description': '已保存的自动化流程，可启用、运行并监控。',
  'flows.page.emptyTitle': '还没有工作流',
  'flows.page.emptyDescription': '在画布中创建工作流后，将显示在此处。',
  'flows.page.loading': '正在加载工作流…',
  'flows.page.loadError': '无法加载工作流，请重试。',
  'flows.page.newWorkflow': '新建工作流',
  'flows.list.lastRun': '上次运行',
  'flows.list.neverRun': '从未运行',
  'flows.list.justNow': '刚刚',
  'flows.discoveries.title': '工作流发现',
  'flows.discoveries.description': 'Flow Scout 根据你的工作方式建议的自动化。',
  'flows.allRuns.title': '工作流运行',
  'flows.allRuns.description': '工作区中的所有工作流运行，最新的优先。',
  'flows.allRuns.loading': '正在加载运行…',
  'flows.allRuns.empty': '暂无工作流运行。',
  'flows.allRuns.unknownWorkflow': '未知工作流',
  'flows.allRuns.status.running': '运行中',
  'flows.allRuns.status.completed': '已完成',
  'flows.allRuns.status.completed_with_warnings': '完成但有警告',
  'flows.allRuns.status.pending_approval': '等待批准',
  'flows.allRuns.status.failed': '失败',
  'flows.allRuns.status.cancelled': '已取消',
  'flows.allRuns.status.interrupted': '已中断',
  'flows.list.minutesAgo': '{count}分钟前',
  'flows.list.hoursAgo': '{count}小时前',
  'flows.list.daysAgo': '{count}天前',
  'flows.list.runNow': '运行',
  'flows.list.running': '运行中…',
  'flows.list.viewRuns': '查看运行记录',
  'flows.list.toggleEnabled': '启用工作流',
  'flows.list.enabled': '已启用',
  'flows.list.paused': '已暂停',
  'flows.list.runStarted': '工作流已启动',
  'flows.runs.title': '{name} 的运行记录',
  'flows.runs.titleFallback': '工作流运行记录',
  'flows.runs.loading': '正在加载运行记录…',
  'flows.runs.loadError': '无法加载运行记录',
  'flows.runs.empty': '暂无运行记录',
  'flows.promptBar.label': '描述一个工作流',
  'flows.promptBar.placeholder': '描述你的工作流',
  'flows.promptBar.copilotTitle': '副驾驶',
  'flows.promptBar.submit': '生成',
  'flows.promptBar.startBuilding': '开始生成',
  'flows.promptBar.disclaimer': '副驾驶是 AI，可能会出错。请仔细核对回复。',
  'flows.promptBar.thinking': '正在生成…',
  'flows.promptBar.heroTitle': '描述一个工作流',
  'flows.promptBar.heroSubtitle': '告诉生成器要自动化什么，然后审阅它的方案。',
  'flows.promptBar.error': '无法连接工作流生成器，请重试。',
  'flows.promptBar.offline': '你已离线，请重新连接以生成工作流。',
  'flows.suggest.title': '为你推荐',
  'flows.suggest.subtitle': 'Flow Scout 根据你的工作方式，认为可能对你有帮助的自动化。',
  'flows.suggest.discover': '发现',
  'flows.suggest.rediscover': '刷新',
  'flows.suggest.discovering': '正在查找自动化…',
  'flows.suggest.empty': '暂无建议。运行发现，Flow Scout 将浏览你的工作，寻找值得设置的自动化。',
  'flows.suggest.error': '无法运行发现，请重试。',
  'flows.suggest.why': '原因',
  'flows.suggest.build': '构建此项',
  'flows.suggest.opening': '正在打开…',
  'flows.suggest.dismiss': '忽略',
  'flows.suggest.uses': '使用',
  'flows.suggest.trigger.schedule': '已排程',
  'flows.suggest.trigger.app_event': '事件触发',
  'flows.suggest.trigger.manual': '按需',
  'flows.copilot.open': '副驾驶',
  'flows.copilot.title': '工作流副驾驶',
  'flows.copilot.subtitle': '请求修改，并在应用每个方案前先审阅。',
  'flows.copilot.close': '关闭副驾驶',
  'flows.copilot.placeholder': '请求一处修改…',
  'flows.copilot.send': '发送',
  'flows.copilot.thinking': '思考中…',
  'flows.copilot.error': '无法连接工作流生成器，请重试。',
  'flows.copilot.offline': '你已离线，请重新连接以使用副驾驶。',
  'flows.copilot.emptyState': '描述对该工作流的修改，生成器会提出更新方案。',
  'flows.copilot.proposalTitle': '建议的修改',
  'flows.copilot.added': '新增 {count} 个',
  'flows.copilot.removed': '移除 {count} 个',
  'flows.copilot.noChanges': '此方案未更改任何节点。',
  'flows.copilot.accept': '应用到草稿',
  'flows.copilot.acceptAndSave': '接受并保存',
  'flows.copilot.saveAndEnable': '保存并启用',
  'flows.copilot.saving': '保存中…',
  'flows.copilot.enabling': '启用中…',
  'flows.copilot.enableError': '已保存，但无法启用该工作流。请尝试从列表中启用它。',
  'flows.copilot.reject': '放弃',
  'flows.copilot.previewHint': '正在查看建议的草稿：尚未保存任何内容。',
  'flows.copilot.repairDisplay': '一次运行失败了，请查看并提出修复方案。',
  'flows.copilot.tool.proposing': '正在提出工作流…',
  'flows.copilot.tool.dryRunning': '正在试运行工作流…',
  'flows.copilot.tool.saving': '正在保存工作流…',
  'flows.copilot.tool.usingTools': '正在使用工具…',
  'flows.copilot.cappedNotice':
    '构建器在完成此工作流之前达到了迭代次数上限。继续将基于当前草稿继续构建。',
  'flows.copilot.continueBuilding': '继续构建',
  'flows.list.view': '查看工作流',
  'flows.list.export': '导出',
  'flows.list.exported': '工作流已导出',
  'flows.page.import': '导入',
  'flows.import.invalidFile': '该文件不是有效的工作流 JSON。',
  'flows.import.error': '无法导入此工作流。请检查文件后重试。',
  'flows.import.warningTitle': '导入警告',
  'flows.canvas.title': '工作流',
  'flows.canvas.loading': '正在加载工作流…',
  'flows.canvas.loadError': '无法加载此工作流。请重试。',
  'flows.canvas.notFound': '未找到此工作流。',
  'flows.canvas.draftMissing': '没有可打开的工作流草稿。请先在聊天中提出一个。',
  'flows.canvas.backToList': '返回工作流列表',
  'flows.nodeKind.trigger': '触发器',
  'flows.nodeKind.agent': '智能体',
  'flows.nodeKind.tool_call': '工具调用',
  'flows.nodeKind.http_request': 'HTTP 请求',
  'flows.nodeKind.code': '代码',
  'flows.nodeKind.condition': '条件',
  'flows.nodeKind.switch': '分支',
  'flows.nodeKind.merge': '合并',
  'flows.nodeKind.split_out': '拆分输出',
  'flows.nodeKind.transform': '转换',
  'flows.nodeKind.output_parser': '输出解析器',
  'flows.nodeKind.sub_workflow': '子工作流',
  'flows.nodeKind.memory': '记忆',
  'flows.nodeKind.dedup': '去重',
  'flows.nodeKind.loop': '循环',
  'flows.nodeSummary.trigger.manual': '按需运行',
  'flows.nodeSummary.trigger.webhook': '收到传入 Webhook 时运行',
  'flows.nodeSummary.trigger.appEventOn': '在{parts}',
  'flows.nodeSummary.trigger.appEvent': '应用事件触发时运行',
  'flows.nodeSummary.trigger.unknownKind': '触发器：{kind}',
  'flows.nodeSummary.agent.defaultModel': '默认模型',
  'flows.nodeSummary.agent.withPrompt': '“{prompt}” · {model}',
  'flows.nodeSummary.agent.default': '询问{model}',
  'flows.nodeSummary.toolCall.runsNative': '运行{name}',
  'flows.nodeSummary.toolCall.pickNative': '运行一个 OpenHuman 工具（请选择一个）',
  'flows.nodeSummary.toolCall.runs': '运行{slug}',
  'flows.nodeSummary.toolCall.pick': '运行一个应用操作（请选择一个）',
  'flows.nodeSummary.http.withUrl': '{method} {url}',
  'flows.nodeSummary.http.noUrl': '{method} 请求（请设置 URL）',
  'flows.nodeSummary.code.runs': '运行 {lang} 代码',
  'flows.nodeSummary.condition.withField': '如果 {field} → 真 / 假',
  'flows.nodeSummary.condition.default': '分支为真 / 假',
  'flows.nodeSummary.switch.byExpr': '按 {expr} 路由',
  'flows.nodeSummary.switch.byExprWithRoutes': '按 {expr} 路由（{count} 条路径）',
  'flows.nodeSummary.switch.byValue': '按值路由',
  'flows.nodeSummary.switch.byValueWithRoutes': '按值路由（{count} 条路径）',
  'flows.nodeSummary.merge': '合并并行分支',
  'flows.nodeSummary.splitOut.withPath': '拆分每个 {path}',
  'flows.nodeSummary.splitOut.default': '将列表拆分为条目',
  'flows.nodeSummary.transform.default': '重塑每个条目',
  'flows.nodeSummary.transform.setFieldsSingular': '为每个条目设置 {n} 个字段',
  'flows.nodeSummary.transform.setFieldsPlural': '为每个条目设置 {n} 个字段',
  'flows.nodeSummary.outputParser': '解析上一步的输出',
  'flows.nodeSummary.subWorkflow': '运行嵌套工作流',
  'flows.nodeSummary.memory.flavourWith': '读取"{flavour}"风格',
  'flows.nodeSummary.memory.flavour': '读取一个记忆风格',
  'flows.nodeSummary.memory.people': '查询人物记忆',
  'flows.nodeSummary.memory.remember': '在此工作流中记住一个值',
  'flows.nodeSummary.memory.forget': '从此工作流中忘记一个值',
  'flows.nodeSummary.memory.searchScoped': '搜索记忆（{scope}）',
  'flows.nodeSummary.memory.search': '搜索记忆',
  'flows.nodeSummary.memory.recallScoped': '从记忆中回忆（{scope}）',
  'flows.nodeSummary.memory.recall': '从记忆中回忆',
  'flows.nodeSummary.dedup.withKey': '按 {key} 跳过已处理过的条目',
  'flows.nodeSummary.dedup.default': '跳过已处理的条目',
  'flows.nodeSummary.loop.upTo': '最多重复 {max} 次',
  'flows.nodeSummary.loop.whileCondition': '当 {condition} 时最多重复 {max} 次',
  'flows.palette.title': '节点',
  'flows.palette.addNode': '添加{kind}节点',
  'flows.editor.save': '保存',
  'flows.editor.deleteSelected': '删除所选',
  // ── Validation UX + draft/dirty state (issue B5b / Phase 3c–3d)
  'flows.editor.saving': '正在保存…',
  'flows.editor.run': '运行',
  'flows.editor.running': '运行中…',
  'flows.editor.runFailed': '无法开始运行',
  'flows.editor.validate': '验证',
  'flows.editor.validating': '正在验证…',
  'flows.editor.discard': '放弃更改',
  'flows.editor.confirm.runTitle': '运行工作流？',
  'flows.editor.confirm.runBody': '这将立即运行工作流。',
  'flows.editor.confirm.saveTitle': '保存更改？',
  'flows.editor.confirm.saveBody': '这将保存你对工作流的更改。',
  'flows.editor.confirm.discardTitle': '放弃更改？',
  'flows.editor.confirm.discardBody': '这将撤销所有未保存的编辑，且无法恢复。',
  'flows.editor.confirm.confirm': '确认',
  'flows.editor.confirm.cancel': '取消',
  'flows.editor.unsaved': '未保存的更改',
  'flows.editor.saveBlocked': '保存前请修复下方的错误。',
  'flows.editor.errorsTitle': '错误',
  'flows.editor.warningsTitle': '警告',
  'flows.editor.saveFailedTitle': '无法保存',
  'flows.editor.leaveTitle': '不保存就离开？',
  'flows.editor.leaveBody': '此工作流有未保存的更改。如果现在离开，更改将会丢失。',
  'flows.editor.leaveStay': '留下',
  'flows.editor.leaveDiscard': '离开',
  // ── Node config drawer (issue B5b / Phase 3b)：per-kind config forms
  'flowRuns.inspector.diagnosticsTitle': '表达式警告',
  'flowRuns.inspector.diagnosticResolvedNull': '解析为 null',
  'flows.runs.sidebarTitle': '运行记录',
  'flows.runs.refresh': '刷新运行记录',
  'flows.palette.appAction': '应用操作',
  'flows.palette.ohTool': '工具',
  'flows.editor.deleteNode': '删除',
  'flows.nodeConfig.connections.title': '连接',
  'flows.nodeConfig.connections.inputs': '输入',
  'flows.nodeConfig.connections.outputs': '输出',
  'flows.nodeConfig.connections.none': '尚未连接到任何其他节点。',
  'flows.nodeConfig.connections.remove': '移除连接',
  'flows.nodeConfig.trigger.scheduleCronLabel': 'Cron 表达式',
  'flows.nodeConfig.trigger.scheduleFreqLabel': '频率',
  'flows.nodeConfig.trigger.scheduleFreq_minutes': '每 N 分钟',
  'flows.nodeConfig.trigger.scheduleFreq_hours': '每 N 小时',
  'flows.nodeConfig.trigger.scheduleFreq_daily': '每天指定时间',
  'flows.nodeConfig.trigger.scheduleEvery': '每',
  'flows.nodeConfig.trigger.scheduleInterval': '间隔',
  'flows.nodeConfig.trigger.scheduleUnit_minutes': '分钟',
  'flows.nodeConfig.trigger.scheduleUnit_hours': '小时',
  'flows.nodeConfig.trigger.scheduleAt': '在',
  'flows.nodeConfig.trigger.scheduleTime': '一天中的时间',
  'flows.nodeConfig.trigger.scheduleDays': '在这些天（可选，留空表示每天）',
  'flows.nodeConfig.trigger.scheduleAdvanced': '高级（编辑 cron）',
  'flows.nodeConfig.trigger.scheduleSimple': '返回简单计划',
  'flows.cron.customSchedule': '自定义计划（{expr}）',
  'flows.cron.noScheduleSet': '未设置计划',
  'flows.cron.weekdays': '工作日',
  'flows.cron.weekends': '周末',
  'flows.cron.everyMinute': '每分钟',
  'flows.cron.everyMinuteOnDays': '{days}每分钟',
  'flows.cron.everyNMinutes': '每 {n} 分钟',
  'flows.cron.everyNMinutesOnDays': '{days}每 {n} 分钟',
  'flows.cron.everyHour': '每小时',
  'flows.cron.everyHourOnDays': '{days}每小时',
  'flows.cron.everyNHours': '每 {n} 小时',
  'flows.cron.everyNHoursOnDays': '{days}每 {n} 小时',
  'flows.cron.everyDayAtTime': '每天 {time}',
  'flows.cron.atTimeOnDays': '在{days} {time}',
  'flows.cron.invalidInterval': '无效的间隔',
  'flows.cron.dailyEvery24h': '每天（每 24 小时）',
  'flows.cron.everyNDays': '每 {n} 天',
  'flows.cron.everyNHoursShort': '每 {n} 小时',
  'flows.cron.everyNMinutesShort': '每 {n} 分钟',
  'flows.cron.everySecond': '每秒',
  'flows.cron.everyNSeconds': '每 {n} 秒',
  'flows.cron.onceAtRaw': '{at} 一次',
  'flows.cron.onceAt': '{at} 一次',
  'flows.nodeConfig.trigger.pickApp': '请先选择一个已连接的应用。',
  'flows.nodeConfig.tool.pickConnection': '请先选择一个连接。',
  'flows.nodeConfig.composio.noConnections':
    '还没有已连接的应用。请在“设置 → 应用”中连接一个，然后在这里选择。',
  'flows.nodeConfig.composio.selectApp': '选择应用…',
  'flows.nodeConfig.composio.select': '选择…',
  'flows.nodeConfig.composio.loading': '正在加载…',
  'flows.nodeConfig.composio.custom': '手动输入…',
  'flows.nodeConfig.composio.customPlaceholder': 'SLUG_NAME',
  'flows.nodeConfig.agent.modelHint': '选择能力层级，工作区会解析具体模型。',
  'flows.nodeConfig.agent.modelInherit': '默认（继承）',
  'flows.nodeConfig.agent.agentRefLabel': '智能体',
  'flows.nodeConfig.agent.agentRefHint': '将此节点作为已注册的智能体运行：其工具和防护措施将生效。',
  'flows.nodeConfig.agent.agentRefInherit': '默认（工作流构建器）',
  'flows.nodeConfig.agent.modelManagedTiers': '托管层级',
  'flows.nodeConfig.agent.modelHints': '模型提示',
  'flows.nodeConfig.agent.modelCustom': '自定义模型…',
  'flows.nodeConfig.agent.modelCustomPlaceholder': '例如 gpt-4o-mini',
  'flows.nodeConfig.tool.requiredMark': '必填',
  'flows.nodeConfig.tool.requiredMissing': '必填：尚未接线',
  'flows.nodeConfig.tool.argsAdvancedLabel': '所有参数（高级）',
  'flows.nodeConfig.upstream.insert': '插入…',
  'flows.nodeConfig.upstream.insertLabel': '插入上一步的值',
  'flows.nodeConfig.native.toolLabel': '工具',
  'flows.nodeConfig.native.toolHint': '助手内置工具之一（搜索、媒体、文件等）。',
  'flows.nodeConfig.native.select': '选择工具…',
  'flows.nodeConfig.native.loading': '正在加载工具…',
  'flows.nodeConfig.close': '关闭设置',
  'flows.nodeConfig.nameLabel': '名称',
  'flows.nodeConfig.namePlaceholder': '节点名称',
  'flows.nodeConfig.editForm': '以表单编辑',
  'flows.nodeConfig.editJson': '以 JSON 编辑',
  'flows.nodeConfig.rawJsonLabel': '配置 (JSON)',
  'flows.nodeConfig.rawJsonHint': '此节点的自由配置。',
  'flows.nodeConfig.rawJsonInvalid': 'JSON 无效：解析成功前更改不会应用。',
  'flows.nodeConfig.expressionHint': '以 = 开头可根据节点输入计算值，例如 =item.url',
  'flows.nodeConfig.expressionBadge': '表达式',
  'flows.nodeConfig.keymapKeyPlaceholder': '键',
  'flows.nodeConfig.keymapValuePlaceholder': '值',
  'flows.nodeConfig.keymapRemove': '删除行',
  'flows.nodeConfig.keymapAdd': '添加行',
  'flows.nodeConfig.credentialLabel': '凭据',
  'flows.nodeConfig.credentialHint': '为此节点选择已连接的账户或凭据。',
  'flows.nodeConfig.credentialEmpty': '没有可用的已连接凭据。',
  'flows.nodeConfig.credentialNone': '无',
  'flows.nodeConfig.trigger.kindLabel': '触发器类型',
  'flows.nodeConfig.trigger.kind_manual': '手动',
  'flows.nodeConfig.trigger.kind_schedule': '计划',
  'flows.nodeConfig.trigger.kind_webhook': 'Webhook',
  'flows.nodeConfig.trigger.kind_app_event': '应用事件',
  'flows.nodeConfig.trigger.scheduleLabel': 'Cron 计划',
  'flows.nodeConfig.trigger.scheduleHint': 'Cron 表达式：分 时 日 月 星期。',
  'flows.nodeConfig.trigger.toolkitLabel': '工具包',
  'flows.nodeConfig.trigger.triggerSlugLabel': '触发器标识',
  'flows.nodeConfig.trigger.webhookHint': 'Webhook 触发器会被保存，但尚不会自动触发。',
  'flows.nodeConfig.http.methodLabel': '方法',
  'flows.nodeConfig.http.urlLabel': 'URL',
  'flows.nodeConfig.http.headersLabel': '请求头',
  'flows.nodeConfig.http.bodyLabel': '正文 (JSON)',
  'flows.nodeConfig.agent.promptLabel': '提示词',
  'flows.nodeConfig.agent.promptPlaceholder': '给智能体的指令…',
  'flows.nodeConfig.agent.modelLabel': '模型',
  'flows.nodeConfig.tool.slugLabel': '工具标识',
  'flows.nodeConfig.tool.argsLabel': '参数 (JSON)',
  'flows.nodeConfig.condition.fieldLabel': '字段',
  'flows.nodeConfig.condition.fieldHint': '用于判断真值的输入项键。路由到 true 或 false。',
  'flows.nodeConfig.switch.expressionLabel': '表达式',
  'flows.nodeConfig.switch.hint': '结果值选择匹配的输出端口；null 路由到 default。',
  'flows.nodeConfig.switch.fieldLabel': '字段（回退）',
  'flows.nodeConfig.transform.setLabel': '设置字段',
  'flows.nodeConfig.transform.setHint': '每个值都是按项求值的表达式，例如 =item.name',
  'flows.nodeConfig.code.languageLabel': '语言',
  'flows.nodeConfig.code.language_javascript': 'JavaScript',
  'flows.nodeConfig.code.language_python': 'Python',
  'flows.nodeConfig.code.sourceLabel': '源代码',
  'flows.nodeConfig.memory.operationLabel': '操作',
  'flows.nodeConfig.memory.operation_recall': '回忆',
  'flows.nodeConfig.memory.operation_search': '搜索',
  'flows.nodeConfig.memory.operation_flavour': '风格',
  'flows.nodeConfig.memory.operation_people': '人物',
  'flows.nodeConfig.memory.operation_remember': '记住',
  'flows.nodeConfig.memory.operation_forget': '忘记',
  'flows.nodeConfig.memory.scopeLabel': '范围',
  'flows.nodeConfig.memory.scopeHint': '在哪里查找这条记忆。',
  'flows.nodeConfig.memory.scopeWriteHint': '写入仅允许在此工作流内进行，绝不会写入你的个人记忆。',
  'flows.nodeConfig.memory.scope_user': '你（只读）',
  'flows.nodeConfig.memory.scope_flow': '此工作流',
  'flows.nodeConfig.memory.scope_flows': '所有工作流（只读）',
  'flows.nodeConfig.memory.queryLabel': '查询',
  'flows.nodeConfig.memory.queryOptionalHint': '可选：缩小人物查找范围。',
  'flows.nodeConfig.memory.flavourLabel': '风格',
  'flows.nodeConfig.memory.flavourHint': '要读取哪个人格面向，例如 communication。',
  'flows.nodeConfig.memory.flavour_communication': '沟通',
  'flows.nodeConfig.memory.flavour_coding_style': '编码风格',
  'flows.nodeConfig.memory.flavour_stack': '技术栈',
  'flows.nodeConfig.memory.flavour_workflow': '工作流程',
  'flows.nodeConfig.memory.flavour_environment': '环境',
  'flows.nodeConfig.memory.flavour_directives': '指令',
  'flows.nodeConfig.memory.flavour_anti_preferences': '负向偏好',
  'flows.nodeConfig.memory.keyLabel': '键',
  'flows.nodeConfig.memory.valueLabel': '值',
  'flows.nodeConfig.memory.limitLabel': '数量上限',
  'flows.nodeConfig.memory.limitHint': '返回结果的最大数量。',
  'flows.nodeConfig.memory.minScoreLabel': '最低分数',
  'flows.nodeConfig.memory.minScoreHint': '相关性阈值，范围为 0 到 1。',
  'flows.nodeConfig.dedup.keyLabel': '键',
  'flows.nodeConfig.dedup.keyHint':
    '每个项目的稳定 id 表达式，例如 =item.id。已出现过该键的项目将被跳过。',

  // `loop` node: a bounded loop head. Emits on `body` until its cap or
  // condition says stop, then on `done`.
  'flows.nodeConfig.loop.maxIterationsLabel': '最大迭代次数',
  'flows.nodeConfig.loop.maxIterationsHint': '循环体在循环停止前最多可运行的次数。始终有限。',
  'flows.nodeConfig.loop.onExceededLabel': '达到上限时',
  'flows.nodeConfig.loop.onExceededHint':
    '让运行失败，或停止循环并携带最后一轮的条目从 done 端口继续。',
  'flows.nodeConfig.loop.onExceeded_error': '让运行失败',
  'flows.nodeConfig.loop.onExceeded_continue': '带着部分结果继续',
  'flows.nodeConfig.loop.conditionLabel': '继续条件',
  'flows.nodeConfig.loop.conditionHint':
    '可选。只要结果为真，循环就继续；第一个为假的结果将从 done 端口退出。',

  'flows.enableApproval.title': '允许此工作流执行操作吗？',
  'flows.enableApproval.intro': '此工作流需要您对以下操作的许可。批准仅适用于此工作流。',
  'flows.enableApproval.approveAll': '全部批准',
  'flows.enableApproval.deny': '拒绝',
  'flows.enableApproval.enableAnyway': '仍然启用',
  'flows.enableApproval.granting': '正在批准…',
  'flows.enableApproval.error': '无法保存批准，请重试。',
  'flows.enableApproval.blockedHint': '已被您的代理访问设置阻止。',
  'flows.enableApproval.dynamicHint': '在工作流运行时决定；如有需要会再询问您。',
  'flows.enableApproval.agentHint': '此 AI 步骤可能会为其自身操作另行请求许可。',
  'flows.enableApproval.deniedDisabled': '已保存，但工作流保持关闭状态。',
  'flows.chooser.title': '创建工作流',
  'flows.chooser.subtitle': '选择你想要的开始方式。',
  'flows.chooser.scratchTitle': '从头开始',
  'flows.chooser.scratchDescription': '从空白画布和单个手动触发器开始。',
  'flows.chooser.templateTitle': '从模板开始',
  'flows.chooser.templateDescription': '从现成的示例开始并进行自定义。',
  'flows.chooser.describeTitle': '描述它',
  'flows.chooser.describeDescription': '告诉助手你想要什么，让它起草工作流。',
  'flows.chooser.creating': '正在创建工作流…',
  'flows.chooser.createError': '无法创建工作流。请重试。',
  'flows.templates.title': '从模板开始',
  'flows.templates.subtitle': '选择一个起点并在编辑器中自定义。',
  'flows.templates.use': '使用模板',
  'flows.templates.back': '返回',
  'flows.templates.empty': '没有可用的模板。',
  'flows.templates.category.scheduled': '定时',
  'flows.templates.category.triggered': '触发',
  'flows.templates.category.onDemand': '按需',
  'flows.templates.daily-digest.name': '每日摘要发送到频道',
  'flows.templates.daily-digest.description': '按计划，智能体编写简短摘要并发布到频道。',
  'flows.templates.scheduled-scrape.name': '定时抓取到记忆',
  'flows.templates.scheduled-scrape.description': '按计划获取来源，重塑结果，并存储到记忆中。',
  'flows.templates.webhook-triage.name': 'Webhook 分流与通知',
  'flows.templates.webhook-triage.description': '传入的 Webhook 由智能体分流，然后通知你。',
  'flows.templates.app-event-route.name': '应用事件到条件操作',
  'flows.templates.app-event-route.description': '来自已连接应用的事件运行检查，匹配时执行操作。',
  'flows.templates.http-fetch-parse.name': '获取并解析 API',
  'flows.templates.http-fetch-parse.description': '按需调用 HTTP 端点，并将响应解析为可用的结构。',
  'flows.templates.ask-agent.name': '询问智能体',
  'flows.templates.ask-agent.description': '一个简单的手动触发器，将任务交给智能体。',
  'flows.templates.opus-sonnet-brief.name': '研究简报（Opus 规划，Sonnet 起草）',
  'flows.templates.opus-sonnet-brief.description':
    '推理层级的智能体规划简报，聊天层级的智能体起草，然后结果会为你整理成形。',

  'oauth.button.connecting': '连接中...',
  'oauth.button.loopbackTimeout': '登录超时：浏览器未完成 OAuth 跳转。请重试。',
  'oauth.login.continueWith': '继续使用',
  'onboarding.contextGathering.buildingDesc': '正在分析你的历史记录...',
  'onboarding.contextGathering.buildingProfile': '正在构建你的档案...',
  'onboarding.contextGathering.continueToChat': '前往对话',
  'onboarding.contextGathering.coreAlive': '核心可访问：首次启动可能需要一分钟。',
  'onboarding.contextGathering.coreAliveProbing': '正在检查核心连接…',
  'onboarding.contextGathering.coreUnreachable': '核心未响应。你可以继续，稍后再试。',
  'onboarding.contextGathering.errorDesc':
    '我们暂时无法构建你的完整资料，但没关系：你可以继续，资料会随时间逐步完善。',
  'onboarding.contextGathering.stillWorkingDesc':
    '我们正在预热本地模型与工具，首次启动可能需要 30–60 秒。你可以随时进入对话：档案构建会在后台继续进行。',
  'onboarding.contextGathering.stillWorkingTitle': '仍在生成你的档案…',
  'onboarding.contextGathering.title': '上下文收集',
  'openhuman.team_list_teams': '团队列表',
  'overlay.ariaAttention': '注意消息',
  'overlay.ariaCompanion': '伴侣已激活',
  'overlay.ariaOrb': 'OpenHuman 浮层',
  'overlay.ariaVoiceActive': '语音输入已激活',
  'overlay.companion.error': '错误',
  'overlay.companion.listening': '正在聆听…',
  'overlay.companion.speaking': '正在说话…',
  'overlay.companion.thinking': '正在思考…',
  'overlay.orbTitle': '拖动以移动 · 双击重置位置',
  'pages.settings.account.connections': '连接',
  'pages.settings.account.connectionsDesc': '管理已连接的账户和服务',
  'pages.settings.account.migration': '从其他助手导入',
  'pages.settings.account.migrationDesc':
    '将 OpenClaw（即将支持 Hermes）的记忆和笔记迁移到此工作区。',
  'pages.settings.account.privacy': '隐私',
  'pages.settings.account.privacyDesc': '控制哪些数据离开你的设备',
  'pages.settings.account.recoveryPhrase': '恢复短语',
  'pages.settings.account.recoveryPhraseDesc': '查看并备份你的恢复短语',
  'pages.settings.account.team': '团队',
  'pages.settings.account.teamDesc': '管理团队成员和权限',
  'pages.settings.accountSection.description': '恢复短语、团队、连接与隐私设置。',
  'pages.settings.accountSection.title': '账户',
  'pages.settings.ai.llm': '语言模型',
  'pages.settings.ai.llmDesc': '选择并配置语言模型提供商',
  'pages.settings.ai.voice': '语音',
  'pages.settings.ai.voiceDesc': '配置语音输入和输出',
  'pages.settings.aiSection.description': '语言模型提供商、本地 Ollama 以及语音（STT / TTS）。',
  'pages.settings.aiSection.title': 'AI',
  'settings.developerMenu.composio.title': 'Composio',
  'settings.developerMenu.composio.desc': '路由模式、集成触发器和触发器历史存档。',
  'pages.settings.features.messagingChannels': '消息渠道',
  'pages.settings.features.messagingChannelsDesc': '配置消息渠道和集成',
  'pages.settings.features.notifications': '通知',
  'pages.settings.features.notificationsDesc': '管理通知偏好',
  'pages.settings.features.tools': '工具',
  'pages.settings.features.toolsDesc': '管理已连接的工具和集成',
  'pages.settings.featuresSection.title': '功能',
  'privacy.dataKind.credentials': '凭据',
  'privacy.dataKind.derived': '派生数据',
  'privacy.dataKind.diagnostics': '诊断信息',
  'privacy.dataKind.metadata': '元数据',
  'privacy.dataKind.raw': '原始数据',
  'privacy.whatLeaves.link.label': '哪些数据会离开我的电脑？',
  'rewards.community.achievementsUnlocked': '已解锁 {unlocked}/{total} 项成就',
  'rewards.community.activityStreakHint': '你在 OpenHuman 连续活跃的天数。',
  'rewards.community.activityTitle': '你的活动',
  'rewards.community.claimCredited': '{amount} 已计入你的余额',
  'rewards.community.claimError': '无法领取，请重试。',
  'rewards.community.claimTokens': '领取 {tokens} 代币',
  'rewards.community.claimed': '已领取',
  'rewards.community.claiming': '领取中…',
  'rewards.community.connectDiscord': '连接 Discord',
  'rewards.community.connectDiscordError': '无法启动 Discord 连接，请重试。',
  'rewards.community.connectingDiscord': '正在连接…',
  'rewards.community.cumulativeTokens': '累计令牌',
  'rewards.community.currentStreak': '活跃连续天数',
  'rewards.community.disconnectDiscord': '断开连接',
  'rewards.community.disconnectDiscordError': '无法断开 Discord 连接，请重试。',
  'rewards.community.disconnectingDiscord': '正在断开连接…',
  'rewards.community.discordAccount': 'Discord 账户',
  'rewards.community.discordConnected': 'Discord 已连接',
  'rewards.community.discordConnectedAs': '已连接为 {username}',
  'rewards.community.discordDetails': 'Discord',
  'rewards.community.discordLinkedNotInGuild': '已关联 Discord 但未加入服务器',
  'rewards.community.discordMember': '已加入服务器',
  'rewards.community.discordNotLinked': '未关联 Discord',
  'rewards.community.discordServer': 'Discord 服务器',
  'rewards.community.discordStatusUnavailable': 'Discord 状态不可用',
  'rewards.community.discordWaiting': '等待 Discord 验证',
  'rewards.community.heroSubtitle': '完成任务，赚取奖励',
  'rewards.community.heroTitle': '社区奖励',
  'rewards.community.joinDiscord': '加入 Discord',
  'rewards.community.loadingRewards': '正在加载奖励…',
  'rewards.community.locked': '已解锁',
  'rewards.community.longestStreak': '最长连续天数',
  'rewards.community.retrying': '重试中…',
  'rewards.community.rewardTokens': '+{tokens} 代币',
  'rewards.community.rewardTokensMonthly': '+{tokens} 代币/月',
  'rewards.community.roleAssigned': '身份组已分配',
  'rewards.community.roleAssignmentCount': '已分配 {assigned}/{unlocked} 个身份组',
  'rewards.community.roleClaimDesc':
    '你已解锁 Discord 身份组，但尚未加入 OpenHuman 服务器。加入后将自动为你分配。',
  'rewards.community.roleClaimTitle': '领取你的 Discord 身份组',
  'rewards.community.roleJoinToClaim': '加入服务器领取',
  'rewards.community.rolePending': '正在同步身份组…',
  'rewards.community.rolesAndRewards': '角色与奖励',
  'rewards.community.streakDays': '{n} 天',
  'rewards.community.syncPending': '奖励同步待处理',
  'rewards.community.syncPendingDesc': '奖励同步正在进行中，请稍后查看。',
  'rewards.community.syncUnavailable': '同步不可用',
  'rewards.community.tryAgain': '重试中…',
  'rewards.community.unknown': '未知',
  'rewards.community.unlocked': '已解锁',
  'rewards.community.yourProgress': '你的进度',
  'rewards.coupon.colCode': '代码',
  'rewards.coupon.colRedeemed': '兑换时间',
  'rewards.coupon.colReward': '奖励',
  'rewards.coupon.colStatus': '状态',
  'rewards.coupon.loadingHistory': '正在加载奖励历史…',
  'rewards.coupon.noCodes': '尚未兑换任何奖励码。',
  'rewards.coupon.pending': '处理中',
  'rewards.coupon.placeholder': '优惠码',
  'rewards.coupon.promoCredits': '促销配额',
  'rewards.coupon.recentRedemptions': '最近兑换',
  'rewards.coupon.redeemAccepted': '{code} 已接受。完成所需操作后将解锁 {amount}。',
  'rewards.coupon.redeemButton': '兑换码',
  'rewards.coupon.redeemSuccess': '{code} 已兑换。{amount} 已添加至你的额度。',
  'rewards.coupon.redeemedCodes': '已兑换代码',
  'rewards.coupon.redeeming': '兑换中...',
  'rewards.coupon.statusApplied': '已应用',
  'rewards.coupon.statusPendingAction': '待操作',
  'rewards.coupon.statusRedeemed': '已兑换',
  'rewards.coupon.subtitle': '输入优惠码以兑换奖励',
  'rewards.coupon.title': '兑换优惠码',
  'rewards.referralSection.activity': '邀请活动',
  'rewards.referralSection.apply': '应用中…',
  'rewards.referralSection.applying': '应用中…',
  'rewards.referralSection.colReferredUser': '被邀请用户',
  'rewards.referralSection.colReward': '奖励',
  'rewards.referralSection.colStatus': '状态',
  'rewards.referralSection.colUpdated': '更新时间',
  'rewards.referralSection.completed': '已完成',
  'rewards.referralSection.copyCode': '复制邀请码',
  'rewards.referralSection.copyFailed': '复制失败',
  'rewards.referralSection.haveCode': '有邀请码？',
  'rewards.referralSection.haveCodeDesc': '输入好友的邀请码，双方均可获得奖励。',
  'rewards.referralSection.linked': '已关联',
  'rewards.referralSection.linkedCode': '已关联邀请码',
  'rewards.referralSection.loading': '正在加载邀请计划…',
  'rewards.referralSection.retry': '重试',
  'rewards.referralSection.noReferrals': '暂无邀请记录',
  'rewards.referralSection.pendingReferrals': '待处理邀请',
  'rewards.referralSection.placeholder': '邀请码',
  'rewards.referralSection.share': '分享',
  'rewards.referralSection.statusCompleted': '已完成',
  'rewards.referralSection.statusExpired': '已过期',
  'rewards.referralSection.statusJoined': '已加入',
  'rewards.referralSection.subtitle': '邀请好友，双方均可获得配额奖励',
  'rewards.referralSection.title': '邀请好友，赚取配额',
  'rewards.referralSection.totalEarned': '总获得',
  'rewards.referralSection.yourCode': '你的邀请码',
  'settings.ai.addCloudProvider': '添加云端提供商',
  'settings.ai.addProvider': '保存中…',
  'settings.ai.apiKeyFieldLabel': 'API 密钥',
  'settings.ai.apiKeyRequired': '请粘贴你的 API 密钥以继续。',
  'settings.ai.apiKeyStoredEncrypted': 'API 密钥已加密存储',
  'settings.ai.apiKeysEncrypted': 'auth-profiles.json',
  'settings.ai.clearStoredKey': '清除已存储的密钥',
  'settings.ai.connectProvider': '连接 {label}',
  'settings.ai.customRouting': '自定义路由',
  'settings.ai.defaultResolvesTo': '默认解析为',
  'settings.ai.discard': '放弃',
  'settings.ai.editProvider': '编辑提供商',
  'settings.ai.llmProviders': 'LLM 提供商',
  'settings.ai.llmProvidersDesc': '配置你的语言模型提供商',
  'settings.ai.localOllama': '本地（Ollama）',
  'settings.ai.modelLabel': '模型',
  'settings.ai.noCustomProviders': '未配置自定义提供商',
  'settings.ai.openAiCompat.authHeaderExample': '授权：持有者<您的密钥>',
  'settings.ai.openAiCompat.authHeaderLabel': '验证标头',
  'settings.ai.openAiCompat.baseUrlLabel': '基础 URL',
  'settings.ai.openAiCompat.baseUrlUnavailable': '不可用',
  'settings.ai.openAiCompat.clearKey': '清除键',
  'settings.ai.openAiCompat.description':
    '将本地测试工具指向此 /v1 服务器，即可通过下方配置的提供商进行路由。身份验证使用你在此处设置的稳定密钥，而不是应用内部的 core bearer。',
  'settings.ai.openAiCompat.keyConfigured': '按键已配置',
  'settings.ai.openAiCompat.keyRequired': '需要钥匙',
  'settings.ai.openAiCompat.rotateKey': '旋转钥匙',
  'settings.ai.openAiCompat.setKey': '设置键',
  'settings.ai.openAiCompat.title': 'OpenAI 兼容端点',
  'settings.ai.providerLabel': '提供商',
  'skills.mcpComingSoon.title': 'MCP 服务器',
  'skills.mcpComingSoon.description':
    'MCP 服务器管理即将推出。此标签页将成为发现、连接和监控 MCP 服务器集成的中心。',
  'settings.ai.routing': '路由',
  'settings.ai.claudeCode.button': 'Claude Code',
  'settings.ai.claudeCode.inlineNotConnected': '未连接：通过你本地的 Claude Code CLI 路由聊天。',
  'settings.ai.claudeCode.checkingSignIn': '正在检查登录状态…',
  'settings.ai.claudeCode.inlineConnected': '已连接。',
  'settings.ai.claudeCode.signedInAs': '登录身份',
  'settings.ai.claudeCode.subscriptionFallback': 'Claude 订阅',
  'settings.ai.claudeCode.usingApiKeyEnv': '正在使用 ANTHROPIC_API_KEY',
  'settings.ai.claudeCode.cliNotInstalled': '未安装 CLI',
  'settings.ai.claudeCode.signInUnknown': '登录状态未知',
  'settings.ai.claudeCode.connectedNotSignedIn': '已连接 · 未登录',
  'settings.ai.claudeCode.modalTitle': 'Claude Code CLI',
  'settings.ai.claudeCode.modelHelp':
    'claude 命令行接受的模型 ID：别名（sonnet、opus）或完整名称（claude-sonnet-4-5）。该值会原样传给 claude --model，因此 sonnet-4-5 这类营销名称会被拒绝。',
  'settings.ai.claudeCode.modalDescription':
    '通过你本地安装的 Claude Code CLI 路由聊天、智能体和推理任务。无需 API 密钥：它使用 CLI 自身的登录。',
  'settings.ai.claudeCode.close': '关闭',
  'settings.ai.claudeCode.connection': '连接',
  'settings.ai.claudeCode.enabled': '已启用',
  'settings.ai.claudeCode.notEnabled': '未启用',
  'settings.ai.claudeCode.disconnect': '断开连接',
  'settings.ai.claudeCode.disconnecting': '正在断开连接…',
  'settings.ai.claudeCode.enable': '启用 Claude Code',
  'settings.ai.claudeCode.enabling': '正在启用…',
  'settings.ai.claudeCode.authentication': '身份验证',
  'settings.ai.claudeCode.recheck': '重新检查',
  'settings.ai.claudeCode.checking': '正在检查…',
  'settings.ai.claudeCode.openingTerminal': '正在打开终端…',
  'settings.ai.claudeCode.signIn': '使用 Claude 登录',
  'settings.ai.claudeCode.reconnect': '重新连接',
  'settings.ai.claudeCode.loginHint': '打开运行 claude login 的终端。完成后，点击“重新检查”。',
  'settings.ai.claudeCode.loginError': '无法打开登录终端。请重试。',
  'settings.ai.claudeCode.fullAccess': '完全访问权限',
  'settings.ai.claudeCode.fullAccessOn': 'Claude Code 可以运行命令、使用网络并生成子智能体。',
  'settings.ai.claudeCode.fullAccessOff': '仅接受编辑：自动应用文件编辑，限制命令和网络。',
  'settings.ai.claudeCode.sandboxNoteMac': '在 macOS 上，两种模式下 ~/.openhuman 都受沙盒保护。',
  'settings.ai.claudeCode.sandboxNoteOther':
    '在此平台上，完全访问不受限制：仅在你信任该工作区时才启用。',
  'settings.ai.claudeCode.enableToCheck': '启用 Claude Code 以检查登录状态。',
  'settings.ai.claudeCode.usingApiKeyEnvDetail': '正在使用环境中的 ANTHROPIC_API_KEY。',
  'settings.ai.claudeCode.notFoundInstall':
    '未找到 Claude Code CLI：请使用以下命令安装：npm install -g @anthropic-ai/claude-code',
  'settings.ai.claudeCode.unknownDetail':
    '无法确定登录状态。你的 claude CLI 可能早于身份验证状态支持：请尝试“重新连接”，然后“重新检查”。',
  'settings.ai.claudeCode.notSignedIn': '未登录。',
  'settings.ai.routingCustom': '自定义路由',
  'settings.ai.routingDefault': '默认',
  'settings.ai.routingDesc': '为不同工作负载选择路由策略',
  'settings.ai.saveChanges': '保存中…',
  'settings.ai.saving': '保存中…',
  'settings.ai.unsavedChange': '未保存的更改',
  'settings.ai.unsavedChanges': '未保存的更改',
  'settings.ai.workloadGroupBackground': '后台工作负载',
  'settings.ai.workloadGroupChat': '对话工作负载',
  'settings.ai.disconnectProvider': '断开 {label}',
  'settings.ai.connectProviderLabel': '连接 {label}',
  'settings.ai.editProviderEndpoint': '编辑 {label} 端点',
  'settings.ai.defaultLocalEndpoint': 'http://localhost:11434/v1',
  'settings.ai.editEndpoint': '编辑端点',
  'settings.ai.endpointUrlLabel': '端点 URL',
  'settings.ai.localRuntimeHelper':
    '{label} 可访问的位置。默认是 localhost；如需使用共享实例，可指向远程主机（例如 http://10.0.0.4:11434/v1）。',
  'settings.ai.endpointUrlRequired': '端点 URL 是必需的。',
  'settings.ai.endpointProtocolRequired': '端点必须以 http:// 或 https:// 开头。',
  'settings.ai.connectProviderDialog': '连接 {label}',
  'settings.ai.getProviderApiKey': '获取 API Key',
  'settings.ai.or': '或者',
  'settings.ai.codexOauthMissingAuthUrl': 'Codex OAuth 未返回授权 URL。请重试登录。',
  'settings.ai.codexOauthMissingCallbackUrl': '登录后请粘贴浏览器中的重定向 URL。',
  'settings.ai.openRouterOauthDescription':
    '使用 OpenRouter 登录，并通过 PKCE 导入由用户控制的 API 密钥。',
  'settings.ai.connecting': '正在连接...',
  'settings.ai.codexAuthButton': '连接 Codex',
  'settings.ai.codexAuthHelper': '使用来自 ~/.codex/auth.json 的现有 Codex CLI 登录。',
  'settings.ai.backgroundLoops': '背景循环',
  'settings.ai.backgroundLoopsDesc':
    '查看没有聊天消息时运行的内容，暂停心跳任务，并检查最近的额度账本行。',
  'settings.ai.heartbeatControls': '心跳控制',
  'settings.ai.heartbeatControlsDesc': '默认关闭。启用会启动循环；禁用会中止正在运行的任务。',
  'settings.ai.heartbeatLoop': '心跳循环',
  'settings.ai.heartbeatLoopDesc': '规划器和可选潜意识推理的主调度器。',
  'settings.ai.subconsciousInference': '潜意识推理',
  'settings.ai.subconsciousInferenceDesc': '在心跳 tick 上运行由模型支持的任务/反思评估。',
  'settings.ai.calendarMeetingChecks': '日历会议检查',
  'settings.ai.calendarMeetingChecksDesc': '为活跃的 Google Calendar 连接调用日历事件列表。',
  'settings.ai.calendarCap': '日历帽',
  'settings.ai.connectionsPerTick': '{count} 个连接/tick',
  'settings.ai.meetingLookahead': '会议前瞻',
  'settings.ai.minutesShort': '{count} 分钟',
  'settings.ai.reminderLookahead': '提醒前瞻',
  'settings.ai.cronReminderChecks': 'Cron 提醒检查',
  'settings.ai.cronReminderChecksDesc': '扫描启用的 cron 作业以查找类似提醒的即将发生的项目。',
  'settings.ai.relevantNotificationChecks': '相关通知检查',
  'settings.ai.relevantNotificationChecksDesc': '将紧急本地通知提升为主动提醒。',
  'settings.ai.externalDelivery': '外部交付',
  'settings.ai.externalDeliveryDesc': '允许心跳提醒向外部渠道发送主动消息。',
  'settings.ai.interval': '间隔',
  'settings.ai.running': '运行...',
  'settings.ai.plannerTickNow': '规划师立即勾选',
  'settings.ai.loadingHeartbeatControls': '正在加载心跳控制...',
  'settings.ai.heartbeatControlsUnavailable': '心跳控制不可用。',
  'settings.ai.loopMap': '循环地图',
  'settings.ai.plannerSummary':
    '规划器：{sourceEvents} 源事件，{sent} 已发送，{deduped} 已删除重复数据。',
  'settings.ai.routeLabel': '路线： {route}',
  'settings.ai.on': '上',
  'settings.ai.off': '关闭',
  'settings.ai.recentUsageLedger': '最近使用分类账',
  'settings.ai.recentUsageLedgerDesc': '后端行会公开今天的操作/时间；来源标签需要后端支持。',
  'settings.ai.latestSpend': '最新支出：{amount}，于 {time} ({action})',
  'settings.ai.topActions': '热门行动',
  'settings.ai.noSpendRows': '未加载支出行。',
  'settings.ai.topHours': '高峰时段',
  'settings.ai.noHourlySpend': '还没有每小时支出。',
  'settings.ai.openhumanDefault': 'OpenHuman（默认）',
  'settings.ai.localModelResolved': 'Ollama · {model}',
  'settings.ai.customRoutingForWorkload': '{label} 的自定义路由',
  'settings.ai.loadingModels': '正在加载模型...',
  'settings.ai.enterModelIdManually': '或手动输入型号 ID：',
  'settings.ai.modelIdPlaceholderForProvider': '{slug} 型号 ID',
  'settings.ai.modelIdPlaceholder': 'model-id',
  'settings.ai.selectModel': '选择型号...',
  'settings.ai.deploymentNameLabel': '部署名称',
  'settings.ai.deploymentNamePlaceholder': 'my-gpt-deployment',
  'settings.ai.deploymentNameHelp': '请输入您在 Azure AI Foundry 中设置的部署名称。这不是模型 ID。',
  'settings.ai.deploymentNameLegacyHint':
    '此值与提供商目录中的基础模型 ID 相同。Azure 按部署名称路由请求，请确认这是您为部署指定的名称。',
  'settings.ai.deploymentNameProviderHint':
    '已检测到 Azure 端点。选择此提供商后，请在模型字段中设置部署名称。',
  'settings.ai.chooseModelFromList': '从列表中选择',
  'settings.ai.enterModelIdManuallyAction': '手动输入模型 ID',
  'settings.ai.enterDeploymentNameManuallyAction': '手动输入部署名称',
  'settings.ai.probeFailedHint':
    '我们无法读取该提供方的模型列表。该列表只用于填充下拉菜单，你仍然可以添加该提供方，并自行输入模型或部署名称。',
  'settings.ai.probeFailedAddAnyway': '不验证直接添加',
  'settings.ai.azureV1EndpointHint':
    '在 Azure 上请使用 v1 基础地址：https://YOUR-RESOURCE.openai.azure.com/openai/v1。旧的资源地址不提供模型列表，并且需要不同的认证请求头。',
  'settings.ai.temperatureOverride': '温度超控',
  'settings.ai.temperatureOverrideSlider': '温度超控（滑块）',
  'settings.ai.temperatureOverrideValue': '温度超控（值）',
  'settings.ai.temperatureOverrideDesc': '值越低，结果越确定。保持未勾选则使用提供商默认值。',
  'settings.ai.modelVision': '支持视觉（图像输入）',
  'settings.ai.modelVisionDesc': '如果此模型接受图像，请启用。选择此模型后可在聊天框中附加图像。',
  'settings.ai.testFailed': '测试失败',
  'settings.ai.providerTest.authRejected':
    "密钥已保存，但 '{slug}' 拒绝了它。请确认你粘贴了完整的密钥，并且它在服务商后台仍然有效。",
  'settings.ai.providerTest.modelNotRecognized':
    "密钥已保存并通过验证，但 '{slug}' 无法识别所选模型。请选择该服务商确实提供的模型 ID（默认模型在服务商条目中设置）。",
  'settings.ai.providerTest.quotaOrBilling':
    "密钥已保存并通过验证，但 '{slug}' 因配额或账单原因拒绝了请求。请在服务商处查看账户余额和速率限制。",
  'settings.ai.providerTest.endpointNotFound':
    "密钥已保存，但为 '{slug}' 配置的接口地址返回了 404。请检查基础 URL：兼容 OpenAI 的服务商通常需要 '/v1' 后缀（例如 https://api.openai.com/v1）。",
  'settings.ai.providerTest.timeout':
    "密钥已保存，但 '{slug}' 未在规定时间内响应。请检查接口地址和网络后重新测试。",
  'settings.ai.providerTest.emptyReply':
    "密钥已保存，但 '{slug}' 对测试提示返回了空响应。请检查为该服务商配置的模型 ID。",
  'settings.ai.providerTest.unknown':
    "密钥已保存，但对 '{slug}' 的测试调用失败。请查看该服务商的状态页面和接口地址后重新测试。",
  'settings.ai.testingModel': '测试模型...',
  'settings.ai.modelResponse': '模型响应',
  'settings.ai.providerWithValue': '提供者：{value}',
  'settings.ai.noneDash': '无',
  'settings.ai.promptHelloWorld': '提示：你好世界',
  'settings.ai.startedAt': '开始： {value}',
  'settings.ai.waitingForModelResponse': '正在等待所选型号的响应...',
  'settings.ai.response': '回应',
  'settings.ai.testing': '测试...',
  'settings.ai.test': '测试',
  'settings.ai.slugMissingError': '输入提供商名称以生成 slug。',
  'settings.ai.slugInUseError': '该提供商名称已被使用。',
  'settings.ai.slugReservedError': '选择不同的提供商名称。',
  'settings.ai.providerNamePlaceholder': '我的提供商',
  'settings.ai.slugLabel': '蛞蝓：',
  'settings.ai.openAiUrlLabel': 'OpenAI URL',
  'settings.ai.openAiUrlPlaceholder': 'https://api.openai.com/v1',
  'settings.ai.keepExistingKeyPlaceholder': '留空以保留现有密钥',
  'settings.ai.reindexingMemory': '重新索引内存',
  'settings.ai.reindexingMemoryMessage':
    '嵌入正在重新处理。{pending} 个记忆项正使用当前模型重新嵌入；完成前语义召回会降低。关键词搜索仍可使用，即使关闭此页面，重新嵌入也会在后台继续。',
  'settings.ai.signInWithOpenRouter': '使用 OpenRouter 登录',
  'settings.ai.weekBudget': '周预算',
  'settings.ai.cycleRemaining': '剩余周期',
  'settings.ai.cycleTotalSpend': '周期总支出',
  'settings.ai.avgSpendRow': '平均支出行',
  'settings.ai.backgroundApiReads': '后台 API 读取',
  'settings.ai.backgroundWakeups': '背景唤醒',
  'settings.ai.budgetMath': '预算数学',
  'settings.ai.rowsLeft': '剩余行数',
  'settings.ai.rowsPerFullWeekBudget': '每整周预算的行数',
  'settings.ai.sampleBurnRate': '样品燃烧率',
  'settings.ai.projectedEmpty': '预计空',
  'settings.ai.apiReadsPerDollarRemaining': 'API 每 $ 剩余读取次数',
  'settings.ai.loopCallBudget': '循环呼叫预算',
  'settings.ai.heartbeatTicks': '心跳滴答声',
  'settings.ai.calendarPlannerCalls': '日历规划师来电',
  'settings.ai.calendarFanoutCap': '日历扇出帽',
  'settings.ai.subconsciousModelCalls': '潜意识模型调用',
  'settings.ai.composioSyncScans': 'Composio 同步扫描',
  'settings.ai.totalBackgroundApiReadBudget': '后台 API 读取总预算',
  'settings.ai.memoryWorkerPolls': '内存工作者民意调查',
  'settings.ai.defaultProviderName': 'OpenHuman',
  'settings.ai.routing.managed': '托管',
  'settings.ai.routing.managedAlwaysOn': '始终可用',
  'settings.ai.routing.managedHint':
    '托管模式始终可作为备用方案。要使用你自己的模型，请在下方选择路由模式。',
  'settings.ai.routing.managedDesc':
    'OpenHuman 会在云端运行所有推理，为任务选择最佳模型，优化成本，并保持最安全的路由默认值。',
  'settings.ai.routing.managedMsg':
    'OpenHuman 会处理每个工作负载的全部推理，并自动选择兼顾成本、质量和安全性的最佳路线。',
  'settings.ai.routing.useYourOwn': '使用您自己的模型',
  'settings.ai.routing.useYourOwnDesc':
    '选择一个提供商 + 模型，并让每个工作负载都通过它路由。这样更简单，但轻量和重量级推理共用同一路由，可能效率较低。',
  'settings.ai.routing.advanced': '高级',
  'settings.ai.routing.advancedDesc':
    '为不同任务选择不同模型。这是严格成本优化和最大控制力的最佳选项。',
  'settings.ai.routing.customDesc':
    '细粒度路由可提供最佳成本优化和最高控制力。使用下方各行决定哪些工作负载保持托管、哪些使用共享默认值、哪些固定到特定模型。',
  'settings.ai.routing.chatAndConversations': '聊天和对话',
  'settings.ai.routing.chatDesc': '用于直接用户交互、回复、推理、智能体循环和编码帮助的模型。',
  'settings.ai.routing.backgroundTasks': '后台任务',
  'settings.ai.routing.bgTasksDesc': '在主对话流程之外用于总结、心跳、学习和潜意识评估的模型。',
  'settings.ai.routing.workload.chat.label': 'Chat',
  'settings.ai.routing.workload.chat.description': '直接对话，也就是“对话”中的“快速”模式',
  'settings.ai.routing.workload.chat.hint':
    '推荐选择价格较低、响应快、吞吐量高且延迟低的聊天模型。只要响应足够流畅，开源本地模型也很适合。',
  'settings.ai.routing.workload.reasoning.label': 'Reasoning',
  'settings.ai.routing.workload.reasoning.description':
    '主聊天智能体和会议摘要，也就是“对话”中的“推理”模式',
  'settings.ai.routing.workload.reasoning.hint':
    '推荐选择能力更强的前沿模型或推理模型。它用于主聊天智能体、会议摘要和较复杂的答案整合，适合投入更多预算。',
  'settings.ai.routing.workload.agentic.label': 'Agentic',
  'settings.ai.routing.workload.agentic.description': '子智能体运行、工具循环和 GIF 决策',
  'settings.ai.routing.workload.agentic.hint':
    '推荐选择指令遵循可靠、工具调用能力强的模型。中等价位的前沿模型通常最稳妥；如果工具调用足够稳定，能力较强的开源模型也可以。',
  'settings.ai.routing.workload.coding.label': 'Coding',
  'settings.ai.routing.workload.coding.description': '代码生成和重构',
  'settings.ai.routing.workload.coding.hint':
    '推荐选择针对编程优化、指令遵循可靠、编辑质量高且长上下文表现好的模型。这个任务通常值得投入更多预算。',
  'settings.ai.routing.workload.vision.label': 'Vision',
  'settings.ai.routing.workload.vision.description': '视觉子智能体的图像理解，始终使用多模态模型',
  'settings.ai.routing.workload.vision.hint':
    '推荐选择支持图像输入的多模态模型。托管默认模型 vision-v1 支持图像；路由到此处的任何提供商都会被视为已启用视觉能力。',
  'settings.ai.routing.workload.memory.label': '记忆总结',
  'settings.ai.routing.workload.memory.description': '树状信息提取和整合',
  'settings.ai.routing.workload.memory.hint':
    '推荐选择价格较低的摘要模型。输出应稳定、简洁，但不需要前沿模型级别的推理能力。',
  'settings.ai.routing.workload.heartbeat.label': 'Heartbeat',
  'settings.ai.routing.workload.heartbeat.description': '用户消息之间的后台推理',
  'settings.ai.routing.workload.heartbeat.hint':
    '推荐选择价格低、效率高的后台模型。它会频繁在对话轮次之间运行，因此成本比极致能力更重要。',
  'settings.ai.routing.workload.learning.label': '学习·反思',
  'settings.ai.routing.workload.learning.description': '定期回顾近期历史',
  'settings.ai.routing.workload.learning.hint':
    '推荐选择更擅长反思和归纳的模型。更好的近期历史整合会带来明显收益，因此可以使用中等价位或高端模型。',
  'settings.ai.routing.workload.subconscious.label': 'Subconscious',
  'settings.ai.routing.workload.subconscious.description': '事件重要性评分和偏移检查',
  'settings.ai.routing.workload.subconscious.hint':
    '推荐选择非常便宜、轻量且表现稳定的监控模型。它用于事件重要性评分、偏移检查和静默后台评估。',
  'settings.ai.routing.addCustomProvider': '添加自定义提供商',
  'settings.ai.globalModel.title': '为所有事情选择一种型号',
  'settings.ai.globalModel.desc':
    '这会让所有推理都通过一个模型路由。它更简单，但轻量和重型任务都使用同一路由，可能不利于成本和质量。',
  'settings.ai.globalModel.noProviders':
    '请先添加或连接提供商。然后你可以在此将每个工作负载路由到一个模型。',
  'settings.ai.globalModel.provider': '提供者',
  'settings.ai.globalModel.model': '型号',
  'settings.ai.globalModel.loadingModels': '正在加载模型...',
  'settings.ai.globalModel.enterModelId': '输入型号 ID',
  'settings.ai.globalModel.appliesToAll':
    '将同一个提供商 + 模型应用于聊天、推理、编码、记忆、心跳、学习和潜意识。嵌入单独配置。点击保存后更改会保存。',
  'settings.ai.globalModel.saving': '正在保存...',
  'settings.ai.globalModel.saved': '已保存',
  'settings.ai.workload.noModel': '未选择型号',
  'settings.ai.workload.changeModel': '改变模型',
  'settings.ai.workload.chooseModel': '选择型号',
  'settings.ai.provider.ollama': 'Ollama',
  'settings.billing.autoRecharge.addAmount': '充入此金额',
  'settings.billing.autoRecharge.addCard': '添加银行卡',
  'settings.billing.autoRecharge.amountHint': '最低充值金额',
  'settings.billing.autoRecharge.defaultCard': '默认银行卡',
  'settings.billing.autoRecharge.lastRechargeFailed': '上次充值失败',
  'settings.billing.autoRecharge.lastRecharged': '上次充值时间',
  'settings.billing.autoRecharge.expires': '过期 {date}',
  'settings.billing.autoRecharge.noCards': '未添加银行卡',
  'settings.billing.autoRecharge.paymentMethods': '支付方式',
  'settings.billing.autoRecharge.rechargeInProgress': '充值进行中',
  'settings.billing.autoRecharge.spentThisWeek': '本周使用的 ${limit} 中的 ${spent}',
  'settings.billing.autoRecharge.rechargeWhen': '余额低于以下金额时自动充值',
  'settings.billing.autoRecharge.saveSettings': '保存中…',
  'settings.billing.autoRecharge.saving': '保存中…',
  'settings.billing.autoRecharge.setDefault': '设为默认',
  'settings.billing.autoRecharge.subtitle': '余额不足时自动充值，确保服务不中断',
  'settings.billing.autoRecharge.title': '启用自动充值',
  'settings.billing.autoRecharge.toggleAriaLabel': '切换自动充值',
  'settings.billing.autoRecharge.weeklyLimit': '每周消费限额',
  'settings.billing.history.desc': '查看你的账单历史',
  'settings.billing.history.empty': '暂无账单记录',
  'settings.billing.history.openPortal': '打开账单门户',
  'settings.billing.history.posted': '已记账',
  'settings.billing.history.title': '账单历史',
  'settings.billing.inferenceBudget.cycleEnds': '周期结束',
  'settings.billing.inferenceBudget.exhausted': '已用尽',
  'settings.billing.inferenceBudget.loadError': '无法加载预算信息',
  'settings.billing.inferenceBudget.noBudgetDesc': '暂无预算配置',
  'settings.billing.inferenceBudget.noRecurringBudget': '无周期性预算',
  'settings.billing.inferenceBudget.noRecurringPlanBudget': '无经常性计划预算',
  'settings.billing.inferenceBudget.noRecurringWeeklyDesc':
    '你当前的方案不包含每周循环推理预算。用量将改从可用额度中支付。',
  'settings.billing.inferenceBudget.remaining': '剩余',
  'settings.billing.inferenceBudget.remainingSummary': '剩余 {remaining} / {budget}',
  'settings.billing.inferenceBudget.spentThisCycle': '本周期花费 {amount}',
  'settings.billing.inferenceBudget.cycleEndsOn': '循环结束 {date}',
  'settings.billing.inferenceBudget.exhaustedDesc':
    '订阅包含的用量已耗尽。充值额度即可继续使用 AI，无需等待下个周期。',
  'settings.billing.inferenceBudget.discountVsPayg': '每次通话比即用即付便宜 {pct}%。',
  'settings.billing.inferenceBudget.cycleSpend': '周期支出',
  'settings.billing.inferenceBudget.totalAmount': '{amount} 总计',
  'settings.billing.inferenceBudget.inference': '推理',
  'settings.billing.inferenceBudget.integrations': '集成',
  'settings.billing.inferenceBudget.calls': '{count} 调用',
  'settings.billing.inferenceBudget.dailySpend': '日常消费',
  'settings.billing.inferenceBudget.dailySpendPoint': '{date}：{amount}',
  'settings.billing.inferenceBudget.topModels': '顶级模特',
  'settings.billing.inferenceBudget.noInferenceUsage': '本周期没有推理使用。',
  'settings.billing.inferenceBudget.topIntegrations': '顶级集成',
  'settings.billing.inferenceBudget.noIntegrationUsage': '本周期没有集成使用。',
  'settings.billing.inferenceBudget.tenHourCap': '10 小时上限',
  'settings.billing.inferenceBudget.title': '推理预算',
  'settings.billing.inferenceBudget.unableToLoad': '无法加载使用数据',
  'settings.billing.inferenceBudget.notAvailable': '不适用',
  'settings.billing.payAsYouGo.available': '可用余额',
  'settings.billing.payAsYouGo.chargeCustomAmount': '打开中…',
  'settings.billing.payAsYouGo.chooseTopUpDesc': '选择充值金额',
  'settings.billing.payAsYouGo.chooseTopUpTitle': '充值余额',
  'settings.billing.payAsYouGo.creditBalanceDesc': '你当前的配额余额',
  'settings.billing.payAsYouGo.creditBalanceTitle': '配额余额',
  'settings.billing.payAsYouGo.customAmount': '自定义金额',
  'settings.billing.payAsYouGo.enterAmount': '输入金额',
  'settings.billing.payAsYouGo.opening': '打开中…',
  'settings.billing.payAsYouGo.promotionalCredits': '促销配额',
  'settings.billing.payAsYouGo.topUpBalance': '充值余额',
  'settings.billing.payAsYouGo.topUpCredits': '充值配额',
  'settings.billing.payAsYouGo.unableToLoad': '无法加载余额。',
  'settings.billing.subscription.annual': '年付',
  'settings.billing.subscription.billedAnnually': '按年计费',
  'settings.billing.subscription.chooseSubtitle': '选择适合你的方案',
  'settings.billing.subscription.chooseTitle': '选择方案',
  'settings.billing.subscription.cryptoDesc': '支持加密货币支付',
  'settings.billing.subscription.cryptoQuestion': '想用加密货币支付？',
  'settings.billing.subscription.current': '当前',
  'settings.billing.subscription.currentPlan': '当前方案',
  'settings.billing.subscription.monthly': '月付',
  'settings.billing.subscription.paymentConfirmed': '支付已确认',
  'settings.billing.subscription.perMonth': '每月',
  'settings.billing.subscription.popular': '热门',
  'settings.billing.subscription.save': '{pct}',
  'settings.billing.subscription.upgrade': '升级',
  'settings.billing.subscription.waiting': '等待中',
  'settings.billing.subscription.waitingPayment': '等待支付',
  'settings.composio.apiKeyDesc': '当前此设备上已存储一个 Composio API 密钥。',
  'settings.composio.apiKeyExamplePlaceholder': 'ck_live_xxxxxxxxxxxxxxxxxx',
  'settings.composio.apiKeyLabel': 'Composio API 密钥',
  'settings.composio.apiKeyStored': 'API 密钥已存储',
  'settings.composio.apiKeyStoredPlaceholder': '••••••••••••••••',
  'settings.composio.clearedToBackend': '已切换到后端模式',
  'settings.composio.confirmItem1': '在 app.composio.dev 上拥有带 API 密钥的账户',
  'settings.composio.confirmItem2': '通过你的个人 Composio 账户重新关联每个集成',
  'settings.composio.confirmItem3':
    '注意：Composio 触发器（实时 Webhook）在直连模式下尚不可用：仅支持同步工具调用',
  'settings.composio.confirmNeedItems': '你需要：',
  'settings.composio.confirmSwitch': '我已了解，切换到直连',
  'settings.composio.confirmTitle': '⚠️ 切换到直连模式',
  'settings.composio.confirmWarning':
    '你现有的集成（通过 OpenHuman 关联的 Gmail、Slack、GitHub 等）将不可见：它们存放在 OpenHuman 托管的 Composio 租户中。',
  'settings.composio.intro':
    'Composio 集成了 250+ 外部应用作为智能体可调用的工具。请选择这些工具调用的路由方式。',
  'settings.composio.title': 'Composio',
  'settings.composio.modeDirect': '直连（自带 API 密钥）',
  'settings.composio.modeDirectDesc':
    '调用直接发送到 backend.composio.dev。自主可控 / 适合离线场景。工具同步执行；实时触发器 Webhook 目前在直连模式下尚未路由（后续问题）。',
  'settings.composio.modeManaged': '托管（由 OpenHuman 管理）',
  'settings.composio.modeManagedDesc':
    'OpenHuman 通过我们的后端代理工具调用（推荐）。认证由我们处理，你无需粘贴 Composio API 密钥。Webhook 完全路由。',
  'settings.composio.routingMode': '路由模式',
  'settings.composio.saveErrorNoKey': '保存失败。直连模式需要非空的 API 密钥。',
  'settings.composio.saving': '保存中…',
  'settings.composio.switching': '切换中…',
  'settings.cron.jobs.commandRequired': 'Shell 任务必须填写命令',
  'settings.cron.jobs.createJob': '新建定时任务',
  'settings.cron.jobs.created': '任务已创建',
  'settings.cron.jobs.custom': '自定义',
  'settings.cron.jobs.desc': '管理核心调度器中的定时任务',
  'settings.cron.jobs.edit': '编辑',
  'settings.cron.jobs.editJob': '编辑定时任务',
  'settings.cron.jobs.empty': '未找到核心定时任务。',
  'settings.cron.jobs.errorCreate': '创建 cron 任务失败：{message}',
  'settings.cron.jobs.errorLoadList': '加载核心 cron 任务失败：{message}',
  'settings.cron.jobs.errorLoadRuns': '加载运行历史失败：{message}',
  'settings.cron.jobs.errorRemove': '删除核心 cron 任务失败：{message}',
  'settings.cron.jobs.errorRun': '运行核心 cron 任务失败：{message}',
  'settings.cron.jobs.errorToggle': '更新核心 cron 任务失败：{message}',
  'settings.cron.jobs.errorUpdate': '更新 cron 任务失败：{message}',
  'settings.cron.jobs.formAtLabel': '运行时间',
  'settings.cron.jobs.formCancel': '取消',
  'settings.cron.jobs.formCommand': 'Shell 命令',
  'settings.cron.jobs.formCommandPlaceholder': '例如 curl https://example.com/health',
  'settings.cron.jobs.formCreate': '创建',
  'settings.cron.jobs.formCronCustom': '自定义表达式',
  'settings.cron.jobs.formCronCustomPlaceholder': '例如 */30 * * * *',
  'settings.cron.jobs.formCronPreset': '预设',
  'settings.cron.jobs.formCronPreview': '运行时间：{preview}',
  'settings.cron.jobs.formDeleteAfterRun': '首次运行后删除',
  'settings.cron.jobs.formDelivery': '投递方式',
  'settings.cron.jobs.formDeliveryNone': '无（仅输出）',
  'settings.cron.jobs.formDeliveryProactive': '主动（推送通知）',
  'settings.cron.jobs.formError': '保存任务失败',
  'settings.cron.jobs.formEveryLabel': '间隔（毫秒）',
  'settings.cron.jobs.formEveryPlaceholder': '例如 3600000',
  'settings.cron.jobs.formJobType': '任务类型',
  'settings.cron.jobs.formJobTypeAgent': 'Agent（AI 提示词）',
  'settings.cron.jobs.formJobTypeShell': 'Shell 命令',
  'settings.cron.jobs.formName': '任务名称',
  'settings.cron.jobs.formNamePlaceholder': '例如 daily-report, cleanup-task',
  'settings.cron.jobs.formPrompt': 'Agent 提示词',
  'settings.cron.jobs.formPromptPlaceholder': '每次运行时 Agent 应执行什么？',
  'settings.cron.jobs.formPromptRequired': 'Agent 任务必须填写提示词',
  'settings.cron.jobs.formSave': '保存',
  'settings.cron.jobs.formSaving': '保存中…',
  'settings.cron.jobs.formScheduleAt': '一次性（在指定时间运行）',
  'settings.cron.jobs.formScheduleCron': '周期性（cron）',
  'settings.cron.jobs.formScheduleEvery': '间隔（每 N 毫秒）',
  'settings.cron.jobs.formScheduleRequired': '必须设置计划',
  'settings.cron.jobs.formScheduleType': '计划类型',
  'settings.cron.jobs.formSessionIsolated': '隔离（推荐）',
  'settings.cron.jobs.formSessionMain': '主会话',
  'settings.cron.jobs.formSessionTarget': '会话目标',
  'settings.cron.jobs.formProfile': '智能体配置',
  'settings.cron.jobs.formProfileNone': '不使用配置',
  'settings.cron.jobs.formProfileHint': '以所选配置运行此任务，使用其灵魂、记忆和工作空间。',
  'settings.cron.jobs.profile': '配置',
  'settings.cron.jobs.lastStatus': '上次状态',
  'settings.cron.jobs.loading': '正在加载定时任务...',
  'settings.cron.jobs.loadingRuns': '加载运行记录中',
  'settings.cron.jobs.nextRun': '下次运行',
  'settings.cron.jobs.pause': '暂停',
  'settings.cron.jobs.paused': '已暂停',
  'settings.cron.jobs.recentRuns': '最近运行',
  'settings.cron.jobs.removing': '删除中',
  'settings.cron.jobs.resume': '恢复',
  'settings.cron.jobs.runningNow': '立即运行',
  'settings.cron.jobs.saving': '保存中…',
  'settings.cron.jobs.schedule': '计划',
  'settings.cron.jobs.title': '核心定时任务',
  'settings.cron.jobs.updated': '任务已更新',
  'settings.cron.jobs.viewRuns': '查看运行记录',
  'settings.cron.schedule.every2hours': '每 2 小时',
  'settings.cron.schedule.every30min': '每 30 分钟',
  'settings.cron.schedule.every6hours': '每 6 小时',
  'settings.cron.schedule.everyHour': '每小时',
  'settings.cron.schedule.onceDaily': '每天一次（上午 9 点）',
  'settings.localModel.deviceCapability.active': '活跃',
  'settings.localModel.deviceCapability.appliedTier': '已应用档位',
  'settings.localModel.deviceCapability.applying': '应用中',
  'settings.localModel.deviceCapability.cores': '{count} 核',
  'settings.localModel.deviceCapability.couldNotLoadPresets': '无法加载预设',
  'settings.localModel.deviceCapability.cpu': 'CPU',
  'settings.localModel.deviceCapability.customModelIds': '自定义模型 ID',
  'settings.localModel.deviceCapability.detected': '已检测到',
  'settings.localModel.deviceCapability.disabled': '已禁用',
  'settings.localModel.deviceCapability.disabledDesc': '本地 AI 已禁用',
  'settings.localModel.deviceCapability.downloadingModels': '（正在下载模型）',
  'settings.localModel.deviceCapability.downloadingSetupDesc':
    '正在下载 OllamaSetup 安装程序（约 2 GB）并解压。首次安装可能需要一分钟。',
  'settings.localModel.deviceCapability.failedToApplyPreset': '应用预设失败',
  'settings.localModel.deviceCapability.gpu': 'GPU',
  'settings.localModel.deviceCapability.installFailed': 'Ollama 安装失败',
  'settings.localModel.deviceCapability.installFailedDesc':
    '安装程序在 Ollama 可用之前退出。点击重试，或从 ollama.com 手动安装。',
  'settings.localModel.deviceCapability.installFirst': '请先运行 Ollama。',
  'settings.localModel.deviceCapability.installFirstDesc':
    '本地层级依赖外部托管的 Ollama 端点。请自行启动它，拉取所需模型，并在运行时可达前继续使用「已禁用（云端回退）」。',
  'settings.localModel.deviceCapability.installOllamaFirst': '请先运行 Ollama 以使用此层级',
  'settings.localModel.deviceCapability.installingOllama': '正在安装 Ollama',
  'settings.localModel.deviceCapability.loadingDeviceInfo': '正在加载设备信息',
  'settings.localModel.deviceCapability.localAiDisabled': '本地 AI 已禁用：使用云端回退。',
  'settings.localModel.deviceCapability.modelTier': '模型档位',
  'settings.localModel.deviceCapability.needsOllama': '需要安装 Ollama',
  'settings.localModel.deviceCapability.notDetected': '未检测到',
  'settings.localModel.deviceCapability.disabledLowercase': '残疾人',
  'settings.localModel.deviceCapability.presetDetails':
    '聊天：{chatModel} · 愿景：{visionModel} · 目标 RAM：{targetRamGb} GB',
  'settings.localModel.deviceCapability.ram': 'RAM',
  'settings.localModel.deviceCapability.recommended': '推荐',
  'settings.localModel.deviceCapability.retryInstall': '重试中…',
  'settings.localModel.deviceCapability.retrying': '重试中…',
  'settings.localModel.deviceCapability.starting': '启动中…',
  'settings.localModel.download.audioPathPlaceholder': '音频文件的绝对路径',
  'settings.localModel.download.capabilityChat': '聊天',
  'settings.localModel.download.capabilityEmbedding': '嵌入',
  'settings.localModel.download.capabilityAssets': '能力资源',
  'settings.localModel.download.capabilityStt': 'STT',
  'settings.localModel.download.capabilityTts': 'TTS',
  'settings.localModel.download.capabilityVision': '愿景',
  'settings.localModel.download.downloading': '下载中...',
  'settings.localModel.download.embeddingDimensions': '尺寸：{dimensions}',
  'settings.localModel.download.embeddingModel': '型号：{modelId}',
  'settings.localModel.download.embeddingPlaceholder': '每行一个输入字符串...',
  'settings.localModel.download.embeddingVectors': '矢量： {count}',
  'settings.localModel.download.noThinkMode': '无思考模式',
  'settings.localModel.download.notAvailable': '不适用',
  'settings.localModel.download.promptPlaceholder': '输入任意提示词并在本地模型上运行...',
  'settings.localModel.download.quantizationPref': '量化偏好',
  'settings.localModel.download.runEmbeddingTest': '运行中...',
  'settings.localModel.download.runPromptTest': '运行提示测试',
  'settings.localModel.download.runSummaryTest': '运行摘要测试',
  'settings.localModel.download.runTranscriptionTest': '运行中...',
  'settings.localModel.download.runTtsTest': '运行中...',
  'settings.localModel.download.runVisionTest': '运行中...',
  'settings.localModel.download.running': '运行中...',
  'settings.localModel.download.runningPrompt': '正在运行提示词',
  'settings.localModel.download.summaryHelper':
    '通过 Rust 核心调用 `open human.inference_summarize`',
  'settings.localModel.download.summarizePlaceholder': '粘贴文本以用本地模型进行摘要...',
  'settings.localModel.download.testCustomPrompt': '测试自定义提示词',
  'settings.localModel.download.testEmbeddings': '测试嵌入',
  'settings.localModel.download.testSummarization': '测试摘要',
  'settings.localModel.download.testVisionPrompt': '测试视觉提示词',
  'settings.localModel.download.testVoiceInput': '测试语音输入（STT）',
  'settings.localModel.download.testVoiceOutput': '测试语音输出（TTS）',
  'settings.localModel.download.transcript': '成绩单：',
  'settings.localModel.download.ttsOutput': '输出：{outputPath}',
  'settings.localModel.download.ttsOutputPlaceholder': '可选输出 WAV 路径',
  'settings.localModel.download.ttsPlaceholder': '输入要合成的文字...',
  'settings.localModel.download.ttsVoice': '声音：{voiceId}',
  'settings.localModel.download.visionImagePlaceholder':
    '每行一个图像引用（data URI、URL 或本地路径标记）',
  'settings.localModel.download.visionPromptPlaceholder': '输入视觉模型的提示词...',
  'settings.localModel.status.allChecksPassed': '所有检查已通过',
  'settings.localModel.status.artifact': '构件',
  'settings.localModel.status.backend': '后端',
  'settings.localModel.status.binary': '二进制文件',
  'settings.localModel.status.bootstrapResume': '引导 / 恢复',
  'settings.localModel.status.checking': '检查中...',
  'settings.localModel.status.checkingOllama': '检查 Ollama',
  'settings.localModel.status.contextBelowMinimumBadge':
    '{contextLength} ctx - 低于 {required} 分钟',
  'settings.localModel.status.contextBelowMinimumTitle':
    '已拒绝：上下文窗口 {contextLength} 令牌低于内存层所需的 {required} 令牌最小值。回忆会因无声截断而被破坏。',
  'settings.localModel.status.contextOkBadge': '{contextLength} ctx ✓',
  'settings.localModel.status.contextOkTitle':
    '上下文窗口 {contextLength} 令牌满足内存层最小值 {required} 令牌。',
  'settings.localModel.status.contextUnknownBadge': 'ctx 未知',
  'settings.localModel.status.contextUnknownTitle':
    '上下文窗口未知；无法确认它满足 {required}-token 内存层最小值。',
  'settings.localModel.status.customLocation': '自定义位置',
  'settings.localModel.status.customLocationDesc': '自定义 Ollama 安装路径',
  'settings.localModel.status.diagnosticsHint':
    '点击「运行诊断」以验证 Ollama 是否正在运行以及模型是否已安装。',
  'settings.localModel.status.downloadingUnknown': '下载中（大小未知）',
  'settings.localModel.status.eta': '预计完成时间',
  'settings.localModel.status.expectedModels': '预期模型',
  'settings.localModel.status.expectedChat': '聊天：{model}',
  'settings.localModel.status.expectedEmbedding': '嵌入：{model}',
  'settings.localModel.status.expectedVision': '愿景：{model}',
  'settings.localModel.status.externalProcess': '外部流程',
  'settings.localModel.status.forceRebootstrap': '强制重新引导',
  'settings.localModel.status.generationTps': '生成 TPS',
  'settings.localModel.status.hideErrorDetails': '隐藏错误详情',
  'settings.localModel.status.installManually': '手动安装',
  'settings.localModel.status.installManuallyFrom': '从以下地址手动安装',
  'settings.localModel.status.installOllama': '启动中…',
  'settings.localModel.status.installedModels': '已安装模型',
  'settings.localModel.status.installing': '安装中...',
  'settings.localModel.status.installingOllama': '正在安装 Ollama 运行时...',
  'settings.localModel.status.issues': '问题',
  'settings.localModel.status.issuesFound': '发现 {count} 个问题',
  'settings.localModel.status.lastLatency': '最近延迟',
  'settings.localModel.status.model': '模型',
  'settings.localModel.status.notAvailable': '不适用',
  'settings.localModel.status.notFound': '未找到',
  'settings.localModel.status.notRunning': '未运行',
  'settings.localModel.status.ollamaBinaryPath': 'Ollama 二进制路径',
  'localModel.ollamaServer.helperText': '示例：http://192.168.1.5:11434',
  'localModel.ollamaServer.label': 'Ollama 服务器 URL',
  'localModel.ollamaServer.modelCount': '个模型',
  'localModel.ollamaServer.placeholder': 'http://localhost:11434',
  'localModel.ollamaServer.reachable': '可访问',
  'localModel.ollamaServer.resetButton': '重置为默认值',
  'localModel.ollamaServer.saveButton': '保存',
  'localModel.ollamaServer.testButton': '测试连接',
  'localModel.ollamaServer.unreachable': '无法访问',
  'localModel.ollamaServer.validationError': '必须是有效的 http:// 或 https:// URL',
  'settings.localModel.status.ollamaDiagnostics': 'Ollama 诊断',
  'settings.localModel.status.ollamaNotInstalled': 'Ollama 运行时不可用',
  'settings.localModel.status.ollamaNotInstalledDesc':
    'OpenHuman 现在将 Ollama 视为外部推理运行时。请启动你自己的 Ollama 服务器，拉取所需模型，并将工作负载路由指向它。',
  'settings.localModel.status.progress': '进度',
  'settings.localModel.status.provider': '提供商',
  'settings.localModel.status.retryBootstrap': '重试引导',
  'settings.localModel.status.runDiagnostics': '检查中...',
  'settings.localModel.status.running': '运行中',
  'settings.localModel.status.runningExternalProcess': '通过外部进程运行',
  'settings.localModel.status.runtimeStatus': '运行时状态',
  'settings.localModel.status.server': '服务器',
  'settings.localModel.status.setPath': '设置中...',
  'settings.localModel.status.setting': '设置中...',
  'settings.localModel.status.showErrorDetails': '隐藏错误详情',
  'settings.localModel.status.showInstallErrorDetails': '隐藏错误详情',
  'settings.localModel.status.suggestedFixes': '建议修复方案',
  'settings.localModel.status.thenSetPath': '然后设置路径',
  'settings.localModel.status.triggering': '触发中...',
  'settings.localModel.status.unavailable': '不可用',
  'settings.localModel.status.working': '处理中...',
  'settings.developerMenu.ai.title': 'AI 配置',
  'settings.developerMenu.ai.desc': '云端提供商、本地 Ollama 模型和按工作负载路由',
  'settings.developerMenu.messagingChannels.title': '消息渠道',
  'settings.developerMenu.messagingChannels.desc': '配置 Telegram/Discord 认证模式和默认渠道路由',
  'settings.developerMenu.tools.title': '工具',
  'settings.developerMenu.tools.desc': '启用或停用 OpenHuman 可代表你使用的能力',
  'settings.developerMenu.agentChat.title': '智能体聊天',
  'settings.developerMenu.agentChat.desc': '使用模型和温度覆盖测试智能体对话',
  'settings.developerMenu.devWorkflow.title': '开发工作流',
  'settings.developerMenu.devWorkflow.desc': '自主选择你的 GitHub issue 并按计划发起 PR 的智能体',
  'settings.developerMenu.devWorkflow.panelDesc':
    '配置一个自主开发智能体，按计划选择分配给你的 GitHub issue 并自动发起 pull request。',
  'settings.developerMenu.skillsRunner.title': '技能运行器',
  'settings.developerMenu.skillsRunner.desc': '临时运行任意内置技能：填写输入并启动后台自主运行',
  'settings.developerMenu.skillsRunner.panelDesc':
    '选择内置技能，填写它声明的输入，并启动一次无需等待的后台运行。如果需要按 cron 计划重复运行，请使用开发工作流。',
  'settings.skillsRunner.skill': '技能',
  'settings.skillsRunner.selectSkill': '选择技能…',
  'settings.skillsRunner.loadingSkills': '正在加载技能…',
  'settings.skillsRunner.loadingDescription': '正在加载技能输入…',
  'settings.skillsRunner.noInputs': '此技能未声明输入。',
  'settings.skillsRunner.placeholder.required': '必填',
  'settings.skillsRunner.runNow': '立即运行',
  'settings.skillsRunner.starting': '启动中…',
  'settings.skillsRunner.started': '已启动：运行 ID：',
  'settings.skillsRunner.logPath': '日志：',
  'settings.skillsRunner.error.listSkills': '加载技能失败：',
  'settings.skillsRunner.error.describe': '加载输入失败：',
  'settings.skillsRunner.error.missingRequired': '缺少必填输入：',
  'settings.skillsRunner.error.run': '启动运行失败：',
  'settings.skillsRunner.error.preflightGate': '预检门禁失败',
  'settings.skillsRunner.error.runtimeUnavailable': '运行时不可用',
  'settings.skillsRunner.error.runtimeUnavailableDefault': '不可用',
  'settings.skillsRunner.schedule.heading': '计划（重复）',
  'settings.skillsRunner.schedule.help':
    '将此技能和输入保存为重复 cron 任务。智能体会在每次触发时调用 run_workflow。',
  'settings.skillsRunner.schedule.frequency': '频率',
  'settings.skillsRunner.schedule.every30min': '每 30 分钟',
  'settings.skillsRunner.schedule.everyHour': '每小时',
  'settings.skillsRunner.schedule.every2hours': '每 2 小时',
  'settings.skillsRunner.schedule.every6hours': '每 6 小时',
  'settings.skillsRunner.schedule.onceDaily': '每天一次（9:00）',
  'settings.skillsRunner.schedule.save': '保存计划',
  'settings.skillsRunner.schedule.saving': '保存中…',
  'settings.skillsRunner.schedule.saved': '计划已保存。',
  'settings.skillsRunner.schedule.error': '保存计划失败：',
  'settings.skillsRunner.schedule.loadingJobs': '正在加载现有计划…',
  'settings.skillsRunner.schedule.noJobs': '此技能尚未保存计划。',
  'settings.skillsRunner.schedule.existing': '此技能的计划任务：',
  'settings.skillsRunner.schedule.inputsLabel': '输入',
  'settings.skillsRunner.schedule.inputsNone': '无输入',
  'settings.skillsRunner.schedule.runNow': '运行',
  'settings.skillsRunner.schedule.remove': '移除',
  'settings.skillsRunner.scheduleEnabled': '已启用',
  'settings.skillsRunner.scheduleDisabled': '已暂停',
  'settings.skillsRunner.scheduleToggleAria': '切换计划启用状态',
  'settings.skillsRunner.schedule.history': '历史记录',
  'settings.skillsRunner.schedule.historyLoading': '正在加载历史记录…',
  'settings.skillsRunner.schedule.historyEmpty': '此计划还没有运行记录。',
  'settings.skillsRunner.schedule.historyNoOutput': '未捕获输出。',
  'settings.skillsRunner.schedule.active': '活跃',
  'settings.skillsRunner.schedule.lastRunLabel': '上次：',
  'settings.skillsRunner.recentRuns.headingForSkill': '此技能的最近运行',
  'settings.skillsRunner.recentRuns.headingAll': '最近技能运行（全部）',
  'settings.skillsRunner.recentRuns.refresh': '刷新',
  'settings.skillsRunner.recentRuns.loading': '正在加载最近运行…',
  'settings.skillsRunner.recentRuns.empty': '暂无最近运行。',
  'settings.skillsRunner.viewer.loading': '正在加载日志…',
  'settings.skillsRunner.viewer.tailing': '实时追踪',
  'settings.skillsRunner.viewer.fetching': '获取中',
  'settings.skillsRunner.viewer.error': '读取日志失败：',
  'settings.skillsRunner.repoPicker.loading': '正在加载仓库…',
  'settings.skillsRunner.repoPicker.select': '选择仓库…',
  'settings.skillsRunner.repoPicker.empty': '未返回仓库。通过 Composio 连接 GitHub 以填充此列表。',
  'settings.skillsRunner.repoPicker.notConnected':
    'GitHub 尚未通过 Composio 连接。请先在“技能 → Composio”下连接。',
  'settings.skillsRunner.repoPicker.privateTag': '（私有）',
  'settings.skillsRunner.branchPicker.needRepo': '请先选择仓库…',
  'settings.skillsRunner.branchPicker.loading': '正在加载分支…',
  'settings.skillsRunner.branchPicker.select': '选择分支…',
  'settings.devWorkflow.githubRepository': 'GitHub 仓库',
  'settings.devWorkflow.loadingRepositories': '正在加载仓库...',
  'settings.devWorkflow.selectRepository': '选择仓库',
  'settings.devWorkflow.privateTag': '（私有）',
  'settings.devWorkflow.detectingForkInfo': '正在检测 fork 信息...',
  'settings.devWorkflow.forkDetected': '检测到 fork',
  'settings.devWorkflow.upstream': '上游：',
  'settings.devWorkflow.forkPrNote': 'PR 将提交到上游仓库。',
  'settings.devWorkflow.notForkNote': '这不是 fork。PR 将直接提交到此仓库。',
  'settings.devWorkflow.targetBranch': '目标分支',
  'settings.devWorkflow.targetBranchNote': 'PR 将提交到此分支',
  'settings.devWorkflow.loadingBranches': '正在加载分支...',
  'settings.devWorkflow.runFrequency': '运行频率',
  'settings.devWorkflow.runFrequencyNote': '智能体检查 issue 并发起 PR 的频率。',
  'settings.devWorkflow.updateConfiguration': '更新配置',
  'settings.devWorkflow.saveConfiguration': '保存配置',
  'settings.devWorkflow.remove': '移除',
  'settings.devWorkflow.saved': '已保存',
  'settings.devWorkflow.activeConfiguration': '当前配置',
  'settings.devWorkflow.activeConfigRepository': '仓库：',
  'settings.devWorkflow.activeConfigUpstream': '上游：',
  'settings.devWorkflow.activeConfigTargetBranch': '目标分支：',
  'settings.devWorkflow.activeConfigSchedule': '计划：',
  'settings.devWorkflow.enabled': '已启用',
  'settings.devWorkflow.paused': '已暂停',
  'settings.devWorkflow.nextRun': '下次运行',
  'settings.devWorkflow.lastRun': '上次运行',
  'settings.devWorkflow.runNow': '立即运行',
  'settings.devWorkflow.running': '运行中…',
  'settings.devWorkflow.recentRuns': '最近运行',
  'settings.devWorkflow.cronSaveError': '保存配置失败',
  'settings.devWorkflow.lastOutput': '上次输出',
  'settings.devWorkflow.noOutput': '未捕获输出',
  'settings.devWorkflow.runningStatus': '智能体正在运行：正在选择 issue 并处理修复...',
  'settings.devWorkflow.errorNotConnected':
    'GitHub 未连接。请先通过“设置 > 高级 > Composio”连接 GitHub。',
  'settings.devWorkflow.errorToolNotEnabled':
    '此后端未启用 GITHUB_LIST_REPOSITORIES_FOR_THE_AUTHENTICATED_USER 工具。请让管理员在 Composio 集成中启用它（backend#842）。',
  'settings.devWorkflow.errorNotAuthenticated': '未认证。请先登录。',
  'settings.devWorkflow.errorNoRepositories': '未找到此 GitHub 账户的仓库。',
  'settings.devWorkflow.schedule.every30min': '每 30 分钟',
  'settings.devWorkflow.schedule.everyHour': '每小时',
  'settings.devWorkflow.schedule.every2hours': '每 2 小时',
  'settings.devWorkflow.schedule.every6hours': '每 6 小时',
  'settings.devWorkflow.schedule.onceDaily': '每天一次（上午 9 点）',
  'settings.developerMenu.tasks.title': '任务',
  'settings.developerMenu.tasks.desc':
    '浏览和管理任务看板：你的待办事项以及智能体在对话中创建的看板。',
  'settings.developerMenu.cronJobs.title': '定时任务',
  'settings.developerMenu.cronJobs.desc': '查看并配置运行时技能的计划任务',
  'settings.developerMenu.localModelDebug.title': '本地模型调试',
  'settings.developerMenu.localModelDebug.desc': 'Ollama 配置、资源下载、模型测试和诊断',
  'settings.developerMenu.webhooks.title': 'Webhook',
  'settings.developerMenu.webhooks.desc': '检查运行时 Webhook 注册和捕获的请求日志',
  'settings.developerMenu.eventLog.title': '事件日志',
  'settings.developerMenu.eventLog.desc': '实时显示所有智能体、工具和系统事件的彩色编码流',
  'settings.developerMenu.eventLog.allTypes': '所有类型',
  'settings.developerMenu.eventLog.filterAgent': '筛选...',
  'settings.developerMenu.eventLog.download': '下载',
  'settings.developerMenu.eventLog.events': '个事件',
  'settings.developerMenu.eventLog.live': '实时',
  'settings.developerMenu.eventLog.disconnected': '已断开连接',
  'settings.developerMenu.eventLog.waiting': '正在等待事件...',
  'settings.developerMenu.eventLog.notConnected': '未连接到核心',
  'settings.developerMenu.eventLog.jumpToLatest': '跳到最新',
  'settings.developerMenu.eventLog.badge.tool': '工具',
  'settings.developerMenu.eventLog.badge.agent': '智能体',
  'settings.developerMenu.eventLog.badge.info': '信息',
  'settings.developerMenu.eventLog.badge.mem': 'MEM',
  'settings.developerMenu.eventLog.badge.chan': 'CHAN',
  'settings.developerMenu.eventLog.badge.cron': 'CRON',
  'settings.developerMenu.eventLog.badge.hook': 'HOOK',
  'settings.developerMenu.eventLog.badge.warn': '警告',
  'settings.developerMenu.eventLog.badge.skill': '技能',
  'settings.developerMenu.eventLog.badge.comp': 'COMP',
  'settings.developerMenu.eventLog.badge.mcp': 'MCP',
  'settings.developerMenu.intelligence.title': '智能',
  'settings.developerMenu.intelligence.desc': '记忆工作区、潜意识引擎、梦境和设置',
  'settings.developerMenu.notificationRouting.title': '通知路由',
  'settings.developerMenu.notificationRouting.desc': '集成提醒的 AI 重要性评分和编排器升级',
  'settings.developerMenu.composeioTriggers.title': 'ComposeIO 触发器',
  'settings.developerMenu.composeioTriggers.desc': '查看 ComposeIO 触发器历史和归档',
  'settings.developerMenu.composioRouting.title': 'Composio 路由（直连模式）',
  'settings.developerMenu.composioRouting.desc':
    '使用你自己的 Composio API 密钥并将调用直接路由到 backend.composio.dev',
  'settings.developerMenu.integrationTriggers.title': '集成触发器',
  'settings.developerMenu.integrationTriggers.desc': '配置 Composio 集成触发器的 AI 分流设置',
  'settings.developerMenu.mcpServer.title': 'MCP 服务器',
  'settings.developerMenu.mcpServer.desc': '配置外部 MCP 客户端以连接到 OpenHuman',
  'settings.developerMenu.autonomy.title': '智能体自主权',
  'settings.developerMenu.autonomy.desc': '工具操作速率限制和安全阈值',
  'settings.developerMenu.voiceDebug.title': '语音（调试）',
  'settings.developerMenu.voiceDebug.desc': '语音听写运行时状态和调试设置',
  'settings.mcpServer.title': 'MCP 服务器',
  'settings.mcpServer.toolsSectionTitle': '可用工具',
  'settings.mcpServer.toolsSectionDesc':
    '运行 openhuman-core mcp 时通过 MCP stdio 服务器暴露的工具',
  'settings.mcpServer.configSectionTitle': '客户端配置',
  'settings.mcpServer.configSectionDesc': '选择你的 MCP 客户端以生成对应的配置代码片段',
  'settings.mcpServer.copySnippet': '复制到剪贴板',
  'settings.mcpServer.copied': '已复制！',
  'settings.mcpServer.openConfigFile': '打开配置文件',
  'settings.mcpServer.binaryPathNotFound':
    '未找到 OpenHuman 二进制文件。如果使用源码运行，请执行：cargo build --bin openhuman-core',
  'settings.mcpServer.openConfigError': '打开配置文件失败',
  'settings.mcpServer.clientClaudeDesktop': '克劳德桌面',
  'settings.mcpServer.clientCursor': '光标',
  'settings.mcpServer.clientCodex': '法典',
  'settings.mcpServer.clientZed': '泽德',
  'settings.mcpServer.configFilePath': '配置文件',
  'settings.mcpServer.clientSelectorAriaLabel': 'MCP 客户端选择器',
  'settings.appearance.menuDesc': '选择浅色、深色或跟随系统主题',
  'settings.agentAccess.title': '智能体系统访问',
  'settings.agentAccess.menuDesc': '控制智能体可读写的位置，以及是否可以使用 shell。',
  'settings.agentAccess.loadError': '无法加载访问设置',
  'settings.agentAccess.saveError': '无法保存访问设置',
  'settings.agentAccess.saved': '已保存：将在你的下一条消息后生效。',
  'settings.agentAccess.desktopOnly': '访问设置仅在桌面应用中可用。',
  'settings.agentAccess.loading': '加载中…',
  'settings.agentAccess.accessMode': '访问模式',
  'settings.agentAccess.tier.readonly.title': '只读',
  'settings.agentAccess.tier.readonly.desc':
    '可读取文件并运行只读命令来探索：但绝不会写入、编辑或运行任何会更改状态的操作。',
  'settings.agentAccess.tier.supervised.title': '编辑前询问',
  'settings.agentAccess.tier.supervised.desc':
    '可自由创建新文件，但在编辑现有文件、运行命令、访问网络或安装任何内容前会请求你的批准。',
  'settings.agentAccess.tier.full.title': '完全访问',
  'settings.agentAccess.tier.full.desc':
    '使用你的完整用户账户权限运行命令：可在允许的位置读写，但凭据和系统存储除外。破坏性命令、网络访问和安装仍会请求批准。',
  'settings.agentAccess.defaultTag': '（默认）',
  'settings.agentAccess.fullWarning':
    '⚠ 完全访问会使用你的完整账户权限运行命令，且没有沙盒。仅在你信任智能体可使用这台机器时启用。凭据和系统目录仍会被阻止，破坏性、网络和安装操作仍会请求批准。',
  'settings.agentAccess.confine.label': '限制在工作区',
  'settings.agentAccess.confine.desc':
    '无论选择哪种访问模式，都将智能体限制在工作区目录（以及已授权文件夹）内。关闭后，它可访问你的用户可访问的任何位置：始终阻止的凭据和系统目录除外。',
  'settings.agentAccess.requireTaskPlanApproval.label': '要求批准任务计划',
  'settings.agentAccess.requireTaskPlanApproval.desc':
    '在指定智能体执行由智能体编写的任务简报前暂停。',
  'settings.agentAccess.autoApproveAll.label': '自动批准所有操作',
  'settings.agentAccess.autoApproveAll.desc':
    '启用后，智能体将自动执行所有符合条件的操作，无需事先征得你的批准。这包括文件写入、Shell 命令、网络请求以及任何其他副作用。严格的安全阻止措施（凭据目录和系统目录）仍然适用，来自不受信任或未知来源的操作永远不会被自动批准。',
  'settings.agentAccess.tinyplaceAutopilot.title': '自主 tiny.place 代理',
  'settings.agentAccess.tinyplaceAutopilot.desc':
    '让 OpenHuman 自行在 tiny.place 上行动：按计划寻找有价值的工作（优先开放的悬赏），完成符合其技能的任务，并以你的身份行动。它在无人监督下运行且可以花费资金，测试时请使用 devnet。默认关闭。',
  'settings.agentAccess.tinyplaceAutopilot.label': '自动运行',
  'settings.agentAccess.timeout.label': '操作超时',
  'settings.agentAccess.timeout.desc':
    '单个工具或操作在被取消前可运行的时长。如果大型本地模型在完成响应前被中断，请增大此值。',
  'settings.agentAccess.timeout.unit': '秒',
  'settings.agentAccess.timeout.invalid': '请输入允许范围内的整数秒数',
  'settings.agentAccess.timeout.envOverride':
    '环境变量 OPENHUMAN_TOOL_TIMEOUT_SECS 正在覆盖此设置，因此在取消该变量之前，此处的更改不会生效。',
  'settings.agentAccess.grantedFolders': '已授权文件夹',
  'settings.agentAccess.alwaysAllow': '始终允许的工具',
  'settings.agentAccess.alwaysAllowDesc':
    '你在聊天中标记为“始终允许”的工具会直接运行且不再询问。移除后会重新提示。',
  'settings.agentAccess.alwaysAllowNone': '还没有始终允许的工具。',
  'settings.agentAccess.grantedDesc':
    '除工作区外，智能体可读写的文件夹。凭据存储（~/.ssh、~/.gnupg、~/.aws、keychains）和系统目录（/etc、/System、C:\\Windows、…）始终被阻止，即使它们位于已授权文件夹内。',
  'settings.agentAccess.noneGranted': '未授权任何文件夹。',
  'settings.agentAccess.readWrite': '读写',
  'settings.agentAccess.readOnly': '只读',
  'settings.agentAccess.remove': '移除',
  'settings.agentAccess.pathPlaceholder': '文件夹的绝对路径',
  'settings.agentAccess.accessLevelLabel': '访问级别',
  'settings.agentAccess.add': '添加',
  'settings.agentAccess.saving': '保存中…',
  'settings.agentAccess.changesApply': '更改将在你的下一条消息后生效。',
  'settings.agentAccess.directories': '目录',
  'settings.agentAccess.actionSandbox': '操作沙箱',
  'settings.agentAccess.readWriteAccess': '读取 + 写入',
  'settings.agentAccess.actionSandboxDesc': 'Shell、文件和 git 工具的默认工作目录。',
  'settings.agentAccess.actionDir.edit': '编辑',
  'settings.agentAccess.actionDir.save': '保存',
  'settings.agentAccess.actionDir.cancel': '取消',
  'settings.agentAccess.actionDir.placeholder': '绝对路径，例如 /Users/you/Projects',
  'settings.agentAccess.actionDir.envLocked':
    '由 OPENHUMAN_ACTION_DIR 设置。请更改环境变量以覆盖。',
  'settings.agentAccess.actionDir.saved': '操作目录已更新。',
  'settings.agentAccess.internalState': '内部状态',
  'settings.agentAccess.agentBlocked': '代理已阻止',
  'settings.agentAccess.internalStateDesc':
    '内存数据库、会话、令牌和其他核心数据。代理工具无法访问。',
  'settings.agentAccess.actionDirInputLabel': '操作沙箱路径',
  'settings.agentAccess.actionDirSave': '保存',
  'settings.agentAccess.actionDirSaving': '正在保存…',
  'settings.agentAccess.actionDirSaved': '操作沙箱已更新。',
  'settings.agentAccess.actionDirEmptyError': '路径不能为空。',
  'settings.agentAccess.actionDirSaveError': '无法更新操作沙箱。',
  'settings.agentAccess.actionDirEnvOverrideError':
    'OPENHUMAN_ACTION_DIR 已设置：请取消该环境变量以在设置中编辑此项。',
  'settings.agentAccess.actionDirEnvOverrideNote':
    '已被 OPENHUMAN_ACTION_DIR 覆盖：请取消该环境变量以在设置中管理。',
  'settings.agentAccess.approvalHistory': '审批历史',
  'settings.agentAccess.approvalHistoryDesc': '查看智能体请求的历次批准/拒绝决定。',
  'settings.agentAccess.viewApprovalHistory': '查看审批历史',

  // ── 权限面板 ──────────────────────────────────────────────────────
  'settings.permissions.title': '权限',
  'settings.permissions.menuDesc': '选择您的助手可以做什么以及可以在哪里工作。',
  'settings.permissions.accessMode': '助手可以做什么？',
  'settings.permissions.accessModeDesc': '选择助手在您的电脑上执行操作时拥有多大的自由度。',
  'settings.permissions.preset.readonly.title': '只看不动',
  'settings.permissions.preset.readonly.desc':
    '助手可以读取文件并进行探索：但绝不会写入、编辑或运行任何改变状态的内容。',
  'settings.permissions.preset.supervised.title': '先征求意见',
  'settings.permissions.preset.supervised.desc':
    '可以自由创建新文件，但在编辑、运行命令或访问网络之前，始终会请求您的批准。',
  'settings.permissions.preset.full.title': '完全控制',
  'settings.permissions.preset.full.desc':
    '以您的完整账户权限运行。破坏性命令、网络访问和安装仍需批准。',
  'settings.permissions.folders': '它可以在哪里工作？',
  'settings.permissions.foldersDesc': '助手读写的默认文件夹。您可以在高级设置中添加更多文件夹。',

  'settings.meetings.title': '会议',
  'settings.meetings.menuDesc': '会议助手自动加入、摘要和转录',
  'settings.meetings.desktopOnly': '会议设置仅在桌面端可用。',
  'settings.meetings.loading': '加载中…',
  'settings.meetings.loadError': '无法加载会议设置。',
  'settings.meetings.saveError': '无法保存会议设置。',
  'settings.meetings.saved': '已保存',
  'settings.meetings.saving': '保存中…',
  'settings.meetings.autoJoin.title': '自动加入策略',
  'settings.meetings.autoJoin.desc': '当日历事件包含 Google Meet 链接时',
  'settings.meetings.autoJoin.askEachTime': '每次询问',
  'settings.meetings.autoJoin.always': '始终加入',
  'settings.meetings.autoJoin.never': '从不加入',
  'settings.meetings.autoSummarize.title': '通话后摘要',
  'settings.meetings.autoSummarize.desc': '通话结束后生成摘要',
  'settings.meetings.autoSummarize.ask': '通话后询问',
  'settings.meetings.autoSummarize.always': '始终摘要',
  'settings.meetings.autoSummarize.never': '从不摘要',
  'settings.meetings.listenOnly': '仅旁听模式',
  'settings.meetings.listenOnlyDesc': '加入时静音麦克风',
  'settings.meetings.ingestTranscripts': '摄取后端转录',
  'settings.meetings.ingestTranscriptsDesc': '将会议转录存储到记忆中',
  'settings.sandbox.title': '沙盒执行',
  'settings.sandbox.menuDesc': '配置沙盒后端以隔离代理工具。',
  'settings.sandbox.loading': '加载中…',
  'settings.sandbox.desktopOnly': '沙盒设置仅在桌面应用中可用。',
  'settings.sandbox.loadError': '加载沙盒设置失败。',
  'settings.sandbox.saveError': '保存沙盒设置失败。',
  'settings.sandbox.saved': '已保存：适用于新的代理会话。',
  'settings.sandbox.saving': '保存中…',
  'settings.sandbox.status': '状态',
  'settings.sandbox.dockerStatus': 'Docker',
  'settings.sandbox.available': '可用',
  'settings.sandbox.unavailable': '不可用',
  'settings.sandbox.detectedBackend': '操作系统后端',
  'settings.sandbox.enableLabel': '启用沙盒执行',
  'settings.sandbox.enableDesc': '在隔离的沙盒环境中运行代理工具。',
  'settings.sandbox.backendLabel': '后端',
  'settings.sandbox.backendDesc': '选择用于沙盒执行的隔离后端。',
  'settings.sandbox.backend.auto': '自动（检测最佳可用选项）',
  'settings.sandbox.backend.docker': 'Docker',
  'settings.sandbox.backend.landlock': 'Landlock (Linux)',
  'settings.sandbox.backend.firejail': 'Firejail (Linux)',
  'settings.sandbox.backend.bubblewrap': 'Bubblewrap (Linux)',
  'settings.sandbox.backend.none': '无（不使用沙盒）',
  'settings.sandbox.dockerSettings': 'Docker 设置',
  'settings.sandbox.dockerImage': '镜像',
  'settings.sandbox.dockerImagePlaceholder': 'alpine:3.20',
  'settings.sandbox.memoryLimit': '内存限制',
  'settings.sandbox.memoryUnit': 'MB',
  'settings.sandbox.cpuLimit': 'CPU 限制',
  'settings.sandbox.cpuUnit': '核心',
  'settings.sandbox.envPassthrough': '环境变量透传',
  'settings.sandbox.envPassthroughDesc': '转发到沙盒中的环境变量。',
  'settings.sandbox.noEnvVars': '未配置任何环境变量。',
  'settings.approvalHistory.title': '审批历史',
  'settings.approvalHistory.subtitle': '最近的工具审批决定，最新优先。',
  'settings.approvalHistory.refresh': 'Refresh',
  'settings.approvalHistory.loading': '正在加载审批历史…',
  'settings.approvalHistory.retry': 'Retry',
  'settings.approvalHistory.emptyState': '尚无审批决定记录。',
  'settings.approvalHistory.errorGeneric': '无法加载审批历史。请重试。',
  'settings.approvalHistory.decidedAt': '决定于 {date}',
  'settings.approvalHistory.decision.approveOnce': '批准一次',
  'settings.approvalHistory.decision.approveAlways': '始终允许',
  'settings.approvalHistory.decision.approveAlwaysFlow': '始终允许（流程）',
  'settings.approvalHistory.decision.deny': 'Denied',
  'settings.theme.variantLight': '浅色',
  'settings.theme.variantDark': '深色',
  'settings.theme.variantAuto': '自动',
  'settings.theme.variantAria': '主题变体',
  'settings.theme.backdropHeading': '背景',
  'settings.theme.backdrop.mesh': '网格',
  'settings.theme.backdrop.solid': '纯色',
  'settings.theme.backdrop.image': '图片',
  'settings.theme.backdropImageUrl': '背景图片 URL',
  'settings.theme.backdropDots': '显示背景圆点',
  'settings.theme.backdropHint': '网格显示动态渐变；纯色使用平面背景；图片使用你自己的背景。',
  'settings.theme.autoForkHint': '编辑预设主题会自动将更改保存为新的自定义主题。',
  'settings.theme.title': '主题工作室',
  'settings.theme.menuDesc': '完全自定义颜色和字体，或选择预设主题。',
  'settings.theme.presetsHeading': '主题',
  'settings.theme.builtInBadge': '预设',
  'settings.theme.customBadge': '自定义',
  'settings.theme.customizeHint': '内置预设为只读。复制此主题以编辑其颜色和字体。',
  'settings.theme.duplicate': '复制并自定义',
  'settings.theme.copyName': '{name}（自定义）',
  'settings.theme.importedName': '已导入的主题',
  'settings.theme.contrastWarn': '文字与背景之间对比度过低：此主题可能难以阅读。',
  'settings.theme.group.surfaces': '表面',
  'settings.theme.group.text': '文字',
  'settings.theme.group.borders': '边框',
  'settings.theme.group.accents': '强调色',
  'settings.theme.showShades': '显示所有强调色色调',
  'settings.theme.hideShades': '隐藏所有强调色色调',
  'settings.theme.fontsHeading': '字体',
  'settings.theme.fontRole.title': '标题',
  'settings.theme.fontRole.heading': '小标题',
  'settings.theme.fontRole.body': '正文',
  'settings.theme.fontRole.mono': '等宽字体',
  'settings.theme.fontRole.serif': '衬线字体',
  'settings.theme.fontCurrent': '当前',
  'settings.theme.actions': '管理主题',
  'settings.theme.reset': '重置覆盖',
  'settings.theme.delete': '删除主题',
  'settings.theme.export': '复制 JSON',
  'settings.theme.copied': '已复制！',
  'settings.theme.import': '导入主题',
  'settings.theme.importHint': '粘贴导出的主题 JSON 以将其添加为自定义主题。',
  'settings.theme.importApply': '导入',
  'settings.theme.importError': '无法解析该主题 JSON。',
  'settings.appearance.title': '外观',
  'settings.appearance.themeHeading': '主题',
  'settings.appearance.themeAria': '主题',
  'settings.appearance.modeLight': '浅色',
  'settings.appearance.modeLightDesc': '明亮界面，深色文字。',
  'settings.appearance.modeDark': '深色',
  'settings.appearance.modeDarkDesc': '暗色界面，夜间更护眼。',
  'settings.appearance.modeSystem': '跟随系统',
  'settings.appearance.modeSystemDesc': '跟随操作系统外观设置。',
  'settings.appearance.helperText':
    '深色模式会将整个应用（包括聊天、设置和面板）切换为暗色调。"跟随系统"会同步你的操作系统外观并实时更新。',
  'settings.appearance.fontSizeHeading': '字体大小',
  'settings.appearance.fontSizeAria': '字体大小',
  'settings.appearance.fontSizeSmall': '小',
  'settings.appearance.fontSizeSmallDesc': '紧凑文字：屏幕显示更多内容。',
  'settings.appearance.fontSizeMedium': '中',
  'settings.appearance.fontSizeMediumDesc': '默认的均衡大小。',
  'settings.appearance.fontSizeLarge': '大',
  'settings.appearance.fontSizeLargeDesc': '更大的文字，阅读更轻松。',
  'settings.appearance.fontSizeXLarge': '超大',
  'settings.appearance.fontSizeXLargeDesc': '最大的文字，可读性最佳。',
  'settings.appearance.fontSizeHelperText':
    '在整个应用（包括聊天、设置和面板）中缩放文字，不受系统字体设置影响。',
  'settings.appearance.fontSizeCustomLabel': '自定义大小',
  'settings.appearance.fontSizeCustomAria': '自定义字体大小（像素）',
  'settings.appearance.fontSizeCustomSliderAria': '自定义字体大小滑块（像素）',
  'settings.appearance.fontSizeUnit': 'px',
  'settings.appearance.tabBarHeading': '底部标签栏',
  'settings.appearance.tabBarAlwaysShowLabels': '始终显示标签',
  'settings.appearance.tabBarAlwaysShowLabelsDesc': '关闭时，标签仅出现在悬停时或活动选项卡上。',
  'settings.appearance.chatHeading': '聊天',
  'settings.appearance.assistantTextMode': '助手回复以文本显示',
  'settings.appearance.hideAgentInsights': '隐藏智能体思考过程',
  'settings.appearance.hideAgentInsightsDesc':
    '折叠聊天中智能体逐步执行的实时时间线。闪烁的“处理中”链接仍可让你打开完整过程。',
  'settings.appearance.showChatMascot': '在消息框上显示 Tiny',
  'settings.appearance.showChatMascotDesc':
    '吉祥物会站在输入框上。隐藏后，聊天将只保留文字，直到你重新开启。',
  'settings.appearance.assistantTextModeDesc': '将助手回复渲染为无边框文本，同时保留你的消息气泡。',
  'settings.mascot.active': '活跃',
  'settings.mascot.characterDesc': '选择你的 OpenHuman 角色',
  'settings.mascot.characterDraft': '草稿',
  'settings.mascot.characterHeading': '角色',
  'settings.mascot.customGifError':
    '输入 HTTPS、file:// 或本地图片链接（PNG、GIF、JPEG、WebP 或 BMP），或上传文件。',
  'settings.mascot.customGifHeading': '自定义图片头像',
  'settings.mascot.customGifLabel': '自定义图片头像链接',
  'settings.mascot.customGifPlaceholder': 'https://example.com/avatar.png',
  'settings.mascot.customGifUpload': '上传图片',
  'settings.mascot.customGifInvalidType':
    '不支持的文件类型。请上传 PNG、GIF、JPEG、WebP 或 BMP 图片。',
  'settings.mascot.customGifTooLarge': '图片太大。请上传不超过 1.5 MB 的文件。',
  'settings.mascot.customGifReadError': '无法读取该图片。请尝试其他文件。',
  'settings.mascot.characterPreview': '预览',
  'settings.mascot.characterStates': '状态',
  'settings.mascot.characterVisemes': '视素',
  'settings.mascot.colorAria': 'OpenHuman 颜色',
  'settings.mascot.colorDesc': '选择颜色方案',
  'settings.mascot.colorHeading': '颜色',
  'settings.mascot.colorBlack': '黑色',
  'settings.mascot.colorBurgundy': '酒红色',
  'settings.mascot.colorCustom': '自定义',
  'settings.mascot.colorNavy': '深蓝色',
  'settings.mascot.primaryColor': '主色',
  'settings.mascot.secondaryColor': '辅助色',
  'settings.mascot.colorYellow': '黄色',
  'settings.mascot.libraryUnavailable': 'OpenHuman 资源库不可用',
  'settings.mascot.title': 'OpenHuman',
  'settings.mascot.loadingLibrary': '正在加载 OpenHuman 库…',
  'settings.mascot.loadDetailError': '无法加载吉祥物。',
  'settings.mascot.loadLibraryError': '无法加载吉祥物库。',
  'settings.mascot.localDefault': '本地 OpenHuman（默认）',
  'settings.mascot.menuTitle': '吉祥物',
  'settings.mascot.menuDesc': '选择应用内使用的吉祥物颜色',
  'settings.mascot.noCharacters': '暂无可用的 OpenHuman 角色',
  'settings.mascot.noColorVariants': '无颜色变体',
  'settings.mascot.secondaryHeading': '会议搭档（第二个吉祥物）',
  'settings.mascot.secondaryDesc':
    '为会议添加第二个吉祥物。设置两个后，它们会一起出现并轮流说话。若只用一个吉祥物，请保持为无。',
  'settings.mascot.secondaryNone': '无（单个吉祥物）',
  'settings.mascot.perMascotVoiceHeading': '每个吉祥物的语音',
  'settings.mascot.primaryVoiceLabel': '第一个吉祥物的语音',
  'settings.mascot.secondaryVoiceLabel': '第二个吉祥物的语音',
  'settings.mascot.voice.current': '当前',
  'settings.mascot.voice.customDesc':
    '在 api.elevenlabs.io/v1/voices 或您的 ElevenLabs 仪表板中查找语音 ID。仅存储 ID：您的 API 密钥保留在后端。',
  'settings.mascot.voice.customHeading': '自定义语音 ID',
  'settings.mascot.voice.customOption': '其他（粘贴语音 ID）…',
  'settings.mascot.voice.customPlaceholder': '例如21m00Tcm4TlvDq8ikWAM',
  'settings.mascot.voice.desc':
    '选择吉祥物用于语音回复的 ElevenLabs 声音。按性别筛选，从精选列表中选择，粘贴自定义 ID，或让应用根据您的界面语言自动选择声音。',
  'settings.mascot.voice.genderFemale': '女声',
  'settings.mascot.voice.genderHeading': '声音性别',
  'settings.mascot.voice.genderMale': '男声',
  'settings.mascot.voice.heading': '声音',
  'settings.mascot.voice.preset': '声音预设',
  'settings.mascot.voice.presetHeading': '声音预设',
  'settings.mascot.voice.preview': '试听声音',
  'settings.mascot.voice.previewError': '声音试听失败',
  'settings.mascot.voice.previewText': '你好，我是你的助手。这是一段声音试听。',
  'settings.mascot.voice.previewing': '试听中…',
  'settings.mascot.voice.reset': '重置为默认值',
  'settings.mascot.voice.useLocaleDefault': '匹配应用语言',
  'settings.mascot.voice.useLocaleDefaultDesc': '为当前界面语言自动选择一个声音。',
  'settings.persona.title': '人格',
  'settings.persona.menuTitle': '人格',
  'settings.persona.menuDesc': '名称、性格、头像和声音：让你的助手成为统一身份',
  'settings.persona.identityHeading': '身份',
  'settings.persona.identityDesc':
    '助手的显示名称和简短描述。会显示在应用中；不会改变助手的推理方式。',
  'settings.persona.displayNameLabel': '显示名称',
  'settings.persona.displayNamePlaceholder': '例如 Nova',
  'settings.persona.descriptionLabel': '描述',
  'settings.persona.descriptionPlaceholder': '例如 为我的团队服务的冷静、简洁助手。',
  'settings.persona.soul.heading': '性格（SOUL.md）',
  'settings.persona.soul.desc':
    '助手在每次对话中遵循的性格提示词。编辑会保存到你的工作区，并在下次回复时生效。',
  'settings.persona.soul.editorLabel': 'SOUL.md 内容',
  'settings.persona.soul.reset': '重置为默认值',
  'settings.persona.soul.usingDefault': '正在使用内置默认值',
  'settings.persona.soul.loadError': '无法加载 SOUL.md',
  'settings.persona.soul.saveError': '无法保存 SOUL.md',
  'settings.persona.soul.resetError': '无法重置 SOUL.md',
  'settings.persona.builder.modeLabel': '角色编辑器模式',
  'settings.persona.builder.modeGuided': '引导式',
  'settings.persona.builder.modeAdvanced': '高级',
  'settings.persona.builder.intro': '填写几个字段，我们会替你写入角色设定。无需 Markdown。',
  'settings.persona.builder.personalityLabel': '性格',
  'settings.persona.builder.personalityPlaceholder': '例如：温暖、好奇、直接。对不确定坦诚。',
  'settings.persona.builder.voiceLabel': '沟通风格',
  'settings.persona.builder.voicePlaceholder': '例如：先给答案，简洁，并贴合我的语气。',
  'settings.persona.builder.aboutLabel': '关于你',
  'settings.persona.builder.aboutPlaceholder': '例如：我经营一家小型设计工作室，喜欢通俗的表达。',
  'settings.persona.builder.preservedNote':
    '你手写的其他部分都会保留：切换到「高级」可查看完整角色设定。',
  'settings.persona.builder.securityNote': '想选择助手可以做什么？',
  'settings.persona.builder.securityLink': '打开代理访问权限',
  'settings.persona.templates.heading': '从模板开始',
  'settings.persona.templates.desc':
    '选择一个起点：它会填写「性格」和「沟通风格」。之后你可以随意修改。',
  'settings.persona.templates.doctor.label': '临床助手',
  'settings.persona.templates.doctor.desc': '严谨、引用来源、标注不确定',
  'settings.persona.templates.researcher.label': '研究助手',
  'settings.persona.templates.researcher.desc': '严谨、有条理、以证据为先',
  'settings.persona.templates.executive.label': '高管助手',
  'settings.persona.templates.executive.desc': '简洁、果断、注重行动',
  'settings.persona.templates.teacher.label': '老师',
  'settings.persona.templates.teacher.desc': '有耐心、循序渐进地讲解',
  'settings.persona.templates.student.label': '学习搭子',
  'settings.persona.templates.student.desc': '鼓励式、出小测、通俗易懂',
  'settings.persona.templates.family.label': '家庭助手',
  'settings.persona.templates.family.desc': '温暖、友好、老少皆宜',
  'settings.persona.appearanceHeading': '头像和声音',
  'settings.persona.appearanceDesc': '吉祥物颜色、自定义图片头像和回复声音在吉祥物设置中配置。',
  'settings.persona.openMascotSettings': '打开吉祥物设置',
  'settings.memoryWindow.balanced.badge': '推荐',
  'settings.memoryWindow.balanced.hint':
    '合理的默认值：在不为每次运行消耗额外 token 的情况下保持良好的连贯性。',
  'settings.memoryWindow.balanced.label': '均衡',
  'settings.memoryWindow.description':
    'OpenHuman 在每次新的智能体运行中注入多少记忆上下文。更大的窗口对过往对话更有感知，但每次运行会消耗更多 token，成本也更高。',
  'settings.memoryWindow.extended.badge': '更多上下文',
  'settings.memoryWindow.extended.hint': '向每次运行注入更多长期记忆。每轮 token 成本更高。',
  'settings.memoryWindow.extended.label': '扩展',
  'settings.memoryWindow.maximum.badge': '最高成本',
  'settings.memoryWindow.maximum.hint': '最大安全窗口。连贯性最佳，每次运行的 token 账单显著更高。',
  'settings.memoryWindow.maximum.label': '最大',
  'settings.memoryWindow.minimal.badge': '最便宜',
  'settings.memoryWindow.minimal.hint': '最小记忆窗口。最便宜、最快，但跨运行的连贯性最弱。',
  'settings.memoryWindow.minimal.label': '最小',
  'settings.memoryWindow.title': '长期记忆窗口',
  'settings.agentbox.title': 'AgentBox',
  'settings.agentbox.desc': 'GMI Cloud 市场适配器状态及提供商配置',
  'settings.agentbox.intro':
    'AgentBox 市场适配器的只读状态。模式和 GMI MaaS 提供商在核心启动时由环境变量设置。',
  'settings.agentbox.modeLabel': '市场模式',
  'settings.agentbox.providerHeading': 'GMI MaaS 提供商',
  'settings.agentbox.slug': '提供商标识',
  'settings.agentbox.baseUrl': '基础 URL',
  'settings.agentbox.model': '模型',
  'settings.agentbox.notConfigured':
    '未配置。请设置 GMI_MAAS_BASE_URL、GMI_MAAS_API_KEY 和 GMI_MODELS 环境变量。',
  'settings.agentbox.unavailable': 'AgentBox 状态不可用',
  'settings.modelHealth.title': '模型健康',
  'settings.modelHealth.desc': '比较各活跃模型的单模型质量、幻觉率和成本',
  'settings.modelHealth.allStatuses': '所有状态',
  'settings.modelHealth.models': '个模型',
  'settings.modelHealth.loading': '正在加载模型数据...',
  'settings.modelHealth.empty': '未注册模型',
  'settings.modelHealth.col.model': '模型',
  'settings.modelHealth.col.quality': '质量',
  'settings.modelHealth.col.halluc': '幻觉率',
  'settings.modelHealth.col.cost': '每 100 万输出成本',
  'settings.modelHealth.col.agents': '智能体',
  'settings.modelHealth.col.status': '状态',
  'settings.modelHealth.badge.keep': '保留',
  'settings.modelHealth.badge.replace': '替换',
  'settings.modelHealth.badge.staging': '预发布测试',
  'settings.modelHealth.badge.vision': '仅视觉',
  'settings.modelHealth.swap': '替换？',
  'settings.modelHealth.modal.title': '替换模型？',
  'settings.modelHealth.modal.hallucRate': '幻觉率',
  'settings.modelHealth.modal.cancel': '取消',
  'settings.modelHealth.modal.apply': '应用替换',
  'settings.modelHealth.tag.cheaper': '更便宜',
  'settings.modelHealth.tag.better': '更好',
  'skills.card.moreActions': '更多操作',
  'skills.channelIcon.discord': 'Discord',
  'skills.channelIcon.imessage': 'iMessage',
  'skills.channelIcon.telegram': 'Telegram',
  'skills.channelIcon.web': '网络',
  'skills.channelIcon.yuanbao': '元宝',
  'skills.composio.poweredBy': '由 Composio 提供支持',
  'skills.composio.staleStatusTitle': '连接显示陈旧状态',
  'skills.create.allowedTools': '允许的工具',
  'skills.create.allowedToolsHelp': '渲染到 SKILL.md frontmatter 中为',
  'skills.create.allowedToolsPlaceholder': '节点执行，获取',
  'skills.create.author': '作者',
  'skills.create.authorPlaceholder': '你的名字',
  'skills.create.commaSeparated': '（逗号分隔）',
  'skills.create.createBtn': '创建技能',
  'skills.create.createError': '无法创建技能',
  'skills.create.creating': '创建中…',
  'skills.create.description': '描述',
  'skills.create.descriptionPlaceholder': '这个技能做什么？',
  'skills.create.optional': '（可选）',
  'skills.create.inputs.heading': 'Inputs',
  'skills.create.inputs.help': '声明技能所需的参数。Skills Runner 将在运行时为这些参数渲染表单。',
  'skills.create.inputs.add': '添加输入',
  'skills.create.inputs.row.name': '输入名称',
  'skills.create.inputs.row.namePlaceholder': '例如 repo',
  'skills.create.inputs.row.nameError': '只能包含字母、数字、下划线和连字符，且必须以字母开头。',
  'skills.create.inputs.row.description': '输入描述',
  'skills.create.inputs.row.descriptionPlaceholder': '此字段用于输入什么？',
  'skills.create.inputs.row.type': 'Type',
  'skills.create.inputs.row.required': 'Required',
  'skills.create.inputs.row.remove': '删除输入',
  'skills.create.inputs.type.string': 'Text',
  'skills.create.inputs.type.integer': 'Number',
  'skills.create.inputs.type.boolean': '是 / 否',
  'skills.create.license': '许可证',
  'skills.create.licensePlaceholder': 'MIT',
  'skills.create.name': '名称',
  'skills.create.namePlaceholder': '例如：交易日志',
  'skills.create.scope': '范围',
  'skills.create.scopeProjectHint': '/.open human/技能/',
  'skills.create.scopeUserHint': '写入 ~/.openhuman/skills/<slug>/SKILL.md：在所有工作空间中可用。',
  'skills.create.slugLabel': '标识符',
  'skills.create.subtitle': '技能.md',
  'skills.create.tags': '标签',
  'skills.create.tagsPlaceholder': '贸易、研究',
  'skills.create.title': '新建技能',
  'skills.detail.allowedTools': '允许的工具',
  'skills.detail.author': '作者',
  'skills.detail.license': '许可证',
  'skills.detail.bundledResources': '捆绑资源',
  'skills.detail.description': '描述',
  'skills.detail.closeAriaLabel': '关闭技能详情',
  'skills.detail.location': '位置',
  'skills.detail.noBundledResources': '无捆绑资源。',
  'skills.detail.platforms': '平台',
  'skills.detail.relatedSkills': '相关技能',
  'skills.detail.source': '来源 URL',
  'skills.detail.sourceFormat': '格式',
  'skills.detail.stars': '星标',
  'skills.detail.tags': '标签',
  'skills.detail.warnings': '警告',
  'skills.detail.version': '版本',
  'skills.install.errors.alreadyInstalledHint':
    '工作区中已存在此 slug 的技能。首先将其删除或更改 frontmatter `metadata.id` / `name`。',
  'skills.install.errors.alreadyInstalledTitle': '技能已安装',
  'skills.install.errors.fetchFailedHint':
    '请求未成功完成。检查 URL 指向可访问的公共文件，并且主机返回 2xx 响应。',
  'skills.install.errors.fetchFailedTitle': '获取失败',
  'skills.install.errors.fetchTimedOutHint': '远程主机没有及时响应。请重试或提高超时（1-600 秒）。',
  'skills.install.errors.fetchTimedOutTitle': '获取超时',
  'skills.install.errors.fetchTooLargeHint':
    'SKILL.md 必须小于 1 MiB。将捆绑的资源拆分为“references/”或“scripts/”文件，而不是内联它们。',
  'skills.install.errors.fetchTooLargeTitle': 'SKILL.md 太大',
  'skills.install.errors.genericHint': '后端返回错误。原始消息如下所示。',
  'skills.install.errors.genericTitle': '无法安装技能',
  'skills.install.errors.invalidSkillHint':
    'frontmatter 必须是有效的 YAML，具有非空的“name”和“description”字段，并以“---”结尾。',
  'skills.install.errors.invalidSkillTitle': 'SKILL.md 未解析',
  'skills.install.errors.invalidUrlHint': '仅允许公共 HTTPS URL。私有、环回和元数据主机被阻止。',
  'skills.install.errors.invalidUrlTitle': 'URL 被拒绝',
  'skills.install.errors.unsupportedUrlHint':
    '只有直接的“.md”链接才有效。对于 GitHub，链接到文件 (github.com/owner/repo/blob/.../SKILL.md) - 未安装树和存储库根。',
  'skills.install.errors.unsupportedUrlTitle': '不支持 URL 形式',
  'skills.install.errors.writeFailedHint':
    '工作区技能目录不可写。检查“<workspace>/.open human/skills/”的文件系统权限。',
  'skills.install.errors.writeFailedTitle': '无法写入 SKILL.md',
  'skills.install.fetchLog': '获取日志',
  'skills.install.fetchingPrefix': '抓取',
  'skills.install.fetchingSuffix': '这可能需要您配置的超时时间。',
  'skills.install.installBtn': '安装中…',
  'skills.install.installComplete': '安装完成',
  'skills.install.installing': '安装中…',
  'skills.install.parseWarnings': '解析警告',
  'skills.install.rawError': '原始错误',
  'skills.install.subtitleMiddle': 'over HTTPS 并将其安装在',
  'skills.install.subtitlePrefix': '获取单个',
  'skills.install.subtitleSuffix': '仅 HTTPS；私有和环回主机被阻止。',
  'skills.install.successDiscovered': '发现{count}新技能。',
  'skills.install.successNoNewIds':
    '已安装技能，但没有出现新的技能 ID - 目录可能已包含具有相同 slug 的技能。',
  'skills.install.timeoutHint': '（秒，可选）',
  'skills.install.timeoutHelp': '默认为 60 秒。 1-600 之外的值在服务器端被限制。',
  'skills.install.timeoutInvalid': '必须是 1 到 600 之间的整数。',
  'skills.install.timeoutLabel': '超时',
  'skills.install.timeoutPlaceholder': '60',
  'skills.install.title': '从 URL 安装技能',
  'skills.install.urlHelpMiddle': '文件。',
  'skills.install.urlHelpPrefix': '直接链接到',
  'skills.install.urlHelpSuffix': 'URLs 自动重写为',
  'skills.install.urlInvalidPrefix': 'URL 必须是格式良好的',
  'skills.install.urlInvalidSuffix': '链接。',
  'skills.install.urlLabel': '技能 URL',
  'skills.install.urlPlaceholder': 'https://raw.githubusercontent.com/owner/repo/main/SKILL.md',
  'skills.meetingBots.bannerDesc': '让 OpenHuman 加入你的会议，自动记录摘要',
  'skills.meetingBots.bannerTitle': '会议机器人',
  'skills.meetingBots.busyTitle': 'OpenHuman 正忙',
  'skills.meetingBots.comingSoon': '即将推出',
  'skills.meetingBots.couldNotLeaveTitle': '无法离开会议',
  'skills.meetingBots.couldNotStartTitle': '无法启动 OpenHuman',
  'skills.meetingBots.displayName': '显示名称',
  'skills.meetingBots.failedToStart': '启动 OpenHuman 失败。',
  'skills.meetingBots.joiningMessage': '它应该在几秒钟内作为参会者出现。',
  'skills.meetingBots.joiningTitle': 'OpenHuman 正在加入会议',
  'skills.meetingBots.meetingLink': '会议链接',
  'skills.meetingBots.modalAriaLabel': '将 OpenHuman 发送到会议',
  'skills.meetingBots.modalDesc': '输入会议链接，让 OpenHuman 作为参会者加入并记录内容。',
  'skills.meetingBots.modalTitle': '将 OpenHuman 发送到会议',
  'skills.meetingBots.newBadge': '新',
  'skills.meetingBots.platformComingSoon': '{label} 支持即将推出。',
  'skills.meetingBots.platformHints.gmeet': 'meet.google.com/abc-defg-hij',
  'skills.meetingBots.platformHints.teams': 'team.microsoft.com/...',
  'skills.meetingBots.platformHints.webex': 'webex.com/meet/...',
  'skills.meetingBots.platformHints.zoom': 'Zoom.us/j/...',
  'skills.meetingBots.platforms.gmeet': 'Google 见面',
  'skills.meetingBots.platforms.teams': '微软团队',
  'skills.meetingBots.platforms.webex': 'Webex',
  'skills.meetingBots.platforms.zoom': '变焦',
  'skills.meetingBots.sendTo': '发送到会议',
  'skills.meetingBots.serverOverloaded': 'OpenHuman 当前负载过高，请几分钟后重试。',
  'skills.meetingBots.soonSuffix': '很快',
  'skills.meetingBots.starting': '启动中…',
  'skills.meetingBots.recentCallsAriaLabel': '最近的会议通话',
  'skills.meetingBots.recentCallsHeading': '最近通话',
  'skills.meetingBots.recentCallsEmpty': '暂无历史通话记录：您的会议记录将显示在此处。',
  'skills.meetingBots.recentCallsLoading': '加载中\u2026',
  'skills.meetingBots.recentCallAddedBy': '由 {name} 添加',
  'skills.meetingBots.recentCallParticipants': '与 {names}',
  'skills.meetingBots.recentCallTurnSingular': '{count} 轮发言',
  'skills.meetingBots.recentCallTurnPlural': '{count} 轮发言',
  'skills.meetingBots.recentCallDuration': '通话 {seconds} 秒',
  'skills.meetingBots.callDetailLoading': '正在加载文字记录…',
  'skills.meetingBots.callDetailError': '无法加载文字记录。',
  'skills.meetingBots.callDetailRetry': '重试',
  'skills.meetingBots.callDetailEmpty': '此通话未记录任何文字记录或摘要。',
  'skills.meetingBots.callSummaryHeading': '摘要',
  'skills.meetingBots.callKeyPointsHeading': '要点',
  'skills.meetingBots.callActionItemsHeading': '待办事项',
  'skills.meetingBots.callTranscriptHeading': '文字记录',
  'skills.meetingBots.liveBadge': '直播',
  'skills.meetingBots.liveTitle': '会议中',
  'skills.meetingBots.liveStatusJoining': '正在加入\u2026',
  'skills.meetingBots.liveStatusActive': '会议直播中',
  'skills.meetingBots.liveStatusListening': '正在收听（已静音）',
  'skills.meetingBots.liveStatusEnded': '会议已结束',
  'skills.meetingBots.liveStatusError': '加入失败',
  'skills.meetingBots.liveTranscriptHeading': '实时转录',
  'skills.meetingBots.liveTranscriptEmpty': '等待语音…',
  'skills.meetingBots.leaveButton': '离开',
  'skills.meetingBots.leavingButton': '正在离开…',
  'skills.meetingBots.respondToParticipant': '您在此会议中的姓名',
  'skills.meetingBots.respondToParticipantHint': '例如：小明（通话中的显示名称）',
  'skills.meetingBots.replyName.label': '您在会议中的名称',
  'skills.meetingBots.replyName.description':
    '机器人识别并回复的名称。请输入您在通话中显示的名称：适用于它加入的每个会议。',
  'skills.meetingBots.replyName.placeholder': '例如：Alex Kim',
  'skills.meetingBots.respondToParticipantDesc':
    '输入您在会议中的确切显示名称。机器人仅在您说出其名称（唤醒词）时才会响应。',
  'skills.meetingBots.wakePhrase': '唤醒词',
  'skills.meetingBots.wakePhraseHint': 'Hey OpenHuman',
  'skills.meetingBots.wakePhraseDesc': '参与者必须先说出此词，机器人才会回复。',
  'skills.meetingBots.activeMode': '当我呼叫时回应',
  'skills.meetingBots.activeModeDesc':
    '开启后，说出唤醒词后机器人会出声回答。关闭后，它只聆听并转写。',
  'skills.meetingBots.history.allPlatforms': '所有平台',
  'skills.meetingBots.history.copyTranscript': '复制',
  'skills.meetingBots.history.downloadTranscript': '下载',
  'skills.meetingBots.history.earlier': '更早',
  'skills.meetingBots.history.participantCount': '{count} 位参与者',
  'skills.meetingBots.history.participantCountPlural': '{count} 位参与者',
  'skills.meetingBots.history.runWithOpenHuman': '使用 OpenHuman 运行',
  'skills.meetingBots.history.searchPlaceholder': '搜索通话…',
  'skills.meetingBots.history.selectPrompt': '选择一个通话以查看其摘要和转录。',
  'skills.meetingBots.history.today': '今天',
  'skills.meetingBots.history.yesterday': '昨天',
  'skills.meetingBots.upcoming.heading': '即将举行',
  'skills.meetingBots.upcoming.when': '时间',
  'skills.meetingBots.upcoming.meeting': '会议',
  'skills.meetingBots.upcoming.platform': '平台',
  'skills.meetingBots.upcoming.people': '人员',
  'skills.meetingBots.upcoming.joinPolicy': '加入策略',
  'skills.meetingBots.upcoming.joinNow': '立即加入',
  'skills.meetingBots.upcoming.joinNowAriaLabel': '加入 {title}',
  'skills.meetingBots.upcoming.join': '加入',
  'skills.meetingBots.upcoming.auto': '自动',
  'skills.meetingBots.upcoming.ask': '询问',
  'skills.meetingBots.upcoming.skip': '跳过',
  'skills.meetingBots.upcoming.today': '今天',
  'skills.meetingBots.upcoming.tomorrow': '明天',
  'skills.meetingBots.upcoming.empty': '没有即将举行的会议：连接 Google Calendar 以在此查看。',
  'skills.meetingBots.upcoming.error': '无法加载即将举行的会议。',
  'skills.meetingBots.upcoming.retry': '重试',
  'skills.meetingBots.upcoming.refresh': '刷新',
  'skills.meetingBots.upcoming.filterAll': '所有平台',
  'skills.meetingBots.upcoming.participants': '{count} 位参与者',
  'skills.meetingBots.upcoming.imminent': '即将开始',
  'skills.meetingBots.upcoming.autoJoinsAt': '自动加入 ~{time}',
  'skills.meetingBots.upcoming.asksAtStart': '开始时询问',
  'skills.meetingBots.upcoming.watchCalendarHint':
    '在默认设置（齿轮图标）中开启「监控我的日历」，以使自动/询问生效：否则这些策略已保存但不会触发。',
  'skills.meetingBots.relative.now': '现在',
  'skills.meetingBots.relative.inMinutes': '{count}分钟后',
  'skills.meetingBots.relative.inHours': '{count}小时后',
  'skills.meetingBots.relative.minutesAgo': '{count}分钟前',
  'skills.meetingBots.relative.hoursAgo': '{count}小时前',
  'skills.meetingBots.relative.daysAgo': '{count}天前',
  'skills.meetingBots.relative.yesterday': '昨天',
  'skills.meetingBots.defaults.drawerTitle': '会议默认设置',
  'skills.meetingBots.defaults.closeDrawer': '关闭',
  'skills.meetingBots.defaults.openDefaults': '会议设置',
  'skills.meetingBots.defaults.watchCalendar': '监控我的日历',
  'skills.meetingBots.defaults.watchCalendarDesc':
    '让 OpenHuman 监控您连接的日历，以便根据以下策略自动加入会议或提示参加会议。这与会议提醒通知是分开的。',
  'skills.meetingBots.defaults.globalPolicy': '全局自动加入策略',
  'skills.meetingBots.defaults.perPlatformTitle': '平台特定设置',
  'skills.meetingBots.defaults.perPlatformDesc': '覆盖特定平台的全局策略。',
  'skills.meetingBots.defaults.useDefault': '使用默认值',
  'skills.resource.preview.closeAriaLabel': '关闭预览',
  'skills.resource.preview.failed': '预览失败',
  'skills.resource.preview.loading': '加载预览中…',
  'skills.resource.tree.assets': '资源',
  'skills.resource.tree.examples': '示例',
  'skills.resource.tree.other': '其他',
  'skills.resource.tree.prompts': '提示词',
  'skills.resource.tree.references': '参考资料',
  'skills.resource.tree.scripts': '脚本',
  'skills.resource.tree.templates': '模板',
  'skills.resource.tree.empty': '无捆绑资源。',
  'skills.search.placeholder': '搜索技能...',
  'skills.setup.voice.activation': '激活方式',
  'skills.setup.voice.activeDescPrefix': 'Fn',
  'skills.setup.voice.activeDescSuffix': 'Fn',
  'skills.setup.voice.activeTitle': '语音智能已激活',
  'skills.setup.voice.customizeSettings': '自定义设置',
  'skills.setup.voice.downloadSttBtn': '下载 STT 模型',
  'skills.setup.voice.enableDesc': '启用语音输入和输出功能',
  'skills.setup.voice.hotkey': '热键',
  'skills.setup.voice.startBtn': '启动中...',
  'skills.setup.voice.startError': '启动语音服务失败',
  'skills.setup.voice.starting': '启动中...',
  'skills.setup.voice.stepEnable': '启动语音服务',
  'skills.setup.voice.stepSetup': '需要下载模型',
  'skills.setup.voice.stepSuccess': '准备就绪',
  'skills.setup.voice.sttNotReady': '语音转文本模型未就绪',
  'skills.setup.voice.sttNotReadyDesc':
    '语音智能需要本地 Whisper 模型进行转录。请从本地模型设置中下载。',
  'skills.setup.voice.sttReady': '语音转文本模型已就绪',
  'skills.setup.voice.sttReturnHint': '完成后将返回此页面',
  'skills.setup.voice.title': '语音智能',
  'skills.uninstall.couldNotUninstall': '无法卸载',
  'skills.uninstall.description':
    '这将永久删除技能目录及其所有捆绑资源。智能体将在下一轮停止看到它。',
  'skills.uninstall.title': '卸载',
  'skills.uninstall.uninstallBtn': '卸载',
  'skills.uninstall.uninstalling': '卸载中…',
  'upsell.global.limitMessage': '升级方案或充值配额以继续使用',
  'upsell.global.limitTitle': '已达使用限制',
  'upsell.global.nearLimitMessage': '你已使用了 {pct}% 的使用限制。升级以获得更高限额。',
  'upsell.global.nearLimitTitle': '接近使用限制',
  'upsell.usageLimit.bodyBudget': '你已达到每周限制。',
  'upsell.usageLimit.bodyRate': '你已达到 10 小时推理速率限制。',
  'upsell.usageLimit.heading': '已达使用限制',
  'upsell.usageLimit.notNow': '暂不',
  'upsell.usageLimit.perWindow': '{amount}',
  'upsell.usageLimit.planIncludes': '{plan}',
  'upsell.usageLimit.resetsIn': '重置时间',
  'upsell.usageLimit.upgradePlan': '升级方案',
  'upsell.usageLimit.weeklyInference': '{amount}',
  'walkthrough.steps.startChat.title': '从聊天开始',
  'walkthrough.steps.startChat.content':
    '聊天是你的起点。新窗口会显示设置后看到的同一欢迎语和快捷操作。',
  'walkthrough.steps.sayHello.title': '打个招呼',
  'walkthrough.steps.sayHello.content': '随时点击这里，开始和你的 AI 助手对话。',
  'walkthrough.steps.meetAi.title': '认识你的 AI',
  'walkthrough.steps.meetAi.content':
    '对话都在这里进行。你可以提问、获取摘要或整理想法，所有内容都可以搜索。',
  'walkthrough.steps.connectWorld.title': '连接你的世界',
  'walkthrough.steps.connectWorld.content': 'Gmail、Slack、WhatsApp 等连接会为助手带来更多能力。',
  'walkthrough.steps.messagingApps.title': '在常用地方聊天',
  'walkthrough.steps.messagingApps.content':
    '连接 WhatsApp、Telegram、Slack、Discord，让助手能在任何地方联系你。',
  'walkthrough.steps.settings.title': '按你的方式设置',
  'walkthrough.steps.settings.content':
    '偏好、隐私和通知都在这里。你可以随时从此页面重新开始本引导。',
  'walkthrough.steps.chatTab.title': '返回聊天',
  'walkthrough.steps.chatTab.content': '想回到对话时，使用 Chat 标签。',
  'walkthrough.steps.humanTab.title': '了解你的 Human 资料',
  'walkthrough.steps.humanTab.content': 'Human 汇集你的个人上下文、身份以及助手可见的资料。',
  'walkthrough.steps.brainTab.title': '打开 Brain',
  'walkthrough.steps.brainTab.content':
    'Brain 是记忆图谱，用来查看 OpenHuman 知道什么，以及想法如何相互连接。',
  'walkthrough.steps.agentWorldTab.title': '探索 Agent World',
  'walkthrough.steps.agentWorldTab.content': 'Agent World 是可复用代理和共享自动化所在的位置。',
  'walkthrough.steps.connectionsTab.title': '管理连接',
  'walkthrough.steps.connectionsTab.content':
    '想添加或调整服务时，Connections 始终可从主导航进入。',
  'walkthrough.steps.feedbackTab.title': '发送反馈',
  'walkthrough.steps.feedbackTab.content': 'Feedback 提供直接入口，用来报告问题或请求改进。',
  'walkthrough.steps.allSet.title': '全部就绪！',
  'walkthrough.steps.allSet.content':
    '你的助手留下了一条欢迎消息：这里就是你聊天、提问和整理想法的空间。祝你使用愉快！',
  'walkthrough.tooltip.letsGo': '出发吧！',
  'walkthrough.tooltip.next': '下一步 →',
  'walkthrough.tooltip.skip': '跳过引导',
  'walkthrough.tooltip.stepCounter': '{n} / {total}',
  'webhooks.activity.empty': '暂无活动',
  'webhooks.activity.title': '最近活动',
  'webhooks.composioHistory.empty': '暂无记录',
  'webhooks.composioHistory.metadataId': '元数据 ID',
  'webhooks.composioHistory.metadataUuid': '元数据 UUID',
  'webhooks.composioHistory.payload': '载荷',
  'webhooks.composioHistory.title': 'ComposeIO 触发器历史',
  'webhooks.tunnels.active': '活跃',
  'webhooks.tunnels.createFailed': '创建隧道失败',
  'webhooks.tunnels.creating': '创建中...',
  'webhooks.tunnels.deleteFailed': '删除隧道失败',
  'webhooks.tunnels.descriptionPlaceholder': '描述（可选）',
  'webhooks.tunnels.echo': '回显',
  'webhooks.tunnels.empty': '暂无隧道',
  'webhooks.tunnels.enableEcho': '启用回显',
  'webhooks.tunnels.inactive': '未激活',
  'webhooks.tunnels.namePlaceholder': '隧道名称（例如：telegram-bot）',
  'webhooks.tunnels.newTunnel': '新建隧道',
  'webhooks.tunnels.removeEcho': '移除回显',
  'webhooks.tunnels.title': 'Webhook 隧道',
  'webhooks.tunnels.toggleFailed': '切换回显失败',
  'composio.directModeRequiresKey': '保存失败。直连模式需要非空的 API 密钥。',
  'composio.integrationSlugsHelp': '以逗号分隔的集成段，例如',
  'composio.integrationSlugsExample': 'Gmail、松弛',
  'composio.integrationSlugsCaseInsensitive': '不区分大小写。',
  'composio.integrationSlugsPlaceholder': 'Gmail、松弛、...',
  'composio.notYetRouted': '尚未路由',
  'composio.triggers.loading': '加载中…',
  'conversations.taskKanban.todo': '待办',
  'chat.addReaction': '添加反应',
  'chat.agentProfile.create': '创建代理资料',
  'chat.agentProfile.createFailed': '无法创建代理配置文件。',
  'chat.agentProfile.customDescription': '定制代理资料',
  'chat.agentProfile.defaultAgentLabel': '协调者',
  'chat.agentProfile.exists': '代理配置文件“{name}”已存在。',
  'chat.agentProfile.label': '代理简介',
  'chat.agentProfile.quick': '快速',
  'chat.agentProfile.reasoning': '推理',
  'chat.agentProfile.namePlaceholder': '个人资料名称',
  'chat.agentProfile.promptStylePlaceholder': '提示风格',
  'chat.agentProfile.allowedToolsPlaceholder': '允许使用的工具',
  'chat.backToThread': '返回{title}',
  'chat.parentThread': '父线程',
  'chat.removeReaction': '删除 {emoji}',
  'settings.composio.loading': '加载中…',
  'settings.mascot.noCharactersAvailable': '暂无可用的 OpenHuman 角色',
  'skills.uninstall.confirmTitle': '卸载 {name}？',
  'conversations.taskKanban.blocked': '已阻塞',
  'conversations.taskKanban.done': '已完成',
  'conversations.taskKanban.pending': '待处理',
  'conversations.taskKanban.working': '处理中',
  'conversations.taskKanban.awaitingApproval': '等待批准',
  'conversations.taskKanban.ready': '就绪',
  'conversations.taskKanban.rejected': '已拒绝',
  'conversations.taskKanban.inProgress': '进行中',
  'conversations.taskKanban.awaitingApprovalColumn': '等待审批',
  'conversations.taskKanban.blockedColumn': '已阻塞',
  'conversations.taskKanban.evidenceBadge': '证据（{count}）',
  'conversations.taskKanban.needsInput': '这些任务需要您的参与',
  'conversations.taskKanban.emptyColumn': '暂无任务',
  'conversations.taskKanban.dragHint': '拖动以在列之间移动',
  'conversations.taskKanban.movingCard': '移动中…',
  'conversations.taskKanban.statusBadge.ready': '准备开始',
  'conversations.taskKanban.statusBadge.rejected': '已拒绝',
  'intelligence.memoryChunk.detail.copiedHint': '已复制',
  'settings.composio.notYetRouted': '尚未路由',
  'settings.localModel.download.manageExternal': '在外部运行时中管理此模型。',
  'settings.localModel.status.manageOllamaExternal':
    '请在 OpenHuman 之外管理 Ollama 进程和模型拉取，然后重新运行诊断。',
  'settings.localModel.status.ollamaDocs': 'Ollama 文档',
  'settings.localModel.status.thenRetry': '获取设置说明，待你的运行时可达后再重试。',
  'devOptions.menuAi': 'AI 配置',
  'devOptions.menuAiDesc': '云端提供商、本地 Ollama 模型与按工作负载路由',
  'devOptions.menuMessaging': '消息通道',
  'devOptions.menuMessagingDesc': '配置 Telegram/Discord 认证模式与默认通道路由',
  'devOptions.menuTools': '工具',
  'devOptions.menuToolsDesc': '启用或禁用 OpenHuman 可代表你使用的能力',
  'devOptions.menuAgentChat': '代理对话',
  'devOptions.menuAgentChatDesc': '使用模型和温度覆盖测试代理对话',
  'devOptions.menuCronJobs': '定时任务',
  'devOptions.menuCronJobsDesc': '查看和配置运行时技能的定时任务',
  'devOptions.menuLocalModelDebug': '本地模型调试',
  'devOptions.menuLocalModelDebugDesc': 'Ollama 配置、资源下载、模型测试与诊断',
  'devOptions.menuWebhooksDebug': '网络钩子',
  'devOptions.menuWebhooksDebugDesc': '查看运行时 webhook 注册和已捕获的请求日志',
  'devOptions.menuIntelligence': '智能',
  'devOptions.menuIntelligenceDesc': '记忆工作区、潜意识引擎、梦境与设置',
  'devOptions.menuNotificationRouting': '通知路由',
  'devOptions.menuNotificationRoutingDesc': 'AI 重要性评分与集成警报的协调升级',
  'devOptions.menuComposeIOTriggers': 'ComposeIO 触发器',
  'devOptions.menuComposeIOTriggersDesc': '查看 ComposeIO 触发器历史与归档',
  'devOptions.menuComposioRouting': 'Composio 路由 (直连模式)',
  'devOptions.menuComposioRoutingDesc':
    '使用你自己的 Composio API 密钥，将调用直接路由到 backend.composio.dev',
  'devOptions.menuComposioTriggers': '集成触发器',
  'devOptions.menuComposioTriggersDesc': '为 Composio 集成触发器配置 AI 分级设置',
  'memory.sourceFilterAria': '按来源过滤',
  'calls.comingSoonDescription': '人工智能辅助通话即将推出。敬请关注。',
  'whatsapp.title': 'WhatsApp',
  'subconscious.priority.critical': '批评的',
  'subconscious.priority.important': '重要的',
  'subconscious.priority.normal': '正常',
  'subconscious.durationSeconds': '{seconds}s',
  'subconscious.durationMilliseconds': '{milliseconds}毫秒',
  'settings.appearance': '外观',
  'settings.appearanceDesc': '选择浅色、深色或跟随系统主题',
  'settings.mascot': '吉祥物',
  'settings.mascotDesc': '选择应用中使用的吉祥物颜色',
  'pages.settings.account.walletBalances': '钱包余额',
  'pages.settings.account.walletBalancesDesc': '查看本地钱包的多链余额',
  'walletBalances.title': '钱包余额',
  'walletBalances.refresh': 'Refresh',
  'walletBalances.loading': '正在加载余额…',
  'walletBalances.retry': 'Retry',
  'walletBalances.emptyState': '暂无钱包账户：请在恢复助记词中设置钱包。',
  'walletBalances.copyAddress': '复制地址',
  'walletBalances.providerMissing': '服务商不可用',
  'walletBalances.rawBalance': '原始值：{raw}',
  'walletBalances.errorGeneric': '无法加载钱包余额。请在恢复助记词中设置钱包后重试。',
  'walletBalances.setupHint': '你的恢复短语尚未设置。设置后即可启用钱包并查看实时余额。',
  'walletBalances.setupCta': '设置恢复短语',
  'walletBalances.notSetUp': '未设置',
  'walletBalances.send': '发送',
  'walletBalances.receive': '接收',
  'walletReceive.scanHint': '扫描此码或复制下方地址以接收资金。',
  'walletReceive.addressLabel': '{network} 地址',
  'walletReceive.onlyChainWarning':
    '仅向此地址发送 {network} 资产。从其他网络发送资产可能导致永久损失。',
  'walletSend.available': '可用',
  'walletSend.recipient': '收款地址',
  'walletSend.recipientPlaceholder': '粘贴目标地址',
  'walletSend.recipientRequired': '请输入收款地址',
  'walletSend.amount': '金额',
  'walletSend.invalidAmount': '请输入有效金额',
  'walletSend.review': '审核',
  'walletSend.preparing': '准备中…',
  'walletSend.confirmHint': '请查看下方详情。签名在本地完成：在你确认之前不会广播任何内容。',
  'walletSend.estimatedFee': '预计网络费用',
  'walletSend.confirmSend': '确认并发送',
  'walletSend.sending': '发送中…',
  'walletSend.sent': '交易已发送',
  'walletSend.txHash': '交易哈希',
  'walletSend.viewExplorer': '在浏览器中查看',
  'walletSend.done': '完成',
  'walletSend.genericError': '无法完成转账。请重试。',
  'settings.taskSources.title': '任务来源',
  'settings.integrations.title': '集成',
  'settings.integrations.menuDesc': '任务来源、Composio 路由和 Webhook 触发器',
  'settings.taskSources.subtitle': '从你的工具拉取任务到智能体待办板',
  'settings.taskSources.description':
    '从 GitHub、Notion、Linear 和 ClickUp 收集工作项，补充信息后路由到智能体待办板。',
  'settings.taskSources.connectHint': '任务来源会使用你已连接的账户。请先在集成中连接它们。',
  'settings.taskSources.disabledBanner': '任务来源已在设置中禁用。启用后可自动轮询。',
  'settings.taskSources.loadError': '加载任务来源失败',
  'settings.taskSources.addTitle': '添加任务来源',
  'settings.taskSources.provider': '提供商',
  'settings.taskSources.name': '名称（可选）',
  'settings.taskSources.namePlaceholder': '例如 我的未解决 issue',
  'settings.taskSources.github.repo': '仓库（所有者/名称，可选）',
  'settings.taskSources.github.labels': '标签（逗号分隔）',
  'settings.taskSources.notion.database': '数据库（看板）ID',
  'settings.taskSources.notion.browseDatabases': '浏览数据库',
  'settings.taskSources.notion.loadingDatabases': '正在加载数据库…',
  'settings.taskSources.notion.selectDatabase': '选择一个数据库…',
  'settings.taskSources.notion.noDatabases': '未找到此连接的数据库。',
  'settings.taskSources.linear.team': '团队 ID（可选）',
  'settings.taskSources.clickup.team': '工作区（团队）ID（可选）',
  'settings.taskSources.assignedToMe': '仅限分配给我的项目',
  'settings.taskSources.add': '添加来源',
  'settings.taskSources.adding': '添加中…',
  'settings.taskSources.preview': '预览',
  'settings.taskSources.previewResult': '{count} 个任务匹配此筛选器',
  'settings.taskSources.fetchNow': '立即获取',
  'settings.taskSources.fetching': '获取中…',
  'settings.taskSources.fetchResult':
    '已路由 {routed}/{fetched} 个任务；已移除 {pruned} 个过期任务',
  'settings.taskSources.syncAll': '全部同步',
  'settings.taskSources.syncing': '正在同步…',
  'settings.taskSources.configured': '已配置来源',
  'settings.taskSources.empty': '尚未配置任务来源。',
  'settings.taskSources.proactive': '主动',
  'settings.taskSources.lastFetch': '上次获取',
  'settings.taskSources.never': '从未',
  'settings.taskSources.statusEnabled': '已启用',
  'settings.taskSources.statusDisabled': '已禁用',
  'settings.taskSources.enable': '启用',
  'settings.taskSources.disable': '禁用',
  'settings.taskSources.remove': '移除',
  'settings.taskSources.removeConfirm':
    '移除此任务来源？所有已摄取的任务历史都将被删除，且无法撤销。',
  'settings.taskSources.refresh': '刷新',
  'settings.taskSources.providers.github': 'GitHub',
  'settings.taskSources.providers.notion': 'Notion',
  'settings.taskSources.providers.linear': 'Linear',
  'settings.taskSources.providers.clickup': 'ClickUp',
  'skills.dashboard.enable': '启用定时工作流',
  'skills.dashboard.disable': '禁用定时工作流',
  'skills.dashboard.lastRun': '上次运行',
  'skills.dashboard.nextRun': '下次运行',
  'skills.dashboard.cardOpenRunner': '在运行器中打开',
  'skills.new.title': '创建工作流',
  'settings.agents.title': '智能体',
  'settings.agents.subtitle': '管理可委派的智能体，包括内置默认智能体和你自定义的智能体。',
  'settings.agents.menuDesc': '管理内置和自定义智能体',
  'settings.agents.newAgent': '新建智能体',
  'settings.agents.loadError': '无法加载智能体',
  'settings.agents.empty': '暂无智能体',
  'settings.agents.sourceDefault': '内置',
  'settings.agents.sourceCustom': '自定义',
  'settings.agents.enable': '启用智能体',
  'settings.agents.disable': '禁用智能体',
  'settings.agents.edit': '编辑',
  'settings.agents.delete': '删除',
  'settings.agents.reset': '恢复默认',
  'settings.agents.modelLabel': '模型',
  'settings.agents.toolsLabel': '工具',
  'settings.agents.toolsAll': '所有工具',
  'settings.agents.toolsCount': '{count} 个工具',
  'settings.agents.actionFailed': '无法更新智能体',
  'settings.agents.orchestratorLocked': '编排智能体始终启用。',
  'settings.agents.editor.createTitle': '新建智能体',
  'settings.agents.editor.editTitle': '编辑智能体',
  'settings.agents.editor.id': 'ID',
  'settings.agents.editor.idHint': '仅限小写字母、数字、_ 和 -。',
  'settings.agents.editor.name': '名称',
  'settings.agents.editor.description': '描述',
  'settings.agents.editor.model': '模型（可选）',
  'settings.agents.editor.modelPlaceholder': '例如 inherit、hint:fast 或模型 ID',
  'settings.agents.editor.systemPrompt': '系统提示词（可选）',
  'settings.agents.editor.tools': '允许的工具',
  'settings.agents.editor.toolsHint': '每行一个工具名称。使用 * 表示所有工具。',
  'settings.agents.editor.defaultsNote': '编辑内置智能体会保存一份覆盖配置，之后可重置。',
  'settings.agents.editor.save': '保存',
  'settings.agents.editor.create': '创建智能体',
  'settings.agents.editor.saving': '保存中…',
  'nav.workflows': 'Workflows',
  'workflows.title': '工作流',
  'workflows.subtitle':
    '可复用的可运行流程：目标加上实现步骤。创建一个、从 URL 安装或打开工作流来运行。',
  'workflows.createNew': '新建工作流',
  'workflows.listHeading': 'Workflows',
  'workflows.delete': '删除工作流',
  'workflows.deleteError': '删除工作流失败',
  'workflows.warnings': '{count} 个警告',
  'workflows.empty.title': '暂无工作流',
  'workflows.empty.body': '创建工作流以为任务生命周期阶段定义规则和脚本。',
  'workflows.create.title': '新建工作流',
  'workflows.create.subtitle': '为智能体定义生命周期绑定的规则集。',
  'workflows.create.name': 'Name',
  'workflows.create.namePlaceholder': '例如 Python 项目工作流',
  'workflows.create.description': 'Description',
  'workflows.create.descriptionPlaceholder': '此工作流的作用是什么？',
  'workflows.create.whenToUse': '何时使用',
  'workflows.create.whenToUsePlaceholder': '智能体何时应使用此工作流？',
  'workflows.create.optional': '（可选）',
  'workflows.create.createBtn': '创建工作流',
  'workflows.create.creating': 'Creating…',
  'workflows.create.createError': '无法创建工作流',
  'workflows.create.successTitle': '工作流已创建',
  'workflows.create.successMessage': '已成功创建。',
  'workflows.deleteConfirm.title': '删除工作流',
  'workflows.deleteConfirm.body': '移除“{name}”？此操作无法撤消。',
  'workflows.detail.tags': 'Tags',
  'workflows.detail.location': 'Location',
  'workflows.detail.warnings': 'Warnings',
  'workflows.detail.phases': 'Phases',
  'workflows.detail.noPhases': '未定义阶段。',
  'workflows.detail.loadError': '加载完整工作流失败',
  'workflows.phase.rules': 'Rules',
  'workflows.phase.rules.empty': '无规则。',
  'workflows.phase.scripts': 'Scripts',
  'workflows.phase.scripts.empty': '无脚本。',
  'workflows.phase.toolScope': '工具范围',
  'workflows.phase.toolScope.allow': 'Allow',
  'workflows.phase.toolScope.deny': 'Deny',
  'workflows.phase.toolScope.inherited': '继承自工作流默认设置。',
  'workflows.phase.toolScope.empty': '无工具限制。',
  'workflows.phase.context': 'Context',
  'workflows.phase.context.empty': '无上下文提供者。',
  'settings.agentsSection.title': 'Agents',
  'settings.agentsSection.description': '管理您的智能体、其自主权及其在本机上的访问权限。',
  'settings.agentsSection.menuDesc': '注册表、自主权与系统访问',
  'settings.cryptoSection.title': '加密货币',
  'settings.cryptoSection.description': '管理你的恢复短语并查看各钱包账户的余额。',
  'settings.cryptoSection.menuDesc': '恢复短语和钱包余额',
  'settings.notificationsHub.title': '通知',
  'settings.notificationsHub.description': '查看你的提醒收件箱，并管理通知偏好与路由。',
  'settings.notificationsHub.menuDesc': '提醒收件箱与通知偏好',
  'settings.notificationsHub.settingsItem': '通知设置',
  'settings.notificationsHub.settingsItemDesc': '偏好与路由',
  'settings.agents.editor.notFound': '未找到智能体。',
  'settings.agents.editor.modelInherit': '继承（平台默认）',
  'settings.agents.editor.modelHints': '路由提示',
  'settings.agents.editor.modelTiers': '模型层级',
  'settings.agents.editor.modelCustom': '自定义模型 ID…',
  'settings.agents.editor.modelCustomPlaceholder': '例如 anthropic/claude-sonnet-4',
  'settings.agents.editor.selectTools': '添加工具',
  'settings.agents.editor.toolsAllSelected': '所有工具',
  'settings.agents.editor.toolsNoneSelected': '未选择工具',
  'settings.agents.editor.removeToolAria': '移除 {tool}',
  'settings.agents.editor.toolsModalTitle': '已允许的工具',
  'settings.agents.editor.toolsSelectedCount': '已选 {count} 个',
  'settings.agents.editor.toolsSearchPlaceholder': '搜索工具…',
  'settings.agents.editor.toolsAllowAll': '允许所有工具 (*)',
  'settings.agents.editor.toolsAllowAllHint': '该智能体可以使用所有可用工具。',
  'settings.agents.editor.toolsLoading': '正在加载工具…',
  'settings.agents.editor.toolsLoadError': '无法加载工具',
  'settings.agents.editor.toolsEmpty': '没有匹配的工具。',
  'settings.agents.editor.toolsDone': 'Done',
  'settings.agents.editor.builtInReadonly':
    '内置智能体不可编辑。您可以在智能体列表中启用、禁用或重置它们。',
  // Chat：agent-generated artifacts (#2779)
  'chat.artifact.aria': '工件：{title}',
  'chat.artifact.generating': '正在生成{kind}…',
  'chat.artifact.ready': '已就绪',
  'chat.artifact.failed': '生成失败',
  'chat.artifact.download': '下载',
  'chat.artifact.downloading': '下载中…',
  'chat.artifact.downloaded': '已保存到 {path}',
  'chat.artifact.download_failed': '下载失败：{reason}',
  'chat.artifact.retry': '重试',
  'chat.artifact.reveal': '在文件夹中显示',
  'chat.artifact.show_more': '显示更多',
  'chat.artifact.show_less': '收起',

  // Chat：files panel (#3024)
  'chat.files.chip.aria.one': '本聊天中有 {count} 个文件',
  'chat.files.chip.aria.other': '本聊天中有 {count} 个文件',
  'chat.files.panel.aria': '本聊天中的文件',
  'chat.files.panel.title': '文件 ({count})',
  'chat.files.panel.empty': '暂无文件。请让智能体生成一个。',
  'chat.files.panel.close': '关闭文件面板',
  'chat.files.delete.aria': '删除 {title}',
  'chat.files.delete.confirm': '要删除此文件吗？',
  'chat.files.delete.cancel': '取消',
  'chat.files.delete.action': '删除',
  'chat.files.delete.failed': '无法删除文件。请重试。',
  'chat.files.error.not_desktop': '下载仅在桌面应用中可用。',
  'chat.files.error.missing_artifact_id': '缺少 artifact id。',
  'chat.files.error.missing_artifact_path': '核心响应中缺少 artifact 路径。',
  'chat.files.error.resolve_failed': '无法解析 artifact。请重试。',
  'chat.files.error.download_failed': '下载失败。请重试。',
  'chat.files.error.delete_failed': '无法删除文件。请重试。',
  'memory.tab.council': 'Council',
  'activity.tabs.automations': '自动化',
  'activity.tabs.automationsDescription': '可复用、可运行的流程：目标及达成目标的步骤。',
  'activity.tabs.backgroundActivity': '潜意识',
  'activity.tabs.alerts': '提醒',

  'intelligence.agents.title': '智能体库',
  'intelligence.agents.subtitle': '查看可运行的专家，并把一个任务交给指定智能体。',
  'intelligence.agents.refresh': '刷新',
  'intelligence.agents.loading': '正在加载智能体…',
  'intelligence.agents.failedToLoad': '无法加载智能体',
  'intelligence.agents.empty': '暂无可运行的智能体。',
  'intelligence.agents.readOnly': '只读',
  'intelligence.agents.writeCapable': '可写入',
  'intelligence.agents.allTools': '全部工具',
  'intelligence.agents.toolCountOne': '{count} 个工具',
  'intelligence.agents.toolCountOther': '{count} 个工具',
  'intelligence.agents.subagentCountOne': '{count} 个子智能体',
  'intelligence.agents.subagentCountOther': '{count} 个子智能体',
  'intelligence.agents.startChat': '开始聊天',
  'intelligence.agents.startChatPrompt':
    '用这个智能体开始聊天。介绍你的专长，询问需要了解的信息，然后等待我的任务。',
  'intelligence.agents.copyId': '复制 ID',
  'intelligence.agents.copied': '已复制',
  'intelligence.agents.taskPlaceholder': '给这个智能体的任务',
  'intelligence.agents.runTask': '运行任务',
  'intelligence.agents.running': '正在运行…',
  'intelligence.agents.runFailed': '无法启动所选智能体',
  'intelligence.agents.model.inherit': '继承',
  'intelligence.agents.tier.chat': '聊天',
  'intelligence.agents.tier.reasoning': '推理',
  'intelligence.agents.tier.worker': '工作者',
  'graphCohesion.brokerBadge': '经纪者',
  'graphCohesion.brokerTitle': '结构洞:该实体的邻居彼此之间没有连接：它是它们之间唯一的链接。',
  'graphCohesion.colCohesion': '凝聚度',
  'graphCohesion.colEntity': '实体',
  'graphCohesion.colLinks': '链接',
  'graphCohesion.colRank': '#',
  'graphCohesion.empty': '暂无知识图。',
  'graphCohesion.emptyHint': '随着助手记录有关你的相互关联的事实,它们的聚类结构将在此呈现。',
  'graphCohesion.errorPrefix': '无法加载图:',
  'graphCohesion.intro':
    '每个实体周围的邻域织得有多紧。经纪者（其邻居彼此之间没有连接的实体）是把本应分离的聚类连接起来的关键节点，这是频率或 PageRank 排序无法揭示的。',
  'graphCohesion.loading': '正在计算凝聚度…',
  'graphCohesion.metricConnections': '连接',
  'graphCohesion.metricEntities': '实体',
  'graphCohesion.metricTriangles': '三角形',
  'graphCohesion.namespaceAll': '所有命名空间',
  'graphCohesion.namespaceLabel': '命名空间',
  'graphCohesion.noBrokers': '还没有连接数达到两条或以上的实体。',
  'graphCohesion.rankedHeading': '经纪者：最松散的邻域',
  'graphCohesion.retry': '重试',
  'graphCohesion.summaryCaption': '平均聚类系数 {avg} · 传递性 {transitivity}',
  'graphCohesion.title': '图的凝聚度',
  'memory.tab.cohesion': 'Cohesion',

  'harnessInit.title': '正在进行设置',

  'announcement.gotIt': '知道了',
  'harnessInit.subtitle': 'OpenHuman 正在准备首次启动所需的组件。',
  'harnessInit.stepPython': 'Python 运行时',
  'harnessInit.stepSpacy': '语言模型',
  'harnessInit.stepNode': 'Node.js 运行时',
  'harnessInit.statePending': '等待中',
  'harnessInit.stateRunning': '正在安装…',
  'harnessInit.stateDone': '就绪',
  'harnessInit.stateSkipped': '已跳过',
  'harnessInit.stateFailed': '失败',
  'harnessInit.failedMessage':
    '部分设置步骤未完成。你可以重试或继续：OpenHuman 将使用内置的后备方案。',
  'harnessInit.retry': '重试',
  'harnessInit.continueAnyway': '仍然继续',
  'harnessInit.runInBackground': '在后台运行',
  'harnessInit.backgroundHint': '在此完成期间，你可以继续使用 OpenHuman。',

  'keyring.consent.title': '安全存储不可用',
  'keyring.consent.description':
    '您的操作系统密钥链不可访问。OpenHuman 需要您的许可，以便使用本地加密存储来保存密钥。',
  'keyring.consent.reasonPrefix': '原因：',
  'keyring.consent.showDetails': '这是什么意思？',
  'keyring.consent.hideDetails': '隐藏详情',
  'keyring.consent.tradeoffTitle': '安全权衡',
  'keyring.consent.tradeoffBody':
    '使用本地加密存储时，您的密钥使用与数据一起存储的主密钥进行磁盘加密。这不如使用硬件保护的操作系统密钥链安全。备份或文件同步可能包含加密数据。',
  'keyring.consent.consentButton': '使用本地加密存储',
  'keyring.consent.retryButton': '重试 OS Keychain',
  'keyring.consent.declineButton': '拒绝',
  'keyring.consent.retrying': '正在重试…',
  'keyring.consent.error': '保存偏好失败，请重试。',
  'keyring.consent.retryFailed': '密钥链仍然不可用。',
  'keyring.settings.title': '安全',
  'keyring.settings.storageMode': '密钥存储模式',
  'keyring.settings.mode.osKeychain': '操作系统密钥链',
  'keyring.settings.mode.encryptedFile': '本地加密',
  'keyring.settings.mode.consentPending': '未配置',
  'keyring.settings.mode.declined': '已拒绝',
  'keyring.settings.availability': '密钥链可用性',
  'keyring.settings.available': '操作系统密钥链可用',
  'keyring.settings.unavailable': '操作系统密钥链不可用',
  'keyring.settings.backend': '后端',
  'keyring.settings.retryButton': '重试密钥链检测',
  'keyring.settings.retryFailed': '重试失败。密钥链仍然不可用。',
  'keyring.settings.consentTitle': '存储同意',
  'keyring.settings.consentDescription': '选择操作系统密钥链不可用时如何存储密钥。',
  'keyring.settings.grantConsent': '允许本地加密存储',
  'keyring.settings.revokeConsent': '拒绝本地存储',
  'pages.settings.account.security': '安全',
  'pages.settings.account.securityDesc': '密钥存储模式和密钥链状态',
  // #002 memory-pipeline-hardening: degraded badges + typed remediation.
  'memoryTree.status.statusDegraded': '已降级',
  'memoryTree.status.statusBudgetExhausted': '已暂停：嵌入额度已用尽',
  'memoryTree.status.degradedRecall': '语义召回已禁用',
  'memoryTree.status.degradedStructure': 'Wiki 结构不完整',
  'memoryTree.status.extractionCoverage': '提取覆盖率：{pct}% 的片段具有结构',
  'memory.health.remediation.budget_exhausted':
    '记忆嵌入已达到托管预算上限。请设置本地 Ollama 嵌入（连接 → API 密钥 → 向量嵌入），或添加你自己的嵌入 API 密钥以继续构建记忆。',
  'memory.health.remediation.auth_missing':
    '未找到嵌入凭据。请登录 OpenHuman，或在连接 → API 密钥 → 向量嵌入 中设置本地 Ollama 嵌入。',
  'memory.health.remediation.auth_invalid':
    '你的嵌入凭据被拒绝。请重新进行身份验证，或在连接 → API 密钥 → 向量嵌入 中切换到本地 Ollama 嵌入。',
  'memory.health.remediation.embeddings_unconfigured':
    '未配置嵌入提供方，因此语义召回已关闭。请设置本地 Ollama 嵌入（推荐），或在连接 → API 密钥 → 向量嵌入 中添加嵌入密钥。',
  'memory.health.remediation.embedding_dim_mismatch':
    '嵌入模型返回的向量大小不正确（记忆需要 1024 维）。请选择 1024 维的模型，或向你的提供方请求 1024 维。',
  'memory.health.remediation.local_model_unavailable':
    '所需的本地模型不可用。请安装/运行 Ollama 并拉取模型，或在连接 → API 密钥 中将此工作负载切换到云提供方。',
  'memory.health.remediation.extraction_timeout':
    '记忆提取模型超时，因此 Wiki 结构很少。请在连接 → API 密钥 → 语言模型 中将记忆提取模型更换为更快的模型。',
  'memory.health.remediation.summarizer_unavailable':
    '没有可用于构建摘要树的摘要提供方。请启用本地 AI（Ollama），或设置 memory_tree.cloud_summarization_opt_in=true，并在连接 → API 密钥 → 语言模型中配置语言模型提供商。',
  'memory.health.remediation.empty_input_refused':
    '由于文本为空，一项记忆已被跳过。无需操作：新条目继续正常嵌入。',
  'memory.health.remediation.storage_unavailable':
    'OpenHuman 无法写入其记忆存储：磁盘或 SD 卡似乎已损坏、已满或为只读。请检查驱动器并释放空间；存储恢复可写后，记忆处理将自动继续。',
  'memory.health.remediation.transient': '临时错误中断了记忆处理。将自动重试。',
  'memory.health.remediation.unknown': '记忆处理遇到问题。请在连接 → API 密钥 中检查配置。',
  // Chat：agent-generated artifacts (#2779)

  // Chat composer toolbar
  'composer.attachFile': '附加文件',
  'composer.modelSelector': '模型',
  'composer.voiceMode': '语音模式',
  'composer.qualityHigh': '高',
  // Agent activity level
  'activityLevel.title': '智能体活动级别',
  'activityLevel.description': '控制您的智能体的主动程度。级别越高，消耗的令牌越多。',
  'activityLevel.off': '关闭',
  'activityLevel.offDesc': '无后台处理。仅在按下按钮时同步。',
  'activityLevel.minimal': '最低',
  'activityLevel.minimalDesc': '每天同步一次来源。无主动消息。',
  'activityLevel.moderate': '适中',
  'activityLevel.moderateDesc': '每小时同步。每日摘要。建议操作。',
  'activityLevel.active': '活跃',
  'activityLevel.activeDesc': '每10分钟同步。监控频道、分类并起草回复。',
  'activityLevel.alwaysOn': '始终开启',
  'activityLevel.alwaysOnDesc': '实时同步。在规定范围内完全自主。',
  'activityLevel.currentMonth': '本月：${amount}',
  'activityLevel.saved': '活动级别已更新。',
  'activityLevel.default': '默认',
  'activityLevel.costFree': '$0',
  'activityLevel.costRange': '~${min}–${max}/月',

  // Sync budget dialog
  'syncBudget.title': '同步预算',
  'syncBudget.maxTokens': '每次同步最大令牌数',
  'syncBudget.maxTokensHelp': '消耗此数量的令牌后停止同步。',
  'syncBudget.maxCost': '每次同步最大费用（USD）',
  'syncBudget.maxCostHelp': '每次同步运行的绝对美元上限。',
  'syncBudget.syncDepth': '同步深度',
  'syncBudget.syncDepthHelp': '仅获取此时间窗口内的项目。',
  'syncBudget.days7': '最近7天',
  'syncBudget.days30': '最近30天',
  'syncBudget.days90': '最近90天',
  'syncBudget.allTime': '所有时间',
  'syncBudget.unlimited': '无限制',
  'syncBudget.saved': '预算已保存。',

  // Sync confirm dialog
  'syncConfirm.title': '确认同步',
  'syncConfirm.message': '此同步将处理约{items}个项目（约{tokens}个令牌，预计${cost}）。',
  'syncConfirm.budgetNote': '预算上限：${max}',
  'syncConfirm.proceed': '继续',
  'syncConfirm.cancel': '取消',
  'syncConfirm.estimating': '正在估算费用...',

  // Monthly cost badge
  'monthlyCost.badge': '本月${amount}',
  'monthlyCost.noData': '本月无同步',

  // Onboarding: Custom > Activity
  'onboarding.custom.stepperActivity': '活动',
  'onboarding.custom.stepperVault': '保险库',
  'onboarding.custom.activity.title': '智能体活动',
  'onboarding.custom.activity.subtitle': '您的智能体在后台监控和行动的主动程度。',
  'onboarding.custom.activity.defaultDesc': '适中活动：每小时同步，每日摘要。',
  'onboarding.custom.activity.configureDesc':
    '选择您自己的活动级别。在设置 › 智能体活动级别中配置。',

  // Onboarding: Custom > Vault
  'onboarding.custom.vault.title': '记忆与保险库设置',
  'onboarding.custom.vault.subtitle':
    '确认记忆笔记的写入位置、源数据的读取方式，以及保险库管道是否正常运行。',
  'onboarding.custom.vault.defaultDesc':
    '使用 OpenHuman 托管的记忆默认设置。保险库路径和同步健康状态仍可稍后查看。',
  'onboarding.custom.vault.configureDesc': '立即查看保险库所有权、运行健康检查并调整记忆控制。',
  'onboarding.custom.vault.localDisabledReason': '托管设置需要登录 OpenHuman，在本地模式下不可用。',
  'onboarding.custom.vault.exitError': '无法完成引导流程，请重试。',

  // Vault Health
  'vaultHealth.title': '保险库健康检查清单',
  'vaultHealth.setupTitle': '保险库设置健康状态',
  'vaultHealth.workspaceVault': '工作区保险库：',
  'vaultHealth.refresh': '刷新',
  'vaultHealth.refreshing': '刷新中…',
  'vaultHealth.revealFolder': '显示文件夹',
  'vaultHealth.openInObsidian': '在 Obsidian 中打开',
  'vaultHealth.installObsidian': '安装 Obsidian',
  'vaultHealth.openObsidianError': '无法打开 Obsidian',
  'vaultHealth.revealError': '无法显示保险库文件夹',
  'vaultHealth.downloadError': '无法打开 Obsidian 下载页面',
  'vaultHealth.loadError': '无法加载保险库健康状态：',
  'vaultHealth.lastSync': '上次同步：',
  'vaultHealth.passed': '通过',
  'vaultHealth.needsAttention': '需要关注',
  'vaultHealth.existsLabel': '工作区保险库路径存在',
  'vaultHealth.existsRecovery': '保险库文件夹缺失。请启动同步或创建该文件夹，然后刷新此检查清单。',
  'vaultHealth.writableLabel': 'OpenHuman 可写入保险库',
  'vaultHealth.writableRecovery': 'OpenHuman 暂时无法写入此保险库。请授予写入权限后刷新。',
  'vaultHealth.obsidianLabel': '保险库已在 Obsidian 中注册',
  'vaultHealth.obsidianRecovery':
    '请在 Obsidian 中选择"将文件夹作为保险库打开"，然后刷新此检查清单。',
  'vaultHealth.pipelineLabel': '记忆管道运行正常',
  'vaultHealth.pipelineRecovery':
    '记忆管道已暂停或出现错误。请在记忆树状态中重新启用自动同步并重试。',
  'vaultHealth.timeNever': '从未',
  'vaultHealth.timeJustNow': '刚刚',
  'vaultHealth.timeMinAgo': '{n} 分钟前',
  'vaultHealth.timeHrAgo': '{n} 小时前',
  'vaultHealth.timeDayAgo': '{n} 天前',
  'vaultHealth.timeDaysAgo': '{n} 天前',

  // Memory Data
  'memoryData.howItWorks': '记忆存储原理',
  'memoryData.workspaceVault': '工作区保险库 · 写入',
  'memoryData.workspaceVaultDesc': 'OpenHuman 将生成的记忆笔记写入 memory_tree/content。',
  'memoryData.connectedSources': '已连接来源 · 读取',
  'memoryData.connectedSourcesDesc':
    '文件夹、邮箱、聊天记录和代码仓库会导入用于记忆索引：其原始文件不会被改写。',
  'memoryData.internalFiles': '内部记忆树文件',
  'memoryData.internalFilesDesc':
    '索引、队列状态和摘要由 OpenHuman 管理，以保持召回和同步的正常运行。',
  'memoryData.windowError': '记忆时间窗口',
  'memoryData.windowUpdated': '记忆时间窗口已更新',
  'memoryData.windowUpdatedMsg': '已设置为 {window}。',
  'skills.create.whenToUse': '使用时机',
  'skills.create.whenToUsePlaceholder': '例如，当用户要求整理收件箱时',
  'skills.create.whenToUseHelp': '代理据以决定运行此工作流的触发条件。留空则沿用描述。',
  'skills.create.inputs.row.descriptionError': '每个输入项都需要填写描述。',
  'skills.detail.run': '运行',
  'skills.detail.runAriaLabel': '运行此工作流',
  'skills.run.title': '工作流',
  'workflows.installFromUrl': '从 URL 安装',
  // Security banner (approval-gate host-aware boot state)
  'security.approvalGateDisabled.title': '审批门已禁用',
  'security.approvalGateDisabled.body':
    '您的环境中设置了 OPENHUMAN_APPROVAL_GATE=0。具有外部影响的工具将在不请求确认的情况下运行。',
  'security.approvalGateOverrideIgnored.title': '覆盖已阻止',
  'security.approvalGateOverrideIgnored.body':
    '检测到 OPENHUMAN_APPROVAL_GATE=0 覆盖，但已忽略：桌面应用始终保持审批门开启。',

  // Run queue
  'runQueue.mode.interrupt': '中断',
  'runQueue.mode.steer': '引导',
  'runQueue.mode.followup': '后续跟进',
  'runQueue.mode.collect': '添加上下文',
  'runQueue.queued': '消息已加入队列',
  'runQueue.steerHint': '引导当前轮次',
  'runQueue.followupHint': '作为后续跟进加入队列',
  'runQueue.collectHint': '作为额外上下文添加',
  'runQueue.status': '已排队 {total} 条',
  'runQueue.cleared': '队列已清空',
  'notch.ready': '就绪',
  'notch.processing': '处理中…',
  'notch.listening': '聆听中…',
  'notch.thinking': '思考中…',
  'notch.speaking': '说话中…',
  'notch.transcribing': '转录中…',
  'notch.executing': '执行中…',
  'memory.tab.orchestration': '编排',
  'memory.tab.orchestrationDescription':
    '运行多智能体工作流：将一个问题分发给多个并行智能体，交叉核对它们的发现，并观察每个阶段汇聚成一个综合答案。',
  'orchestration.subtitle': '启动多智能体工作流，观察其各阶段进展，并阅读综合结果。',
  'orchestration.loading': '正在加载工作流…',
  'orchestration.failedToLoad': '加载工作流失败',
  'orchestration.definitions': '可用工作流',
  'orchestration.noDefinitions': '没有可用的工作流定义。',
  'orchestration.approvalRequired': '需要批准',
  'orchestration.start': '启动',
  'orchestration.confirmStart': '启动运行',
  'orchestration.starting': '正在启动…',
  'orchestration.questionLabel': '研究问题（可选）',
  'orchestration.questionPlaceholder': '智能体应研究什么？',
  'orchestration.runProgress': '运行进度',
  'orchestration.recentRuns': '近期运行',
  'orchestration.noRuns': '尚无工作流运行。',
  'orchestration.close': '关闭',
  'orchestration.tier.readOnly': '只读',
  'orchestration.tier.standard': '标准',
  'orchestration.tier.editCapable': '可编辑',
  'orchestration.approval.title': '批准此工作流运行',
  'orchestration.approval.body': '这是一次高成本或高并发的运行，启动前需要您明确批准：',
  'orchestration.approval.reason.tier': '其智能体可执行超出只读研究范围的操作。',
  'orchestration.approval.reason.concurrency': '它会同时运行许多智能体。',
  'orchestration.approval.reason.children': '它总共可能生成大量智能体。',
  'orchestration.approval.tier': '安全级别',
  'orchestration.approval.concurrency': '并发数',
  'orchestration.approval.maxChildren': '最大智能体数',
  'orchestration.approval.approve': '批准并启动',
  'orchestration.approval.starting': '正在启动…',
  'orchestration.approval.cancel': '取消',
  'orchestration.runStatus.pending': '等待中',
  'orchestration.runStatus.running': '运行中',
  'orchestration.runStatus.completed': '已完成',
  'orchestration.runStatus.failed': '已失败',
  'orchestration.runStatus.cancelled': '已取消',
  'orchestration.runStatus.interrupted': '已中断',
  'orchestration.phaseStatus.pending': '等待中',
  'orchestration.phaseStatus.running': '运行中',
  'orchestration.phaseStatus.completed': '已完成',
  'orchestration.phaseStatus.failed': '已失败',
  'orchestration.detail.stop': '停止',
  'orchestration.detail.resume': '继续',
  'orchestration.detail.agents': '个智能体',
  'orchestration.detail.childRefs': '子智能体',
  'orchestration.detail.synthesis': '最终综合',
  // ── Agent Profiles ───────────────────────────────────────────────────────
  'settings.profiles.title': '智能体配置',
  'settings.profiles.subtitle': '风格化智能体：每个都有自己的灵魂、记忆、连接器和技能。',
  'settings.profiles.menuDesc': '创建并管理智能体配置',
  'settings.profiles.new': '新建配置',
  'settings.profiles.empty': '暂无智能体配置',
  'settings.profiles.loadError': '无法加载配置',
  'settings.profiles.active': '当前使用',
  'settings.profiles.setActive': '设为当前',
  'settings.profiles.sourceBuiltIn': '内置',
  'settings.profiles.sourceCustom': '自定义',
  'settings.profiles.deleteConfirm': '删除此配置？此操作无法撤销。',
  'settings.profiles.editor.createTitle': '新建配置',
  'settings.profiles.editor.editTitle': '编辑配置',
  'settings.profiles.editor.name': '名称',
  'settings.profiles.editor.id': '标识',
  'settings.profiles.editor.idHint': '仅限小写字母、数字和短横线。',
  'settings.profiles.editor.description': '描述',
  'settings.profiles.editor.soul': '灵魂（SOUL.md）',
  'settings.profiles.editor.soulHint': '此配置的自定义身份。留空则回退到工作区的 SOUL.md。',
  'settings.profiles.editor.baseAgent': '基础智能体',
  'settings.profiles.editor.baseAgentHint': '此配置运行所基于的智能体定义（例如 orchestrator）。',
  'settings.profiles.editor.model': '模型',
  'settings.profiles.editor.modelHint': '可选的模型覆盖。留空则继承默认值。',
  'settings.profiles.editor.temperature': '温度',
  'settings.profiles.editor.systemPromptSuffix': '系统提示词后缀',
  'settings.profiles.editor.agentConversations': '召回智能体对话',
  'settings.profiles.editor.agentConversationsHint': '在此配置的上下文中纳入此前对话和跨会话记忆。',
  'settings.profiles.editor.memorySources': '记忆来源',
  'settings.profiles.editor.memorySourcesHint': '此配置召回所使用的记忆来源。',
  'settings.profiles.editor.connectors': '连接器',
  'settings.profiles.editor.connectorsHint': '此配置可使用的 Composio 工具包。',
  'settings.profiles.editor.skills': '技能',
  'settings.profiles.editor.skillsHint': '此配置可列出并运行的工作流。',
  'settings.profiles.editor.mcpServers': 'MCP 服务器',
  'settings.profiles.editor.mcpServersHint': '此配置可访问的 MCP 服务器。',
  'settings.profiles.editor.dedicatedMemory': '专属记忆',
  'settings.profiles.editor.dedicatedMemoryHint': '为此配置分配专属记忆，而不是共享默认记忆。',
  'settings.profiles.editor.dedicatedWorkspace': '专属工作区',
  'settings.profiles.editor.dedicatedWorkspaceHint':
    '为此配置分配专属工作目录，用于文件和工具操作。',
  'settings.profiles.editor.soulMdFile': 'SOUL.md 文件',
  'settings.profiles.editor.workspaceDir': '工作目录',
  'settings.profiles.editor.skillsDir': '技能目录',
  'settings.profiles.editor.skillsDirHint': '放在此处的 SKILL.md 文件仅对该配置私有。',
  'settings.profiles.editor.all': '全部',
  'settings.profiles.editor.selected': '指定',
  'settings.profiles.editor.addPlaceholder': '输入标识后按回车',
  'settings.profiles.editor.removeAria': '移除 {item}',
  'settings.profiles.editor.notFound': '未找到配置',
  'settings.profiles.editor.saving': '正在保存…',
  'settings.profiles.editor.idRequired': '配置标识不能为空',
  'agentworld.jobs.applyModal.title': '申请职位',
  'agentworld.jobs.applyModal.successHeading': '提案提交成功！',
  'agentworld.jobs.applyModal.successBody': '招聘方将审核您的申请。',
  'agentworld.jobs.applyModal.coverLetterLabel': '求职信',
  'agentworld.jobs.applyModal.coverLetterPlaceholder': '描述您的经验以及为何适合此职位',
  'agentworld.jobs.applyModal.bidAmountLabel': '报价金额',
  'agentworld.jobs.applyModal.bidAmountPlaceholder': '例：450 USDC',
  'agentworld.jobs.applyModal.deliveryLabel': '预计交付时间',
  'agentworld.jobs.applyModal.deliveryPlaceholder': '例：2周',
  'agentworld.feed.live': '实时',
  'agentworld.jobs.applyModal.cancel': '取消',
  'agentworld.jobs.applyModal.submit': '提交申请',
  'agentworld.jobs.applyModal.submitting': '申请中…',
  'agentworld.messaging.live': '实时',
  'agentworld.messaging.missingSignalBundle':
    '此用户尚未启用加密消息。发送消息前，请让对方打开 Agent World 并启用安全私信。',
  'agentworld.messaging.notAContact':
    '在对方成为联系人之前，你无法向其发送消息。请发送联系人请求，待对方接受后再试。',
  'agentworld.messaging.sendContactRequest': '发送联系人请求',
  'agentworld.messaging.contactRequestSending': '正在发送请求…',
  'agentworld.messaging.contactRequestSent': '联系人请求已发送。对方接受后你即可发送消息。',
  'agentworld.messaging.contactRequestFailed': '无法发送联系人请求，请重试。',

  // User-actionable runtime errors (#3931)
  'userErrors.title': '需要操作',
  'userErrors.dismiss': '忽略',
  'userErrors.action.openBilling': '打开账单',
  'userErrors.action.openProviderSettings': '提供商设置',
  'userErrors.action.openEmbeddingsSettings': '设置嵌入',
  'userErrors.budgetExceeded.title': '托管预算已用尽',
  'userErrors.budgetExceeded.body': '托管 AI 预算已用尽，请增加预算或更改套餐。',
  'userErrors.insufficientCredits.title': '需要提供商额度',
  'userErrors.insufficientCredits.body': '提供商额度已用完，请充值或更新 API 密钥。',
  'userErrors.apiKeyMissing.title': '需要 API 密钥',
  'userErrors.apiKeyMissing.body': '您的 AI 提供商未设置 API 密钥，请在提供商设置中添加以继续。',
  'userErrors.localModelUnavailable.title': '本地模型不可用',
  'userErrors.localModelUnavailable.body':
    '无法在配置的端点连接 Ollama，或所需模型未安装在该端点。请启动 Ollama 并在该端点拉取模型，或将此工作切换到云端提供商。',
  'userErrors.scope.chat': '聊天',
  'userErrors.scope.cron': '定时任务',
  'userErrors.scope.workspace': '工作区',
  'userErrors.memoryBudgetExhausted.title': '记忆已停止增长',
  'userErrors.memoryBudgetExhausted.body':
    '你的嵌入额度已用尽，新内容不会再加入记忆。设置本地嵌入或添加你自己的 API 密钥即可恢复。',
  'memoryBudget.approachingTitle': '记忆即将达到嵌入额度上限',
  'memoryBudget.approachingMessage':
    '你已使用 {pct}% 的嵌入额度。设置本地嵌入或添加你自己的 API 密钥，让记忆不中断地继续增长。',
  'memoryBudget.exhaustedTitle': '记忆已停止增长',
  'memoryBudget.exhaustedMessage':
    '你的嵌入额度已用尽，新内容不会再加入记忆。设置本地嵌入或添加你自己的 API 密钥即可恢复。',
  'memoryBudget.cta': '设置嵌入',
  'userErrors.scope.memory': '记忆',
  // Agent World：Identity trading (confirm-before-spend + balance gate)
  'agentWorld.trading.amountLabel': '金额',
  'agentWorld.trading.networkLabel': '网络',
  'agentWorld.trading.balanceLabel': '你的余额',
  'agentWorld.trading.walletLabel': '钱包',
  'agentWorld.trading.balanceUnknown': '未知',
  'agentWorld.trading.cancel': '取消',
  'agentWorld.trading.addFunds': '添加资金',
  'agentWorld.trading.confirmPay': '确认并支付',
  'agentWorld.trading.confirmCommit': '确认',
  'agentWorld.trading.continue': '继续',
  'agentWorld.trading.submitting': '正在提交…',
  'agentWorld.trading.placeBid': '出价',
  'agentWorld.trading.submitOffer': '提交报价',
  'agentWorld.trading.bidTitlePrefix': '出价：',
  'agentWorld.trading.offerTitlePrefix': '报价：',
  'agentWorld.trading.bidReviewTitlePrefix': '确认出价：',
  'agentWorld.trading.offerReviewTitlePrefix': '确认报价：',
  'agentWorld.trading.spendInsufficient':
    '余额不足，无法完成此次支付。请向你的钱包添加资金以继续。',
  'agentWorld.trading.spendBroadcastNote': '你的钱包将对此次支付进行签名并广播至',
  'agentWorld.trading.commitInsufficientWarning':
    '如果该承诺被接受，你的余额可能不足以支付。你仍然可以提交：资金仅在被接受时才会转移。',
  'agentWorld.trading.commitSettleNote': '这是一项已签名的承诺：仅在被接受时资金才会转移。',
  'agentWorld.trading.commitReviewSubtitle': '提交前请检查你的承诺。',
  'agentWorld.trading.balanceUnverified':
    '我们无法验证你的钱包余额。你仍然可以继续：支付将在提交时进行检查。',
  'agentWorld.trading.amountTooManyDecimals': '该金额的小数位数过多。',
  'agentWorld.trading.amountMustBePositive': '请输入大于零的金额。',
  'agentWorld.trading.amountInvalid': '请输入有效的金额。',

  // Code block chrome
  'codeBlock.copy': '复制',
  'codeBlock.copied': '已复制！',
  'flows.editor.undo': '撤销',
  'flows.editor.redo': '重做',
  'flows.editor.onboardingTitle': '构建你的工作流',
  'flows.editor.onboardingBody': '从左侧面板添加节点，然后在各卡片的圆点之间拖动以连接它们。',
  'flows.palette.search': '搜索节点…',
  'flows.palette.noResults': '没有匹配的节点',
  'flows.palette.group.triggers': '触发器',
  'flows.palette.group.actions': '操作',
  'flows.palette.group.logic': '逻辑',
  'flows.list.duplicate': '复制',
  'flows.list.duplicated': '工作流已复制',
  'flows.list.delete': '删除',
  'flows.list.deleted': '工作流已删除',
  'flows.list.moreActions': '更多操作',
  'flows.delete.title': '删除工作流？',
  'flows.delete.body': '“{name}”及其运行历史将被永久删除。此操作无法撤销。',
  'flows.delete.cancel': '取消',
  'flows.delete.confirm': '删除',
  'flows.delete.deleting': '正在删除…',
  'flows.canvas.renameLabel': '重命名工作流',
  'memorySources.codingSessions.title': '编程智能体会话',
  'memorySources.codingSessions.description':
    '将 Codex 和 Claude Code 中的决策与纠正转化为私有人格记忆。',
  'memorySources.codingSessions.importAll': '导入所有会话',
  'memorySources.codingSessions.draining': '正在导入…第 {passes} 轮',
  'memorySources.codingSessions.stop': '停止',
  'memorySources.codingSessions.progress': '已导入 {processed} 个会话 · {observations} 条观察',
  'memorySources.codingSessions.remaining': '约剩 {remaining} 个',
  'memorySources.codingSessions.stopped': '导入已暂停',
  'memorySources.codingSessions.stoppedMessage':
    '已导入 {processed} 个会话。再次运行导入以继续剩余的 {remaining} 个。',
  'memorySources.codingSessions.claude': '克劳德代码',
  'memorySources.codingSessions.codex': 'Codex',
  'memorySources.codingSessions.counts': '{files} 个会话 · {evidence} 条证据',
  'memorySources.codingSessions.notFound': '未找到本地历史记录',
  'memorySources.codingSessions.scanning': '正在扫描本地会话历史…',
  'memorySources.codingSessions.truncated': '扫描仅限前 1,000 个会话文件。',
  'memorySources.codingSessions.complete': '编程会话已摄取',
  'memorySources.codingSessions.completeMessage':
    '{processed} 个会话生成了 {observations} 条人格观察。',
  'memorySources.codingSessions.partialFailure':
    '{processed} 个会话已处理，{failed} 个失败。请再次运行摄取以重试。',
  'memorySources.codingSessions.failed': '编程会话摄取失败',
  'flows.canvas.sidePanelToggle': '侧边栏',
  'flows.canvas.legendTab': '手动',

  // Privacy status pill + per-action egress disclosure (#4437 / S3)
  'privacy.status.ariaLabel': '隐私状态',
  'privacy.status.external': '设备外',
  'privacy.status.local': '本地设备',
  // Data Sync layered pipeline status (GH-4690)
  'sync.pipeline.ingestedOnly': '仅已导入',
  'sync.pipeline.storedWithoutVectors': '已存储但无向量。语义搜索不可用。',
  'sync.pipeline.signInToEnable': '登录以启用',
  'sync.pipeline.extractionFailed': '记忆结构提取失败。维基可能不完整。',
  'sync.pipeline.treeDegraded': '记忆树已降级。检索可能返回过时的结果。',
  'sync.pipeline.viewHealth': '查看记忆健康状况',
  'notifications.configRecovered.title': '已恢复设置文件',
  'notifications.configRecovered.body':
    '无法读取你的设置文件，因此已从备份恢复或重置为默认值。无法读取的文件已保留并加上 ".corrupted" 后缀，以备你需要。',
};

export default messages;
